(function () {
	'use strict';

	angular.module('novusTerminal', [
		'ngCookies',
		'ngTouch',
		'ngStorage',
		'ngSanitize',
		'ngMessages',
		'ngAria',
		'restangular',
		'ui.router',
		'ui.bootstrap',
		'toastr',
		'ngIdle',
		'daterangepicker',
		'ui.select',
		'barcode',
        'angular-virtual-keyboard'
	]);
})();

/**
 * Created by Emre on 28.06.2017.
 */

(function () {
      'use strict';

      var path = 'app/profile/transactions/directives/transactionList';

      angular
          .module('novusTerminal')
          .directive('aptTransactionList', DirectiveFn);

      function DirectiveFn() {
            return {
                  restrict: 'EA',
                  scope: {},
                  bindToController: true,
                  controller: ControllerFn,
                  controllerAs: 'vmTransactionList',
                  templateUrl: function (elem, attrs) {
                        if (attrs.template) {
                              return path + '/transactionList.' + attrs.template + '.html';
                        } else {
                              return path + '/transactionList.html';
                        }
                  }
            }
      }

      ControllerFn.$inject = ['TransactionsService'];
      function ControllerFn(TransactionsService) {
            var vm = this;

            vm.transactions = TransactionsService.getTransactions();

      }

})();
/**
 * Created by Emre on 28.06.2017.
 */

(function () {
      'use strict';

      var path = 'app/profile/transactions/directives/transactionForm';

      angular
          .module('novusTerminal')
          .directive('aptTransactionForm', DirectiveFn);

      function DirectiveFn() {
            return {
                  restrict: 'EA',
                  scope: {},
                  bindToController: true,
                  controller: ControllerFn,
                  controllerAs: 'vmTransactionForm',
                  templateUrl: function (elem, attrs) {
                        if (attrs.template) {
                              return path + '/transactionForm.' + attrs.template + '.html';
                        } else {
                              return path + '/transactionForm.html';
                        }
                  }
            }
      }

      ControllerFn.$inject = ['CalendarConfigurationService', 'TransactionsService'];
      function ControllerFn(CalendarConfigurationService, TransactionsService) {
            var vm = this;

            vm.data = {};
            vm.data.start_time = "";
            vm.data.end_time = "";

            vm.data.ticket_type="all";
            vm.data.transaction_type = "sportsbook";
            vm.data.type = "all";



            vm.dateOptions = CalendarConfigurationService.getCalendarOptions();
            vm.date = CalendarConfigurationService.getInitTimeForCalendar();



            vm.transactionsSearch = transactionsSearchFn;
            function transactionsSearchFn() {
                  setLocalDate(vm.date);
                  TransactionsService.setTransactions(vm.data);
            }

            function setLocalDate(date) {
                  var localDateConfig = CalendarConfigurationService.getTimeForDbRecord(date);
                  vm.data.start_time = localDateConfig.startDate;
                  vm.data.end_time = localDateConfig.endDate;
            }
      }

})();
/**
 * Created by Emre on 17.06.2017.
 */

(function () {
    'use strict';
    angular
        .module('novusTerminal')
        .config(InterceptorFn)
        .factory('transactionDetailModel', ServiceFn);

    InterceptorFn.$inject = ['RestangularProvider'];
    function InterceptorFn(RestangularProvider) {

        RestangularProvider.addResponseInterceptor(function (data, operation, what, url, response, deferred) {


            // var auth = response.headers('auth');
            return data;

        });

        RestangularProvider.addRequestInterceptor(function (data, operation, what, url) {

            // var auth = $cookies.get('terminalAuth') || '';

            // var languageId = 1;
            // data.auth = auth;
            // data.language_id = languageId;
            return data;
        });

    }

    ServiceFn.$inject = ['ApiService'];
    function ServiceFn(ApiService) {


        var rest = ApiService.serviceOne();

        return rest.service('user/transactions');

    }

})();
/**
 * Created by Emre on 28.06.2017.
 */

(function () {
      'use strict';
      // var path = 'app/profile/transactions/directives/transactionDetail';
      angular
          .module('novusTerminal')
          .controller('transactionsDetail', ControllerFn);
      ControllerFn.$inject = ['transactionDetailModel','$state'];
      function ControllerFn(transactionDetailModel, $state) {
            var vm = this;

            vm.data = {};
            vm.data.start_time = "";
            vm.data.end_time = "";
            vm.data.transactionsType = "all";
            vm.data.product = "sportsbook";
            vm.data.ticketType = "all";
            vm.data.transaction_id = $state.params.transactionId;

            transactionDetailModel.post(vm.data).then(function (res) {
                  vm.transactionDetailData = res.data.transaction[0];
            });
      }

})();
(function () {

      var path = 'app/profile/revenueReport/directives/list';

      angular
            .module('novusTerminal')
            .directive('nvsRevenueReportList', DirectiveFn);

      function DirectiveFn() {
            return {
                  restrict: 'EA',
                  scope: {},
                  bindToController: true,
                  controller: ControllerFn,
                  controllerAs: 'vmRevenueReportList',
                  templateUrl: function (elem, attrs) {
                        if (attrs.template) {
                              return path + '/revenue-report-list.' + attrs.template + '.html';
                        } else {
                              return path + '/revenue-report-list.html';
                        }
                  }
            }
      }

      ControllerFn.$inject = ['RevenueReportService'];
      function ControllerFn(RevenueReportService) {
            var vm = this;

            vm.dataLoadingStatus = RevenueReportService.getLoadingStatus();
            vm.user = RevenueReportService.getUser();
            vm.reportList = RevenueReportService.getReportList();
            vm.filter = RevenueReportService.getFilterData();
      }

})();
(function () {

      var path = 'app/profile/revenueReport/directives/filter';

      angular
            .module('novusTerminal')
            .directive('nvsRevenueReportFilter', DirectiveFn);

      function DirectiveFn() {
            return {
                  restrict: 'EA',
                  scope: {},
                  bindToController: true,
                  controller: ControllerFn,
                  controllerAs: 'vmRevenueReportFilter',
                  templateUrl: function (elem, attrs) {
                        if (attrs.template) {
                              return path + '/revenue-report-filter.' + attrs.template + '.html';
                        } else {
                              return path + '/revenue-report-filter.html';
                        }
                  }
            }
      }

      ControllerFn.$inject = ['RevenueReportService', 'DateRangeConstantSettings', 'NotifyingService', '$scope', '$timeout'];
      function ControllerFn(RevenueReportService, DateRangeConstantSettings, NotifyingService, $scope, $timeout) {
            var vm = this;

            vm.search = searchFn;
            var userPin = false;
            var parameterValue = '';
            vm.filterData = RevenueReportService.getFilterData();
            vm.user = RevenueReportService.getUser();
            vm.showDatePicker = true;

            /**
             * initial date time
             * and Date Range Picker Options
             */
            vm.dateTime = DateRangeConstantSettings.getDateRangePickerInitialDateValue();
            vm.dateOptions = DateRangeConstantSettings.getDateRangePicker();

            function filterData() {
                  RevenueReportService.setRequestDataDateTime(vm.dateTime);
                  RevenueReportService.setUser(vm.user);
                  RevenueReportService.setRequestData(vm.filterData);
            }

            NotifyingService.subscribe($scope, 'pinCode:set', function (event, data) {
                  if (userPin && (_.isEmpty(data) || RevenueReportService.getParameter("pin_for_reports") !== data * 1)) {
                        RevenueReportService.verifyPinCode(parameterValue);
                        return;
                  }
                  vm.filterData.pin = data;
            });
            function checkPinForReport() {
                  parameterValue = RevenueReportService.getParameter("pin_for_reports");
                  if (!_.isNaN(parameterValue) && !_.isNull(parameterValue)) {
                        RevenueReportService.verifyPinCode(parameterValue);
                        userPin = true;
                        return;
                  }
            }

            checkPinForReport();
            function searchFn() {
                  if (userPin && (_.isEmpty(vm.filterData.pin) || RevenueReportService.getParameter("pin_for_reports") != vm.filterData.pin * 1)) {
                        RevenueReportService.verifyPinCode(parameterValue);
                        return;
                  }
                  filterData();
            }

            /**
             *language change date format
             */
            NotifyingService.subscribe($scope, 'translate-json:set', function () {
                  vm.showDatePicker = false;
                  _.merge(vm.dateTime, DateRangeConstantSettings.getDateRangeDateValue(vm.dateTime));
                  _.merge(vm.dateOptions, DateRangeConstantSettings.getDateRangePicker());

                  $timeout(function () {
                        vm.showDatePicker = true;
                  }, 50);
            });
            vm.reportList = RevenueReportService.getReportList();


      }
})();
/**
 * Created by Emre on 22.06.2017.
 */

(function () {
      'use strict';

      angular
          .module('novusTerminal')
          .directive('aptTicketStatus', DirectiveFn);

      function DirectiveFn() {
            return {
                  restrict: 'EA',
                  scope: {
                        status: '@'
                  },
                  link: linkFn
            };

            function linkFn(scope, elem, attr) {

                  var ticketStatus = {
                        1: 'running',
                        2: 'pending',
                        3: 'cancelled',
                        4: 'rejected',
                        5: 'awaiting',
                        6: 'void',
                        7: 'win',
                        8: 'lost',
                        11: 'open_win',
                        12: 'paid_win'
                  };

                  if (_.isUndefined(ticketStatus[scope.status])) {
                        return elem.html("-");
                  } else {
                        return elem.html(ticketStatus[scope.status]);
                  }
            }
      }
})();
/**
 * Created by Emre on 22.06.2017.
 */

(function () {
      'use strict';

      var path = 'app/profile/betHistory/directives/betHistoryHeaderRightForm';

      angular
          .module('novusTerminal')
          .directive('aptBetHistoryHeaderRight', DirectiveFn);

      function DirectiveFn() {
            return {
                  restrict: 'EA',
                  scope: {},
                  bindToController: true,
                  controller: ControllerFn,
                  controllerAs: 'vmBetHistoryHeaderRight',
                  templateUrl: function (elem, attrs) {
                        if (attrs.template) {
                              return path + '/betHistoryHeaderRightForm.' + attrs.template + '.html';
                        } else {
                              return path + '/betHistoryHeaderRightForm.html';
                        }
                  }
            }
      }

      ControllerFn.$inject = ['BetHistoryService'];
      function ControllerFn(BetHistoryService) {
            var vm = this;
            vm.stats = BetHistoryService.getStats();
      }

})();
/**
 * Created by Emre on 22.06.2017.
 */

(function () {
      'use strict';

      var path = 'app/profile/betHistory/directives/betHistoryHeaderLeftForm';

      angular
          .module('novusTerminal')
          .directive('aptBetHistoryHeaderLeft', DirectiveFn);

      function DirectiveFn() {
            return {
                  restrict: 'EA',
                  scope: {},
                  bindToController: true,
                  controller: ControllerFn,
                  controllerAs: 'vmBetHistoryHeaderLeft',
                  templateUrl: function (elem, attrs) {
                        if (attrs.template) {
                              return path + '/betHistoryHeaderLeftForm.' + attrs.template + '.html';
                        } else {
                              return path + '/betHistoryHeaderLeftForm.html';
                        }
                  }
            }
      }

      ControllerFn.$inject = ['BetHistoryService', 'CalendarConfigurationService'];
      function ControllerFn(BetHistoryService, CalendarConfigurationService) {
            var vm = this;

            vm.data = {};
            vm.data.status = "all";
            vm.data.start_time = "";
            vm.data.end_time = "";

            vm.dateOptions = CalendarConfigurationService.getCalendarOptions();
            vm.date = CalendarConfigurationService.getInitTimeForCalendar();

            vm.setBetList = setBetListFn;
            function setBetListFn() {
                  setLocalDate(vm.date);
                  BetHistoryService.setBetList(vm.data);
            }

            function setLocalDate(date) {
                  var localDateConfig = CalendarConfigurationService.getTimeForDbRecord(date);
                  vm.data.start_time = localDateConfig.startDate;
                  vm.data.end_time = localDateConfig.endDate;
            }


      }

})();
/**
 * Created by Emre on 22.06.2017.
 */

(function () {
      'use strict';

      var path = 'app/profile/betHistory/directives/betHistoryContentList';

      angular
          .module('novusTerminal')
          .directive('aptBetHistoryContentList', DirectiveFn);

      function DirectiveFn() {
            return {
                  restrict: 'EA',
                  scope: {},
                  bindToController: true,
                  controller: ControllerFn,
                  controllerAs: 'vmBetHistoryContentList',
                  templateUrl: function (elem, attrs) {
                        if (attrs.template) {
                              return path + '/betHistoryContentList.' + attrs.template + '.html';
                        } else {
                              return path + '/betHistoryContentList.html';
                        }
                  }
            }
      }

      ControllerFn.$inject = ['BetHistoryService'];
      function ControllerFn(BetHistoryService) {
            var vm = this;

            vm.betList = BetHistoryService.getBetList();

      }

})();
/**
 * Created by Emre on 23.06.2017.
 */

(function () {
      'use strict';
      angular
          .module('novusTerminal')
          .config(InterceptorFn)
          .factory('BetHistoryDetailModelService', ServiceFn);

      InterceptorFn.$inject = ['RestangularProvider'];
      function InterceptorFn(RestangularProvider) {

            RestangularProvider.addResponseInterceptor(function (data, operation, what, url, response, deferred) {
                  return data;
            });

            RestangularProvider.addRequestInterceptor(function (data, operation, what, url) {
                  return data;
            });
      }

      ServiceFn.$inject = ['ApiService'];
      function ServiceFn(ApiService) {

            var rest = ApiService.serviceOne();

            return rest.service('user/ticket');

      }

})();
/**
 * Created by Emre on 23.06.2017.
 */

(function () {
      'use strict';
      angular
          .module('novusTerminal')
          .factory('BetHistoryDetailService', ServiceFn);

      ServiceFn.$inject = ['BetHistoryDetailModelService', 'ToastrNotificationService'];
      function ServiceFn(BetHistoryDetailModelService, ToastrNotificationService) {
            var ServiceObject;

            var betHistoryDetail = {};

            ServiceObject = {

                  setBetHistoryDetail: function (data) {
                        betHistoryDetail={};
                        BetHistoryDetailModelService.post(data)
                            .then(function (response) {

                                  _.merge(betHistoryDetail, response.data.ticket);

                            })
                            .catch(function(error) {
                                  ToastrNotificationService.notificationPopUp(error.data.error_message, 'error');
                            })
                  },

                  getBetHistoryDetail: function() {

                        return betHistoryDetail;
                  }

            };

            return ServiceObject;
      }

})();
/**
 * Created by Emre on 23.06.2017.
 */

(function () {
      'use strict';

      var path = 'app/profile/betHistory/betHistoryDetail/directives';

      angular
          .module('novusTerminal')
          .directive('aptBetHistoryDetailContent', DirectiveFn);

      function DirectiveFn() {
            return {
                  restrict: 'EA',
                  scope: {},
                  bindToController: true,
                  controller: ControllerFn,
                  controllerAs: 'vmBetHistoryDetailContent',
                  templateUrl: function (elem, attrs) {
                        if (attrs.template) {
                              return path + '/betHistoryDetailContent.' + attrs.template + '.html';
                        } else {
                              return path + '/betHistoryDetailContent.html';
                        }
                  }
            }
      }

      ControllerFn.$inject = ['BetHistoryDetailService','TicketEventService','$location','printManagerService'];
      function ControllerFn(BetHistoryDetailService,TicketEventService, $location, printManagerService) {
            var vm = this;
          vm.betHistoryDetail = BetHistoryDetailService.getBetHistoryDetail();
          vm.placedTicketData = TicketEventService.getLastPlaceBetTicketData();

		vm.printCopyTicket = printCopyTicketFn;

		function printCopyTicketFn() {

            var previousState = encodeURIComponent($location.path());

            var path = '/print-manager/copyTicket/' + vm.betHistoryDetail.code + '/' + previousState;
            return $location.path(path);
		}
      }

})();
/**
 * Created by unal on 7/14/2017.
 */
(function () {
	angular.module('novusTerminal').factory('TicketPrintService', ServiceFn);
	ServiceFn.$inject = [
		'TicketModel',
		'UtilsService',
		'ToastrNotificationService',
		'$uibModal',
		'$window',
		'$timeout'
	];
	function ServiceFn(TicketModel, UtilsService, ToastrNotificationService, $uibModal, $window, $timeout) {
		var ticketPrintData = {};
		var ticketPrinterData = {
			tournaments: []
		};
		var serviceObj = {
			loadPrint: function (ticketCode) {
				return TicketModel.one('set-print').post(undefined, {ticket_code: ticketCode}).then(function (data) {
					// return TicketModel.one().post('set-print', {ticket_code: 'MBA-NZZW6KJN-105562'}).then(function (data) {
					UtilsService.removeAndMerge(ticketPrintData, data.data.ticket);
					UtilsService.removeObjectProperties(ticketPrinterData);
					ticketPrinterData.tournaments = [];
					setPrintDataForPrinter();
				}).catch(function (res) {
					ToastrNotificationService.notificationPopUp(res.data.error_message, 'error');
				})
			},
			getPrintData: function () {
				return ticketPrinterData;
			},
			openTicketPopToPrint: function (ticketCode) {

				this.loadPrint(ticketCode).then(function () {
					var printModalInstance = $uibModal.open({
						template: '<data-nvs-ticket-print-popup></data-nvs-ticket-print-popup>',
						size: 'xs',
						controller: function () {

						},
						controllerAs: 'TicketPrint'
					});
					printModalInstance.rendered.then(function () {
						var data = $window.document.getElementById('print-content').innerHTML;
						var printWindow = $window.open('', 'Print Ticket', 'height=1000,width=1600');
						printWindow.document.write('<html><head><title>Print Ticket</title>');
						printWindow.document.write('</head><body >');
						printWindow.document.write(data);
						printWindow.document.write('</body></html>');
						$timeout(function () {
							printWindow.print();
							printWindow.close();
							printModalInstance.close();
						});
						return true;
					});
				});

			}
		};

		function setPrintDataForPrinter() {
			_.forEach(ticketPrintData.items, function (item) {
				if (_.findIndex(ticketPrinterData.tournaments, {tournament_id: item.tournament_id}) >= 0) {
					var ticketPrintDataTournament = _.find(ticketPrinterData.tournaments, {tournament_id: item.tournament_id});
					if (!_.has(ticketPrintDataTournament, 'events')) {
						ticketPrintDataTournament.events = [];
					}
					// ticketPrintDataTournament.events.push(item);
					if (_.findIndex(ticketPrintDataTournament.events, {event_id: item.event_id}) >= 0) {
						var ticketPrintDataEvent = _.find(ticketPrintDataTournament.events, {event_id: item.event_id});

						if (!_.has(ticketPrintDataEvent, 'items')) {
							ticketPrintDataEvent.items = [];
						}
						ticketPrintDataEvent.items.push(item);
					} else {
						// ticketPrinterData.events = [];
						var newTicketEvent = {
							event_id: item.event_id,
							group_id: item.group_id,
							event_name: item.event_name,
							date: moment(item.event_date).format('DD/MM/YYYY HH:mm:ss'),
							code: item.event_code,
							is_live: item.is_live,
							items: [],
							category: {},
							sport: {},
							tournament: {}
						};
						_.merge(newTicketEvent.category, item.category);
						_.merge(newTicketEvent.sport, item.sport);
						_.merge(newTicketEvent.tournament, item.tournament);
						newTicketEvent.items.push(item);
						ticketPrintDataTournament.events.push(newTicketEvent);
					}
				} else {
					var newTicketTournament = {
						sport: {},
						tournament: {},
						category: {},
						tournament_id: item.tournament_id,
						events: []
					};
					_.merge(newTicketTournament.category, item.category);
					_.merge(newTicketTournament.sport, item.sport);
					_.merge(newTicketTournament.tournament, item.tournament);
					var newTicketInitEvent = {
						event_id: item.event_id,
						group_id: item.group_id,
						event_name: item.event_name,
						date: moment(item.event_date).format('DD/MM/YYYY HH:mm:ss'),
						code: item.event_code,
						is_live: item.is_live,
						items: [],
						category: {},
						sport: {},
						tournament: {}
					};
					_.merge(newTicketInitEvent.category, item.category);
					_.merge(newTicketInitEvent.sport, item.sport);
					_.merge(newTicketInitEvent.tournament, item.tournament);
					newTicketInitEvent.items.push(item);
					newTicketTournament.events.push(newTicketInitEvent);
					ticketPrinterData.tournaments.push(newTicketTournament);
				}
			});
			_.merge(ticketPrinterData, ticketPrintData);
		}

		return serviceObj;
	}
})();

/**
 * Created by Emre on 8.07.2017.
 */
(function () {
    'use strict';
    var path = 'app/nvsTicket/directives/novusCheckout/directives';
    angular.module('novusTerminal').directive('nvsTicketPrintPopup', DirectiveFn);
    function DirectiveFn() {
        return {
            restrict: 'EA',
            scope: {},
            bindToController: {
                closePopupAuto: '&'
            },
            controller: ControllerFn,
            controllerAs: 'vmTicketPrintPopup',
            templateUrl: function (elem, attr) {
                if (attr.template) {
                    return path + '/ticket-print-popup.' + attr.template + '.html';
                } else {
                    return path + '/ticket-print-popup.html';
                }
            }
        }
    }
    ControllerFn.$inject = [
        'TicketPrintService',
        'nvsConstant'
    ];
    function ControllerFn(TicketPrintService, nvsConstant) {
        var vm = this;
        vm.printData = TicketPrintService.getPrintData();
        vm.barCode = nvsConstant.ticketBarcodeUnique + vm.printData.code.split('-')[1];
        vm.barcodeOptions = {
            width: 2,
            height: 100,
            quite: 10,
            displayValue: false,
            font: "monospace",
            textAlign: "center",
            fontSize: 12,
            backgroundColor: "",
            lineColor: "#000"
        };
        var qrCodeData = new QRious({
            value: nvsConstant.ticketQrCodeUnique + vm.printData.code,
            size: 200
        });
        vm.qrCodeImage = qrCodeData.toDataURL();
    }
})();

/**
 * Created by unal on 10.04.2017.
 */



(function () {

	var path = 'app/user/register/registerForm';

	angular
		.module('novusTerminal')
		.directive('aptRegisterForm', DirectiveFn);

	function DirectiveFn() {
		return {
			restrict: 'EA',
			scope: {},
			bindToController: {
				closePopup: '&'
			},
			controller: ControllerFn,
			controllerAs: 'vmRegisterForm',
			templateUrl: function (elem, attrs) {
				if (attrs.template) {
					return path + '/register-form.' + attrs.template + '.html';
				} else {
					return path + '/register-form.html';
				}
			}
		}
	}

	ControllerFn.$inject = [
		'CreatePopupComponentService',
		'RegisterService',
		'languageService'
	];
	function ControllerFn(CreatePopupComponentService, RegisterService, languageService) {
		var vm = this;

		// seçili dil objesini getirir
		vm.language = languageService.getSelectedLanguage();
		vm.loginForm = loginFormFn;
		vm.close = closeFn;
		vm.register = registerFn;
		vm.data = RegisterService.getRegisterData();
		vm.settings = RegisterService.getSettings();
		vm.validOnlyText = /^([^0-9-!$%^&*()_+|~=`{}\[\]:";'<>?,.\/]*)$/;
		vm.email = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;;
		vm.password = /^(?=.*[0-9])(?=.*[a-zA-Z])([a-zA-Z0-9!"#$%&()\*\+,-.\/\@[\]^_`{}~]+)$/;
		function loginFormFn() {
			var componentSetting = {
				name: 'login-form'
			};
			CreatePopupComponentService.createPopupComponent(componentSetting);
			closeFn();
		}

		function closeFn() {
			if (_.isFunction(vm.closePopup)) {
				vm.closePopup({ data: false });
			}

		}
		vm.passwordValid = true;
		function validatePassword(password) {
			var regexp = /^(?=.*[0-9])(?=.*[a-zA-Z])([a-zA-Z0-9!"#$%&()\*\+,-.\/\@[\]^_`{}~]+)$/; // at least 1 char and 1 number
			vm.passwordValid = regexp.test(password);
			if (password.length < 8) {
				debugger
				vm.lengthError = true;
			} else {
				vm.lengthError = false;
			}
		}
		function registerFn() {
			RegisterService.register(vm.data).then(function (res) {
				if (!res) {
					
					return;
				} else if(res = true) {
					vm.data = {};
					closeFn();
				  //loginFormFn();
					return;
				}
			});

		}
	}

})();
/**
 * Created by unal on 22.05.2017.
 */



(function () {

      angular
              .module('novusTerminal')
              .factory('OddsService', ServiceFn);

      ServiceFn.$inject = [
            'OddsModelService',
            'TimeFrameService',
            'DateFormatService',
            'ExtraOddsModelService',
            'CategoryService'
      ];
      function ServiceFn(OddsModelService, TimeFrameService, DateFormatService, ExtraOddsModelService, CategoryService) {


            var oddsTournaments = [];

            var defaultMarketsBar = [];

            var extraOddsEventData = [];


            var oddsPageUiSetting = {
                  tournamentSelection: false,
                  loadingBar: false,
                  extraOddsLoadingBar: false,
                  loadingBarMarketGroup: false
            };

            var serviceObj = {

                  loadSelectedTournament: function (tournamentIds) {

                        _.merge(oddsPageUiSetting, {loadingBar: true});

                        return OddsModelService.post({
                              tournament_ids: _.isArray(tournamentIds) ? tournamentIds : [tournamentIds],
                              tf:TimeFrameService.getSelectedTimeFrameStatus()


                        }).then(function (data) {

                              if (data.data.tournaments.length == 0) {
                                    _.merge(oddsPageUiSetting, {loadingBar: false});
                                    return false;
                              }

                              oddsTournaments.push(data.data.tournaments[0]);

                              setOddsPageDefaultMarketsBar(data.data.tournaments[0]);

                              setEventsDateAndTime();
                              setDefaultMarketGroupSelected();

                              _.merge(oddsPageUiSetting, {loadingBar: false});

                              return true;
                        }).catch(function (res) {
					_.merge(oddsPageUiSetting, {loadingBar: false});
				});

                  },

                  getOddsPageUiSetting: function () {
                        return oddsPageUiSetting;
                  },

                  getTournaments: function () {
                        return oddsTournaments;
                  },

                  getDefaultMarketBar: function () {
                        return defaultMarketsBar;
                  },

                  checkTournamentSelected: function (tournamentId) {
                        var idx = _.findIndex(oddsTournaments, {tournament_id: tournamentId});
                        return idx >= 0 ? true : false;
                  },

                  removeSelectedTournament: function (tournamentId) {
                        var idx = _.findIndex(oddsTournaments, {tournament_id: tournamentId});

                        if (idx < 0) {
                              return;
                        }
                        oddsTournaments.splice(idx, 1);
                  },


                  loadSelectedMarketGroup: function (tournamentId, marketGroupId) {
                        var tournamentIds = [];

                        tournamentIds.push(tournamentId);
                        _.merge(oddsPageUiSetting, {loadingBarMarketGroup: true});

                        OddsModelService.post({
                              tournament_ids: tournamentIds,
                              market_group_id: marketGroupId,
                              tf: TimeFrameService.getSelectedTimeFrameStatus()
                        }).then(function (item) {

                              /**
                               *that if control make if selected market group has no data
                               * remove market group active
                               */
                              ///////////////////////////////////////////////////////////
                              if (item.data.tournaments.length <= 0) {
                                    var hasNoMarketGroupTournament = _.find(oddsTournaments, {tournament_id: tournamentId});
                                    var emptyMarketGroup = _.find(hasNoMarketGroupTournament.market_groups, {market_group_id: marketGroupId});
                                    emptyMarketGroup.selected = false;
                                    return;
                              }


                              _.merge(oddsPageUiSetting, {loadingBarMarketGroup: false});

                              var tournament = _.find(oddsTournaments, {tournament_id: item.data.tournaments[0].tournament_id});
                              if (!tournament) {
                                    return;
                              }
                              tournament.marketGroupEvents.push(setTournamentMarketGroupEvents(item.data.tournaments[0].marketGroupEvents[0]));

                        });
                  },

                  removeSelectedMarketGroupEvent: function (tournamentId, marketGroupId) {
                        var tournament = _.find(oddsTournaments, {tournament_id: tournamentId});
                        var marketGroupIdx = _.findIndex(tournament.marketGroupEvents, {market_group_id: marketGroupId});
                        tournament.marketGroupEvents.splice(marketGroupIdx, 1);
                  },

                  loadEventExtraOdds: function (eventId) {
                        ExtraOddsModelService.post({
                              event_id: eventId
                        }).then(function (data) {
                              _.merge(extraOddsEventData, data.data.markets);

                        });
                  },

                  getExtraOddsEventMarket: function () {
                        return extraOddsEventData;
                  },

                  loadReloadPageTournaments: function (tournamentIds) {

                        _.merge(oddsPageUiSetting, {loadingBar: true});

                        OddsModelService.post({
                              tournament_ids: _.isArray(tournamentIds) ? tournamentIds : [tournamentIds],
                              tf: TimeFrameService.getSelectedTimeFrameReqValue()
                        }).then(function (data) {


                              _.forEach(data.data.tournaments, function (tournament) {
                                    oddsTournaments.push(tournament);
                                    setOddsPageDefaultMarketsBar(tournament);
                                    CategoryService.setLeftSideBarDisplaySetting(tournament);
                              });


                              setEventsDateAndTime();
                              setDefaultMarketGroupSelected();

                              _.merge(oddsPageUiSetting, {loadingBar: false});
                        });

                  },

                  resetData: function () {
                        oddsTournaments.splice(0, oddsTournaments.length);

                        defaultMarketsBar.splice(0, defaultMarketsBar.length);
                  }

            };

            /**
             *its for main selected market group and all data
             */
            function setEventsDateAndTime() {
                  angular.forEach(oddsTournaments, function (tournament) {
                        angular.forEach(tournament.marketGroupEvents, function (marketEventGroup) {
                              if (_.has(marketEventGroup, 'eventGroups')) {
                                    return;
                              }
                              marketEventGroup.eventGroups = [];

                              marketEventGroup.marketNavBarLength = 0;
                              _.forEach(marketEventGroup.markets, function (market) {
                                    marketEventGroup.marketNavBarLength += market.odds.length;
                              });


                              angular.forEach(marketEventGroup.events, function (event) {


                                    event.time = DateFormatService.getMinuteHourMoment(event.date);
                                    var eventTimezoneDate = DateFormatService.getDateForOddsDataEventGroups(event.date);
                                    if (marketEventGroup.eventGroups.length == 0) {
                                          createNewEventGroup();
                                          return;
                                    }

                                    var eventGroupIdIdx = _.findIndex(marketEventGroup.eventGroups, {event_group_id: eventTimezoneDate});

                                    if (eventGroupIdIdx < 0) {
                                          createNewEventGroup();
                                          return;
                                    }

                                    var createdEventGroup = _.find(marketEventGroup.eventGroups, {event_group_id: eventTimezoneDate});
                                    createdEventGroup.events.push(event);

                                    function createNewEventGroup() {
                                          var initialEventGroup = {
                                                event_group_id: eventTimezoneDate,
                                                events: []
                                          };
                                          initialEventGroup.events.push(event);
                                          marketEventGroup.eventGroups.push(initialEventGroup);
                                    }

                              });

                              marketEventGroup.events.splice(0, marketEventGroup.events.length);

                        });

                  });
            };


            /**
             * its for only selected tournament other market group
             */
            function setTournamentMarketGroupEvents(marketEventGroup) {

                  marketEventGroup.eventGroups = [];


                  marketEventGroup.marketNavBarLength = 0;
                  _.forEach(marketEventGroup.markets, function (market) {
                        marketEventGroup.marketNavBarLength += market.odds.length;
                  });



                  angular.forEach(marketEventGroup.events, function (event) {

                        if (marketEventGroup.market_group_id == 9) {
                              _.forEach(event.markets, function (market) {
                                    _.forEach(market.rows, function (row) {
                                          if (market.column == row.odds.length) {
                                                return;
                                          }

                                          var odds = {
                                                name: '-',
                                                code: '-'
                                          };

                                          var oIdx = market.column - row.odds.length;

                                          for (var i = 0; i < oIdx; i++) {
                                                row.odds.push(odds);
                                          }

                                    })
                              })
                        }

                        event.time = DateFormatService.getMinuteHourMoment(event.date);
                        var eventTimezoneDate = DateFormatService.getDateForOddsDataEventGroups(event.date);
                        if (marketEventGroup.eventGroups.length == 0) {
                              createNewEventGroup();
                              return;
                        }

                        var eventGroupIdIdx = _.findIndex(marketEventGroup.eventGroups, {event_group_id: eventTimezoneDate});

                        if (eventGroupIdIdx < 0) {
                              createNewEventGroup();
                              return;
                        }

                        var createdEventGroup = _.find(marketEventGroup.eventGroups, {event_group_id: eventTimezoneDate});
                        createdEventGroup.events.push(event);

                        function createNewEventGroup() {
                              var initialEventGroup = {
                                    event_group_id: eventTimezoneDate,
                                    events: []
                              };
                              initialEventGroup.events.push(event);
                              marketEventGroup.eventGroups.push(initialEventGroup);
                        }

                  });

                  marketEventGroup.events.splice(0, marketEventGroup.events.length);

                  return marketEventGroup;
            }


            function setOddsPageDefaultMarketsBar(tournament) {
                  if (defaultMarketsBar.length > 0) {
                        return;
                  }

                  _.forEach(tournament.marketGroupEvents, function (marketGroup) {
                        _.merge(defaultMarketsBar, marketGroup.markets);
                  })
            }

            function setDefaultMarketGroupSelected() {
                  angular.forEach(oddsTournaments, function (tournament) {
                        angular.forEach(tournament.market_groups, function (market_group) {
                              if (market_group.name == 'Main') {
                                    market_group.selected = true;
                                    return;
                              }
                        })
                  });
            }

            return serviceObj;


      }

})();
/**
 * Created by unal on 18.05.2017.
 */



(function () {

      angular
            .module('novusTerminal')
            .config(InterceptorFn)
            .factory('OddsModelService', ServiceFn);


      InterceptorFn.$inject = ['RestangularProvider'];
      function InterceptorFn(RestangularProvider) {

            /**
             * The responseInterceptor is called after we get each response from the server.
             * It's a function that receives this arguments:

             data: The data received got from the server
             operation: The operation made. It'll be the HTTP method used except for a GET which returns a list of element which will return getList so that you can distinguish them.
             what: The model that's being requested. It can be for example: accounts, buildings, etc.
             url: The relative URL being requested. For example: /api/v1/accounts/123
             response: Full server response including headers
             deferred: The deferred promise for the request.
             */
            RestangularProvider.addResponseInterceptor(function (data, operation, what, url, response, deferred) {


                  // var auth = response.headers('auth');
                  return data;

            });


            /**
             * The requestInterceptor is called before sending any data to the server.
             * It's a function that must return the element to be requested. This function receives the following arguments:

             element: The element to send to the server.
             operation: The operation made. It'll be the HTTP method used except for a GET which returns a list of element which will return getList so that you can distinguish them.
             what: The model that's being requested. It can be for example: accounts, buildings, etc.
             url: The relative URL being requested. For example: /api/v1/accounts/123

             */
            RestangularProvider.addRequestInterceptor(function (data, operation, what, url) {

                  // var auth = $cookies.get('terminalAuth') || '';

                  // var languageId = 1;
                  // data.auth = auth;
                  // data.language_id = languageId;
                  return data;
            });

      }


      ServiceFn.$inject = ['ApiService'];
      function ServiceFn(ApiService) {
            var rest = ApiService.serviceOne();

            return rest.service('get-tournament-events-terminal');
      }


})();
/**
 * Created by unal on 18.05.2017.
 */



(function () {

      angular
            .module('novusTerminal')
            .config(InterceptorFn)
            .factory('ExtraOddsModelService', ServiceFn);


      InterceptorFn.$inject = ['RestangularProvider'];
      function InterceptorFn(RestangularProvider) {

            /**
             * The responseInterceptor is called after we get each response from the server.
             * It's a function that receives this arguments:

             data: The data received got from the server
             operation: The operation made. It'll be the HTTP method used except for a GET which returns a list of element which will return getList so that you can distinguish them.
             what: The model that's being requested. It can be for example: accounts, buildings, etc.
             url: The relative URL being requested. For example: /api/v1/accounts/123
             response: Full server response including headers
             deferred: The deferred promise for the request.
             */
            RestangularProvider.addResponseInterceptor(function (data, operation, what, url, response, deferred) {


                  // var auth = response.headers('auth');
                  return data;

            });


            /**
             * The requestInterceptor is called before sending any data to the server.
             * It's a function that must return the element to be requested. This function receives the following arguments:

             element: The element to send to the server.
             operation: The operation made. It'll be the HTTP method used except for a GET which returns a list of element which will return getList so that you can distinguish them.
             what: The model that's being requested. It can be for example: accounts, buildings, etc.
             url: The relative URL being requested. For example: /api/v1/accounts/123

             */
            RestangularProvider.addRequestInterceptor(function (data, operation, what, url) {

                  // var auth = $cookies.get('terminalAuth') || '';

                  // var languageId = 1;
                  // data.auth = auth;
                  // data.language_id = languageId;
                  return data;
            });

      }


      ServiceFn.$inject = ['ApiService'];
      function ServiceFn(ApiService) {
            var rest = ApiService.serviceOne();

            return rest.service('event-markets-refactor');
      }


})();
/**
 * Created by unal on 07.04.2017.
 */



(function () {

      var path = 'app/sport/oddsPage/directives';

      angular
            .module('novusTerminal')
            .directive('aptExtraOddsPage', DirectiveFn);

      function DirectiveFn() {
            return {
                  restrict: 'EA',
                  scope: {},
                  bindToController: {
                        event: '=?'
                  },
                  controller: ControllerFn,
                  controllerAs: 'vmExtraOddsPage',
                  templateUrl: function (elem, attrs) {
                        if (attrs.template) {
                              return path + '/extra-odds-page.' + attrs.template + '.html';
                        } else {
                              return path + '/extra-odds-page.html';
                        }
                  }
            }
      }

      ControllerFn.$inject = [
            'OddsService',
            'TicketEventService'
      ];
      function ControllerFn(OddsService, TicketEventService) {
            var vm = this;

            vm.extraOddsData = OddsService.getExtraOddsEventMarket();

            vm.checkOdds = checkOddsFn;
            vm.clickOdds = clickOddsFn;


            function clickOddsFn(odds,data) {
                  odds.market_name = data.name || '';
                  odds.market_id = data.market_id || '';
                  TicketEventService.manageClickedItem(vm.event, odds);
            }


            var clickedOddsEvents = TicketEventService.getClickedOddsEvents();

            function checkOddsFn(odds) {

                  if (clickedOddsEvents.length <= 0) {
                        return false;
                  }

                  var oIdx = _.findIndex(clickedOddsEvents, {event_odds_id: odds.event_odds_id});
                  return oIdx >= 0 ? true : false;

            }


      }

})();
/**
 * Created by Emre on 28.06.2017.
 */

(function () {
      'use strict';
      angular
          .module('novusTerminal')
          .factory('TransactionsService', ServiceFn);

      ServiceFn.$inject = ['TransactionsModelService', 'ToastrNotificationService'];
      function ServiceFn(TransactionsModelService, ToastrNotificationService) {
            var ServiceObject;
            var transactionsTotal = {};
            var transactions = [];
            ServiceObject = {

                  setTransactions: function(data) {
                        TransactionsModelService.post(data).then(function(response) {
                              _.merge(transactionsTotal, response.data);
                            _.remove(transactions);
                            _.merge(transactions, response.data.transaction);
                              _.merge(transactions, response.data.transaction);
                              if(!response.data.transaction.length > 0) {
                                    ToastrNotificationService.notificationPopUp('No Transaction', 'warning');
                              }
                        }, function(error) {
                              ToastrNotificationService.notificationPopUp(error.message, 'warning');
                        })
                  },

                  getTransactions: function() {

                        return transactions;
                  },

                  getTransactionsTotal: function() {
                        return transactionsTotal;
                  }

            };

            return ServiceObject;
      }

})();
/**
 * Created by Emre on 28.06.2017.
 */

(function () {
      'use strict';
      angular
          .module('novusTerminal')
          .config(InterceptorFn)
          .factory('TransactionsModelService', ServiceFn);

      InterceptorFn.$inject = ['RestangularProvider'];
      function InterceptorFn(RestangularProvider) {

            RestangularProvider.addResponseInterceptor(function (data, operation, what, url, response, deferred) {
                  return data;
            });

            RestangularProvider.addRequestInterceptor(function (data, operation, what, url) {
                  return data;
            });
      }

      ServiceFn.$inject = ['ApiService'];
      function ServiceFn(ApiService) {

            var rest = ApiService.serviceOne();

            return rest.service('user/transactions');

      }

})();
/**
 * Created by unal on 17.05.2017.
 */



(function () {

      angular
              .module('novusTerminal')
              .factory('SessionService', ServiceFn);

      ServiceFn.$inject = [
            'SessionModelService',
            'ToastrNotificationService'];
      function ServiceFn(SessionModelService, ToastrNotificationService) {

            var sessions = [];

            var sessionPageSetting = {
                  showLoadingBar: false,
                  showSessionList: false
            };

            var serviceObj = {

                  loadSessions: function (requestData) {
                        resetData();
                        _.merge(sessionPageSetting, {showLoadingBar: true});
                        _.merge(sessionPageSetting, {showSessionList: false});
                        SessionModelService.post(requestData).then(function (res) {
                              _.merge(sessions, res.data.sessions);
                              _.merge(sessionPageSetting, {showLoadingBar: false});
                              if (sessions.length > 0) {
                                    _.merge(sessionPageSetting, {showSessionList: true});

                              } else {
                                    _.merge(sessionPageSetting, {showSessionList: false});
                              }

                        }).catch(function (res) {
                              _.merge(sessionPageSetting, {showLoadingBar: false});
                              ToastrNotificationService.notificationPopUp(res.data.error_message, 'error', 'Error');
                        })
                  },

                  getSessions: function () {
                        return sessions;
                  },

                  getSessionSetting: function () {
                        return sessionPageSetting;
                  }

            };


            function resetData() {
                  sessions.splice(0, sessions.length);
            }

            return serviceObj;
      }

})();
/**
 * Created by unal on 18.05.2017.
 */



(function () {

        angular
                  .module('novusTerminal')
                  .config(InterceptorFn)
                  .factory('SessionModelService', ServiceFn);


        InterceptorFn.$inject = ['RestangularProvider'];
        function InterceptorFn(RestangularProvider) {


                RestangularProvider.addResponseInterceptor(function (data, operation, what, url, response, deferred) {


                        // var auth = response.headers('auth');
                        return data;

                });

                RestangularProvider.addRequestInterceptor(function (data, operation, what, url) {

                        if (what !== 'user/sessions') {
                                return data;
                        }

                        return data;
                });

        }

        ServiceFn.$inject = ['ApiService'];
        function ServiceFn(ApiService) {
                var rest = ApiService.serviceOne();

                return rest.service('user/sessions');
        }


})();
/**
 * Created by unal on 10.04.2017.
 */



(function () {

      var path = 'app/profile/sessions/directives';

      angular
              .module('novusTerminal')
              .directive('aptSessionList', DirectiveFn);

      function DirectiveFn() {
            return {
                  restrict: 'EA',
                  scope: {},
                  bindToController: true,
                  controller: ControllerFn,
                  controllerAs: 'vmSessionList',
                  templateUrl: function (elem, attrs) {
                        if (attrs.template) {
                              return path + '/session-list.' + attrs.template + '.html';
                        } else {
                              return path + '/session-list.html';
                        }
                  }
            }
      }

      ControllerFn.$inject = [
            'SessionService'
      ];
      function ControllerFn(SessionService) {
            var vm = this;

            vm.sesionList = SessionService.getSessions();
            vm.sessionListSetting = SessionService.getSessionSetting();

            vm.paginationOptions = {
                  maxSize: 5,
                  currentPage: 1,
                  itemsPerPage: 10
            };

            vm.setPage = setPageFn;

            function setPageFn() {
                  var a = vm.paginationOptions.currentPage;
            }


      }

})();
/**
 * Created by unal on 10.04.2017.
 */



(function () {

        var path = 'app/profile/sessions/directives';

        angular
                  .module('novusTerminal')
                  .directive('aptSessionFilter', DirectiveFn);

        function DirectiveFn() {
                return {
                        restrict: 'EA',
                        scope: {},
                        bindToController: true,
                        controller: ControllerFn,
                        controllerAs: 'vmSessionFilter',
                        templateUrl: function (elem, attrs) {
                                if (attrs.template) {
                                        return path + '/session-filter.' + attrs.template + '.html';
                                } else {
                                        return path + '/session-filter.html';
                                }
                        }
                }
        }

        ControllerFn.$inject = [
                'CalendarConfigurationService',
                'SessionService'];
        function ControllerFn(CalendarConfigurationService, SessionService) {
                var vm = this;

                vm.dateOptions = CalendarConfigurationService.getCalendarOptions();
                vm.date = CalendarConfigurationService.getInitTimeForCalendar();

                vm.search = searchFn;

                var requestData = {
                        start_time: '',
                        end_time: ''
                };


                function searchFn() {
                        setRequestDate();
                        SessionService.loadSessions(requestData);
                }

                function setRequestDate() {
                        var dbDate=CalendarConfigurationService.getTimeForDbRecord(vm.date);
                        requestData.start_time=dbDate.startDate;
                        requestData.end_time=dbDate.endDate;
                }

        }

})();
/**
 * Created by Byn on 9.07.2017.
 */
(function () {

      angular.module('novusTerminal').factory('RevenueReportService', ServiceFn);

      ServiceFn.$inject = ['RevenueReportModel', 'UserTreeService', 'UserService', 'UtilsService', 'PopupComponentService', 'DateTimeToReqConvertService'];


      function ServiceFn(RevenueReportModel, UserTreeService, UserService, UtilsService, PopupComponentService, DateTimeToReqConvertService) {

            var defaultFilterData = {
                  pin: '',
                  provider: 'all',
                  viewMethod: 'all',
                  product: 'sportsbook',
                  platform: 'desktop',
                  ticketType: 'open'
            };
            var pageSettings = {
                  offset: 0,
                  currentPage: 1,
                  itemPerPage: 50,
            };
            var dateOptions;
            var selectedGroup = {};
            var dataLoadingStatus = {};
            var user = {};
            var reportList = [];
            var requestData = {};
            var serviceObj = {
                  getFilterData: function () {
                        return defaultFilterData;
                  },
                  setUser: function () {
                        user = UserService.getUser();
                  },
                  getUser: function () {
                        return user;
                  },
                  loadReportList: function () {
                        setLoadingBarInitial(true, true);
                        RevenueReportModel.post(requestData).then(function (res) {
                              if (requestData.ticket_status === "all") {
                                    UtilsService.removeAndMerge(reportList, UserTreeService.UserTree([res.data.tree.all]));
                              } else {
                                    UtilsService.removeAndMerge(reportList, UserTreeService.UserTree([res.data.tree]));
                              }
                              setUserTreeStatus();
                              setSubAccountsView();
                              setLoadingBarInitial(false, true);
                        });
                  },
                  getReportList: function () {
                        return reportList;
                  },
                  getSelectedGroup: function () {
                        return selectedGroup;
                  },
                  setRequestDataDateTime: function (dateTime) {
                        setRequestDataDateTime(dateTime);
                  },
                  setRequestData: function (data) {
                        requestData.type = data.product;
                        requestData.provider = data.provider;
                        requestData.pin = data.pin;
                        requestData.platform = data.platform;
                        if (data.product === 'sportsbook') {
                              requestData.ticket_status = data.ticketStatus;
                        } else {
                              requestData.provider = data.provider;
                        }
                        serviceObj.loadReportList();
                  },
                  getLoadingStatus: function () {
                        return dataLoadingStatus;
                  },
                  getDate: function () {
                        return date;
                  },
                  getDateOptions: function () {
                        return dateOptions;
                  },
                  getPageSettings: function () {
                        return pageSettings;
                  },
                  getParameter: function (parameter) {
                        return UserService.getParameterValue(parameter);
                  },
                  verifyPinCode: function (pinValue) {
                        PopupComponentService.openPinPopup(pinValue);
                  },
                  resetAllFilters: function () {
                        defaultFilterData = {
                              pin: '',
                              provider: 'all',
                              viewMethod: 'all',
                              product: 'sportsbook',
                              platform: 'desktop',
                              ticketType: 'open'
                        };
                  }
            };

            function setLoadingBarInitial(loadStatus, searchStatus) {
                  _.merge(dataLoadingStatus, {isLoading: loadStatus, isSearched: searchStatus});
            }

            function setUserTreeStatus() {
                  reportList.users[user.id].isOpen = true;
            }

            function setSubAccountsView() {
                  _.forEach(reportList.users, function (user) {
                        if (!user.id) {
                              return;
                        }
                        if (!_.has(user, 'childUsers') || user.childUsers.length <= 0) {
                              return;
                        }
                        if (user === user.id) {
                              reportList.users[user.id].isOpen = true;
                        }
                        if (defaultFilterData.viewMethod == 'all') {
                              reportList.users[user.id].isOpen = true;
                        }
                  })
            }

            function setRequestDataDateTime(dateTime) {
                  /**
                   *for req param db date time format
                   */
                  var dbReqDateTimeParam = DateTimeToReqConvertService.getDateTimeForDbRequest(dateTime);

                  requestData.from_date = dbReqDateTimeParam.startDate;
                  requestData.to_date = dbReqDateTimeParam.endDate;
            }

            return serviceObj;
      }

})();
/**
 * Created by Byn on 9.07.2017.
 */
(function () {

      angular.module('novusTerminal').factory('RevenueReportModel', ServiceFn);

      ServiceFn.$inject = ['ApiService'];
      function ServiceFn(ApiService) {
            var rest = ApiService.serviceOne();

            return rest.service('reports/get');
      }
})();
/**
 * Created by unal on 17.05.2017.
 */



(function () {

        angular
                  .module('novusTerminal')
                  .factory('RegisterOptionService', ServiceFn);

        ServiceFn.$inject = [
                'RegisterModelService'
        ];
        function ServiceFn(RegisterModelService) {

                var timezonesData = [];
                var currency = [];
                var country = [];
                var genders = [];

                var serviceObj = {
                        loadOptions: function () {
                                resetOptions();
                                RegisterModelService.one().post('options').then(function (res) {
                                        _.merge(timezonesData, res.data.timezone);
                                        _.merge(currency, res.data.currencies);
                                        _.merge(country, res.data.countries);
                                        _.merge(genders, res.data.genders);
                                })
                        },

                        getTimezonesData: function () {
                                return timezonesData;
                        },

                        getCurrency: function () {
                                return currency;
                        },

                        getCountry: function () {
                                return country;
                        },

                        getGenders: function () {
                                return genders;
                        }
                };

                function resetOptions() {
                        timezonesData.splice(0, timezonesData.length);
                        country.splice(0, country.length);
                        currency.splice(0, currency.length);
                        genders.splice(0, genders.length);
                }

                return serviceObj;
        }

})();
/**
 * Created by unal on 17.05.2017.
 */



(function () {

      angular
              .module('novusTerminal')
              .factory('PersonalDetailService', ServiceFn);

      ServiceFn.$inject = [
            'PersonalDetailModelService',
            'UtilsService',
            'ToastrNotificationService',
            'UserModelService',
            'UserService'
      ];
      function ServiceFn(PersonalDetailModelService, UtilsService, ToastrNotificationService, UserModelService, UserService) {


            var personalData = {};

            var serviceObj = {

                  resetPersonalData: function () {
                        UtilsService.removeObjectProperties(personalData);
                  },

                  loadPersonalDetail: function () {
                        PersonalDetailModelService.post().then(function (res) {
                              UtilsService.removeAndMerge(personalData, res.data.user);
                        }).catch(function (res) {
                              ToastrNotificationService.notificationPopUp(res.data.error_message, 'error', 'Error');
                        })
                  },

                  getPersonalDetail: function () {
                        return personalData;
                  },

                  updateUserTimezone: function (timezone) {
                        UserModelService.one().post('change-timezone', {'timezone_value': timezone}).then(function (res) {
                              UserService.setUserTimezone(res.data.user.timezone_value);
                              moment.tz.setDefault(res.data.user.timezone_value);
                              ToastrNotificationService.notificationPopUp('timezone_has_been_updated', 'success');
                        })
                  }

            };


            return serviceObj;
      }

})();
/**
 * Created by unal on 18.05.2017.
 */



(function () {

        angular
                  .module('novusTerminal')
                  .config(InterceptorFn)
                  .factory('PersonalDetailModelService', ServiceFn);


        InterceptorFn.$inject = ['RestangularProvider'];
        function InterceptorFn(RestangularProvider) {


                RestangularProvider.addResponseInterceptor(function (data, operation, what, url, response, deferred) {


                        if (what !== 'user/profile2') {
                                return data;
                        }

                        return data;

                });

                RestangularProvider.addRequestInterceptor(function (data, operation, what, url) {

                        if (what !== 'user/profile2') {
                                return data;
                        }

                        return data;
                });

        }

        ServiceFn.$inject = ['ApiService'];
        function ServiceFn(ApiService) {
                var rest = ApiService.serviceOne();

                return rest.service('user/profile2');
        }


})();
/**
 * Created by Serkan
 */
(function () {
    angular.module('novusTerminal').controller('MoneywithdrawManagerCtrl', ControllerFn);
    ControllerFn.$inject = ['NotifyingService', 'MoneyTransferService', 'UserService', 'ApiService', 'TranslateService', '$rootScope', '$scope', '$location', '$compile', 'VoucherModelService','$cookies'];
    function ControllerFn(NotifyingService, MoneyTransferService, UserService, ApiService, TranslateService, $rootScope, $scope, $location, $compile, VoucherModelService,$cookies) {
        var vm = this;
        $scope.currentBankTab = 2;
        vm.isAmount = true;
        $scope.activeTabs = [];


        vm.user = {};
        vm.isUser = 1;
        vm.setActiveTab = function (tabKey) {
            vm.activeTab = tabKey;
        };
        vm.isTabSet = function (tab) {
            return vm.activeTab === tab;
        };

        // vm.decrease = decreaseFn;
        //vm.increase = increaseFn;
        //vm.user = UserService.getUser();
        vm.inputData = {
            accountHolder: '',
            accountNumber: '',
            accountType: '',
            bank: '',
            email: '',
            phone: '',
            amount: ''
        };
        vm.transactionInfo = {};
        vm.mtoken= $cookies.get('mtoken');
        vm.url = $cookies.get('cashier');
        //http://localhost:3000/?cashier=http://api.desktop.dev.betnovus.tech&mtoken=mqF0ww4bZxcYlVO9A0Q3RGLvt2QhPNQCevoYr12YOMini6IidMHKmT0Ma4YM#/profile/money/money-deposit
        vm.text = '?cashier=' + vm.url + '&mtoken=' + vm.mtoken;
        VoucherModelService.post({ slug: 'withdraw', mUrl: vm.text }).then(function (res) {
            setTimeout(function () {
                $('#money_container').html($compile($(res))($scope));
            });
        });
        vm.showMethod = function (data) {
            vm.apCoPayData = null;
            if (data && typeof data === 'number') {
                VoucherModelService.post({ slug: 'withdraw', id: data }).then(function (res) {
                vm.paymentMethod = res;
                    $('.methodContainer').html($compile($(vm.paymentMethod))($scope));
                    vm.stuffToDoWithTheDom();
                    vm.activeTab = data;
                }).error(function (res) {
                    console.log(res);
                });
            } else {
                $location.path('/' + data);
            }
        };


    }
})();

/**
 * Created by unal on 24.01.2017.
 */



(function () {

      angular
            .module('novusTerminal')
            .factory('MoneyTransferService', ServiceFn);

      ServiceFn.$inject = ['CalendarConfigurationService', 'TicketStakeButtonService', 'apiService'];
      function ServiceFn(CalendarConfigurationService, TicketStakeButtonService, apiService) {

            var months = [];

            var years = [];

            var monthsName = [];

            var serviceObj = {
                  setMonths: function () {
                        months.splice(0, months.length);
                        monthsName.splice(0, monthsName.length);
                        setMonthsName();
                        for (var i = 1; i <= 12; i++) {
                              var monthName = _.find(monthsName, {id: i});
                              var month = {
                                    value: monthName.month + ' ' + '(' + (i < 10 ? '0' + i : i) + ')',
                                    month: i
                              };
                              months.push(month);
                        }

                  },

                  getMonths: function () {
                        return months;
                  },

                  setYears: function () {
                        years.splice(0, years.length);
                        var startYear = moment().year();
                        var finishYear = startYear + 10;
                        for (startYear; startYear <= finishYear; startYear++) {
                              var year = {
                                    year: startYear
                              };

                              years.push(year);
                        }
                  },

                  getYears: function () {
                        return years;
                  },

                  resetMoneyDate: function () {
                        months.splice(0, months.length);
                        years.splice(0, years.length);
                        monthsName.splice(0, monthsName.length);
                  },

                  getMonetIncreaseValue: function () {
                        return TicketStakeButtonService.getFirstStakeButtonsValue();
                  },

                  moneyTransfer: function (data) {
                        return apiService.call('', data);
                  },
                  getContent: function (data) {
                        return apiService.call('content', data);
                  },

            };

            function setMonthsName() {
                  var mIdx = 1;
                  var dateOptions = CalendarConfigurationService.get();
                  angular.forEach(dateOptions.locale.monthNames, function (month) {
                        monthsName.push({id: mIdx, month: month});
                        mIdx++;
                  })
            }

            return serviceObj;
      }

})();
/**
 * Created by unal on 10.04.2017.
 */



(function () {

      var path = 'app/profile/personalDetails/directives';

      angular
              .module('novusTerminal')
              .directive('aptPersonalDetailForm', DirectiveFn);

      function DirectiveFn() {
            return {
                  restrict: 'EA',
                  scope: {},
                  bindToController: true,
                  controller: ControllerFn,
                  controllerAs: 'vmPersonalDetailForm',
                  templateUrl: function (elem, attrs) {
                        if (attrs.template) {
                              return path + '/personal-detail-form.' + attrs.template + '.html';
                        } else {
                              return path + '/personal-detail-form.html';
                        }
                  }
            }
      }

      ControllerFn.$inject = [
            'PersonalDetailService',
            'RegisterOptionService'
      ];
      function ControllerFn(PersonalDetailService, RegisterOptionService) {
            var vm = this;

            vm.personalData = PersonalDetailService.getPersonalDetail();

            vm.timezones = RegisterOptionService.getTimezonesData();
            vm.currencies = RegisterOptionService.getCurrency();
            vm.countries = RegisterOptionService.getCountry();
            vm.genders = RegisterOptionService.getGenders();
            vm.dates = dateFunction();
            vm.months = mounthFunction();
            vm.years = yearsFunction();
            function dateFunction(){
                  var dates=[];
                  for(var i=1; i<32; i++){
                        dates.push(i);
                }
                return dates;
            }
          function mounthFunction(){
              var mounths=[];
              for(var i=1; i<13; i++){
                  mounths.push(i);
              }
              return mounths;
          }
          function yearsFunction(){
              var years=[];
              for(var i=2018-80; i<2019; i++){
                  years.push(i);
              }
              return years;
          }

            vm.updateTimezone = updateTimezoneFn;
            function updateTimezoneFn() {
                  PersonalDetailService.updateUserTimezone(vm.personalData.timezone_value);
                /*  accountServices.changeTimezone($scope.data.timezone_value).success(function (res) {
                        $rootScope.user.timezone_value = res.data.user.timezone_value;
                        moment.tz.setDefault(res.data.user.timezone_value);
                        TranslateService.translate('timezone_has_been_updated', 'success');
                  });*/
            };

      }

})();
/**
 * Created by unal on 17.03.2017.
 */

(function () {
    angular
        .module('novusTerminal')
        .factory('VoucherService', ServiceFn);

    ServiceFn.$inject = ['ApiService', '$uibModal', '$location', 'VoucherModelService', 'VoucherListSearchtModelService', 'VoucherListCreateService', 'VoucherListModelService'];
    function ServiceFn(ApiService, $uibModal, $location, VoucherModelService, VoucherListSearchtModelService, VoucherListCreateService, VoucherListModelService) {
        var voucherData = {};
        var voucherList = [];
        var voucherTotalData = {};
        var voucherButtonSetting = {
            printTicketButtonStatus: true,
            exportTicketButtonStatus: true,
        };
        var serviceObj = {
            reset: function () {
                voucherList.splice(0, voucherList.length);
                removeObjectProperties(voucherData);
                removeObjectProperties(voucherTotalData);
                _.merge(voucherButtonSetting, {
                    printTicketButtonStatus: true,
                    exportTicketButtonStatus: true,
                });
            },

            create: function (amount, currencyId) {
                return VoucherListCreateService.post({
                    platform: 'terminal',
                    amount: amount,
                    currencyId: currencyId
                }).then(function (res) {
                    removeAndMerge(voucherData, res.data.voucher);
                    voucherList.push(res.data.voucher);
                    _.merge(voucherButtonSetting, {
                        printTicketButtonStatus: false,
                        exportTicketButtonStatus: false,
                    });
                });
            },

            printVoucher: function (code) {
                var previousState = encodeURIComponent($location.path());
                var path = '/print-manager/voucher/' + code + '/' + previousState;
                return $location.path(path);
            },
            exportVoucher: function () {
                var exportPopUp = $uibModal.open({
                    templateUrl: 'app/profile/money/voucher/voucher-export-popup.html',
                    size: 'lg',
                    backdrop: 'static',
                    keyboard: false,
                    controller: ['$scope', 'DateFormatService', '$rootScope', function ($scope, DateFormatService, $rootScope) {
                        $scope.voucherExportData = voucherData;
                        $scope.createdHour = DateFormatService.getMinuteHourMomentSecond($scope.voucherExportData.created_at);
                        $scope.expHour = DateFormatService.getMinuteHourMomentSecond($scope.voucherExportData.expiration_date);
                        $scope.barcodeOptions = {
                            width: 2,
                            height: 100,
                            format: 'auto',
                            quite: 10,
                            backgroundColor: '',
                            lineColor: '#000'
                        };
                        var qr = new QRious({
                            value: '{@}' + $scope.voucherExportData.code,
                            size: 200
                        });
                        $scope.base64Src = qr.toDataURL();
                        $scope.barcode = $rootScope.voucherBarcodeUnique + $scope.voucherExportData.code;
                    }]
                });
                exportPopUp.rendered.then(function () {
                    html2canvas($('#exportContainer').find('.printable'), {
                        onrendered: function (canvas) {
                            var a = document.createElement('a');
                            a.href = canvas.toDataURL('image/jpeg').replace('image/jpeg', 'image/octet-stream');
                            a.download = 'Voucher.jpg';
                            a.click();
                            exportPopUp.close();
                        }
                    }
                    );
                });
            },

            getVoucherList: function () {
                return voucherList;
            },

            loadVoucherList: function () {
                return VoucherListSearchtModelService.post(data).then(function (res) {
                    _.merge(voucherList, res.data.vouchers);
                    _.merge(voucherTotalData, res.data.totals);
                });
            },

            setVoucherData: function (voucher) {
                removeAndMerge(voucherData, voucher);
            },

            redeemVoucher: function (code) {
                return VoucherListModelService.post({ code: code }).then(function (res) {
                    voucherList.push(res.data.voucher);
                });
            },

            getInitVoucherSetting: function () {
                return voucherButtonSetting;
            },

            cancelVoucher: function (voucher) {
                return VoucherModelService.post('voucher/cancel', { platform: 'terminal', code: voucher.code }).then(function (res) {
                    var canceledVoucher = _.find(voucherList, { id: voucher.id });
                    _.merge(canceledVoucher, res.data.voucher);
                });
            },

            filterVoucherList: function (data) {
                voucherList.splice(0, voucherList.length);
                return VoucherListSearchtModelService.post(data).then(function (res) {
                    _.merge(voucherList, res.data.vouchers);
                    removeAndMerge(voucherTotalData, res.data.totals);
                });
            },

            getVoucherTotalData: function () {
                return voucherTotalData;
            },

            getVoucherData: function () {
                return voucherData;
            }
        };

        function removeObjectProperties(object) {
            for (var member in object) delete object[member];
        }

        function removeAndMerge(object, mergeWith) {
            removeObjectProperties(object);
            _.merge(object, mergeWith);
        }
        return serviceObj;
    }
})();


/**
 * Created by unal on 16.03.2017.
 */
(function () {
    var path = 'app/profile/money/voucher';
    angular
        .module('novusTerminal')
        .directive('aptVoucherRedeemDeposit', DirectiveFn);
    function DirectiveFn() {
        return {
            restrict: 'EA',
            scope: {},
            bindToController: true,
            controller: ControllerFn,
            controllerAs: 'vmVoucherRedeemDeposit',
            templateUrl: function (elem, attrs) {
                if (attrs.template) {
                    return path + '/redeem-deposit.' + attrs.template + '.html';
                } else {
                    return path + '/redeem-deposit.html';
                }
            }
        }
    }
    ControllerFn.$inject = ['VoucherService', 'TranslateService', '$stateParams', 'ToastrNotificationService'];
    function ControllerFn(VoucherService, TranslateService, $stateParams, ToastrNotificationService) {
        var vm = this;

        vm.redeemDeposit = redeemDepositFn;
        if ($stateParams.code) {
            vm.code = $stateParams.code;
        }

        function redeemDepositFn() {
            VoucherService.redeemVoucher(vm.code).then(function () {
                ToastrNotificationService.notificationPopUp('redeemed_successfully', 'success');
                vm.code = '';
            }).catch(function (res) {
                ToastrNotificationService.notificationPopUp(res.data.error_message, 'error');
            });
        }
    }
})();
/**
 * Created by Emre on 17.06.2017.
 */

(function () {
    'use strict';
    angular
        .module('novusTerminal')
        .config(InterceptorFn)
        .factory('VoucherListModelService', ServiceFn);

    InterceptorFn.$inject = ['RestangularProvider'];
    function InterceptorFn(RestangularProvider) {

        RestangularProvider.addResponseInterceptor(function (data, operation, what, url, response, deferred) {


            // var auth = response.headers('auth');
            return data;

        });

        RestangularProvider.addRequestInterceptor(function (data, operation, what, url) {

            // var auth = $cookies.get('terminalAuth') || '';

            // var languageId = 1;
            // data.auth = auth;
            // data.language_id = languageId;
            return data;
        });

    }

    ServiceFn.$inject = ['ApiService'];
    function ServiceFn(ApiService) {


        var rest = ApiService.serviceOne();

        return rest.service('voucher/deposit');

    }

})();
/**
 * Created by unal on 16.03.2017.
 */

(function () {
    angular.module('novusTerminal').controller('VoucherManagerCtrl', ControllerFn);
    ControllerFn.$inject = ['$cookies', 'VoucherService', '$location', '$stateParams'];
    function ControllerFn($cookies, VoucherService, $location, $stateParams) {
        var vm = this;



        vm.user = $cookies.get('userType');

        vm.purpose = $location.$$url || '';



        if (vm.purpose.indexOf("deposit") != -1) {
            vm.section = 'deposit';
        } else if (vm.purpose.indexOf("withdraw") != -1) {
            vm.section = 'withdraw';
        }


        VoucherService.reset();
    }
})();

/**
 * Created by unal on 30.03.2017.
 */



(function () {

    var path = 'app/profile/money/voucher';

    angular
        .module('novusTerminal')
        .directive('aptVoucherListFilter', DirectiveFn);

    function DirectiveFn() {
        return {
            restrict: 'EA',
            scope: {},
            bindToController: true,
            controller: ControllerFn,
            controllerAs: 'vmVoucherListFilter',
            templateUrl: function (elem, attrs) {
                if (attrs.template) {
                    return path + '/voucher-list-filter.' + attrs.template + '.html';
                } else {
                    return path + '/voucher-list-filter.html';
                }
            }
        }
    }

    ControllerFn.$inject = [
        'VoucherService',
        'CalendarConfigurationService'
    ];
    function ControllerFn(VoucherService, CalendarConfigurationService) {
        var vm = this;
        vm.defaultDate = { startDate: moment.utc().startOf('isoweek'), endDate: moment.utc().endOf('isoweek') };
        vm.datePickerOptions = {
            locale: {
                applyClass: 'btn-green',
                applyLabel: 'Apply',
                fromLabel: 'From',
                format: 'MMM D, YYYY HH:mm',
                toLabel: 'To',
                cancelLabel: 'Cancel',
                customRangeLabel: 'Custom range',
                opens: 'center',
                weekLabel: 'W',
                daysOfWeek: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
                monthNames: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
                firstDay: 1
            },
            showDropdowns: true,
            showWeekNumbers: false,
            showISOWeekNumbers: false,
            timePicker: true,
            timePicker24Hour: true,
            timePickerSeconds: false,
            autoApply: true,
            alwaysShowCalendars: true
        };
        vm.search = searchFn;
        vm.date = vm.defaultDate;
        vm.dateOptions = vm.datePickerOptions;
        vm.data = {
            date_type: 'issue_date'
        };
        vm.voucherTotalData = VoucherService.getVoucherTotalData();

        function searchFn() {
            setDateFormat();
            //vm.data.voucher_status = 1;
            //vm.data.voucher_status = vm.data.voucher_status * 1;
            VoucherService.filterVoucherList(vm.data);
        }


        function setDateFormat() {
            var dbDate = CalendarConfigurationService.getTimeForDbRecord(vm.date, 'UTC');
            vm.data.min_date = dbDate.startDate;
            vm.data.max_date = dbDate.endDate;

        }

    }

})();
/**
 * Created by Emre on 17.06.2017.
 */

(function () {
    'use strict';
    angular
        .module('novusTerminal')
        .config(InterceptorFn)
        .factory('VoucherListSearchtModelService', ServiceFn);

    InterceptorFn.$inject = ['RestangularProvider'];
    function InterceptorFn(RestangularProvider) {

        RestangularProvider.addResponseInterceptor(function (data, operation, what, url, response, deferred) {


            // var auth = response.headers('auth');
            return data;

        });

        RestangularProvider.addRequestInterceptor(function (data, operation, what, url) {

            // var auth = $cookies.get('terminalAuth') || '';

            // var languageId = 1;
            // data.auth = auth;
            // data.language_id = languageId;
            return data;
        });

    }

    ServiceFn.$inject = ['ApiService'];
    function ServiceFn(ApiService) {


        var rest = ApiService.serviceOne();

        return rest.service('voucher/list');

    }

})();
/**
 * Created by unal on 17.03.2017.
 */



(function () {

    var path = 'app/profile/money/voucher';

    angular
        .module('novusTerminal')
        .directive('aptVoucherList', DirectiveFn);

    function DirectiveFn() {
        return {
            restrict: 'EA',
            scope: {},
            bindToController: true,
            controller: ControllerFn,
            controllerAs: 'vmVoucherList',
            templateUrl: function (elem, attrs) {
                if (attrs.template) {
                    return path + '/voucher-list.' + attrs.template + '.html';
                } else {
                    return path + '/voucher-list.html';
                }
            }
        }
    }

    ControllerFn.$inject = [
        'VoucherService',
        '$cookies',
        'TranslateService',
        'ToastrNotificationService',
        'TicketPrintLogoService'
    ];
    function ControllerFn(VoucherService, $cookies, TranslateService, ToastrNotificationService,TicketPrintLogoService) {
        var vm = this;

        vm.printVoucher = printVoucherFn;
        vm.cancelVoucher = cancelVoucherFn;
        vm.voucherData = VoucherService.getVoucherList();
        vm.user = $cookies.get('userType');
        vm.couponLogo = TicketPrintLogoService.getTicketLogo();


        function printVoucherFn(voucher) {
            VoucherService.setVoucherData(voucher);
            VoucherService.printVoucher(voucher.code);
        }

        function cancelVoucherFn(voucher) {
            WarningModalService.openWarningModal('are_you_sure_cancel', 'warning').then(function (result) {
                if (!result) {
                    return;
                }
                VoucherService.cancelVoucher(voucher).success(function (res) {
                    // TranslateService.translate('Voucher Canceled', 'success');
                    ToastrNotificationService.notificationPopUp('Voucher Canceled', 'success');

                }).error(function (res) {
                    TranslateService.translate(res.error_message);
                });
            });

        }
    }

})();

/**
 * Created by unal on 16.03.2017.
 */



(function () {

    var path = 'app/profile/money/voucher';

    angular
        .module('novusTerminal')
        .directive('aptVoucherCreateWithdraw', DirectiveFn);

    function DirectiveFn() {
        return {
            restrict: 'EA',
            scope: {},
            bindToController: true,
            controller: ControllerFn,
            controllerAs: 'vmVoucherCreateWithdraw',
            templateUrl: function (elem, attrs) {
                if (attrs.template) {
                    return path + '/create-withdraw.' + attrs.template + '.html';
                } else {
                    return path + '/create-withdraw.html';
                }
            }
        }
    }

    ControllerFn.$inject = [
        'TicketStakeButtonService',
        'TranslateService',
        'UserService',
        'VoucherService',
        'ToastrNotificationService',
    ];
    function ControllerFn(TicketStakeButtonService, TranslateService, UserService, VoucherService, ToastrNotificationService) {
        var vm = this;

        vm.setAmount = setAmountFn;
        vm.createWithdraw = createWithdrawFn;
        vm.resetAmount = resetAmountFn;
        vm.printWithdraw = printWithdrawFn;
        vm.exportWithdraw = exportWithdrawFn;
        vm.stakeButtons = TicketStakeButtonService.getTicketStakeButtons();
        vm.amount = null;
        vm.buttonsStatus = VoucherService.getInitVoucherSetting();
        vm.voucherData = VoucherService.getVoucherList();
        var user = UserService.getUser();

        function setAmountFn(button) {
            vm.amount = vm.amount * 1;
            vm.amount += button.stake;
        }

        function resetAmountFn() {
            vm.amount = null;
        }

        function createWithdrawFn() {
            if (vm.amount * 1 <= 0) {
                ToastrNotificationService.notificationPopUp('amount_must_be_greater_than_zero', 'warning');
                return;
            }

            if (vm.amount * 1 > user.balance) {
                ToastrNotificationService.notificationPopUp('you_dont_have_enough_balance', 'error');
                return;
            }

            VoucherService.create(vm.amount * 1, user.currency_id).then(function () {
                ToastrNotificationService.notificationPopUp('created_successfully', 'success');
                resetAmountFn();
            }).catch(function (res) {
                ToastrNotificationService.notificationPopUp(res.data.error_message, 'error');
            });

        }

        function printWithdrawFn(code) {
            VoucherService.printVoucher(code[0].code);
        }

        function exportWithdrawFn() {
            VoucherService.exportVoucher();
        }
    }

})();

/**
 * Created by unal on 16.03.2017.
 */



(function () {

    var path = 'app/profile/money/voucher';

    angular.module('novusTerminal').directive('aptVoucherCreateDeposit', DirectiveFn);

    function DirectiveFn() {
        return {
            restrict: 'EA',
            scope: {},
            bindToController: true,
            controller: ControllerFn,
            controllerAs: 'vmVoucherCreateDeposit',
            templateUrl: function (elem, attrs) {
                if (attrs.template) {
                    return path + '/create-deposit.' + attrs.template + '.html';
                } else {
                    return path + '/create-deposit.html';
                }
            },
        };
    }

    ControllerFn.$inject = [
        'TicketStakeButtonService',
        'TranslateService',
        'UserService',
        'VoucherService',
    ];
    function ControllerFn(TicketStakeButtonService, TranslateService, UserService, VoucherService) {
        var vm = this;
        vm.setAmount = setAmountFn;
        vm.createDeposit = createDepositFn;
        vm.printDeposit = printDepositFn;
        vm.resetAmount = resetAmountFn;
        vm.exportDeposit = exportDepositFn;
        vm.stakeButtons = TicketStakeButtonService.getTicketStakeButtons();
        vm.amount = null;
        vm.buttonsStatus = VoucherService.getInitVoucherSetting();
        var user = UserService.getUser();

        function setAmountFn(button) {
            vm.amount = vm.amount * 1
            vm.amount += button.stake;
        }

        function resetAmountFn() {
            vm.amount = null;
        }

        function createDepositFn() {
            if (vm.amount * 1 <= 0) {
               // ToastrNotificationService.notificationPopUp('amount_must_be_greater_than_zero', 'warning');
                return;
            }
            if (user && vm.amount * 1 > user.balance) {
                //ToastrNotificationService.notificationPopUp('you_dont_have_enough_balance', 'error');
                return;
            }
            VoucherService.create(vm.amount * 1, user.currency_id).success(function () {
               // ToastrNotificationService.notificationPopUp('created_successfully', 'success');
                resetAmountFn();
            }).error(function (res) {
                TranslateService.translate(res.error_message);
            });
        }

        function printDepositFn() {
            VoucherService.printVoucher();
        }

        function exportDepositFn() {
            VoucherService.exportVoucher();
        }
    }

})();


(function () {
    'use strict';
    angular
        .module('novusTerminal')
        .config(InterceptorFn)
        .factory('VoucherListCreateService', ServiceFn);

    InterceptorFn.$inject = ['RestangularProvider'];
    function InterceptorFn(RestangularProvider) {

        RestangularProvider.addResponseInterceptor(function (data, operation, what, url, response, deferred) {


            // var auth = response.headers('auth');
            return data;

        });

        RestangularProvider.addRequestInterceptor(function (data, operation, what, url) {

            // var auth = $cookies.get('terminalAuth') || '';

            // var languageId = 1;
            // data.auth = auth;
            // data.language_id = languageId;
            return data;
        });

    }

    ServiceFn.$inject = ['ApiService'];
    function ServiceFn(ApiService) {


        var rest = ApiService.serviceOne();

        return rest.service('voucher/create');

    }

})();
/**
 * Created by Emre on 17.06.2017.
 */

(function () {
    'use strict';
    angular
        .module('novusTerminal')
        .config(InterceptorFn)
        .factory('VoucherModelService', ServiceFn);

    InterceptorFn.$inject = ['RestangularProvider'];
    function InterceptorFn(RestangularProvider) {

        RestangularProvider.addResponseInterceptor(function (data, operation, what, url, response, deferred) {


            // var auth = response.headers('auth');
            return data;

        });

        RestangularProvider.addRequestInterceptor(function (data, operation, what, url) {

            // var auth = $cookies.get('terminalAuth') || '';

            // var languageId = 1;
            // data.auth = auth;
            // data.language_id = languageId;
            return data;
        });

    }

    ServiceFn.$inject = ['ApiService'];
    function ServiceFn(ApiService) {


        var rest = ApiService.serviceOne();

        return rest.service('payment-pages');

    }

})();
/**
 * Created by Emre on 22.06.2017.
 */

(function () {
      'use strict';
      angular
          .module('novusTerminal')
          .factory('BetHistoryService', ServiceFn);

      ServiceFn.$inject = ['BetHistoryModelService', 'ToastrNotificationService'];
      function ServiceFn(BetHistoryModelService, ToastrNotificationService) {
            var ServiceObject;
            var betList = [];
            var stats = {};
            ServiceObject = {
                  setBetList: function (data) {
                        BetHistoryModelService.post(data).then(function (response) {
                              betList.length > 0 ? betList.splice(0, betList.length) : betList;
                              _.merge(betList, response.data.betlist);
                              _.merge(stats, response.data.stats);
                              if(!betList.length > 0) {
                                    ToastrNotificationService.notificationPopUp('No ticket item', 'warning');
                              }
                        }).catch(function (error) {
                              ToastrNotificationService.notificationPopUp(error.data.error_message, 'error');
                        })
                  },

                  getStats: function () {
                        return stats;
                  },

                  getBetList: function () {
                        return betList;
                  }

            };

            return ServiceObject;
      }

})();
/**
 * Created by Emre on 22.06.2017.
 */

(function () {

      angular
          .module('novusTerminal')
          .config(InterceptorFn)
          .factory('BetHistoryModelService', ServiceFn);


      InterceptorFn.$inject = ['RestangularProvider'];
      function InterceptorFn(RestangularProvider) {


            RestangularProvider.addResponseInterceptor(function (data, operation, what, url, response, deferred) {

                  return data;

            });

            RestangularProvider.addRequestInterceptor(function (data, operation, what, url) {

                  return data;
            });

      }

      ServiceFn.$inject = ['ApiService'];
      function ServiceFn(ApiService) {
            var rest = ApiService.serviceOne();

            return rest.service('user/bet-list');
            

      }


})();
/**
 * Created by engin
 */

(function () {
    angular
        .module('novusTerminal')
        .filter('timeZoneFilter',['DateSettingsService' ,function(DateSettingsService) {

            var timeZone = 'UTC';

            var dateSetting = DateSettingsService.getDateSetting();

            if(dateSetting.userTimezone!== ""){
                timeZone = dateSetting.userTimezone;
            }else{
                timeZone = dateSetting.bookmakerTimezone;
            }

            return function(date) {
                if(date == null){
                    return " - ";
                }
                var ConveryTimeZone = moment.utc(date).tz(timeZone).format("MMM D, YYYY")+ ' '+
                    moment.utc(date).tz(timeZone).format("HH:mm:ss");

                return ConveryTimeZone;
            };

        }]);

})();



/**
 * Created by Emre on 20.06.2017.
 */

(function () {
      'use strict';
      angular
          .module('novusTerminal')
          .controller('BetHistoryDetailCtrl', ControllerFn);

      ControllerFn.$inject = ['$stateParams', 'BetHistoryDetailService'];
      function ControllerFn($stateParams, BetHistoryDetailService) {
            var vm = this;

            vm.ticketCode = $stateParams.ticketCode;

            vm.data = {};
            vm.data.code = vm.ticketCode;
            BetHistoryDetailService.setBetHistoryDetail(vm.data);

      }

})();
(function () {
	'use strict';
	angular.module('novusTerminal')
		.directive('aptVoucherPrinter', voucherPrinterFn)
		.controller('voucherPrinterCtrl', VoucherPrinterCtrlFn);

	function voucherPrinterFn() {
		return {
			restrict: 'EA',
			scope: {
				voucherCode: '=',
				previousState: '='
			},
			bindToController: true,
			controller: 'voucherPrinterCtrl',
			controllerAs: 'vmVoucherPrinter',
			templateUrl: 'app/printManager/directives/voucher/print-voucher.html'
		};
	}

	VoucherPrinterCtrlFn.$inject = ['VoucherService', '$rootScope', 'DateFormatService', 'printManagerService','TicketPrintLogoService'];
	function VoucherPrinterCtrlFn(VoucherService, $rootScope, DateFormatService, printManagerService, TicketPrintLogoService) {
		var vm = this;
		vm.voucherPrintData = VoucherService.getVoucherData();
		vm.createdHour = DateFormatService.getMinuteHourMomentSecond(vm.voucherPrintData.created_at);
		vm.expHour = DateFormatService.getMinuteHourMomentSecond(vm.voucherPrintData.expiration_date);

        vm.couponLogo = TicketPrintLogoService.getTicketLogo();
       


		vm.barcodeOptions = {
			width: 2,
			height: 100,
			format: 'auto',
			quite: 10,
			backgroundColor: '',
			lineColor: '#000'
		};
        var qr = new QRious({
			value: $rootScope.voucherQrCodeUnique + vm.voucherPrintData.code,
			size: 200
		});
		vm.base64Src = qr.toDataURL();
		vm.barcode = $rootScope.voucherBarcodeUnique + vm.voucherPrintData.code;
		//vm.voucherLogo = TicketPrintLogoService.getTicketLogo();
		function callAfterPrint() {

		}

		printManagerService.handlePrint(vm.previousState, callAfterPrint);
	}
})();



(function () {
	'use strict';
	angular.module('novusTerminal')
		.directive('aptTicketPrinter', ticketPrinterFn)
		.controller('ticketPrinterCtrl', TicketPrinterCtrlFn);

	function ticketPrinterFn() {
		return {
			restrict: 'EA',
			scope: {
				ticketCode: '=',
				previousState: '='
			},
			bindToController: true,
			controller: 'ticketPrinterCtrl',
			controllerAs: 'vmTicketPrinter',
			templateUrl: 'app/printManager/directives/ticket/print-ticket.html'
		};
	}

	TicketPrinterCtrlFn.$inject = ['TicketModel', 'printManagerService', 'ToastrNotificationService', 'UtilsService','TicketPrintLogoService'];
	function TicketPrinterCtrlFn(TicketModel, printManagerService, ToastrNotificationService, UtilsService,TicketPrintLogoService) {
		var vm = this;


		var ticketPrintData = {};
		var ticketPrinterData = {
			tournaments: []
		};


		vm.original = _.includes(vm.ticketCode, printManagerService.originalTicketUnique);
		vm.ticketCode = vm.ticketCode.split(printManagerService.originalTicketUnique)[0];
		vm.ticketLogo = TicketPrintLogoService.getTicketLogo();

		TicketModel.one().post('set-print', { ticket_code: vm.ticketCode }).then(function (data) {
			UtilsService.removeAndMerge(ticketPrintData, data.data.ticket);
			UtilsService.removeObjectProperties(ticketPrinterData);
			ticketPrinterData.tournaments = [];
			setPrintDataForPrinter(data);
			function callAfterPrintingDone() {

			}
			setTimeout(function () {
				var contentContainerDom = $('.content-container');
				//var contentHeight = contentContainerDom.height();
				// contentContainerDom.css('height', vm.original ? contentHeight + 30 : contentHeight + 25);
				printManagerService.handlePrint(vm.previousState, callAfterPrintingDone);
			}, 1000);
		}).catch(function (reason) {
			window.history.back();
			ToastrNotificationService.notificationPopUp(reason.data.error_message, 'error');
		});


		function setPrintDataForPrinter(data) {
			_.forEach(ticketPrintData.items, function (item) {
				if (_.findIndex(ticketPrinterData.tournaments, { tournament_id: item.tournament_id }) >= 0) {
					var ticketPrintDataTournament = _.find(ticketPrinterData.tournaments, { tournament_id: item.tournament_id });
					if (!_.has(ticketPrintDataTournament, 'events')) {
						ticketPrintDataTournament.events = [];
					}
					if (_.findIndex(ticketPrintDataTournament.events, { event_id: item.event_id }) >= 0) {
						var ticketPrintDataEvent = _.find(ticketPrintDataTournament.events, { event_id: item.event_id });

						if (!_.has(ticketPrintDataEvent, 'items')) {
							ticketPrintDataEvent.items = [];
						}
						ticketPrintDataEvent.items.push(item);
					} else {
						var newTicketEvent = {
							event_id: item.event_id,
							group_id: item.group_id,
							event_name: item.event_name,
							date: moment(item.event_date).format('DD/MM/YYYY HH:mm:ss'),
							code: item.event_code,
							is_live: item.is_live,
							items: [],
							category: {},
							sport: {},
							tournament: {}
						};
						_.merge(newTicketEvent.category, item.category);
						_.merge(newTicketEvent.sport, item.sport);
						_.merge(newTicketEvent.tournament, item.tournament);
						newTicketEvent.items.push(item);
						ticketPrintDataTournament.events.push(newTicketEvent);
					}
				} else {
					var newTicketTournament = {
						sport: {},
						tournament: {},
						category: {},
						tournament_id: item.tournament_id,
						events: []
					};
					_.merge(newTicketTournament.category, item.category);
					_.merge(newTicketTournament.sport, item.sport);
					_.merge(newTicketTournament.tournament, item.tournament);
					var newTicketInitEvent = {
						event_id: item.event_id,
						group_id: item.group_id,
						event_name: item.event_name,
						date: moment(item.event_date).format('DD/MM/YYYY HH:mm:ss'),
						code: item.event_code,
						is_live: item.is_live,
						items: [],
						category: {},
						sport: {},
						tournament: {}
					};
					_.merge(newTicketInitEvent.category, item.category);
					_.merge(newTicketInitEvent.sport, item.sport);
					_.merge(newTicketInitEvent.tournament, item.tournament);
					newTicketInitEvent.items.push(item);
					newTicketTournament.events.push(newTicketInitEvent);
					ticketPrinterData.tournaments.push(newTicketTournament);
				}
			});
			_.merge(ticketPrinterData, ticketPrintData);
			vm.ticketData = ticketPrintData;
			vm.ticketData.printDate = new Date();
			vm.ticketData.qcode = vm.ticketData.code.split('-')[1];
			vm.ticketData.is_printed = vm.original ? 0 : 1;
			if (!_.includes(vm.ticketData.qcode.toString(), printManagerService.barcodeUnique)) {
				vm.ticketData.qcode = printManagerService.barcodeUnique + vm.ticketData.qcode;
			}
			vm.barcodeOptions = {
				width: 2,
				height: 100,
				format: 'auto',
				quite: 10,
				backgroundColor: '',
				lineColor: '#000'
			};
			var qr = new QRious({
				value: vm.ticketData.code,
				size: 200
			});
			vm.base64Src = qr.toDataURL();
            vm.ticketLogo =  TicketPrintLogoService.getTicketLogo();
			vm.ticketData.items = getTicketItems(vm.ticketData.items);

		}

		var eventTournamentGroups = [];

		function getTicketItems(items) {
			setItemsTournamentsGroups(items);
			setTournamentGroupsItems();
			return eventTournamentGroups;
		}
		function setItemsTournamentsGroups(eventItems) {
			_.forEach(eventItems, function (item) {
				setPreMatchEventsTournamentsGroup(item);
			});
		}
		function setPreMatchEventsTournamentsGroup(item) {
			var tIdx = _.findIndex(eventTournamentGroups, { tournament_id: item.tournament_id });
			if (tIdx < 0) {
				createNewTournamentGroup();
			}
			var tournament = _.find(eventTournamentGroups, { tournament_id: item.tournament_id });
			if (!tournament) {
				return;
			}
			tournament.items.push(item);
			function createNewTournamentGroup() {
				var newTournamentGroup = {
					tournament_id: item.tournament_id,
					tournament_name: _.has(item.tournament, 'name') ? item.tournament.name : (_.has(item.live_tournament, 'name') ? item.live_tournament.name : null),
					category_name: _.has(item.category, 'name') ? item.category.name : '',
					sport_name: _.has(item.sport, 'name') ? item.sport.name : item.live_sport ? item.live_sport.name : null,
					items: [],
					events: []
				};
				eventTournamentGroups.push(newTournamentGroup);
			}
		}

		function setTournamentGroupsItems() {
			_.forEach(eventTournamentGroups, function (tournamentGroup) {
				_.forEach(tournamentGroup.items, function (item) {
					var eIdx;
					if (item.is_live) {
						eIdx = _.findIndex(tournamentGroup.events, { id: item.event_id });
					} else {
						eIdx = _.findIndex(tournamentGroup.events, { code: item.event_code });
					}
					if (eIdx < 0) {
						createNewEventGroup();
					}
					var event;
					if (item.is_live) {
						event = _.find(tournamentGroup.events, { id: item.event_id });
					} else {
						event = _.find(tournamentGroup.events, { code: item.event_code });
					}
					if (!event) {
						return;
					}
					event.items.push(item);
					function createNewEventGroup() {
						var newEventGroup = {
							code: item.event_code,
							event_name: item.event_name,
							event_date: item.event_date,
							banker: item.banker,
							is_live: item.is_live,
							id: item.event_id,
							items: []
						};
						tournamentGroup.events.push(newEventGroup);
					}
				});
				delete tournamentGroup.items;
			});
		}

	}
})();
(function () {
  'use strict';
  angular
    .module('novusTerminal')
    .factory('TicketPrintLogoService', ServiceFn);

  ServiceFn.$inject = ['ticketPrintLogoModelService'];
  function ServiceFn(ticketPrintLogoModelService) {

    var ticketLogo;

    var ServiceObject;
    ServiceObject = {

      setSiteTitle: function (data) {
        localStorage.setItem("ticketLogo", data);
      },
        getTicketLogo: function () {
          return ticketLogo;
        },
      readTicketLogo: function () {
       ticketPrintLogoModelService.post().then(function(res){
           ticketLogo = res.logo;
        });
      }


    };

    return ServiceObject;
  }

})();



(function () {
    'use strict';
    angular
        .module('novusTerminal')
        .config(InterceptorFn)
        .factory('ticketPrintLogoModelService', ServiceFn);

    InterceptorFn.$inject = ['RestangularProvider'];
    function InterceptorFn(RestangularProvider) {

        RestangularProvider.addResponseInterceptor(function (data, operation, what, url, response, deferred) {
            return data;
        });

        RestangularProvider.addRequestInterceptor(function (data, operation, what, url) {
            return data;
        });

    }

    ServiceFn.$inject = ['ApiService'];
    function ServiceFn(ApiService) {


        var rest = ApiService.serviceOne();

        return rest.service('ticket-print-logo');

    }

})();
(function () {
	'use strict';
	angular.module('novusTerminal')
		.directive('aptCouponPrinter', couponPrinterFn)
		.controller('couponPrinterCtrl', CouponPrinterCtrlFn);

	function couponPrinterFn() {
		return {
			restrict: 'EA',
			scope: {
				couponCode: '=',
				previousState: '='
			},
			bindToController: true,
			controller: 'couponPrinterCtrl',
			controllerAs: 'vmCouponPrinter',
			templateUrl: 'app/printManager/directives/coupon/print-coupon.html'
		};
	}

	CouponPrinterCtrlFn.$inject = ['TicketEventService', 'printManagerService', 'TicketPrintLogoService'];
	function CouponPrinterCtrlFn(TicketEventService, printManagerService, TicketPrintLogoService) {
		var vm = this;
		vm.barcodeOptions = {
			width: 2,
			height: 100,
			format: 'auto',
			quite: 10,
			backgroundColor: '',
			lineColor: '#000'
		};
		vm.currentDate = new Date();
        vm.couponLogo = TicketPrintLogoService.getTicketLogo();
		function callAfterPrintingDone() {
			TicketEventService.removeSavedTicketData();
		}
		printManagerService.handlePrint(vm.previousState, callAfterPrintingDone);
	}
})();
/**
 *
 */
(function () {
    'use strict';

    angular.module('novusTerminal')
        .directive('aptCopyTicketPrinter', DirectiveFn)
        .controller('copyTicketCtrl',CopyTicketCtrlFn);

    function DirectiveFn() {
        return {
            restrict: 'EA',
            scope: {
                ticketCode: '=',
                previousState: '=',

            },
            bindToController: true,
            controller: 'copyTicketCtrl',
            controllerAs: 'vmTicketPrinter',
            templateUrl:'app/printManager/directives/ticket/print-ticket.html'

        }
    }
    CopyTicketCtrlFn.$inject = [
        'BetHistoryDetailService',
        'nvsConstant',
        'printManagerService',
        'TicketPrintLogoService',
        'UtilsService'
    ];
    function CopyTicketCtrlFn(BetHistoryDetailService, nvsConstant, printManagerService, TicketPrintLogoService,UtilsService) {
        var vm = this;
        var eventTournamentGroups = [];
        var ticketPrintData = {};
        var ticketPrinterData = {
            tournaments: []
        };

        vm.original = _.includes(vm.ticketCode, printManagerService.originalTicketUnique);
        vm.printData = BetHistoryDetailService.getBetHistoryDetail();
        vm.ticketCode = vm.ticketCode.split(printManagerService.originalTicketUnique)[0];

        setPrintDataForPrinter(BetHistoryDetailService.getBetHistoryDetail());
        function setPrintDataForPrinter(data) {
            UtilsService.removeAndMerge(ticketPrintData, data);
            UtilsService.removeObjectProperties(ticketPrinterData);
            ticketPrinterData.tournaments = [];

            _.forEach(ticketPrinterData.items, function (item) {
                if (_.findIndex(ticketPrinterData.tournaments, { tournament_id: item.tournament_id }) >= 0) {
                    var ticketPrintDataTournament = _.find(ticketPrinterData.tournaments, { tournament_id: item.tournament_id });
                    if (!_.has(ticketPrintDataTournament, 'events')) {
                        ticketPrintDataTournament.events = [];
                    }

                    if (_.findIndex(ticketPrintDataTournament.events, { event_id: item.event_id }) >= 0) {
                        var ticketPrintDataEvent = _.find(ticketPrintDataTournament.events, { event_id: item.event_id });

                        if (!_.has(ticketPrintDataEvent, 'items')) {
                            ticketPrintDataEvent.items = [];
                        }
                        ticketPrintDataEvent.items.push(item);
                    } else {
                        var newTicketEvent = {
                            event_id: item.event_id,
                            group_id: item.group_id,
                            event_name: item.event_name,
                            date: moment(item.event_date).format('DD/MM/YYYY HH:mm:ss'),
                            code: item.event_code,
                            is_live: item.is_live,
                            items: [],
                            category: {},
                            sport: {},
                            tournament: {}
                        };
                        _.merge(newTicketEvent.category, item.category);
                        _.merge(newTicketEvent.sport, item.sport);
                        _.merge(newTicketEvent.tournament, item.tournament);
                        newTicketEvent.items.push(item);
                        ticketPrintDataTournament.events.push(newTicketEvent);
                    }
                } else {
                    var newTicketTournament = {
                        sport: {},
                        tournament: {},
                        category: {},
                        tournament_id: item.tournament_id,
                        events: []
                    };
                    _.merge(newTicketTournament.category, item.category);
                    _.merge(newTicketTournament.sport, item.sport);
                    _.merge(newTicketTournament.tournament, item.tournament);
                    var newTicketInitEvent = {
                        event_id: item.event_id,
                        group_id: item.group_id,
                        event_name: item.event_name,
                        date: moment(item.event_date).format('DD/MM/YYYY HH:mm:ss'),
                        code: item.event_code,
                        is_live: item.is_live,
                        items: [],
                        category: {},
                        sport: {},
                        tournament: {}
                    };
                    _.merge(newTicketInitEvent.category, item.category);
                    _.merge(newTicketInitEvent.sport, item.sport);
                    _.merge(newTicketInitEvent.tournament, item.tournament);
                    newTicketInitEvent.items.push(item);
                    newTicketTournament.events.push(newTicketInitEvent);
                    ticketPrinterData.tournaments.push(newTicketTournament);
                }
            });
            _.merge(ticketPrinterData, ticketPrintData);
            ticketPrintData.qcode='A'+ticketPrintData.qcode;

            vm.ticketData = ticketPrintData;
            vm.ticketData.printDate=new Date();

            vm.ticketData.is_printed = vm.original ? 0 : 1;
            vm.ticketData.items = getTicketItems(vm.ticketData.items);
        }


        function getTicketItems(items) {
            setItemsTournamentsGroups(items);
            setTournamentGroupsItems();
            return eventTournamentGroups;
        }
        function setItemsTournamentsGroups(eventItems) {
            _.forEach(eventItems, function (item) {
                setPreMatchEventsTournamentsGroup(item);
            });
        }
        function setPreMatchEventsTournamentsGroup(item) {
            var tIdx = _.findIndex(eventTournamentGroups, { tournament_id: item.tournament_id });
            if (tIdx < 0) {
                createNewTournamentGroup();
            }
            var tournament = _.find(eventTournamentGroups, { tournament_id: item.tournament_id });
            if (!tournament) {
                return;
            }
            tournament.items.push(item);
            function createNewTournamentGroup() {
                var newTournamentGroup = {
                    tournament_id: item.tournament_id,
                    tournament_name: _.has(item.tournament, 'name') ? item.tournament.name : (_.has(item.live_tournament, 'name') ? item.live_tournament.name : null),
                    category_name: _.has(item.category, 'name') ? item.category.name : '',
                    sport_name: _.has(item.sport, 'name') ? item.sport.name : item.live_sport ? item.live_sport.name : null,
                    items: [],
                    events: []
                };

                eventTournamentGroups.push(newTournamentGroup);
            }
        }

        function setTournamentGroupsItems() {
            _.forEach(eventTournamentGroups, function (tournamentGroup) {
                _.forEach(tournamentGroup.items, function (item) {
                    var eIdx;
                    if (item.is_live) {
                        eIdx = _.findIndex(tournamentGroup.events, { id: item.event_id });
                    } else {
                        eIdx = _.findIndex(tournamentGroup.events, { code: item.event_code });
                    }
                    if (eIdx < 0) {
                        createNewEventGroup();
                    }
                    var event;
                    if (item.is_live) {
                        event = _.find(tournamentGroup.events, { id: item.event_id });
                    } else {
                        event = _.find(tournamentGroup.events, { code: item.event_code });
                    }
                    if (!event) {
                        return;
                    }
                    event.items.push(item);
                    function createNewEventGroup() {
                        var newEventGroup = {
                            code: item.event_code,
                            event_name: item.event_name,
                            event_date: item.event_date,
                            banker: item.banker,
                            is_live: item.is_live,
                            id: item.event_id,
                            items: []
                        };
                        tournamentGroup.events.push(newEventGroup);
                    }
                });
                delete tournamentGroup.items;
            });
        }


        vm.is_printed = vm.printData.is_printed;
        vm.barcodeOptions = {
            width: 3,
            height: 100,
            quite: 10,
            displayValue: false,
            font: "monospace",
            textAlign: "center",
            fontSize: 12,
            backgroundColor: "",
            lineColor: "#000"
        };
        //nvsConstant.ticketQrCodeUnique +
        var qrCodeData = new QRious({
            value: vm.printData.code,
            size: 200
        });
        vm.base64Src = qrCodeData.toDataURL();
        vm.ticketLogo = TicketPrintLogoService.getTicketLogo();
        function callAfterPrint() {

        }
        printManagerService.handlePrint(vm.previousState, callAfterPrint);
    }
})();

/**
 * Created by unal on 6/28/2017.
 */

(function () {

	var path = 'app/nvsTicket/directives/novusEvents';

	angular.module('novusTerminal').directive('aptTicketEventsList', DirectiveFn);

	function DirectiveFn() {
		return {
			restrict: 'EA',
			scope: {},
			bindToController: true,
			controller: ControllerFn,
			controllerAs: 'vmTicketEventsList',
			templateUrl: function (elem, attrs) {
				if (attrs.template) {
					return path + '/ticket-events-list.' +
						attrs.template + '.html';
				} else {
					return path + '/ticket-events-list.html';
				}
			},
		};
	}

	ControllerFn.$inject = [
		'TicketEventService',
		'NotifyingService',
		'$scope',
		'ToastrNotificationService'];
	function ControllerFn(TicketEventService, NotifyingService, $scope, ToastrNotificationService) {
		var vm = this;

        vm.ticketLoadByCode = function (code) {
            if(code) {
                var w = code.slice(0, 1);
                if (w == 'A') {
                    code = code.slice(1, code.length);
                }
            }
            TicketEventService.loadTicketByCode(code);
        };

		vm.ticketEvents = TicketEventService.getTicketEvents();
		vm.ticketOptions = TicketEventService.getTicketDisplayOption();

		vm.removeTicketEvent = removeTicketEventFn;
		vm.removeTicketEventItem = removeTicketEventItemFn;
		vm.showItemError = showItemErrorFn;
		vm.setBanker = setBankerFn;

		function removeTicketEventFn(ticketEvent) {
			TicketEventService.deleteTicketEvent(ticketEvent);
		}

		function removeTicketEventItemFn(ticketEvent, item) {
			TicketEventService.deleteTicketEventItem(ticketEvent, item);
		}

		function showItemErrorFn(errorMessage) {
			ToastrNotificationService.notificationPopUp(errorMessage, 'warning', 'Item Changed');
		}

		var ticketScrollStatus = 0;

		NotifyingService.subscribe($scope, 'upContent', function () {
			if (ticketScrollStatus == 0) {
				return false;
			}
			ticketScrollStatus++;
			document.getElementById(
				'ticket-event-content').style.transform = 'translateY(' +
				ticketScrollStatus * 100 + 'px)';
		});

		NotifyingService.subscribe($scope, 'downContent', function () {
			ticketScrollStatus--;
			document.getElementById(
				'ticket-event-content').style.transform = 'translateY(' +
				ticketScrollStatus * 100 + 'px)';
		});

		function setBankerFn(event, odds) {
			TicketEventService.setBanker(event, odds);
		}

	}

})();
/**
 * Created by unal on 07.04.2017.
 */



(function () {

    var path = 'app/nvsTicket/directives/novusCombinations';

    angular.module('novusTerminal').directive('aptTicketEventCombinations', DirectiveFn);

    function DirectiveFn() {
        return {
            restrict: 'EA',
            scope: {},
            bindToController: true,
            controller: ControllerFn,
            controllerAs: 'vmTicketEventCombinations',
            templateUrl: function (elem, attrs) {
                if (attrs.template) {
                    return path + '/ticket-event-combinations.' +
                        attrs.template + '.html';
                } else {
                    return path + '/ticket-event-combinations.html';
                }
            },
        };
    }

    ControllerFn.$inject = ['TicketEventService'];
    function ControllerFn(TicketEventService) {

        var vm = this;

        // vm.displaySystemStatus = TicketEventService.getComboScreenStatus();
        //vm.showSystem = showSystemFn;
        vm.ticket = TicketEventService.getTicketData();
        vm.ticketOptions = TicketEventService.getTicketDisplayOption();


        vm.setSystemStake = setSystemStakeFn;

        // function showSystemFn() {
        //     vm.displaySystemStatus = !vm.displaySystemStatus;
        // }

        function setSystemStakeFn(code, stake) {
            TicketEventService.setSystemStake(code, stake);
        }

    }
})();
/**
 * Created by unal on 6/28/2017.
 */

(function () {

	var path = 'app/nvsTicket/directives/novusCheckout';

	angular.module('novusTerminal').directive('aptTicketCheckout', DirectiveFn);

	function DirectiveFn() {
		return {
			restrict: 'EA',
			scope: {},
			bindToController: true,
			controller: ControllerFn,
			controllerAs: 'vmTicketCheckout',
			templateUrl: function (elem, attrs) {
				if (attrs.template) {
					return path + '/ticket-checkout.' + attrs.template + '.html';
				} else {
					return path + '/ticket-checkout.html';
				}
			}
		};
	}

	ControllerFn.$inject = [
		'TicketEventService',
		'printManagerService',
		'$location',
		'$rootScope'
	];
	function ControllerFn(TicketEventService, printManagerService, $location , $rootScope) {
		var vm = this;


		vm.setTicketToBetAgain = setTicketToBetAgainFn;
		vm.printTicket = printTicketFn;
		vm.reloadTicket = reloadTicketFn;
		vm.placedTicketData = TicketEventService.getLastPlaceBetTicketData();

		vm.isprinted = $rootScope.isPrinted;


		function setTicketToBetAgainFn() {

			TicketEventService.setTicketToBetAgain();
		}


		function reloadTicketFn(code) {
			TicketEventService.reloadLastTicket(code);
		}

		function printTicketFn() {
            $rootScope.isPrinted = false;
			var previousState = encodeURIComponent($location.path());
			var path = '/print-manager/ticket/' + vm.placedTicketData.code + printManagerService.originalTicketUnique +'/' + previousState;
			return $location.path(path);

		}
	}
})();
/**
 * Created by unal on 07.04.2017.
 */



(function () {

	var path = 'app/nvsTicket/directives/novusBonuses';

	angular.module('novusTerminal').directive('aptTicketEventBonuses', DirectiveFn);

	function DirectiveFn() {
		return {
			restrict: 'EA',
			scope: {},
			bindToController: true,
			controller: ControllerFn,
			controllerAs: 'vmTicketEventBonuses',
			templateUrl: function (elem, attrs) {
				if (attrs.template) {
					return path + '/ticket-event-bonuses.' +
						attrs.template + '.html';
				} else {
					return path + '/ticket-event-bonuses.html';
				}
			},
		};
	}

	ControllerFn.$inject = [
		'PlaceBetService',
		'TicketEventService',
		'UserService',
		'$rootScope'
	];
	function ControllerFn(PlaceBetService, TicketEventService, UserService, $rootScope) {
		var vm = this;

		vm.placeBetStatus = TicketEventService.getDisplaySetting();
		vm.ticketCalculator = TicketEventService.getTicketData();
		vm.ticketChangeStatus = TicketEventService.getTicketChangeStatus();

		vm.placeBet = placeBetFn;
		vm.resetBet = resetFn;
		vm.saveBet = saveFn;
		vm.printSavedTicket = printSavedTicketFn;
		vm.updateTicketChangeStatus = updateTicketChangeStatusFn;

		function updateTicketChangeStatusFn(key) {
			TicketEventService.updateOddsAndStakeChange(key, vm.ticketChangeStatus[key]);
		}

		/**
		 *place bet
		 */
		function placeBetFn() {
            $rootScope.isPrinted = false;
			PlaceBetService.checkout();
		}

		vm.user = UserService.getUserSubAccount();


		// Stake Virtual Keyboard Functionality

		vm.virtualStake = '';

		vm.closeStake = showStakeKeyboardFn;
		vm.showStakeKeyboard = showStakeKeyboardFn;
		function showStakeKeyboardFn() {
			vm.stakeKeyboard = !vm.stakeKeyboard;
			if (vm.stakeKeyboard == true) {
				removeKeyboardFn();
			}
		}

		vm.setKeyboard = setKeyboardFn;
		function setKeyboardFn(value) {
			if (_.isNumber(value)) {
				vm.ticketCalculator.calculator.couponData.Stake += value;
			} else {
				vm.ticketCalculator.calculator.couponData.Stake += '.';
			}
		}

		vm.removeKeyboard = removeKeyboardFn;
		function removeKeyboardFn() {
			vm.ticketCalculator.calculator.couponData.Stake = '';
		}

		vm.setTotalStake = setTotalStakeFn;
		function setTotalStakeFn() {
			TicketEventService.setStake(vm.ticketCalculator.calculator.couponData.Stake);
			showStakeKeyboardFn();
		}

		function resetFn() {
			TicketEventService.resetTicket();
		}

		function saveFn() {
			TicketEventService.saveTicket();
		}
		function printSavedTicketFn() {
			// TicketEventService.printSavedTicket();
			console.log(vm.ticketCalculator.savedTicket)
		}
		vm.referenceUserId = "";

		vm.setTicketReferenceUserId = setTicketReferenceUserIdFn;
		function setTicketReferenceUserIdFn() {
			PlaceBetService.setUserReference(vm.referenceUserId);
		}


	}

})();
/**
 * Created by Emre on 5.06.2017.
 */

(function () {
	'use strict';

	var path = 'app/live/eventView/eventDetail';

	angular
		.module('novusTerminal')
		.directive('aptEventDetail', DirectiveFn);

	function DirectiveFn() {
		return {
			restrict: 'EA',
			scope: {},
			bindToController: true,
			controller: ControllerFn,
			controllerAs: 'vmEventDetail',
			templateUrl: function (elem, attrs) {
				if (attrs.template) {
					return path + '/event-detail.' + attrs.template + '.html';
				} else {
					return path + '/event-detail.html';
				}
			}
		}
	}

	ControllerFn.$inject = [
		'LiveService',
		'TicketEventService'
	];
	function ControllerFn(LiveService, TicketEventService) {
		var vm = this;

		vm.event = LiveService.getEventViewData();
		vm.sport = LiveService.getEventViewSportData();

		vm.isOpen = [];

		vm.liveEngineData = LiveService.getLiveEngineData();
		var ticketLiveItems = TicketEventService.getClickedOddsLiveEvents();

		vm.openMarket = openMarketFn;

		function openMarketFn(id) {

			vm.isOpen[id] = !vm.isOpen[id];
		}

		vm.checkLiveOddsActive = checkLiveOddsActiveFn;


		function checkLiveOddsActiveFn(subMarket, subOdd) {
			if (ticketLiveItems.length <= 0) {
				return false;
			}
			var typeKey = subMarket.type + '|' + subMarket.type_id + '|' + subMarket.sub_type;
			var liveItemsKey = vm.event.id + typeKey + subOdd.code + subMarket.special_bet_value;

			var oIdx = _.findIndex(ticketLiveItems, {live_item_key: liveItemsKey});
			return oIdx >= 0 ? true : false;
		}


		vm.clickLive = clickLiveFn;
		function clickLiveFn(status, subMarket, odds) {

			var liveEvent = vm.liveEngineData.data.events[vm.event.id];
			var typeKey = subMarket.type + '|' + subMarket.type_id + '|' + subMarket.sub_type;
			TicketEventService.manageClickedLiveItem(liveEvent, subMarket, typeKey, odds.code, odds.value, status);
		}

		var carouselStatus = 0;
		vm.topScroll = topScrollFn;
		function topScrollFn() {
			if (carouselStatus == 0) {
				return false;
			}
			carouselStatus--;
			document.getElementById("event-detail-inner").style.transform = "translateY(-" + carouselStatus * 100 + "px)";
		}

		vm.bottomScroll = bottomScrollFn;
		function bottomScrollFn() {
			var scrollContainer = document.getElementById("event-detail-wrapper").offsetHeight;
			var scrollContent = document.getElementById("event-detail-inner").offsetHeight;
			var scrollDifference = scrollContent - scrollContainer;
			if (scrollDifference < 0) {
				return false;
			} else {
				var scrollIndex = scrollDifference / 100;
				scrollIndex = Math.floor(scrollIndex) + 1;
				if (carouselStatus >= scrollIndex) {
					return false;
				} else {
					carouselStatus++;
					document.getElementById("event-detail-inner").style.transform = "translateY(-" + carouselStatus * 100 + "px)";
				}
			}
		}

	}

})();
/**
 * Created by unal on 07.04.2017.
 */



(function () {


      var path = 'app/common/sessionTimeout/modalPopUps';


      angular
            .module('novusTerminal')
            .directive('aptIdleStart', DirectiveFn);

      function DirectiveFn() {
            return {
                  restrict: 'EA',
                  scope: {},
                  bindToController: true,
                  controller: ControllerFn,
                  controllerAs: 'vmIdleStart',
                  templateUrl: function (elem, attrs) {
                        if (attrs.template) {
                              return path + '/idle-start-popup.' + attrs.template + '.html';
                        } else {
                              return path + '/idle-start-popup.html';
                        }
                  }
            }
      }

      ControllerFn.$inject = [
            'Idle',
      ];
      function ControllerFn(Idle) {
            var vm = this;

            vm.timeout = Idle.getTimeout()


      }

})();
(function () {
	var path = 'app/common/rightSideBar/directives';
	angular.module('novusTerminal').directive('aptPrintSavedTicket', DirectiveFn);

	function DirectiveFn() {
		return {
			restrict: 'EA',
			scope: {},
			bindToController: true,
			controller: ControllerFn,
			controllerAs: 'vmPrintSavedTicket',
			templateUrl: function (elem, attr) {
				if (attr.template) {
					return path + '/print-saved-ticket' + attr.template + '.html';
				} else {
					return path + '/print-saved-ticket.html';
				}
			}
		}
	}

	ControllerFn.$inject = ['TicketEventService', '$location', 'TicketPrintLogoService'];
	function ControllerFn(TicketEventService, $location, TicketPrintLogoService) {
		var vm = this;
        vm.couponLogoPrint = TicketPrintLogoService.getTicketLogo();


		vm.currentDate = new Date();
		vm.savedTicketData = TicketEventService.getTicketData().savedTicket;
		vm.barcodeOptions = {
			width: 2,
			height: 100,
			format: 'auto',
			quite: 10,
			backgroundColor: '',
			lineColor: '#000'
		};
		vm.back = function () {
			TicketEventService.removeSavedTicketData();
		};
		vm.print = function (code) {
			var previousState = encodeURIComponent($location.path());
			var path = '/print-manager/coupon/' + code + '/' + previousState;
			return $location.path(path);
		};
	}
})();
/**
 * Created by unal on 9/15/2017.
 */


(function () {

	angular.module('novusTerminal').factory('LeftMenuService', ServiceFn);

	ServiceFn.$inject = [];
	function ServiceFn() {

		var menuSettings = {
			menuDisplay: false,
			menuButton: false
		};

		var serviceObj = {

			setMenuSettings: function (settings) {
				_.merge(menuSettings, settings);
			},

			getMenuSettings: function () {
				return menuSettings;
			}
		};


		return serviceObj;
	}

})();
/**
 * Created by unal on 23.05.2017.
 */



(function () {

	angular
		.module('novusTerminal')
		.factory('UserService', ServiceFn);

	ServiceFn.$inject = [
		'UtilsService',
		'$cookies',
	];
	function ServiceFn(UtilsService, $cookies) {

		var userTimezoneValue = '';

		var user = {};

		var userBalanceData = {};

		var userSubAccounts = [];

		var userParameters = [];
		var userMenu = [];


		var serviceObj = {
			setUser: function (userData) {
				$cookies.put('UserLoggedIn', 1);
				UtilsService.removeAndMerge(user, userData);
			},

			getUser: function () {
				return user;
			},
			setMenu: function (menu) {
                _.remove(userMenu);
				_.merge(userMenu,menu);
            },

			getMenu: function(){
				return userMenu;
			},


			resetUser: function () {

				/**
				 *we need to delete
				 */
				UtilsService.removeObjectProperties(user);
				UtilsService.removeObjectProperties(userBalanceData);
			},

			setUserBalanceData: function (balanceData) {
				UtilsService.removeAndMerge(userBalanceData, balanceData);
			},

			getUserBalanceData: function () {
				return userBalanceData;
			},


			setUserSubAccount: function (subAccounts) {
				userSubAccounts.splice(0, userSubAccounts.length);
				_.merge(userSubAccounts, subAccounts);
			},

			getUserSubAccount: function () {
				return userSubAccounts;
			},

			setUserParameters: function (parameters) {
				userParameters.splice(0, length);
				_.forIn(parameters, function (parameter) {
					userParameters.push(parameter);
				})
			},

			getUserParameters: function () {
				return userParameters;
			},

			getParameterValue: function (parameterName) {
				var parameterObj = _.find(userParameters, {code: parameterName});
				if (parameterObj.value === '') {
					return null;
				}
				return parameterObj.value * 1;
			},

			setUserTimezone: function (timezoneNewValue) {
				userTimezoneValue = timezoneNewValue;
			}

		};


		return serviceObj;
	}

})();
/**
 * Created by unal on 18.05.2017.
 */



(function () {

      angular
            .module('novusTerminal')
            .factory('UserModelService', ServiceFn);


      ServiceFn.$inject = ['ApiService'];
      function ServiceFn(ApiService) {
            var rest = ApiService.serviceOne();

            return rest.service('user');
      }


})();
/**
 * Created by unal on 9/18/2017.
 */


(function () {

	angular
		.module('novusTerminal')
		.factory('RegisterService', ServiceFn);

	ServiceFn.$inject = [
		'RegisterModelService',
		'ToastrNotificationService'
	];
	function ServiceFn(RegisterModelService, ToastrNotificationService) {


		var registerTestData = {
			name: "",
			surname: "",
			document_number: "",
			gender: "2",
			currency_id: "5",
			mobile: "",
			language_id: "1",
			country_of_birth: "",
			city: "",
			country_of_residance: 158,
			zip: "",
			address: "",
			username: "",
			password: "",
			password_confirm: "",
			email: "",
			place_of_birth: "",
			answer: "carol",
			facebook: "",
			province: "",
			phone: "905453333333",
			whatsapp: "",
			nationality: "",
			question_id: "2",
			timezone: "Europe/Malta",
			skype: "",
			term_and_condition: true,
			accept_information: true,
			subscribe: true,
			phoneDetails: ["tr", "+90", "905453333333"],
			selected: {"code": "NG", "id": 169, "name": "Nigeria"},
			birthday: "1985-6-6",
		};

		var settings = {
			buttonDisable: false,
			loadingBar: false
		};

		var serviceObj = {

			register: function (data) {
				_.merge(settings, {buttonDisable: true});
				_.merge(settings, {loadingBar: true});
				return RegisterModelService.post(data).then(function (res) {
					ToastrNotificationService.notificationPopUp('Successfully Registered!', 'success');
					_.merge(settings, {buttonDisable: false});
					_.merge(settings, {loadingBar: false});
					return true;
				}).catch(function (res) {
					_.merge(settings, {buttonDisable: false});
					_.merge(settings, {loadingBar: false});
					if (_.has(res.data.data, 'errors')) {
						var idx = 0;
						_.forEach(res.data.data.errors, function (key, value) {
							idx++;
							if (idx > 1) {
								return;
							}
							ToastrNotificationService.notificationPopUp(key[0], 'error');

						});


					} else {
						ToastrNotificationService.notificationPopUp('Validate Error', 'error');
					}
					return false;
				})
			},

			getRegisterData: function () {
				return registerTestData;
			},

			getSettings: function () {
				return settings;
			}
		};


		return serviceObj;
	}

})();

/**
 * Created by Emre on 30.06.2017.
 */

(function () {
      'use strict';
      angular
          .module('novusTerminal')
          .controller('RegisterManagerCtrl', ControllerFn);

      ControllerFn.$inject = [];
      function ControllerFn() {
            var vm = this;
      }

})();
/**
 * Created by unal on 17.05.2017.
 */



(function () {

	angular
		.module('novusTerminal')
		.factory('LogoutService', ServiceFn);

	ServiceFn.$inject = [
		'LogoutModel',
		'UserService',
		'$cookies',
		'Idle',
		'ToastrNotificationService',
		'AuthorizationService',
		'SessionTimeoutService',
		'$state',
		'CurrencyService'];
	function ServiceFn(LogoutModel, UserService, $cookies, Idle,
				 ToastrNotificationService, AuthorizationService,
				 SessionTimeoutService, $state, CurrencyService) {

		var serviceObj = {
			logout: function () {
				LogoutModel.post().then(function (data) {
					loadUserPermissions();
					UserService.resetUser();
					stopSessionTimeout();
					$cookies.put('UserLoggedIn', 0);
					CurrencyService.resetCurrencyData();
					ToastrNotificationService.notificationPopUp('logged_out_successfully', 'success');
				}).catch(function (response) {
                    ToastrNotificationService.notificationPopUp(response.data.error_message, 'error');
                })
			}

		};

		/**
		 *after user logout we cancel idle
		 */
		function stopSessionTimeout() {
			Idle.unwatch();
			Idle.setIdle(1);
			SessionTimeoutService.setTime(null);
		};


		/**
		 *after user logout we get default permissions
		 * and redirect main page
		 */
		function loadUserPermissions() {
			AuthorizationService.loadAuth().then(function () {
				if ($state.current.authenticate && !AuthorizationService.checkRoutePermissions($state.current.authenticate)) {
					$state.go('sport');
				}
			});
		}

		return serviceObj;
	}

})();
/**
 * Created by unal on 18.05.2017.
 */



(function () {

      angular
            .module('novusTerminal')
            .factory('LogoutModel', ServiceFn);


      ServiceFn.$inject = ['ApiService'];
      function ServiceFn(ApiService) {
            var rest = ApiService.serviceOne();

            return rest.service('logout');
      }


})();
/**
 * Created by unal on 17.05.2017.
 */



(function () {

      angular
              .module('novusTerminal')
              .factory('LoginService', ServiceFn);

      ServiceFn.$inject = [
            'LoginModelService',
            'UserService',
            'UpdateService',
            'ToastrNotificationService',
            'InitService',
            'AuthorizationService'];
      function ServiceFn(LoginModelService, UserService,
                         UpdateService, ToastrNotificationService,
                         InitService, AuthorizationService) {

            var serviceObj = {
                  login: function (userData) {
                        return LoginModelService.post(userData).then(function (data) {
                              loadUserPermissions();
                              UserService.setUser(data.data.user);
                              UpdateService.getUpdate();
                              UpdateService.setExtendTimeoutStatus(true);
                              ToastrNotificationService.notificationPopUp('logged_in_successfully', 'success');
                              setRequiredUserDataFromInit();
                        }).catch(function (response) {
                              ToastrNotificationService.notificationPopUp(response.data.error_message, 'error');
                        })
                  }

            };

            function setRequiredUserDataFromInit() {
                  InitService.initAfterLoggedIn();
            };

            function loadUserPermissions() {
                  AuthorizationService.loadAuth();
            }

            return serviceObj;
      }

})();
/**
 * Created by unal on 18.05.2017.
 */



(function () {

      angular
            .module('novusTerminal')
            .config(InterceptorFn)
            .factory('LoginModelService', ServiceFn);


      InterceptorFn.$inject = ['RestangularProvider'];
      function InterceptorFn(RestangularProvider) {


            RestangularProvider.addResponseInterceptor(function (data, operation, what, url, response, deferred) {


                  // var auth = response.headers('auth');
                  return data;

            });

            RestangularProvider.addRequestInterceptor(function (data, operation, what, url) {

                  if (what != 'login') {
                        return data;
                  }

                  return data;
            });

      }

      ServiceFn.$inject = ['ApiService'];
      function ServiceFn(ApiService) {
            var rest = ApiService.serviceOne();

            return rest.service('login');
      }


})();
/**
 * Created by unal on 10.04.2017.
 */



(function () {

      var path = 'app/user/login';

      angular
            .module('novusTerminal')
            .directive('aptLoginForm', DirectiveFn);

      function DirectiveFn() {
            return {
                  restrict: 'EA',
                  scope: {},
                  bindToController: {
                        closePopup: '&'
                  },
                  controller: ControllerFn,
                  controllerAs: 'vmLoginForm',
                  templateUrl: function (elem, attrs) {
                        if (attrs.template) {
                              return path + '/login-form.' + attrs.template + '.html';
                        } else {
                              return path + '/login-form.html';
                        }
                  }
            }
      }

      ControllerFn.$inject = [
            'CreatePopupComponentService',
            'LoginService',
            'languageService'
      ];
      function ControllerFn(CreatePopupComponentService, LoginService, languageService) {
            var vm = this;

            // seçili dil objesini getirir
            vm.language = languageService.getSelectedLanguage();

            vm.close = closeFn;
            vm.forgotPassword = forgotPasswordFn;
            vm.login = loginFn;
            vm.registerForm = registerFormFn;
            vm.password = /^(?=.*[0-9])(?=.*[a-zA-Z])([a-zA-Z0-9!"#$%&()\*\+,-.\/\@[\]^_`{}~]+)$/;
            vm.credentials = {
                  isEmail: '',
                  password: ''
            };

            function forgotPasswordFn() {
                  var componentSetting = {
                        name: 'forgot-password-form'
                  };

                  CreatePopupComponentService.createPopupComponent(componentSetting);
                  closeFn();
            }

            function registerFormFn() {
                  var componentSetting = {
                        name: 'register-form'
                  };

                  CreatePopupComponentService.createPopupComponent(componentSetting);
                  closeFn();
            }

            function closeFn() {
                  if (_.isFunction(vm.closePopup)) {
                        vm.closePopup({ data: false });
                  }
            }
            setFormFlag();
            function setFormFlag() {
                  vm.isEmail = true;
                  vm.isPassword = true;
                  vm.isPasswordsConditions = true;
                  vm.isCredentials = true;
            }
            function loginFn() {
                  setFormFlag();
                  if (vm.loginValidationForm.$invalid) {
                        vm.isEmail = false;
                        vm.isPassword = false;
                        vm.isPasswordsConditions = false;
                        vm.isCredentials = false;
                  } else if (vm.credentials.password !== '' && vm.credentials.isEmail !== '' && vm.credentials.password.length < 8) {
                        if (vm.credentials.password === vm.password) {
                              vm.isPasswordsConditions = false;
                        }
                  } else {
                        LoginService.login(vm.data).then(function () {
                              closeFn();
                        });
                  }
            }

      }

})();
/**
 * Created by unal on 10.04.2017.
 */



(function () {

      var path = 'app/user/';

      angular
            .module('novusTerminal')
            .directive('aptForgotPasswordForm', DirectiveFn);

      function DirectiveFn() {
            return {
                  restrict: 'EA',
                  scope: {},
                  bindToController: {
                        closePopup: '&'
                  },
                  controller: ControllerFn,
                  controllerAs: 'vmForgotPasswordForm',
                  templateUrl: function (elem, attrs) {
                        if (attrs.template) {
                              return path + 'forgotPasswordForm/forgot-password-form.' + attrs.template + '.html';
                        } else {
                              return path + 'forgotPasswordForm/forgot-password-form.html';
                        }
                  }
            }
      }

      ControllerFn.$inject = ['CreatePopupComponentService','languageService'];
      function ControllerFn(CreatePopupComponentService, languageService) {
            var vm = this;

            // seçili dil objesini getirir
            vm.language = languageService.getSelectedLanguage();

            vm.close = closeFn;
            vm.loginForm = loginFormFn;
            vm.registerForm = registerFormFn;

            function loginFormFn () {
                var componentSetting = {
                    name: 'login-form'
                };

                CreatePopupComponentService.createPopupComponent(componentSetting);
                closeFn();
            }

            function registerFormFn() {
                var componentSetting = {
                    name: 'register-form'
                };

                CreatePopupComponentService.createPopupComponent(componentSetting);
                closeFn();
            }

            function closeFn() {
                  if (_.isFunction(vm.closePopup)) {
                        vm.closePopup({data: false});
                  }
            }

      }

})();
/**
 * Created by unal on 07.04.2017.
 */



(function () {

      var path = 'app/sport/tournamentsTimeframe';

      angular
              .module('novusTerminal')
              .directive('aptTournamentsTimeFrame', DirectiveFn);

      function DirectiveFn() {
            return {
                  restrict: 'EA',
                  scope: {},
                  bindToController: true,
                  controller: ControllerFn,
                  controllerAs: 'vmTournamentsTimeFrame',
                  templateUrl: function (elem, attrs) {
                        if (attrs.template) {
                              return path + '/tournaments-timeFrame.' + attrs.template + '.html';
                        } else {
                              return path + '/tournaments-timeFrame.html';
                        }
                  }
            }
      }

      ControllerFn.$inject = ['TimeFrameService', 'CategoryService'];
      function ControllerFn(TimeFrameService, CategoryService) {
            var vm = this;

            vm.timeFrames = TimeFrameService.getTimeFrames();
            vm.selectedTimeFrame = TimeFrameService.getSelectedTimeFrame();
            vm.selectMenuStatus = false;
            vm.setTimeFrame = setTimeFrameFn;
            vm.selectMenu = selectMenuFn;


            function setTimeFrameFn(timeFrame) {
                  vm.selectedTimeFrame = timeFrame.type;
                  TimeFrameService.setTimeFrame(timeFrame);
                  CategoryService.resetCategoryData();
                  CategoryService.loadCategoryData();
                  setSelectedTimeFrameData();
                  selectMenuFn();
            }

            function selectMenuFn() {
                  vm.selectMenuStatus = !vm.selectMenuStatus;
            }

            setSelectedTimeFrameData();

            function setSelectedTimeFrameData() {
                  vm.selectedTimeFrameDataName = _.find(vm.timeFrames, {type: vm.selectedTimeFrame * 1}).name;
            }
      }

})();
/**
 * Created by unal on 23.05.2017.
 */



(function () {

	angular
		.module('novusTerminal')
		.factory('TimeFrameService', ServiceFn);

	ServiceFn.$inject = [
		'$cookies'
	];

	function ServiceFn($cookies) {

		var timeFrames = [
			{
				type: 1,
				status: '1',
				value: '1hour',
				name: '1_hour'
			},
			{
				type: 2,
                status: '2',
				value: '3hours',
				name: '3_hours'
			},
			{
				type: 3,
                status: '3',
				value: 'today',
				name: 'today'
			},
			{
				type: 4,
                status: '4',
				value: '3days',
				name: '3_days'
			},
			{
				type: 5,
                status: '5',
				value: 'all',
				name: 'all_select'
			}
		];


		var selectedTimeFrame = $cookies.get('terminalTimeFrame') * 1 || 5;

		var serviceObj = {

			getTimeFrames: function () {
				return timeFrames;
			},

			getSelectedTimeFrameReqValue: function () {
				return _.find(timeFrames, {type: selectedTimeFrame * 1}).value;
			},
			getSelectedTimeFrame: function () {
				return selectedTimeFrame * 1;
			},
            getSelectedTimeFrameStatus: function () {
                return _.find(timeFrames, {type: selectedTimeFrame * 1}).status;
            },
            setTimeFrame: function (timeFrame) {
				selectedTimeFrame = timeFrame.type;
				$cookies.put('terminalTimeFrame', timeFrame.type);
			},

		};


		return serviceObj;
	}

})();
/**
 * Created by unal on 07.04.2017.
 */



(function () {

      var path = 'app/sport/oddsPage';

      angular
              .module('novusTerminal')
            .filter('roundUp', function() {
                  return function(input) {
                      return Math.ceil(input);
                  };
              })
              .directive('aptOddsPage', DirectiveFn)
            .directive("scrollHeightDetector", function() {

            return {
                        restrict : "A",
                        link : function(scope, element, attrs) {

                            var height = attrs.scrollHeight;

                        }
                  }
            });

      function DirectiveFn() {
            return {
                  restrict: 'EA',
                  scope: {},
                  bindToController: true,
                  controller: ControllerFn,
                  controllerAs: 'vmOddsPage',
                  templateUrl: function (elem, attrs) {
                        if (attrs.template) {
                              return path + '/odds-page.' + attrs.template + '.html';
                        } else {
                              return path + '/odds-page.html';
                        }
                  }
            }
      }
      ControllerFn.$inject = ['OddsService','LeftSideBarService','TicketEventService','GeneralPurposeService','NotifyingService','$scope'];

      function ControllerFn (OddsService, LeftSideBarService, TicketEventService, GeneralPurposeService, NotifyingService, $scope) {

             var vm = this;

          NotifyingService.subscribe($scope,'sport-left-odds-content-header-show:click', function () {
              vm.isShowLeftSideBar = GeneralPurposeService.getToolBar();

          });



            vm.markets = OddsService.getDefaultMarketBar();
            vm.tournaments = OddsService.getTournaments();

            vm.settings = OddsService.getOddsPageUiSetting();
            vm.allMarketGroups = function (tournament) {
                  tournament.allMarketGroupItems = !tournament.allMarketGroupItems;
            };

            vm.loadMarketGroup = loadMarketGroupFn;
            vm.openExtraOdds = openExtraOddsFn;
            vm.closeTournamentMarketGroup = closeTournamentMarketGroupFn;
            vm.clickOdds = clickOddsFn;
            vm.checkOdds = checkOddsFn;



            function loadMarketGroupFn(marketGroup, tournamentId) {
                  if (!marketGroup.selected) {
                        OddsService.loadSelectedMarketGroup(tournamentId, marketGroup.market_group_id);
                        marketGroup.selected = true;
                  } else {
                        marketGroup.selected = false;
                        OddsService.removeSelectedMarketGroupEvent(tournamentId, marketGroup.market_group_id);
                  }
            }


            function openExtraOddsFn(event) {
                  event.eventExtraOdds = !event.eventExtraOdds;

                  if (event.eventExtraOdds) {
                        OddsService.loadEventExtraOdds(event.event_id);
                  }
            }

            function closeTournamentMarketGroupFn(tournament, marketGroupEvent) {
                  var mgIdx = _.findIndex(tournament.marketGroupEvents, {market_group_id: marketGroupEvent.market_group_id});

                  if (mgIdx < 0) {
                        return;
                  }


                  /**
                   * market group active control
                   * the market closed market
                   */
                  var closedMarketGroup = _.find(tournament.market_groups, {market_group_id: marketGroupEvent.market_group_id});

                  if (_.isObject(closedMarketGroup)) {
                        closedMarketGroup.selected = false;
                  }

                  /**
                   *we delete selected market group from tournament
                   */
                  tournament.marketGroupEvents.splice(mgIdx, 1);


                  /**
                   *if tournament opened market groups count > 0
                   * we dont close tournament we only close
                   * market group
                   */
                  if (tournament.marketGroupEvents.length > 0) {
                        return;
                  }


                  /**
                   *we delete tournament from oddsData tournaments
                   */
                  OddsService.removeSelectedTournament(tournament.tournament_id);

                  /**
                   * this functions for left sidebar control
                   * we cancel active class and clicked tournament control
                   */
                  LeftSideBarService.removeActiveClassForClosedTournament(tournament.tournament_id);
                  LeftSideBarService.removeClickedTournament(tournament.tournament_id);
            };


            function clickOddsFn(event, odds, market,tournament) {

			if (_.isEqual(odds.value, '-')) {
				return;
			}
			odds.market_name = market.name || '';
			odds.market_id = market.market_id || '';

			/**
			 *this control for goal scorer
			 */
			if (_.isEqual(tournament.group_id, event.group_id)) {
				TicketEventService.manageTicketGroupEvents(event, odds, tournament);
				return;
			}

			TicketEventService.manageClickedItem(event, odds);

            }


            var clickedOddsEvents = TicketEventService.getClickedOddsEvents();

            function checkOddsFn(odds) {


                  if (clickedOddsEvents.length <= 0) {
                        return false;
                  }

                  var oIdx = _.findIndex(clickedOddsEvents, {event_odds_id: odds.event_odds_id});
                  return oIdx >= 0 ? true : false;

            }



          // scroll  control///



          var scrollStatus = 0;
          vm.upOddsScroll = upScrollFn;
          vm.downOddsScroll = bottomScrollFn;

          function upScrollFn() {

              var element = $('#odds-page-content')[0];

              var odsScrollHeight = element.scrollHeight;
              scrollStatus = element.scrollTop;

              if(scrollStatus >= 0 && odsScrollHeight >= scrollStatus ){
                  scrollStatus -=  100;

              }else {
                  scrollStatus = 0;
              }

              element.scrollTop=scrollStatus;

          }

          function bottomScrollFn() {

              var element = $('#odds-page-content')[0];

              var odsScrollHeight = element.scrollHeight;
              scrollStatus = element.scrollTop;

              if(scrollStatus >= 0 && odsScrollHeight >= scrollStatus ){
                  scrollStatus +=  100;

              }else {
                  scrollStatus = 0;
              }

              element.scrollTop=scrollStatus;

          }
          // scroll control ///






            // var carouselStatus = 0;
            // vm.topScroll = topScrollFn;
            // function topScrollFn() {
            //       if (carouselStatus == 0) {
            //             return false;
            //       }
            //       carouselStatus--;
            //       document.getElementById("odds-page-scroll-content").style.transform = "translateY(-" + carouselStatus * 100 + "px)";
            // }
            //
            // vm.bottomScroll = bottomScrollFn;
            //
            //
            //
            // function bottomScrollFn() {
            //       var scrollContainer = document.getElementById("odds-page-content").offsetHeight;
            //       var scrollContent = document.getElementById("odds-page-scroll-content").offsetHeight;
            //       var scrollDifference = scrollContent - scrollContainer;
            //       if (scrollDifference < 0) {
            //             return false;
            //       } else {
            //             var scrollIndex = scrollDifference / 100;
            //             scrollIndex = Math.floor(scrollIndex) + 1;
            //             if (carouselStatus >= scrollIndex) {
            //                   return false;
            //             } else {
            //                   carouselStatus++;
            //                   document.getElementById("odds-page-scroll-content").style.transform = "translateY(-" + carouselStatus * 100 + "px)";
            //             }
            //       }
            // }
      }
})();
/**
 * Created by unal on 22.05.2017.
 */



(function () {

      angular
            .module('novusTerminal')
            .factory('CategoryService', ServiceFn);

      ServiceFn.$inject = [
            'CategoryModelService',
            'UtilsService',
            'TimeFrameService',
            'NotifyingService'
      ];
      function ServiceFn(CategoryModelService, UtilsService, TimeFrameService, NotifyingService) {

            var navBarSportsData = [];
            var navBarOutrightData = [];

            var selectedSportCategory = [];
            var navBarSelectedSport = [];

          var selectedOutrightCategory = [];
          var navBarSelectedOutright = [];



            var serviceObj = {

                  loadCategoryData: function () {

                        CategoryModelService.post({
                              tf: TimeFrameService.getSelectedTimeFrameReqValue()
                        }).then(function (data) {

                              if (_.has(data.data.sidebar, 'matches') && data.data.sidebar.matches.length > 0) {


                                  var matches = _.merge(navBarSportsData, data.data.sidebar.matches);

                                  // matches dizisine classını farklı göstermek için outright değişkeni 0 eklendi
                                  for (var i = 0; i < matches.length; i++) {
                                      matches[i].outright = 0;

                                  }

                                  // machhes dizisine active classı kontrolü için indx eklendi

                                  for (var i = 0; i < matches.length; i++) {
                                      matches[i].indx = i;

                                  }

                                  setInitialSportCategory(matches[0].categories);
                                  setInitialSelectedNavBarSport(matches[0]);

                              }
                              if (_.has(data.data.sidebar, 'outrights') && data.data.sidebar.outrights.length > 0) {


                                    var outrights = _.merge(navBarOutrightData, data.data.sidebar.outrights);

                                  // outrights dizisine classını farklı göstermek için outright değişkeni 1 eklendi
                                  for (var i = 0; i < outrights.length; i++) {
                                      outrights[i].outright = 1;

                                  }
                                  // outrights dizisine active classı kontrolü için indx eklendi

                                  for (var i = 0; i < outrights.length; i++) {
                                      outrights[i].indx = i;

                                  }

                                  // machhes ve outrights dizileri birleştirildi

                                  for (var i = 0; i < outrights.length; i++) {
                                      matches.push(outrights[i]);
                                  }

                                  setInitialOutrightCategory(outrights[0].categories);
                                  setInitialSelectedNavBarOutright();
                              }



                        })
                  },

                    getNavBarSports: function () {

                        return navBarSportsData;
                    },

                    getNavBarOutrights: function () {

                        return navBarOutrightData;
                    },

                  getSelectedSportCategory: function () {
                        return selectedSportCategory;
                  },

                  setSelectedSportCategories: function (sport) {
                      selectedSportCategory.splice(0, selectedSportCategory.length);
                      var selectedSportData;
                        if(sport.outright === 0) {
                            selectedSportData = _.find(navBarSportsData, {indx: sport.indx});
                        }
                        else {
                            selectedSportData = _.find(navBarOutrightData, {indx: sport.indx});
                        }

                        _.merge(selectedSportCategory, selectedSportData.categories);
                  },

                getSelectedNavBarSport: function () {
                    return navBarSelectedSport;
                },
                getSelectedNavBarOutright: function () {
                    return navBarSelectedOutright;
                },

                  setSelectedNavBarSport: function (sport) {

                        UtilsService.removeAndMerge(navBarSelectedSport, sport);
                  },

                  resetCategoryData: function () {
                        navBarSportsData.splice(0, navBarSportsData.length);
                        selectedSportCategory.splice(0, selectedSportCategory.length);
                        UtilsService.removeObjectProperties(navBarSelectedSport);
                        navBarOutrightData.splice(0, navBarOutrightData.length);
                        NotifyingService.notify('time-frame:changed');
                  },

                  setLeftSideBarDisplaySetting: function (tournament) {
                        var category = _.find(selectedSportCategory, {id: tournament.category_id}) || _.find(selectedSportCategory, {id: tournament.special_category_id * 1});

                        if (!category) {
                              return;
                        }

                        category.isOpenSubItem = true;

                        var categoryTournament = _.find(category.tournaments, {id: tournament.tournament_id});

                        if (!categoryTournament) {
                              return;
                        }

                        categoryTournament.clicked = true;

                  }
            };

            function setInitialSportCategory(categories) {
                  _.merge(selectedSportCategory, categories);
            }

            function setInitialSelectedNavBarSport(sport) {


                  _.merge(navBarSelectedSport, sport);
            }

          function setInitialOutrightCategory(categories) {
              _.merge(selectedOutrightCategory, categories);
          }

          function setInitialSelectedNavBarOutright(outright) {

              _.merge(navBarSelectedOutright, outright);


          }

            return serviceObj;
      }

})();
/**
 * Created by unal on 18.05.2017.
 */



(function () {

      angular
            .module('novusTerminal')
            .config(InterceptorFn)
            .factory('CategoryModelService', ServiceFn);


      InterceptorFn.$inject = ['RestangularProvider'];
      function InterceptorFn(RestangularProvider) {


            RestangularProvider.addResponseInterceptor(function (data, operation, what, url, response, deferred) {


                  // var auth = response.headers('auth');
                  return data;

            });

            RestangularProvider.addRequestInterceptor(function (data, operation, what, url) {

                  // var auth = $cookies.get('terminalAuth') || '';

                  // var languageId = 1;
                  // data.auth = auth;
                  // data.language_id = languageId;
                  return data;
            });

      }

      ServiceFn.$inject = ['ApiService'];
      function ServiceFn(ApiService) {
            var rest =ApiService.serviceTwo();

            return rest.service('side-bar-terminal');
      }


})();
/**
 * Created by Emre on 28.06.2017.
 */

(function () {
      'use strict';
      angular
          .module('novusTerminal')
          .controller('TransactionsManagerCtrl', ControllerFn);

      ControllerFn.$inject = [];
      function ControllerFn() {
            var vm = this;
      }

})();
/**
 * Created by Emre on 20.06.2017.
 */

(function () {
        'use strict';
        angular
                  .module('novusTerminal')
                  .controller('SessionsCtrl', ControllerFn);

        ControllerFn.$inject = [];
        function ControllerFn() {
                var vm = this;

        }

})();
/**
 * Created by Byn on 9.07.2017.
 */
(function () {

      angular
            .module('novusTerminal')
            .controller('RevenueReportManagerCtrl', ControllerFn);

      ControllerFn.$inject = ['RevenueReportService'];
      function ControllerFn(RevenueReportService) {
            var vm = this;

            RevenueReportService.resetAllFilters();
            RevenueReportService.setUser();
      }

})();
/**
 * Created by unal on 18.05.2017.
 */



(function () {

        angular
                  .module('novusTerminal')
                  .config(InterceptorFn)
                  .factory('RegisterModelService', ServiceFn);


        InterceptorFn.$inject = ['RestangularProvider'];
        function InterceptorFn(RestangularProvider) {


                RestangularProvider.addResponseInterceptor(function (data, operation, what, url, response, deferred) {


                        // var auth = response.headers('auth');
                        return data;

                });

                RestangularProvider.addRequestInterceptor(function (data, operation, what, url) {

                        return data;
                });

        }

        ServiceFn.$inject = ['ApiService'];
        function ServiceFn(ApiService) {
                var rest = ApiService.serviceOne();

                return rest.service('register');
        }


})();
/**
 * Created by Emre on 20.06.2017.
 */

(function () {
        'use strict';
        angular
                  .module('novusTerminal')
                  .controller('PersonalDetailsCtrl', ControllerFn);

        ControllerFn.$inject = [
                'PersonalDetailService',
                'RegisterOptionService'
        ];
        function ControllerFn(PersonalDetailService, RegisterOptionService) {
                var vm = this;
                PersonalDetailService.resetPersonalData();
                PersonalDetailService.loadPersonalDetail();
                RegisterOptionService.loadOptions();
        }

})();
/**
 * Created by unal on 03.01.2017.
 */



(function () {

    angular
        .module('novusTerminal')
        .factory('TicketStakeButtonService', ServiceFn);

    ServiceFn.$inject = ['$cookies'];
    function ServiceFn($cookies) {

        var ticketStakes = [];
        var serviceObj = {

            setTicketStakeButtons: function (stakes, status) {
                if (status && status == 'defaultButtonsStake') {
                    $cookies.putObject('bookmaker-stake-buttons', {stake: stakes})
                }
                ticketStakes.splice(0, ticketStakes.length);
                _.merge(ticketStakes, stakes);
            },

            getTicketStakeButtons: function () {
                return ticketStakes;
            },

            /**
             * money deposit and withdraw increase money value
             * @returns {*}
             */
            getFirstStakeButtonsValue: function () {
                return ticketStakes[0];
            }
        };

        return serviceObj;
    }

})();

/**
 * Created by unal on 24.01.2017.
 */



(function () {

    angular
        .module('novusTerminal')
        .factory('MoneyTransferService', ServiceFn);

    ServiceFn.$inject = ['CalendarConfigurationService', 'TicketStakeButtonService', 'ApiService'];
    function ServiceFn(CalendarConfigurationService, TicketStakeButtonService, ApiService) {

        var months = [];

        var years = [];

        var monthsName = [];

        var serviceObj = {
            setMonths: function () {
                months.splice(0, months.length);
                monthsName.splice(0, monthsName.length);
                setMonthsName();
                for (var i = 1; i <= 12; i++) {
                    var monthName = _.find(monthsName, {id: i});
                    var month = {
                        value: monthName.month + ' ' + '(' + (i < 10 ? '0' + i : i) + ')',
                        month: i
                    };
                    months.push(month);
                }

            },

            getMonths: function () {
                return months;
            },

            setYears: function () {
                years.splice(0, years.length);
                var startYear = moment().year();
                var finishYear = startYear + 10;
                for (startYear; startYear <= finishYear; startYear++) {
                    var year = {
                        year: startYear
                    };

                    years.push(year);
                }
            },

            getYears: function () {
                return years;
            },

            resetMoneyDate: function () {
                months.splice(0, months.length);
                years.splice(0, years.length);
                monthsName.splice(0, monthsName.length);
            },

            getMonetIncreaseValue: function () {
                return TicketStakeButtonService.getFirstStakeButtonsValue();
            },

            moneyTransfer: function (data) {
                return ApiService.serviceOne('', data);
            },
            getContent: function (data) {
                return ApiService.serviceOne('content', data);
            },


        };

        function setMonthsName() {
            var mIdx = 1;
            var dateOptions = CalendarConfigurationService.getCalendarOptions();
            angular.forEach(dateOptions.locale.monthNames, function (month) {
                monthsName.push({id: mIdx, month: month});
                mIdx++;
            })
        }

        return serviceObj;
    }

})();
/**
 * Created by unal on 24.01.2017.
 */
(function () {
    angular.module('novusTerminal').controller('MoneyDepositManagerCtrl', ControllerFn);
    ControllerFn.$inject = ['MoneyTransferService', 'NotifyingService', '$scope', '$sce', 'ApiService', '$compile', 'UserService', '$location', '$uibModal','VoucherModelService','$cookies'];
    function ControllerFn(MoneyTransferService, NotifyingService, $scope, $sce, ApiService, $compile, UserService, $location, $uibModal,VoucherModelService, $cookies) {
        var vm = this;
        $scope.currentBankTab = 2;
        vm.isAmount = true;
        $scope.activeTabs = [];

        vm.mtoken= $cookies.get('mtoken');
        vm.url = $cookies.get('cashier');
        //http://localhost:3000/?cashier=http://api.desktop.dev.betnovus.tech&mtoken=mqF0ww4bZxcYlVO9A0Q3RGLvt2QhPNQCevoYr12YOMini6IidMHKmT0Ma4YM#/profile/money/money-deposit
        vm.text= '?cashier='+vm.url+'&mtoken='+vm.mtoken;

        VoucherModelService.post({slug: 'deposit',mUrl:vm.text}).then(function (res) {
            setTimeout(function () {
                $('#money_container').html($compile($(res))($scope));
            });
        });
        vm.user = {};
        vm.isUser = 1;
        vm.setActiveTab = function (tabKey) {
            vm.activeTab = tabKey;
        };
        vm.isTabSet = function (tab) {
            return vm.activeTab === tab;
        };
        vm.stuffToDoWithTheDom = function domStuff() {
            vm.apCoPayDataInput = document.getElementById('dark-input-radius');
            if (vm.apCoPayDataInput) {
                vm.apCoPayDataInput.addEventListener('keypress', function (e) {
                    if (e.which === 13 || e.keyCode === 13) {
                        vm.apCoPay();
                    }
                });
            }
            if (vm.apCoPayForm && vm.apCoPayData) {
                vm.apCoPayData.amount = vm.apCoPayForm = null;
            }
        };
        vm.showMethod = function (data) {
            vm.apCoPayData = null;
            if (data && typeof data === 'number') {
                VoucherModelService.post({ slug: 'deposit', id: data }).then(function (res) {
                    vm.paymentMethod = res;
                    $('.methodContainer').html($compile($(vm.paymentMethod))($scope));
                    vm.stuffToDoWithTheDom();
                    vm.activeTab = data;
                }).error(function (res) {
                    console.log(res);
                });
            } else {
                $location.path('/' + data);
            }
        };
        vm.date = new Date();
        MoneyTransferService.setYears();
        MoneyTransferService.setMonths();
        vm.interSwitchUpdate = function (e) {
            if ((!e || e.which === 13 || e.keyCode === 13 || (!e.keyCode && !e.which)) && vm.depositForm.$valid) {
                VoucherModelService.post('user/interswitch', {
                    amount: parseInt(vm.inputData.amount, 10),
                    provider: e && !e.keyCode && !e.which ? e : 'interswitch'
                }).then(function (res) {
                    vm.interSwitch = res.data.deposit;
                    _.merge(vm.user, UserService.getUser());
                    vm.formSubmitted = true;
                }).error(function (res) {
                    console.log(res);
                });
            } else {
                vm.depositForm.$setDirty();
                angular.forEach(vm.depositForm, function (value) {
                    if (typeof value === 'object' && value.$setDirty) {
                        value.$setDirty();
                    }
                });
            }
        };
        vm.data = {
            provider: 'paystack',
            amount: ''
        };
        vm.checkoutData = {
            provider: 'paystack',
            amount: 0,
            full_name: '',
            email: '',
            phone: ''
        };
        vm.cardData = {
            number: '',
            cvv: '',
            expiry_month: '',
            expiry_year: ''
        };
        var setDepositData = function (data) {
            var handler = PaystackPop.setup({
                access_code: data.deposit.access_code,
                key: data.deposit.provider_key,
                email: data.user.email,
                amount: data.deposit.amount,
                ref: data.deposit.transaction_id,
                metadata: {
                    custom_fields: [
                        {
                            display_name: 'Mobile Number',
                            variable_name: 'mobile_number',
                            value: data.user.mobile
                        },
                        {
                            display_name: 'Full Name',
                            variable_name: 'full_name',
                            value: data.user.name
                        }
                    ]
                },
                callback: function (response) {
                    alert('success. transaction ref is ' + response.reference);
                },
                onClose: function () {

                }
            });
            handler.openIframe();
        };
        vm.payDeposit = function () {
            if (vm.data.amount === '' || _.isUndefined(vm.data.amount)) {
                vm.isAmount = false;
            } else {
                vm.isAmount = true;
                VoucherModelService.post('user/deposit', vm.data).then(function (res) {
                    setDepositData(res.data);
                }).error(function (res) {
                    TranslateService.translate(res.error_message);
                });
            }
        };
        vm.apCoPay = function apCoPay() {
            if (!vm.apCoPayData || vm.apCoPaySubmitted) {
                return false;
            }
            if (vm.apCoPayForm && vm.apCoPayForm.$invalid) {
                return TranslateService.translate('required_amount');
            }
            vm.apCoPaySubmitted = true;
            VoucherModelService.post('user/apco', { provider: 'apco', amount: vm.apCoPayData.amount }).then(function apCoPaySuccess(res) {
                vm.apCoPayData.action = res.data.deposit.fast_pay_url;
                vm.apCoPayData.XML = encodeURIComponent(res.data.deposit.xml);
                var htmlForm = '<form method="post" id="apCpSpForm" action="' + vm.apCoPayData.action + '" target="output_frame"><input name="params" type="hidden" ng-value="VmMoneyDepositManager.apCoPayData.XML"></form>';
                $('#apCpPay').html($compile($(htmlForm))($scope));
                var apCoModal = $uibModal.open({
                    templateUrl: 'views/components/apco-payment.html',
                    size: 'lg',
                    windowClass: 'apCoModal'
                });
                apCoModal.rendered.then(function () {
                    setTimeout(function onFormLoad() {
                        document.getElementById('apCpSpForm').submit();
                    });
                    vm.apCoPayData.amount = null;
                    vm.apCoPaySubmitted = false;
                });
                window.closeApCoModal = apCoModal.close();
            }).error(function apCoPayError(res) {
                console.log(res);
            });
        };
        vm.checkoutProcess = function () {
            VoucherModelService.post('user/deposit-money', vm.checkoutData).then(function (res) {
                setDepositData(res.data);
            }).error(function (res) {
                TranslateService.translate(res.error_message);
            });
        };
        vm.confirmCard = function () {
            VoucherModelService.post('user/deposit-money', vm.cardData).then(function (res) {
                setDepositData(res.data);
            });
        };
        vm.defaultTab = 1;
        vm.togglePayment = togglePaymentFn;
        function togglePaymentFn(tab) {
            vm.defaultTab = tab;
        }
        vm.isToggle = isToggleFn;
        vm.cancelDeposit = function () {
            delete vm.interSwitch;
            vm.formSubmitted = false;
        };
        function isToggleFn(newTab) {
            return vm.defaultTab === newTab;
        }

        NotifyingService.subscribe($scope, 'languageJson:set', function () {
            MoneyTransferService.resetMoneyDate();
            MoneyTransferService.setYears();
            MoneyTransferService.setMonths();
            vm.showMethod();
        });
    }
})();

/**
 * Created by unal on 27.11.2016.
 */
(function () {
    angular.module('novusTerminal').factory('CalendarConfigurationService', serviceFn);
    serviceFn.$inject = ['languageService'];
    function serviceFn(languageService) {
        var serviceObj = {
            get: function () {
                return {
                    locale: {
                        applyClass: 'btn-green',
                        applyLabel: languageService.get('apply'),
                        fromLabel: languageService.get('from'),
                        format: languageService.getSelectedLanguage().date_format,
                        toLabel: languageService.get('to'),
                        cancelLabel: languageService.get('cancel'),
                        customRangeLabel: languageService.get('custom_range'),
                        opens: 'center',
                        weekLabel: 'W',
                        daysOfWeek: [
                            languageService.get('day_short2_sunday'),
                            languageService.get('day_short2_monday'),
                            languageService.get('day_short2_tuesday'),
                            languageService.get('day_short2_wednesday'),
                            languageService.get('day_short2_friday'),
                            languageService.get('day_short2_thursday'),
                            languageService.get('day_short2_saturday')
                        ],
                        monthNames: [
                            languageService.get('month_full_january'),
                            languageService.get('month_full_february'),
                            languageService.get('month_full_march'),
                            languageService.get('month_full_april'),
                            languageService.get('month_full_may'),
                            languageService.get('month_full_june'),
                            languageService.get('month_full_july'),
                            languageService.get('month_full_august'),
                            languageService.get('month_full_september'),
                            languageService.get('month_full_october'),
                            languageService.get('month_full_november'),
                            languageService.get('month_full_december')
                        ],
                        firstDay: languageService.getSelectedLanguage().first_day
                    }
                };
            },
            getTimeForDbRecord: function (date, timezone) {
                var dbDate = {
                    startDate: moment.utc(date.startDate).tz(timezone).format(),
                    endDate: moment.utc(date.endDate).tz(timezone).format()
                };
                if (moment(dbDate.endDate).seconds() === 0) {
                    dbDate.endDate = moment(dbDate.endDate).add(59, 'seconds').format();
                }
                return dbDate;
            },
            getInitTimeForCalendar: function (timezone) {
                return {
                    startDate: moment()
                        .startOf('date')
                        .subtract(1, 'week')
                        .tz(timezone)
                        .format(),
                    endDate: moment()
                        .endOf('date')
                        .tz(timezone)
                        .format()
                };
            },
            getInitTimeForPalimpsest: function (timezone) {
                return {
                    startDate: moment.utc().tz(timezone),
                    endDate: moment.utc().tz(timezone).add(7, 'days').endOf('day')
                };
            }

        };
        return serviceObj;
    }
})();

/**
 * Created by Emre on 20.06.2017.
 */

(function () {
      'use strict';
      angular
          .module('novusTerminal')
          .controller('BetHistoryManagerCtrl', ControllerFn);

      ControllerFn.$inject = ['BetHistoryService', 'CalendarConfigurationService'];
      function ControllerFn(BetHistoryService, CalendarConfigurationService) {
            var vm = this;
      }

})();
(function () {

      var path = 'app/profile/accountTreeTable/views';

      angular
            .module('novusTerminal')
            .directive('nvsAccountTreeTable', DirectiveFn);

      function DirectiveFn() {
            return {
                  restrict: 'EA',
                  scope: {
                        type: "@",
                        ownerId: '=',
                        reports: '=',
                        template: '@',
                        withdrawMoney: "=",
                        depositMoney: "="
                  },
                  bindToController: true,
                  controller: ControllerFn,
                  controllerAs: 'vmAccountTreeTable',
                  templateUrl: function (elem, attrs) {
                        if (attrs.template) {
                              return path + '/account-tree-' + attrs.template + '.html';
                        }

                  }
            }
      }

      ControllerFn.$inject = ['PopupComponentService', 'RevenueReportService'];
      function ControllerFn(PopupComponentService, RevenueReportService) {
            var vm = this;

            vm.filter = RevenueReportService.getFilterData();

            vm.transferAmounts = {};

            vm.toggleOpen = function (uid) {
                  vm.reports.users[uid].isOpen = !vm.reports.users[uid].isOpen;
            };

            vm.selectedMarkets = [];
            vm.selectedUserMarket = function (id) {
                  vm.selectedMarkets[id] = !vm.selectedMarkets[id];
            };

            vm.changePassword = function (userId) {
                  var componentSetting = {
                        name: 'edit-password-form',
                        user: userId
                  };
                  PopupComponentService.createPopup(componentSetting);
            };

            vm.transfer = function (userId) {
                  var componentSetting = {
                        name: 'transfer-form',
                        user: userId
                  };
                  PopupComponentService.createPopup(componentSetting);
            };

            vm.disableUser = function (userId) {
                  var componentSetting = {
                        name: 'disable-user-form',
                        user: userId
                  };
                  PopupComponentService.createPopup(componentSetting);
            };

            vm.filterByUsername = function (id) {
                  if (!vm.data.username || vm.data.username === '') return true;
                  var uIdx = _.find(vm.reports.users, {id: data});
                  var regex = new RegExp('\\b' + usernameRegExp(vm.data.username), 'i');
                  return regex.test(uIdx.username);
            };
            function usernameRegExp(string) {
                  return string.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, "\\$1");
            }
      }

})();
(function () {
    'use strict';
    angular.module('novusTerminal').service('printManagerService', printManagerServiceFn);
    printManagerServiceFn.$inject = ['$location', '$window','$rootScope'];
    function printManagerServiceFn($location, $window, $rootScope) {
        this.handlePrint = function (previousState, callAfterPrintingDone) {




            this.novusobj = null;
            setTimeout(function () {


                if (this.novusobj) {
                    this.novusobj.initTicket("{:param1}");
                    this.novusobj.printTicket(JSON.stringify([{
                        param: 'param1',
                        value: document.getElementById('print-view-template').innerHTML
                    }
                    ]));
                    $rootScope.isPrinted = true;
                }else{

                    $window.print();
                    $window.onafterprint = function () {

                        $rootScope.isPrinted = true;
                    }


                }


                $location.path(decodeURIComponent(previousState));
                callAfterPrintingDone();
            });

        };

        this.barcodeUnique = 'A';
        this.voucherBarcodeUnique = 'O';
        this.originalTicketUnique = '{^}';
        this.voucherQrCodeUnique = '{@}';

    }

})();
/**
 * Created by unal on 6/28/2017.
 */


(function () {

    angular.module('novusTerminal').factory('TicketEventService', ServiceFn);

    ServiceFn.$inject = [
        'TicketModel',
        'CalculatorService',
        '$sessionStorage',
        'UtilsService',
        'ToastrNotificationService',
        'languageService'

    ];
    function ServiceFn(TicketModel, CalculatorService, $sessionStorage, UtilsService, ToastrNotificationService, languageService) {

        var ticketData = {
            ticketEvents: [],
            ticketLiveEvents: {
                events: {}
            },
            calculator: '',
        };

        var clickedOddsEvents = [];

        var clickedOddsLiveEvents = [];

        var ticketId = null;

        var ticketDisplayOption = {
            ticketHasNoEvents: false,
            ticketPlaceBet: false,
            ticketHasEvents: false,
            ticketIdLoaded: false,
            ticketSaved: false,
            ticketCouponSaved: false
        };

        var lastPlacedBetTicketData = {};

        var ticketChangeStatus = {
            accept_odds_changes: false,
            accept_counter_offer: false
        };

        var displaySetting = {
            disablePlaceBet: false,
            loadingBar: false
        };

        var savedTicket = {
            ticketCode: ''
        };



        var serviceObj = {
            loadTicketId: function () {
                _.merge(displaySetting, {loadingBar: true});
                TicketModel.one().post('get').then(function (data) {
                    setTicketDisplayStatus('ticketIdLoaded');
                    ticketData.calculator = new CalculatorService(data.data.ticket.id);
                    loadTicket();
                    ticketId = data.data.ticket.id;
                    _.merge(ticketChangeStatus, {accept_odds_changes: data.data.ticket.accept_odds_changes == 1 ? true : false});
                    _.merge(ticketChangeStatus, {accept_counter_offer: data.data.ticket.accept_counter_offer == 1 ? true : false});
                });
            },
            manageClickedItem: function (event, odds) {
                var oIdx = _.findIndex(clickedOddsEvents, {event_odds_id: odds.event_odds_id});

                if (oIdx < 0) {
                    addItem(event, odds);
                } else {
                    removeTicketEventItem(event.id, odds);
                }
            },

            manageTicketGroupEvents: function (event, odds, tournament) {
                var oIdx = _.findIndex(clickedOddsEvents, {event_odds_id: odds.event_odds_id});

                if (oIdx < 0) {
                    addGroupEventItem(event, odds, tournament);
                } else {
                    removeTicketGroupEventItem(event, odds, tournament);
                }

            },

            manageClickedLiveItem: function (liveEvent, liveEventMarket, typeKey, oddsCode, oddsValue, status) {



                /**
                 *type key for sub markets
                 */

                var liveItemsKey = liveEvent.id + (liveEventMarket.typeKey || typeKey) + oddsCode + liveEventMarket.special_bet_value;

                var liveOddIdx = _.findIndex(clickedOddsLiveEvents, {live_item_key: liveItemsKey});

                if (liveOddIdx < 0) {

                    if (_.has(ticketData.ticketLiveEvents.events[liveEvent.id], 'items')) {

                        var liveItemIdx = false;
                        _.forEach(ticketData.ticketLiveEvents.events[liveEvent.id].items, function (item, value) {
                            if (item.sub_type == liveEventMarket.sub_type) {
                                liveItemIdx = true;
                                return;
                            }
                        });
                    }

                    if (liveItemIdx) {
                        ToastrNotificationService.notificationPopUp('You cant only one odd per market from same event', 'warning', 'Please Try Again');
                        return;
                    }

                    addLiveItem(liveEvent, liveEventMarket, typeKey, oddsCode, oddsValue, status, liveItemsKey);
                } else {
                    removeLiveEventItem(liveEvent.id, typeKey, oddsValue, liveItemsKey);
                }

            },


            resetTicket: function () {
                _.merge(displaySetting, {loadingBar: true});
                //////////////////////////////////////////
                TicketModel.one().post('reset').then(function (res) {

                    ticketData.ticketEvents.splice(0, ticketData.ticketEvents.length);
                    UtilsService.removeObjectProperties(ticketData.ticketLiveEvents.events);
                    clickedOddsEvents.splice(0, clickedOddsEvents.length);
                    clickedOddsLiveEvents.splice(0, clickedOddsLiveEvents.length);
                    delete $sessionStorage['ticketsItem'];
                    delete $sessionStorage['clickedOddsEvents'];
                    delete $sessionStorage['clickedOddsLiveEvents'];
                    delete $sessionStorage['ticketLiveEvents'];
                    window.localStorage.removeItem("coupons");
                    ticketData.calculator = new CalculatorService(res.data.ticket.id);
                    _.merge(displaySetting, {loadingBar: false});

                    /**
                     *after place bet reset ticket and
                     * we dont need to set display status reset
                     */
                    if (!_.isEmpty(lastPlacedBetTicketData)) {
                        return;
                    }


                    setTicketDisplayStatus('reset');
                });


            },
            getTicketEvents: function () {

                return ticketData.ticketEvents;
            },

            getTicketLiveEvents: function () {

                return ticketData.ticketLiveEvents;
            },

            getTicketData: function () {

                return ticketData;
            },

            /**
             * selected odds
             * @returns {Array}
             */
            getClickedOddsEvents: function () {
                return clickedOddsEvents;
            },

            getClickedOddsLiveEvents: function () {
                return clickedOddsLiveEvents;
            },


            deleteTicketEventItem: function (event, item) {
                if (event.is_live) {
                    removeLiveEventItem(event.event_id, item.market_type_key, item.value, item.live_item_key)
                } else {
                    removeTicketEventItem(event.event_id, item)
                }
            },

            deleteTicketEvent: function (ticketEvent) {
                if (ticketEvent.is_live) {
                    removeLiveEvent(ticketEvent);
                } else {
                    removeTicketEvent(ticketEvent)
                }
            },


            setSystemStake: function (systemCode, stake) {

                if ((stake >= 0.01) || (stake == '')) {

                    if (stake == '') {
                        stake = 0;
                    }

                    if (ticketData.calculator.couponData.Combinations[systemCode].StakeS ==
                        '') {
                        ticketData.calculator.couponData.Combinations[systemCode].StakeS = 0;
                    }

                    var oldOne = parseFloat(
                        ticketData.calculator.couponData.Combinations[systemCode].StakeS);
                    var newOne = parseFloat(stake);
                    if ((oldOne > newOne) || (oldOne < newOne)) {
                        ticketData.calculator.setSystemStake(
                            systemCode, stake);
                    }
                }
            },


            setStake: function (stake) {
                if (_.isString(stake)) {
                    stake = stake * 1;
                }
                if ((stake >= 0.01) || (stake == '') ||
                    (stake == null)) {
                    if ((stake == '') || (stake == null)) {
                        stake = 0;
                    }
                    if (ticketData.calculator.couponData.StakeS ==
                        '') {
                        ticketData.calculator.couponData.StakeS = 0;
                    }
                    var oldOne = parseFloat(
                        ticketData.calculator.couponData.StakeS);
                    var newOne = parseFloat(stake);
                    if ((oldOne > newOne) || (oldOne < newOne)) {
                        ticketData.calculator.setStake(stake);
                    }
                }
                ticketData.calculator.setStake(stake);
            },

            setBanker: function (event, odds) {
                var ticketEvent = _.find(ticketData.ticketEvents, {event_id: event.event_id});
                var ticketEventOdds = _.find(ticketEvent.items, {event_odds_id: odds.event_odds_id});
                ticketEventOdds.is_banker = !ticketEventOdds.is_banker;
                ticketData.calculator.setBanker(event.group_id, odds.event_odds_id);
                $sessionStorage.ticketsItem = ticketData.ticketEvents;
            },

            getTicketChangeStatus: function () {
                return ticketChangeStatus;
            },

            updateOddsAndStakeChange: function (key, val) {

                TicketModel.one().post('update', {
                    "key": key,
                    "value": val
                }).then(function (data) {
                    ticketData.calculator = new CalculatorService(data.data.ticket.id);
                    // _.merge(ticketChangeStatus,{ticketChangeStatus[key]:val});
                });


            },

            hasLiveItem: function () {
                return _.isEmpty(ticketData.ticketLiveEvents.events) ? false : true;
            },

            getTicketDisplayOption: function () {
                return ticketDisplayOption;
            },

            setLastPlaceBetTicketData: function (ticketData) {
                UtilsService.removeAndMerge(lastPlacedBetTicketData, ticketData);
                setTicketDisplayStatus('placeBet');
            },

            getLastPlaceBetTicketData: function () {
                return lastPlacedBetTicketData;
            },


            setTicketErrors: function (ticket) {
                var liveEvents = ticket.liveItems;
                var b = clickedOddsLiveEvents;
                var c = ticketData;

                _.forIn(liveEvents, function (event, eIdx) {
                    _.forIn(event.items, function (item, idx) {


                        var brokenEvent = _.find(ticketData.ticketEvents, {event_id: eIdx * 1});

                        var liveItemsKey = eIdx * 1 + item.market_key + item.odds_code + item.special_bet_value;

                        var brokenItem = _.find(brokenEvent.items, {live_item_key: liveItemsKey});

                        if (_.has(item, 'errors')) {
                            brokenItem.error = item.errors[0];
                        } else {
                            delete brokenItem.error;
                        }
                    })
                })
            },

            /**
             * for goal scorer
             */
            //////////remove event group item
            removeTicketEventGroupEvent: function (eventGroup, event, odds) {
                removeTicketGroupEventItem(event, odds, eventGroup);
            },
            ///////// remove event group
            removeTicketEventGroup: function (eventGroup, event) {

                _.forEach(event.clickedOdds, function (removedOdds) {

                    var oIdx = _.findIndex(clickedOddsEvents, {event_odds_id: removedOdds.event_odds_id});

                    if (oIdx < 0) {
                        return;
                    }
                    clickedOddsEvents.splice(oIdx, 1);
                    // ticketData.calculator.removeItem(event.event_id, removedOdds.event_odds_id);
                    ticketData.calculator.removeItem(event.group_id, removedOdds.event_odds_id);
                });

                var egIdx = _.findIndex(ticketData.ticketEvents, {group_id: eventGroup.group_id});

                if (egIdx < 0) {
                    return;
                }

                ticketData.ticketEvents.splice(egIdx, 1);

                $sessionStorage.clickedOddsEvents = clickedOddsEvents;
                $sessionStorage.ticketsItem = ticketData.ticketEvents;

                if (ticketData.ticketEvents.length > 0) {
                    setTicketDisplayStatus('addItem');
                } else {
                    setTicketDisplayStatus('ticketNoEvents');
                }
            },
            loadTicketByCode: function (code) {
                _.merge(displaySetting, {loadingBar: true});

                TicketModel.one().post('get-ticket-by-code', {
                    code: code
                }).then(function (res) {
                    setTicketDisplayStatus('ticketIdLoaded');

                    // Clear Items
                    ticketData.ticketEvents.splice(0, ticketData.ticketEvents.length);
                    UtilsService.removeObjectProperties(ticketData.ticketLiveEvents.events);
                    clickedOddsEvents.splice(0, clickedOddsEvents.length);
                    clickedOddsLiveEvents.splice(0, clickedOddsLiveEvents.length);

                    ticketId = res.data.ticket.id;
                    ticketData.calculator = new CalculatorService(res.data.ticket.id);
                    _.forEach(res.data.ticket.items, function (item) {
                        var itemEvent = {
                            event_id: item.event_id,
                            group_id: item.group_id,
                            id: item.id,
                            name: item.event_name,
                            code: item.event_code
                        };
                        var itemOdds = {
                            code: item.odds_code,
                            event_odds_id: item.event_odds_id,
                            id: item.odds_id,
                            market_id: item.market_id,
                            market_name: item.market_name,
                            name: item.odds_code,
                            special_value: item.special_value,
                            value: item.odds_value
                        };
                        addItem(itemEvent, itemOdds);
                    });

                    angular.forEach(res.data.ticket.systems, function (system) {
                        serviceObj.setSystemStake(system.code, system.stake);
                    });

                    _.merge(displaySetting, {loadingBar: false});

                }).catch(function (res) {
                    _.merge(displaySetting, {loadingBar: false});
                    ToastrNotificationService.notificationPopUp(res.data.error_message, 'warning');
                })
            },

            setDisplayStatus: function (settings) {
                _.merge(displaySetting, settings);
            },
            getDisplaySetting: function () {
                return displaySetting;
            },

            /**
             * bet again
             */

            setTicketToBetAgain: function () {
                UtilsService.removeObjectProperties(lastPlacedBetTicketData);
                setTicketDisplayStatus('reset');
            },

            /**
             * saved ticket code
             */

            setSavedTicketCode: function (code) {
                _.merge(savedTicket, {ticketCode: code});
                _.merge(ticketDisplayOption, {ticketHasNoEvents: false});
                _.merge(ticketDisplayOption, {ticketPlaceBet: false});
                _.merge(ticketDisplayOption, {ticketHasEvents: false});
                _.merge(ticketDisplayOption, {ticketIdLoaded: false});
                _.merge(ticketDisplayOption, {ticketSaved: true});
            },

            getSavedTicketCode: function () {
                return savedTicket;
            },

            /**
             * after saved coupon we click back and
             * we need close saved ticket
             */
            placeBetAgain: function () {
                UtilsService.nullifyObjectProperties(savedTicket);
                _.merge(ticketDisplayOption, {ticketHasNoEvents: true});
                _.merge(ticketDisplayOption, {ticketPlaceBet: false});
                _.merge(ticketDisplayOption, {ticketHasEvents: false});
                _.merge(ticketDisplayOption, {ticketIdLoaded: false});
                _.merge(ticketDisplayOption, {ticketSaved: false});
            },


            /**
             *reload last ticket
             */

            reloadLastTicket: function (code) {
                _.merge(displaySetting, {loadingBar: true});

                TicketModel.one().post('reload-last-ticket', {code: code}).then(function (res) {
                    UtilsService.removeObjectProperties(lastPlacedBetTicketData);
                    _.forEach(res.data.ticket.items, function (item) {
                        var itemEvent = {
                            event_id: item.event_id,
                            group_id: item.group_id,
                            id: item.id,
                            name: item.event_name,
                            code: item.event_code
                        };

                        var itemOdds = {
                            code: item.odds_code,
                            event_odds_id: item.event_odds_id,
                            id: item.odds_id,
                            market_id: item.market_id,
                            market_name: item.market_name,
                            name: item.odds_code,
                            special_value: item.special_value,
                            value: item.odds_value
                        };
                        addItem(itemEvent, itemOdds);
                    })

                    _.merge(displaySetting, {loadingBar: false});

                })
            },
            saveTicket: function () {
                var data = { ticket: {} };
                data.ticket.Winning = ticketData.calculator.couponData.Winning;
                //data.ticket.Events = ticketData.ticketEvents;
                data.ticket.Stake = ticketData.calculator.couponData.Stake;
                data.ticket.accept_withdraw = false;
                data.ticket.couponId = ticketData.calculator.couponId;
                data.ticket.couponType = ticketData.calculator.couponData.couponType;
                data.ticket.Combinations = {};
                data.ticket.banker = {};
                data.ticket.noAddItem = 1;
                if (typeof ticketData.calculator.couponData.Combinations === 'object') {
                    for (var sysOptionGroup in ticketData.calculator.couponData.Combinations) {
                        data.ticket.Combinations[sysOptionGroup] = {};
                        data.ticket.Combinations[sysOptionGroup].Active = ticketData.calculator.couponData.Combinations[sysOptionGroup].Active;
                        data.ticket.Combinations[sysOptionGroup].BonusMax = ticketData.calculator.couponData.Combinations[sysOptionGroup].BonusMax;
                        data.ticket.Combinations[sysOptionGroup].BonusMin = ticketData.calculator.couponData.Combinations[sysOptionGroup].BonusMin;
                        data.ticket.Combinations[sysOptionGroup].Code = ticketData.calculator.couponData.Combinations[sysOptionGroup].Code;
                        data.ticket.Combinations[sysOptionGroup].Count = ticketData.calculator.couponData.Combinations[sysOptionGroup].Count;
                        data.ticket.Combinations[sysOptionGroup].Max = ticketData.calculator.couponData.Combinations[sysOptionGroup].Max;
                        data.ticket.Combinations[sysOptionGroup].Min = ticketData.calculator.couponData.Combinations[sysOptionGroup].Min;
                        data.ticket.Combinations[sysOptionGroup].Stake = ticketData.calculator.couponData.Combinations[sysOptionGroup].Stake;
                    }
                }

                data.ticket.liveItems = ticketData.calculator.storage.liveItems;
                data.win_confirmed = 1;
                data.ticket.Events=editEventsData(ticketData.calculator);

                TicketModel.one('save2').post(undefined,data).then(function (data) {
                    serviceObj.resetTicket();
                    ticketData.savedTicket = data.data.ticket;
                    ticketData.savedTicket.save_code = data.data.code;
                    _.merge(ticketDisplayOption, { ticketCouponSaved: true });
                },function(error) {
                    ToastrNotificationService.notificationPopUp(error.data.error_message, 'warning');
                }.bind(this));

            },
            removeSavedTicketData: function () {
                _.merge(ticketData, { savedTicket: null });
                _.merge(ticketDisplayOption, { ticketCouponSaved: false });
            }
        };


        function editEventsData(data){
            var dataEvents ={};
            _.forEach(data.defaultCouponObj, function (item) {
                dataEvents = item.Events;
            });
            return dataEvents;
        }

        function addItem(event, odds) {
            clickedOddsEvents.push(odds);
            setTicketEvents(event, odds);
            $sessionStorage.clickedOddsEvents = clickedOddsEvents;
            $sessionStorage.ticketsItem = ticketData.ticketEvents;
            // ticketData.calculator.addItem(event.event_id, odds.event_odds_id, odds.value, 1, 0);
            ticketData.calculator.addItem(event.group_id, odds.event_odds_id, odds.value, 1, 0);
            if (ticketData.ticketEvents.length > 0) {
                setTicketDisplayStatus('addItem');
            } else {
                setTicketDisplayStatus('ticketNoEvents');
            }

        };

        /**
         *add ticket group event
         * @param event
         * @param odds
         */
        function addGroupEventItem(event, odds, tournament) {

            var tGIdx = _.findIndex(ticketData.ticketEvents, {group_id: tournament.group_id});

            if (tGIdx < 0) {
                ticketData.ticketEvents.push(createNewGroupEventTournament(tournament));
            }

            var ticketGroupEventTournament = _.find(ticketData.ticketEvents, {group_id: tournament.group_id});

            var eIdx = _.findIndex(ticketGroupEventTournament.items, {event_id: event.event_id});


            if (eIdx < 0) {
                event.clickedOdds = [];
                ticketGroupEventTournament.items.push(event);
            }

            clickedOddsEvents.push(odds);
            event.clickedOdds.push(odds);

            $sessionStorage.clickedOddsEvents = clickedOddsEvents;
            $sessionStorage.ticketsItem = ticketData.ticketEvents;
            // ticketData.calculator.addItem(event.event_id, odds.event_odds_id, odds.value, 1, 0);
            ticketData.calculator.addItem(event.group_id, odds.event_odds_id, odds.value, 1, 0);
            if (ticketData.ticketEvents.length > 0) {
                setTicketDisplayStatus('addItem');
            } else {
                setTicketDisplayStatus('ticketNoEvents');
            }

        };

        /**
         *create new group ticket event
         */
        function createNewGroupEventTournament(tournament) {
            return {
                group_id: tournament.group_id,
                name: tournament.tournament_name,
                category_name: tournament.category_name,
                category_id: tournament.category_id,
                sport_id: tournament.sport_id,
                tournament_id: tournament.tournament_id,
                has_group: true,
                items: []
            };

        }

        /**
         *remove ticket group event
         */
        function removeTicketGroupEventItem(event, odds, tournament) {
            var tournamentEventGroup = _.find(ticketData.ticketEvents, {group_id: tournament.group_id});

            if (!tournamentEventGroup) {
                return;
            }

            var tournamentEventGroupEvent = _.find(tournamentEventGroup.items, {event_id: event.event_id});

            var removedOddsIdx = _.findIndex(tournamentEventGroupEvent.clickedOdds, {event_odds_id: odds.event_odds_id});

            if (removedOddsIdx < 0) {
                return;
            }

            tournamentEventGroupEvent.clickedOdds.splice(removedOddsIdx, 1);

            var removedClickedOddsIdx = _.findIndex(clickedOddsEvents, {event_odds_id: odds.event_odds_id});

            if (removedClickedOddsIdx < 0) {
                return;
            }

            clickedOddsEvents.splice(removedClickedOddsIdx, 1);
            // ticketData.calculator.removeItem(event.event_id, odds.event_odds_id);
            ticketData.calculator.removeItem(event.group_id, odds.event_odds_id);

            if (tournamentEventGroupEvent.clickedOdds.length <= 0) {
                var tgeIdx = _.findIndex(tournamentEventGroup.items, {event_id: event.event_id});
                tournamentEventGroup.items.splice(tgeIdx, 1);
            }


            if (tournamentEventGroup.items.length <= 0) {
                var tegIdx = _.find(ticketData.ticketEvents, {group_id: tournament.group_id});
                ticketData.ticketEvents.splice(tegIdx, 1);
            }

            $sessionStorage.clickedOddsEvents = clickedOddsEvents;
            $sessionStorage.ticketsItem = ticketData.ticketEvents;

            if (ticketData.ticketEvents.length > 0) {
                setTicketDisplayStatus('addItem');
            } else {
                setTicketDisplayStatus('ticketNoEvents');
            }
        };

        /**
         *remove ticket event
         * @param ticketEvent
         */
        function removeTicketEvent(ticketEvent) {
            var eIdx = _.findIndex(ticketData.ticketEvents,
                {event_id: ticketEvent.event_id});

            if (eIdx < 0) {
                return;
            }

            ticketData.ticketEvents.splice(eIdx, 1);

            _.forEach(ticketEvent.items, function (item) {

                var idx = _.findIndex(clickedOddsEvents,
                    {event_odds_id: item.event_odds_id});

                if (idx < 0) {
                    return;
                }

                clickedOddsEvents.splice(idx, 1);

            });
            // ticketData.calculator.removeItem(ticketEvent.event_id, 0);
            ticketData.calculator.removeItem(ticketEvent.group_id, 0);
            $sessionStorage.clickedOddsEvents = clickedOddsEvents;
            $sessionStorage.ticketsItem = ticketData.ticketEvents;
            if (ticketData.ticketEvents.length > 0) {
                setTicketDisplayStatus('addItem');
            } else {
                setTicketDisplayStatus('ticketNoEvents');
            }
        };

        function removeLiveEvent(ticketEvent) {
            var eIdx = _.findIndex(ticketData.ticketEvents,
                {event_id: ticketEvent.event_id});

            if (eIdx < 0) {
                return;
            }

            ticketData.ticketEvents.splice(eIdx, 1);

            _.forEach(ticketEvent.items, function (item) {
                var oIdx = _.findIndex(clickedOddsLiveEvents, {live_item_key: item.live_item_key});

                if (oIdx < 0) {
                    return;
                }

                clickedOddsLiveEvents.splice(oIdx, 1);
            });


            ticketData.calculator.removeItem(ticketEvent.event_id, 0);

            delete ticketData.ticketLiveEvents.events[ticketEvent.event_id];

            $sessionStorage.clickedOddsLiveEvents = clickedOddsLiveEvents;
            $sessionStorage.ticketsItem = ticketData.ticketEvents;
            $sessionStorage.ticketLiveEvents = ticketData.ticketLiveEvents;
            if (ticketData.ticketEvents.length > 0) {
                setTicketDisplayStatus('addItem');
            } else {
                setTicketDisplayStatus('ticketNoEvents');
            }
        }


        function addLiveItem(liveEvent, liveEventMarket, typeKey, oddsCode, oddsValue, status, liveItemsKey) {
            var liveItemsOdds = fillAndGetLiveItemOdds(liveItemsKey, oddsCode, oddsValue, liveEventMarket, typeKey);
            var ticketLiveEvent = fillAndGetLiveEvent(liveEvent, liveItemsKey);
            clickedOddsLiveEvents.push(liveItemsOdds);
            setTicketEvents(ticketLiveEvent, liveItemsOdds);
            setTicketDataLiveItems(liveEvent, liveEventMarket, typeKey, oddsCode, oddsValue, status);
            $sessionStorage.clickedOddsLiveEvents = clickedOddsLiveEvents;
            $sessionStorage.ticketsItem = ticketData.ticketEvents;
            $sessionStorage.ticketLiveEvents = ticketData.ticketLiveEvents;
            ticketData.calculator.addItem(liveEvent.id, typeKey, oddsValue, 1, 1);
            if (ticketData.ticketEvents.length > 0) {
                setTicketDisplayStatus('addItem');
            } else {
                setTicketDisplayStatus('ticketNoEvents');
            }

        };

        function fillAndGetLiveItemOdds(liveItemsKey, oddsCode, oddsValue, liveEventMarket, typeKey) {

            var refactorKey = 'lo_' + (liveEventMarket.type || '') + '_' + (liveEventMarket.type_id || '') + '_' + (liveEventMarket.sub_type == null ? '_' : liveEventMarket.sub_type+'_' ) + oddsCode;
            var refactoredKey = languageService.refactorKey(refactorKey);

            var oddsCodeTranslation = refactoredKey + '_liveodds_' + oddsCode;
            return {
                live_item_key: liveItemsKey,
                code: oddsCode,
                value: oddsValue,
                market_type_key: typeKey,
                market_name: liveEventMarket.free_text,
                special_bet_value: liveEventMarket.special_bet_value,
                odds_code_translation: oddsCodeTranslation
            };
        }

        function fillAndGetLiveEvent(event, liveItemsKey) {
            return {
                active: event.active,
                away: event.away,
                home: event.home,
                event_id: event.id,
                sport_id: event.sport_id,
                tournament_id: event.tournament_id,
                is_live: true,
                name: event.home + ' ' + event.away,
                live_item_key: liveItemsKey
            };
        }

        function setTicketDataLiveItems(liveEvent, liveEventMarket, typeKey, oddsCode, oddsValue, status) {

            var firstItemForEvent = false;

            if (!_.has(ticketData.ticketLiveEvents.events, liveEvent.id)) {
                ticketData.ticketLiveEvents.events[liveEvent.id] = {};
                firstItemForEvent = true;
            }

            var marketType = liveEventMarket.sub_type +
                '|' + liveEventMarket.type +
                '|' + liveEventMarket.type_id +
                '|' + liveEventMarket.special_bet_value +
                '-' + oddsCode;

            var refactorKey = 'lo_' + (liveEventMarket.type || '') + '_' + (liveEventMarket.type_id || '') + '_' + (liveEventMarket.sub_type == null ? '_' : liveEventMarket.sub_type+'_' ) + oddsCode;
            var refactoredKey = languageService.refactorKey(refactorKey);


            var event = {};

            if (firstItemForEvent) {
                var newEventStructure = {
                    is_live_event: 1,
                    id: liveEvent.id,
                    name: liveEvent.home + ' - ' + liveEvent.away,
                    items: {},
                };

                _.merge(event, newEventStructure);

            } else {
                _.merge(event, ticketData.ticketLiveEvents.events[liveEvent.id]);
            }




            event.items[marketType] = {
                'is_live': 1,
                'marketType': marketType,
                'live_market': {'name': liveEventMarket.free_text},
                'odds_code': oddsCode,
                'odds_code_translation': refactoredKey + '_liveodds_' + oddsCode,
                'special_value': liveEventMarket.special_bet_value,
                'special_bet_value': liveEventMarket.special_bet_value,
                'type': liveEventMarket.type,
                'type_id': liveEventMarket.type_id,
                'sub_type': liveEventMarket.sub_type,
                'odds_value': oddsValue,
                'is_default': status,
                'market_key': typeKey
            };



            _.merge(ticketData.ticketLiveEvents.events[liveEvent.id], event);


        }

        function removeLiveEventItem(eventId, typeKey, oddsValue, liveItemsKey) {
            var ticketEvent = _.find(ticketData.ticketEvents,
                {event_id: eventId});

            if (!ticketEvent) {
                return;
            }

            var oIdx = _.findIndex(ticketEvent.items,
                {live_item_key: liveItemsKey});

            if (oIdx < 0) {
                return;
            }

            ticketEvent.items.splice(oIdx, 1);


            var idx = _.findIndex(clickedOddsLiveEvents,
                {live_item_key: liveItemsKey});

            if (idx < 0) {
                return;
            }
            clickedOddsLiveEvents.splice(idx, 1);

            ticketData.calculator.removeItem(eventId, typeKey, oddsValue, 1, 1);


            if (ticketEvent.items.length == 0) {
                var ticketEventIdx = _.findIndex(ticketData.ticketEvents,
                    {event_id: eventId});

                if (ticketEventIdx < 0) {
                    return;
                }

                ticketData.ticketEvents.splice(ticketEventIdx, 1);
                delete ticketData.ticketLiveEvents.events[eventId];
            }

            $sessionStorage.clickedOddsLiveEvents = clickedOddsLiveEvents;
            $sessionStorage.ticketsItem = ticketData.ticketEvents;
            $sessionStorage.ticketLiveEvents = ticketData.ticketLiveEvents;
            if (ticketData.ticketEvents.length > 0) {
                setTicketDisplayStatus('addItem');
            } else {
                setTicketDisplayStatus('ticketNoEvents');
            }

        }


        function setTicketEvents(event, item) {

            var ticketEvent = _.find(ticketData.ticketEvents,
                {event_id: event.event_id});

            if (ticketEvent) {
                ticketEvent.items.push(item);
            } else {

                event.items = [];
                event.items.push(item);
                ticketData.ticketEvents.push(event);
            }

        }



        function removeTicketEventItem(eventId, item) {
            var ticketEvent = _.find(ticketData.ticketEvents,
                {event_id: eventId});

            if (!ticketEvent) {
                return;
            }

            var oIdx = _.findIndex(ticketEvent.items,
                {event_odds_id: item.event_odds_id});

            if (oIdx < 0) {
                return;
            }

            ticketEvent.items.splice(oIdx, 1);


            var idx = _.findIndex(clickedOddsEvents,
                {event_odds_id: item.event_odds_id});

            if (idx < 0) {
                return;
            }

            clickedOddsEvents.splice(idx, 1);

            // ticketData.calculator.removeItem(eventId, item.event_odds_id);
            ticketData.calculator.removeItem(ticketEvent.group_id, item.event_odds_id);

            if (ticketEvent.items.length == 0) {
                removeTicketEvent(ticketEvent);
            }
            $sessionStorage.clickedOddsEvents = clickedOddsEvents;
            $sessionStorage.ticketsItem = ticketData.ticketEvents;
            if (ticketData.ticketEvents.length > 0) {
                setTicketDisplayStatus('addItem');
            } else {
                setTicketDisplayStatus('ticketNoEvents');
            }

        }

        function loadTicket() {
            clickedOddsEvents.slice(0, clickedOddsEvents.length);
            ticketData.ticketEvents.slice(0,
                ticketData.ticketEvents.length);


            _.merge(clickedOddsEvents,
                $sessionStorage.clickedOddsEvents);

            _.merge(clickedOddsLiveEvents,
                $sessionStorage.clickedOddsLiveEvents);

            _.merge(ticketData.ticketEvents,
                $sessionStorage.ticketsItem);

            _.merge(ticketData.ticketLiveEvents,
                $sessionStorage.ticketLiveEvents);


            _.forEach(ticketData.ticketEvents, function (event) {
                // ticketData.calculator.addItem(event.event_id);
                ticketData.calculator.addItem(event.group_id);

                /**
                 *check this part for banker
                 */
                /*   _.forEach(event.items, function (item) {
                 if (!item.is_banker) {
                 return;
                 }
                 ticketData.calculator.setBanker(event.group_id, item.event_odds_id);
                 })*/
            });


            /**
             * for load ticket ıd
             */
            _.merge(displaySetting, {loadingBar: false});


            if (!_.isEmpty(lastPlacedBetTicketData)) {
                return;
            }


            if (ticketData.ticketEvents.length <= 0) {
                setTicketDisplayStatus('ticketNoEvents');
            } else {
                setTicketDisplayStatus('ticketHasEvents');
            }

        }


        function setTicketDisplayStatus(status) {

            var ticketHasNoEventsValue;
            var ticketPlaceBetValue;
            var ticketHasEventsValue;
            var ticketIdLoadedValue;

            switch (status) {
                case 'reset':
                case'ticketNoEvents':
                    ticketHasNoEventsValue = true;
                    ticketHasEventsValue = false;
                    ticketPlaceBetValue = false;
                    break;
                case 'addItem':
                case 'ticketHasEvents':
                    ticketHasNoEventsValue = false;
                    ticketHasEventsValue = true;
                    ticketPlaceBetValue = false;
                    break;
                case 'placeBet':
                    ticketHasNoEventsValue = false;
                    ticketPlaceBetValue = true;
                    ticketHasEventsValue = false;
                case'ticketIdLoaded':
                    ticketIdLoadedValue = true;
                    break;
            }

            _.merge(ticketDisplayOption, {ticketHasNoEvents: ticketHasNoEventsValue});
            _.merge(ticketDisplayOption, {ticketPlaceBet: ticketPlaceBetValue});
            _.merge(ticketDisplayOption, {ticketHasEvents: ticketHasEventsValue});
            _.merge(ticketDisplayOption, {ticketIdLoaded: ticketIdLoadedValue});

        }


        return serviceObj;
    }

})();

'use strict';

/**
 * @ngdoc service
 * @name sportsbookApp.ticketService
 * @description
 * # ticketService
 * Factory in the sportsbookApp.
 */
angular.module('novusTerminal')
	.factory('TicketApiService', function (TicketModel) {

		// create service object
		var ticketService = {};

		/**
		 *  -- Gets the current ticket of the current session
		 * @returns {*}
		 */
		ticketService.getTicket = function () {
			return TicketModel.one().post('get', {
				language_id: 1
			});
		};

		/**
		 *
		 * @param eventOddsId
		 * @returns {*}
		 */
		ticketService.addItemII = function (eventOddsId) {
			return TicketModel.one().post('add-item', {
				event_odds_id: eventOddsId
			});
		};

		/**
		 *
		 * @param eventOddsId
		 * @returns {*}
		 */
		ticketService.addItem = function (eventOddsId) {
			return TicketModel.one().post('add-item2', {
				event_odds_id: eventOddsId
			});
		};

		/**
		 *
		 * @param marketId
		 * @param odds
		 * @returns {*}
		 */
		ticketService.addLiveItem = function (eventId, marketType, marketId, oddId, oddValue) {
			eventId = eventId || null;
			return TicketModel.one().post('add-live-item', {
				live_odd_value: oddValue,
				live_odd_id: oddId,
				live_market_id: marketId,
				live_market_type: marketType,
				live_event_id: eventId
			});
		};

		/**
		 *
		 * @param eventOddsId
		 * @returns {*}
		 */
		ticketService.updateItem = function (eventOddsId) {
			return TicketModel.one().post('update-item', {
				item_id: eventOddsId
			});
		};

		/**
		 *
		 * @param ticketItemId
		 * @returns {*}
		 */
		ticketService.removeItem = function (ticketItemId) {
			return TicketModel.one().post('remove-item2', {
				// return apiService.call('ticket/remove-item', {
				ticket_item_id: ticketItemId
			});
		};

		/**
		 *
		 * @param eventId
		 * @returns {*}
		 */
		ticketService.removeEvent = function (eventId) {
			return TicketModel.one().post('remove-event2', {
				// return apiService.call('ticket/remove-event', {
				event_id: eventId
			});
		};

		/**
		 *
		 * @returns {*}
		 */
		ticketService.resetTicket = function () {
			return TicketModel.one().post('reset');
		};

		/**
		 *
		 * @param stake
		 * @returns {*}
		 */
		ticketService.setStake = function (stake) {
			return TicketModel.one().post('set-stake', {
				stake: stake
			});
		};

		/**
		 *
		 * @param code
		 * @returns {*}
		 */
		ticketService.cancelTicket = function (code) {
			return TicketModel.one().post('cancel', {
				ticket_code: code
			});
		};

		/**
		 *
		 * @param code
		 * @returns {*}
		 */
		ticketService.setPrint = function (code) {
			return TicketModel.one().post('set-print', {
				ticket_code: code
			});
		};
		/**
		 *
		 * @param ticketItemId
		 * @param banker
		 * @returns {*}
		 */
		ticketService.setBanker = function (ticketItemId, banker) {
			return TicketModel.one().post('set-banker', {
				ticket_item_id: ticketItemId,
				banker: banker
			});
		};

		/**
		 *
		 * @param systemCode
		 * @param stake
		 * @returns {*}
		 */
		ticketService.setSystem = function (systemCode, stake) {
			var data = {
				system_code: systemCode
			};
			if (stake) {
				data.stake = stake;
			}
			return TicketModel.one().post('set-system', data);
		};

		/**
		 *
		 * @param systemCode
		 * @returns {*}
		 */
		ticketService.unsetSystem = function (systemCode) {
			return TicketModel.one().post('unset-system', {
				system_code: systemCode
			});
		};

		/**
		 *
		 * @param id
		 * @param ticket
		 * @returns {*}
		 */
		ticketService.save = function saveTicket () {

		};
		ticketService.checkout = function (id, ticket) {
			var data = {ticket: {}};
			// Service quick impromevents. We're destroying un-neccessary parts because of Request Entity Too Large Error.
			data.ticket.Winning = ticket.Winning;
			data.ticket.Events = ticket.Events;
			data.ticket.Stake = ticket.Stake;
			// data.ticket.accept_withdraw = ticket.accept_withdraw;
			data.ticket.couponId = ticket.couponId;
			data.ticket.couponType = ticket.couponType;
			data.ticket.Combinations = {};
			if (typeof ticket.Combinations == "object") {
				for (var sysOptionGroup in ticket.Combinations) {
					data.ticket.Combinations[sysOptionGroup] = {};
					data.ticket.Combinations[sysOptionGroup].Active = ticket.Combinations[sysOptionGroup].Active;
					data.ticket.Combinations[sysOptionGroup].BonusMax = ticket.Combinations[sysOptionGroup].BonusMax;
					data.ticket.Combinations[sysOptionGroup].BonusMin = ticket.Combinations[sysOptionGroup].BonusMin;
					data.ticket.Combinations[sysOptionGroup].Code = ticket.Combinations[sysOptionGroup].Code;
					data.ticket.Combinations[sysOptionGroup].Count = ticket.Combinations[sysOptionGroup].Count;
					data.ticket.Combinations[sysOptionGroup].Max = ticket.Combinations[sysOptionGroup].Max;
					data.ticket.Combinations[sysOptionGroup].Min = ticket.Combinations[sysOptionGroup].Min;
					data.ticket.Combinations[sysOptionGroup].Stake = ticket.Combinations[sysOptionGroup].Stake;
				}
			}

			data.ticket.liveItems = ticket.liveItems;
			// Quick impromevents ends.


			if (ticket.win_confirmed == 1) {
				data.win_confirmed = 1;
			}

			if (id != '') {
				data.reference_user_id = id;

			}

			/**
			 *for checkout no add item flag
			 * @type {boolean}
			 */
			data.ticket.noAddItem = true;
			return TicketModel.one().post('checkout2', data);
		};

		/**
		 *
		 * @param systemCode
		 * @param stake
		 * @returns {*}
		 */
		ticketService.setSystemstake = function (systemCode, stake) {
			return TicketModel.one().post('set-system-stake', {
				system_code: systemCode,
				stake: stake
			});
		};

		/**
		 *
		 * @param ticketId
		 * @param confirm
		 * @returns {*}
		 */
		ticketService.confirm = function (ticketId, confirm) {
			return TicketModel.one().post('confirm', {
				ticket_id: ticketId,
				confirm: confirm
			});
		};

		/**
		 *
		 * @param key
		 * @param value
		 * @returns {*}
		 */
		ticketService.update = function (key, value) {
			return TicketModel.one().post('update', {
				"key": key,
				"value": value
			});
		};

		/**
		 *
		 * @param ticket
		 * @returns {*}
		 */
		ticketService.save = function (id, ticket) {
			var data = {ticket: {}};
			data.ticket.Winning = ticket.Winning;
			data.ticket.Events = ticket.Events;
			data.ticket.Stake = ticket.Stake;
			data.ticket.couponId = ticket.couponId;
			data.ticket.couponType = ticket.couponType;
			data.ticket.Combinations = {};
			if (typeof ticket.Combinations === 'object') {
				for (var sysOptionGroup in ticket.Combinations) {
					data.ticket.Combinations[sysOptionGroup] = {};
					data.ticket.Combinations[sysOptionGroup].Active = ticket.Combinations[sysOptionGroup].Active;
					data.ticket.Combinations[sysOptionGroup].BonusMax = ticket.Combinations[sysOptionGroup].BonusMax;
					data.ticket.Combinations[sysOptionGroup].BonusMin = ticket.Combinations[sysOptionGroup].BonusMin;
					data.ticket.Combinations[sysOptionGroup].Code = ticket.Combinations[sysOptionGroup].Code;
					data.ticket.Combinations[sysOptionGroup].Count = ticket.Combinations[sysOptionGroup].Count;
					data.ticket.Combinations[sysOptionGroup].Max = ticket.Combinations[sysOptionGroup].Max;
					data.ticket.Combinations[sysOptionGroup].Min = ticket.Combinations[sysOptionGroup].Min;
					data.ticket.Combinations[sysOptionGroup].Stake = ticket.Combinations[sysOptionGroup].Stake;
				}
			}
			data.ticket.liveItems = ticket.liveItems;
			if (ticket.win_confirmed === 1) {
				data.win_confirmed = 1;
			}
			if (id !== '') {
				data.reference_user_id = id;
			}
			data.ticket.noAddItem = true;
			return TicketModel.one().post('save2', data);
		};


		/**
		 *
		 * @param code
		 * @returns {*}
		 */
		ticketService.getTicketByCode = function (code) {
			return TicketModel.one().post('get-ticket-by-code', {code: code});
		};

		/**
		 *
		 * @param bet
		 * @returns {*}
		 */
		ticketService.fastBetting = function (bet) {
			return TicketModel.one().post('fast-betting', {
				bet: bet
			});
		};

		/**
		 *
		 * @param code
		 * @returns {*}
		 */
		ticketService.getEventByCode = function (code) {
			return TicketModel.one().post('get-event-by-code/' + code);
		};

		/**
		 *
		 * @param code
		 * @returns {*}
		 */
		ticketService.getTicketWithCode = function (code) {
			return TicketModel.one().post('get-ticket-with-code/' + code);
		};

		/**
		 *
		 * @returns {*}
		 */
		ticketService.check = function () {
			return TicketModel.one().post('ticket-check');
		};

		/**
		 * reloadTicket func for
		 * 1-bet again
		 * 2-click my tickets any ticket
		 */

		ticketService.reloadTicket = function (code) {
			return TicketModel.one().post('reload-last-ticket', {code: code});
		};
		return ticketService;

	});

/**
 * Created by unal on 23.05.2017.
 */



(function () {

	angular
		.module('novusTerminal')
		.factory('PlaceBetService', ServiceFn);

	ServiceFn.$inject = [
		'ToastrNotificationService',
		'TicketEventService',
		'UserService',
		'TicketApiService',
		'BetCounter',
		'$cookies'
	];
	function ServiceFn(ToastrNotificationService, TicketEventService, UserService, TicketApiService, BetCounter, $cookies) {

		var ticketData = TicketEventService.getTicketData();
		var userParameters = UserService.getUserParameters();
		var userSubAccounts = UserService.getUserSubAccount();
		var isBonusSelected = false;
		var user = UserService.getUser();


		var serviceObj = {

			checkout: function () {

				var subUser = UserService.getUserSubAccount();

				var couponData = ticketData.calculator.couponData;

				if (_.isEmpty(user)) {
					ToastrNotificationService.notificationPopUp('you_must_login_to_check_out', 'error');
					return;
				}

				/**
				 *for player user
				 */
				if (subUser.length <= 0) {
					ticketData.referenceUserId = user.id;
				}

				couponData.accept_withdraw = ticketData.accept_withdraw ? 1 : 0;

				ticketData.useBonus = isBonusSelected ? 1 : 0;


				if (!couponData.Stake || couponData.Stake == "" || parseFloat(couponData.Stake) <= 0) {
					ToastrNotificationService.notificationPopUp('enter_a_valid_stake_greater_than_zero', 'warning');
					return false
				}

				if (ticketData.calculator.checkout()) {

					ticketData.checkoutProgress = true;

					checkoutTime();

					/**
					 * for live items
					 */
					// ticketData.liveItems = TicketEventService.getTicketLiveEvents[TicketEventService.id];
					couponData.liveItems = TicketEventService.getTicketLiveEvents();

					TicketEventService.setDisplayStatus({
						disablePlaceBet: true,
						loadingBar: true
					});

					TicketApiService.checkout(ticketData.referenceUserId, couponData).then(function (res) {


						var filtered = _.findIndex(userSubAccounts, function (o) {
							return o.id === res.data.ticket.user.id;
						});
						if (userSubAccounts[filtered]) {
							userSubAccounts[filtered].balance = res.data.ticket.user.balance;
						}
						if ($cookies.get('betCounterStatus') == 1) {
							BetCounter.increaseStake(res.data.ticket.stake);
							BetCounter.increaseBets();
						}


						TicketEventService.resetTicket();
						// TicketEventService.setTicketPlaceBetStatus();
						/**
						 *load new TicketId
						 */
						// TicketEventService.loadTicketId();


						TicketEventService.setLastPlaceBetTicketData(res.data.ticket);


						clearCheckoutTime();


						//ToastrNotificationService.notificationPopUp('Bet Played Successfully', 'success');

						TicketEventService.setDisplayStatus({
							disablePlaceBet: false,
							loadingBar: false
						});

					}).catch(function (res) {

                        ToastrNotificationService.notificationPopUp(res.data.error_message, 'warning');
						TicketEventService.setDisplayStatus({
							disablePlaceBet: false,
							loadingBar: false
						});


						//ToastrNotificationService.notificationPopUp(res.data.error_message, 'error');

						if (_.has(res.data.data.ticket, 'liveItems')) {
							TicketEventService.setTicketErrors(res.data.data.ticket);
						}


						// if (res.error_code == 4990) {
						//     // Max Winning Error;
						//     TicketEventService.checkoutStatus = 1;
						//     // TicketEventService.calculator = new Calculator(res.data.ticket.id, res.data.ticket);
						//     for (var systemOption in res.data.set_stakes.systems) {
						//         TicketEventService.calculator.setSystemStake(systemOption, res.data.set_stakes.systems[systemOption]);
						//     }
						//     TicketEventService.calculator.couponData.accept_winning = 1;
						//     TicketEventService.calculator.couponData.win_confirmed = 1;
						// } else if (res.error_code == 9001) {
						//     // If one of item has error, we should update ticket object to show error on view level.
						//     TicketEventService.ticket.setData(res.data.ticket);
						// }
						// ticketCalculator.checkoutProgress = false;
						//
						// clearCheckoutTime();
					})
				}
				else {
					// ticketCalculator.checkoutProgress = false;
					//
					// clearCheckoutTime();
				}
			},

			setUserReference: function (userId) {
				ticketData.referenceUserId = userId;
			},


			saveTicket: function () {

				var couponData = ticketData.calculator.couponData;


				couponData.accept_withdraw = ticketData.accept_withdraw ? 1 : 0;

				ticketData.useBonus = isBonusSelected ? 1 : 0;


				couponData.liveItems = TicketEventService.getTicketLiveEvents();

				TicketEventService.setDisplayStatus({
					disablePlaceBet: true,
					loadingBar: true
				});

				TicketApiService.save(couponData).then(function (res) {
					TicketEventService.setSavedTicketCode(res.data.code);
					TicketEventService.setDisplayStatus({
						disablePlaceBet: false,
						loadingBar: false
					});
				}).catch(function (res) {
					TicketEventService.setDisplayStatus({
						disablePlaceBet: false,
						loadingBar: false
					});
					ToastrNotificationService.notificationPopUp(res.data.error_message, 'error');
				})
			}

		};

		function checkoutTime() {
			ticketData.checkoutTime = 0;

			var userCheckOutTime = _.find(userParameters, {code: 'user_checkout_time_for_live_betting'}).value;

			if (TicketEventService.hasLiveItem()) {

				if (user && userCheckOutTime) {
					ticketData.checkoutTime = userCheckOutTime;
				}
			}
		};

		function clearCheckoutTime() {
			ticketData.checkoutTime = 0;
		}

		return serviceObj;
	}
})();

angular.module('novusTerminal')
	.factory('CalculatorService', ['BookmakerService', function (BookmakerService) {
		function Calculator(couponId, backendItems, checkedStatus) {
			// Real;
			this.maxCombinationCount = 9000;
			this.couponValues = {};
			this.combinations = {};
			this.couponId = couponId;
			this.couponData = {
				couponId: couponId,
				Events: {},
				Combinations: {},
				Winning: {Min: 0, Max: 0, BonusMin: 0, BonusMax: 0, MaxAllCombWin: 0},
				Stake: 0,
				StakeS: 0,
				bonusOptions: {},
				couponType: 0,
				totalOdds: 1
			};
			this.couponData.bankerCount = 0;
			// this.couponData.totalItemCount = 0; This is commented cause of bonus option calculation is not looking for it.
			this.storage = localStorage;
			this.couponCombinationsBackup = {};
			this.couponStorage = this.storage.getItem('coupons');
			if (this.couponStorage === null) {
				this.defaultCouponObj = {};
				this.defaultCouponObj[couponId] = this.couponData;
				this.storage.setItem('coupons', JSON.stringify(this.defaultCouponObj));
				this.couponStorage = this.storage.getItem('coupons');
				this.couponStorageObj = JSON.parse(this.couponStorage);
			} else {
				this.couponStorageObj = JSON.parse(this.couponStorage);
				if (!this.couponStorageObj[couponId]) {
					this.defaultCouponObj = {};
					this.defaultCouponObj[couponId] = this.couponData;
					this.storage.setItem('coupons', JSON.stringify(this.defaultCouponObj));
					this.couponStorage = this.storage.getItem('coupons');
				}
				this.couponStorageObj = JSON.parse(this.couponStorage);
			}
			this.couponData = this.couponStorageObj[couponId];

			if (typeof backendItems != "undefined") {
				for (var backendItemKey in backendItems.items) {
					var backendItem = backendItems.items[backendItemKey];
					if (backendItem.is_live == 0) {

						// Ticket add prematch item.
						var groupId = backendItem.group_id || backendItem.event_id;
						var eventOddsId = backendItem.event_odds_id;
						var eventOddsValue = backendItem.odds_value;
						var ticketItemId = backendItem.id;
						this.addItem(groupId, eventOddsId, eventOddsValue, ticketItemId);

						// Ticket set banker.
						if ((backendItem.banker == 1) && (this.couponData.Events[groupId][eventOddsId].Banker == 1)) {
							this.setBanker(groupId, eventOddsId);
						}
					}
				}
				for (var backendSystemKey in backendItems.systems) {
					if (backendSystemKey != backendItems.systems.length - 1) {
						this.setSystem(backendItems.systems[backendSystemKey].code);
					} else {
						this.setSystem(backendItems.systems[backendSystemKey].code);
						this.setSystem(backendItems.systems[backendSystemKey].code);
					}

				}
				if (backendItems.stake) {
					if (backendItems.stake > 0) {
						this.setStake(backendItems.stake);
					}
				}
			}
			this.checkCouponType();
			this.generateItemList();
			this.calculateWinnings();

			this.coupon();
		};
		Calculator.prototype.checkCouponType = function () {
			this.couponData.couponType = 0;

			for (var eventId in this.couponData.Events) {
				for (var itemId in this.couponData.Events[eventId]) {
					var eventItemData = this.couponData.Events[eventId][itemId];
					if (eventItemData.isLive == 1) {
						if (this.couponData.couponType == 0) {
							this.couponData.couponType = 2;
						} else if (this.couponData.couponType == 1) {
							this.couponData.couponType = 3;
						}
					} else {
						if (this.couponData.couponType == 0) {
							this.couponData.couponType = 1;
						} else if (this.couponData.couponType == 2) {
							this.couponData.couponType = 3;
						}
					}
				}
			}
			return this.setBonusOptions(this.couponData.couponType);
		};
		Calculator.prototype.setBonusOptions = function (betslipType) {
			// This method allows to system to change bonus percentages per betslip Type.
			if (typeof BookmakerService.getBonuses() == "object") {
				this.couponData.bonusOptions = BookmakerService.getBonuses()[betslipType];
			}
			return this.couponData.bonusOptions;
		};
		Calculator.prototype.factorial = function (n) {
			var value = 1;
			for (var i = 1; i <= n; i++) {
				value *= i;
			}
			return value;
		};
		Calculator.prototype.combinator = function (n, r) {
			if ((n == 0) || (r == 0)) {
				return 1;
			}
			if (n >= r) {
				return (this.factorial(n) / (this.factorial(n - r) * this.factorial(r)));
			} else {
				return 1;
			}
		};
		Calculator.prototype.combinationCounter = function (systemOptionGroup) {
			return '-';
		};
		Calculator.prototype.calculateWinnings = function () {
			var activated = false;
			this.couponCombinationsBackup = this.couponData.Combinations;
			this.couponData.Combinations = {};
			var eventLength = Object.keys(this.couponData.Events).length;
			var systemOptionGroup = this.couponData.bankerCount;
			if (systemOptionGroup <= 0) {
				systemOptionGroup = 1;
				this.couponData.bankerCount = 0;
			}


			for (var systemOptionGroup = systemOptionGroup; systemOptionGroup <= eventLength; systemOptionGroup++) {
				var combinationCount = this.getCombinationCount(systemOptionGroup);
				if (combinationCount <= this.maxCombinationCount) {
					if (!this.couponData.Combinations[systemOptionGroup]) {
						// Create fresh system option
						this.couponData.Combinations[systemOptionGroup] = {
							Active: 0,
							ActiveS: 0,
							Code: systemOptionGroup,
							Count: combinationCount,
							Stake: 0,
							Min: 0,
							Max: 0,
							BonusMin: 0,
							BonusMax: 0,
							Combinations: {},
							MaxBonusStorage: 0,
							MinBonusStorage: 0,
							MinStorage: 0,
							MaxStorage: 0,
							RealMaxWinning: 0,
							RealMaxWinningStorage: 0,
							RealMaxBonusWinning: 0,
							RealMaxBonusWinningStorage: 0
						}
					} else {
						// Update system option
						this.couponData.Combinations[systemOptionGroup].Count = combinationCount;
					}

					if (this.couponCombinationsBackup[systemOptionGroup]) {
						this.couponData.Combinations[systemOptionGroup].Active = this.couponCombinationsBackup[systemOptionGroup].Active;
						this.couponData.Combinations[systemOptionGroup].ActiveS = this.couponCombinationsBackup[systemOptionGroup].ActiveS;
						if (this.couponData.Combinations[systemOptionGroup].Active == 1) {
							if (this.couponData.Combinations[systemOptionGroup].ActiveS == 1) {
								this.couponData.Combinations[systemOptionGroup].Active = 0;
								this.couponData.Combinations[systemOptionGroup].ActiveS = 0;
							} else {
								activated = true;
							}
						}
						//if (this.couponData.Combinations[systemOptionGroup].Stake)
						//this.couponData.Combinations[systemOptionGroup].Stake = this.couponCombinationsBackup[systemOptionGroup].Stake; Commented because of stake bug.
					}
					if (systemOptionGroup == eventLength) {
						if (activated == false) {
							this.couponData.Combinations[systemOptionGroup].Active = 1;
							this.couponData.Combinations[systemOptionGroup].ActiveS = 1;
						}
					}

					if (this.couponData.Combinations[systemOptionGroup].Active == 1) {
						// We will do this if its activated actually. We will see how it will works. (If count will be perfect, We're fine..
						this.couponData.Combinations[systemOptionGroup].Combinations = this.generateCombinations(this.couponData.eventData, systemOptionGroup);
						this.calculateMinMaxSystem(systemOptionGroup);
						if ((this.couponData.Combinations[systemOptionGroup].Max == 0) || (this.couponData.Combinations[systemOptionGroup].Min == 0)) {
							//delete this.couponData.Combinations[systemOptionGroup];
						} else {
							if (this.couponData.Combinations[systemOptionGroup].Count <= 0) {
								//delete this.couponData.Combinations[systemOptionGroup];
							} else {
								this.fixSystemStakeWinnings(systemOptionGroup, true);
							}

						}
						this.reCalculateStakes('calculateWinnings');
					}
				}
			}
		};
		Calculator.prototype.fixSystemStakeWinnings = function (groupNumber, reCalculated) {
			var stake = this.couponData.Combinations[groupNumber].Stake;
			if (reCalculated == true) {
				this.couponData.Combinations[groupNumber].MaxStorage = this.couponData.Combinations[groupNumber].Max;
				this.couponData.Combinations[groupNumber].MinStorage = this.couponData.Combinations[groupNumber].Min;
				this.couponData.Combinations[groupNumber].MinBonusStorage = this.couponData.Combinations[groupNumber].BonusMin;
				this.couponData.Combinations[groupNumber].MaxBonusStorage = this.couponData.Combinations[groupNumber].BonusMax;
				this.couponData.Combinations[groupNumber].RealMaxWinningStorage = this.couponData.Combinations[groupNumber].RealMaxWinning;
				this.couponData.Combinations[groupNumber].RealMaxBonusWinningStorage = this.couponData.Combinations[groupNumber].RealMaxBonusWinning;
			} else {
				this.couponData.Combinations[groupNumber].BonusMin = this.couponData.Combinations[groupNumber].MinBonusStorage;
				this.couponData.Combinations[groupNumber].BonusMax = this.couponData.Combinations[groupNumber].MaxBonusStorage;
				this.couponData.Combinations[groupNumber].Max = this.couponData.Combinations[groupNumber].MaxStorage;
				this.couponData.Combinations[groupNumber].RealMaxWinning = this.couponData.Combinations[groupNumber].RealMaxWinningStorage;
				this.couponData.Combinations[groupNumber].RealMaxBonusWinning = this.couponData.Combinations[groupNumber].RealMaxBonusWinningStorage;
				this.couponData.Combinations[groupNumber].Min = this.couponData.Combinations[groupNumber].MinStorage;
			}
			if (this.couponData.Combinations[groupNumber].BonusMax > 1) {
				// this.couponData.Combinations[groupNumber].BonusMax = Math.round(stake * this.couponData.Combinations[groupNumber].BonusMax * 100) / 100;
				// this.couponData.Combinations[groupNumber].BonusMin = Math.round(stake * this.couponData.Combinations[groupNumber].BonusMin * 100) / 100;
			} else {
				// this.couponData.Combinations[groupNumber].BonusMax = 0;
				// this.couponData.Combinations[groupNumber].BonusMin = 0;
			}
			this.couponData.Combinations[groupNumber].Min = Math.round(stake * this.couponData.Combinations[groupNumber].Min * 100) / 100;
			this.couponData.Combinations[groupNumber].Max = Math.round(stake * this.couponData.Combinations[groupNumber].Max * 100) / 100;
			this.couponData.Combinations[groupNumber].RealMaxWinning = Math.round(stake * this.couponData.Combinations[groupNumber].RealMaxWinning * 100) / 100;
			this.couponData.Combinations[groupNumber].RealMaxBonusWinning = Math.round(stake * this.couponData.Combinations[groupNumber].RealMaxBonusWinning * 100) / 100;
			return true;
		};
		Calculator.prototype.reCalculateStakes = function (type) {
			// Fix All Stakes;
			if ((this.couponData.Stake >= 0)) {

				var couponStakerFixStatus = false;
				var totalSystemsStake = 0;
				var totalSystemCount = 0;
				for (var systemGroupNumber in this.couponData.Combinations) {

					if (this.couponData.Combinations[systemGroupNumber].Active == 1) {
						totalSystemsStake += this.couponData.Combinations[systemGroupNumber].Stake * this.couponData.Combinations[systemGroupNumber].Count;
						totalSystemCount += this.couponData.Combinations[systemGroupNumber].Count;
					}
				}
				if (type == 'setSystemStake') {
					this.couponData.Stake = totalSystemsStake;
				} else {
					if (type == 'setStake') {
						couponStakerFixStatus = true;
					} else {
						if (totalSystemsStake > this.couponData.Stake) {
							this.couponData.Stake = totalSystemsStake;
						} else {
							couponStakerFixStatus = true;
						}
					}
				}


				if (couponStakerFixStatus == true) {

					var newValue = this.couponData.Stake / totalSystemCount;
					if (this.couponData.Stake <= 0) {
						var newValue = 0;
					}
					var systemOptionsStakes = newValue;
					for (var systemGroupNumber in this.couponData.Combinations) {
						if (this.couponData.Combinations[systemGroupNumber].Active == 1) {
							this.couponData.Combinations[systemGroupNumber].Stake = systemOptionsStakes;
						} else {
							this.couponData.Combinations[systemGroupNumber].Stake = 0;
						}
						this.fixSystemStakeWinnings(systemGroupNumber);
					}
				}
			}
		};
		Calculator.prototype.calculateMinMaxSystem = function (groupNumber) {
			if (!this.couponData.Combinations[groupNumber]) {
				return false;
			}
			var minOddsForBonus = this.couponData.bonusOptions[0].min_odds;
			this.couponData.Combinations[groupNumber].NewMaximumPercentagedBonusWinning = 0;
			this.couponData.Combinations[groupNumber].BonusMin = 88888;
			this.couponData.Combinations[groupNumber].Max = 0;
			// this.couponData.Combinations[groupNumber].Count = 0;
			for (var combinationId in this.couponData.Combinations[groupNumber].Combinations) {
				// this.couponData.Combinations[groupNumber].Count += 1;
				var eventsForThisCombination = [];
				var value = 1;
				var maxWinningFix = 1;
				var bonusWinningFix = 1;
				var bankerCheckCount = this.couponData.bankerCount;
				var minOdssItemCount = -1;
				for (var combinationItem in this.couponData.Combinations[groupNumber].Combinations[combinationId]) {

					if (!this.couponData.Combinations[groupNumber].Combinations[combinationId]) {
						continue;
					}

					var combinationValueInfo = this.couponData.Combinations[groupNumber].Combinations[combinationId][combinationItem];
					if (eventsForThisCombination.indexOf(combinationValueInfo[1]) == '-1') {
						eventsForThisCombination.push(combinationValueInfo[1]);

						// Banker Fixer Starts.
						if (this.couponData.bankerCount > 0) {
							if (combinationValueInfo[0]) {
								bankerCheckCount -= 1;
							}
						}
						// Banker Fixer Ends
						if (this.couponData.Combinations[groupNumber].Combinations[combinationId]) {
							// Check, If banker doesnt kill that, Continue ...,
							if (this.couponData.bonusOptions[groupNumber - 1]) {
								if (combinationValueInfo[3] > minOddsForBonus) {
									minOdssItemCount += 1;
								}
							}

							value *= combinationValueInfo[3];
							// Check max winning for success.
							var eventObj = this.couponData.Events[combinationValueInfo[1]];
							if (eventObj) {
								if (Object.keys(eventObj).length > 1) {
									var eventValuesArr = [];
									for (var x in eventObj) {
										eventValuesArr.push(eventObj[x].Value);
									}
									var eventsMaximumOdd = Math.max.apply(null, eventValuesArr);
									var searchIndex = eventValuesArr.indexOf(eventsMaximumOdd);
									delete eventValuesArr[searchIndex];
									if (eventValuesArr.indexOf(parseFloat(combinationValueInfo[3])) >= 0) {
										maxWinningFix = value;
									}
								}
							}
						}

					} else {
						// There is same event in one combination.
						delete this.couponData.Combinations[groupNumber].Combinations[combinationId];
						// this.couponData.Combinations[groupNumber].Count -= 1;

					}
					if (minOdssItemCount >= 0) {
						var realPercentageRateForThisCombination = this.couponData.bonusOptions[minOdssItemCount].percentage;
						var realPercentagedWinningForThisCombination = (value / 100) * realPercentageRateForThisCombination;
					} else {
						var realPercentageRateForThisCombination = 0;
						var realPercentagedWinningForThisCombination = 0;
					}


				}
				// Banker Fixer Starts.
				if (this.couponData.bankerCount > 0) {
					if (bankerCheckCount > 0) {
						if (this.couponData.Combinations[groupNumber].Combinations[combinationId]) {
							delete this.couponData.Combinations[groupNumber].Combinations[combinationId];
							// this.couponData.Combinations[groupNumber].Count -= 1;
						}

					}
				}
				// Banker Fixer Ends.
				if (this.couponData.Combinations[groupNumber].Combinations[combinationId]) {
					if (this.couponData.Combinations[groupNumber].Min == 0) {
						this.couponData.Combinations[groupNumber].Min = value;
					}
					if (this.couponData.Combinations[groupNumber].Min >= value) {
						this.couponData.Combinations[groupNumber].Min = value;
					}

					if (this.couponData.Combinations[groupNumber].BonusMin >= realPercentagedWinningForThisCombination) {
						this.couponData.Combinations[groupNumber].BonusMin = realPercentagedWinningForThisCombination;
					}


					if (maxWinningFix == 1) {
						if (this.couponData.Combinations[groupNumber].Max <= value) {
							this.couponData.Combinations[groupNumber].Max = value;
						}
					}

					if (this.itemCount == this.eventCount) {
						// Normal Coupon
						this.couponData.Combinations[groupNumber].BonusMax += realPercentagedWinningForThisCombination;
					} else {
						// Split Column Coupon
						if (this.couponData.Combinations[groupNumber].BonusMax < realPercentagedWinningForThisCombination) {
							this.couponData.Combinations[groupNumber].BonusMax = realPercentagedWinningForThisCombination;
						}
					}

					this.couponData.Combinations[groupNumber].RealMaxWinning += value;

					if (bonusWinningFix == 1) {
						// this.couponData.Combinations[groupNumber].RealMaxBonusWinning += value;
					} else {
						this.couponData.Combinations[groupNumber].RealMaxBonusWinning += bonusWinningFix;
					}

					this.couponData.Combinations[groupNumber].NewMaximumPercentagedBonusWinning += realPercentagedWinningForThisCombination;
					if ((this.couponData.Combinations[groupNumber].Max == 0) && (this.couponData.Combinations[groupNumber].Min != 0)) {
						this.couponData.Combinations[groupNumber].Max = this.couponData.Combinations[groupNumber].Min;
					}
				}

			}
			// if (this.couponData.Combinations[groupNumber].BonusMin == 88888) {
			//     this.couponData.Combinations[groupNumber].BonusMin = 0;
			// }
		};
		Calculator.prototype.create2Darray = function (n) {
			for (var i = [], t = 0; t < n; t++) i[t] = [];
			return i;
		};

		Calculator.prototype.chooseFromSets = function (n, t) {
			var e = n.length,
				f, u, i, r;
			if (t == 0 || t > e) return 0;
			for (f = 0, u = this.create2Darray(t + 1), i = 1; i <= e - t + 1; i++)
				if (i == 1)
					for (r = 1; r <= t; r++) u[r][i] = n.slice(0, r).reduce(function (n, t) {
						return n * t
					}, 1), f = u[r][i];
				else
					for (u[1][i] = n.slice(0, i).reduce(function (n, t) {
						return n + t
					}, 0), f = u[1][i], r = 2; r <= t; r++) u[r][i] = u[r][i - 1] + u[r - 1][i] * n[r + i - 2], f = u[r][i];
			return f
		};

		Calculator.prototype.choose = function (n, t) {
			var i, u, f, r;
			if (n < 0 || t < 0) throw new Error("Invalid negative parameter in Choose()");
			if (n < t) return 0;
			if (n == t || t == 0) return 1;
			for (i = 0, u = 0, t < n - t ? (i = n - t, u = t) : (i = t, u = n - t), f = i + 1, r = 2; r <= u; ++r) f = f * (i + r) / r;

			return f;
		};


		Calculator.prototype.getCombinationCount = function (combinationGroup) {

			if (this.couponData.bankerCount > combinationGroup) {
				return this.maxCombinationCount + 1;
			} else if (this.couponData.bankerCount == combinationGroup) {
				return 1;
			}

			var set = [];
			for (var eventId in this.couponData.Events) {
				var bankerCount = 0;
				for (var itemId in this.couponData.Events[eventId]) {
					if (this.couponData.Events[eventId][itemId].Banker != 0) {
						bankerCount += 1;
					}
				}
				if (bankerCount == 0) {
					set[set.length] = Object.keys(this.couponData.Events[eventId]).length;
				} else {
					combinationGroup -= 1;
				}
			}

			if (this.itemCount == this.eventCount) {
				var returnCount = this.choose(this.eventCount - this.couponData.bankerCount, combinationGroup);
			} else {
				var returnCount = this.chooseFromSets(set, combinationGroup);
			}
			return returnCount;

		};
		Calculator.prototype.arrayUnique = function (master, array) {
			var a = array;
			var masterEventId = master[0];
			for (var i = 0; i < a.length; ++i) {
				var eventId = a[i];
				if (masterEventId[1] === eventId[1])
					return false;
			}
			return true;
		};
		Calculator.prototype.generateCombinations = function (set, k) {
			var i, j, combs, head, tailcombs, headEventId, newSet, c;
			if (k > set.length || k <= 0) {
				return [];
			}
			if (k == set.length) {
				return [set];
			}
			if (k == 1) {
				combs = [];
				for (i = 0; i < set.length; i++) {
					combs.push([set[i]]);
				}
				return combs;
			}
			combs = [];
			for (i = 0; i < set.length - k + 1; i++) {
				// head is a list that includes only our current element.
				head = set.slice(i, i + 1);
				headEventId = head[0][1];
				// We take smaller combinations from the subsequent elements
				newSet = set.slice(i + 1);
				for (c = 0; c < newSet.length; c++) {
					if (headEventId === newSet[c][1])
						newSet.splice(c, 1);
				}

				tailcombs = this.generateCombinations(newSet, k - 1);
				// For each (k-1)-combination we join it with the current
				// and store it to the set of k-combinations.

				for (j = 0; j < tailcombs.length; j++) {
					if (this.arrayUnique(head, tailcombs[j])) {
						combs.push(head.concat(tailcombs[j]));
					}
				}
			}
			return combs;
		};
		Calculator.prototype.generateItemList = function () {
			this.couponData.totalOdds = 1;
			this.couponData.eventData = [];
			this.eventCount = 0;
			this.itemCount = 0;
			var maxDatas = {};
			for (var eventId in this.couponData.Events) {
				if (typeof maxDatas[eventId] == "undefined") {
					maxDatas[eventId] = 0;
				}
				var bankerCount = 0;
				this.eventCount += 1;
				var bankerStatus = (Object.keys(this.couponData.Events[eventId]).length > 1) ? false : true;
				for (var itemId in this.couponData.Events[eventId]) {
					this.couponData.Events[eventId][itemId].isBankerEnabled = bankerStatus;
					this.itemCount += 1;
					var eventItemInfo = this.couponData.Events[eventId][itemId];
					if (eventItemInfo.Value >= maxDatas[eventId]) {
						maxDatas[eventId] = eventItemInfo.Value;
					}
					var lengthOfArr = this.couponData.eventData.length;
					this.couponData.eventData[lengthOfArr] = [];
					if (eventItemInfo.Banker == 0) {
						this.couponData.eventData[lengthOfArr][0] = false;
					} else {
						bankerCount += 1;
						this.couponData.eventData[lengthOfArr][0] = true;
					}
					this.couponData.eventData[lengthOfArr][1] = eventId;
					this.couponData.eventData[lengthOfArr][2] = itemId;
					this.couponData.eventData[lengthOfArr][3] = eventItemInfo.Value;
				}
				this.couponData.totalOdds *= maxDatas[eventId];

			}
			return this.couponData.eventData;
		};
		Calculator.prototype.addItem = function (combinationId, itemId, odd, ticketOddId, isLive) {
			if (ticketOddId > 0) {
				var odd = parseFloat(odd);
				if (!this.couponData.Events[combinationId]) {
					this.couponData.Events[combinationId] = {};
				}
				if (!this.couponData.Events[combinationId][itemId]) {
					// this.couponData.totalItemCount += 1; This is commented cause of bonus option calculation is not looking for it.
					this.couponData.Events[combinationId][itemId] = {
						Banker: 0,
						Name: itemId,
						Value: odd,
						TicketItemId: ticketOddId,
						isLive: isLive,
						isBankerEnabled: true
					};
					if (Object.keys(this.couponData.Events[combinationId]).length > 1) {
						for (var eventItemsId in this.couponData.Events[combinationId]) {
							if (this.couponData.Events[combinationId][eventItemsId].Banker == 1) {
								this.couponData.Events[combinationId][eventItemsId].Banker = 0;
								this.couponData.bankerCount -= 1;
							}
						}
					}
					this.checkCouponType();
					this.generateItemList();
					this.calculateWinnings();
					return this.coupon();
				} else {
					this.checkCouponType();
					return true;
				}
			} else {
				return false;
			}

		};
		Calculator.prototype.addItem2 = function (eventId, itemId, odd, ticketOddId, isLive) {
			if (ticketOddId > 0) {
				var odd = parseFloat(odd);
				if (!this.couponData.Events[eventId]) {
					this.couponData.Events[eventId] = {};
				}
				if (!this.couponData.Events[eventId][itemId]) {
					// this.couponData.totalItemCount += 1; This is commented cause of bonus option calculation is not looking for it.
					this.couponData.Events[eventId][itemId] = {
						Banker: 0,
						Name: itemId,
						Value: odd,
						TicketItemId: ticketOddId,
						isLive: isLive
					};
					if (Object.keys(this.couponData.Events[eventId]).length > 1) {
						for (var eventItemsId in this.couponData.Events[eventId]) {
							if (this.couponData.Events[eventId][eventItemsId].Banker == 1) {
								this.couponData.Events[eventId][eventItemsId].Banker = 0;
								this.couponData.bankerCount -= 1;
							}
						}
					}
					this.checkCouponType();
					this.generateItemList();
					return this.coupon();
				} else {
					this.checkCouponType();
					return true;
				}
			} else {
				return false;
			}

		};
		Calculator.prototype.changeItem = function (eventId, itemId, odd, ticketItemId) {
			this.couponData.Events[eventId][itemId] = {
				Banker: 0,
				Name: itemId,
				Value: odd,
				TicketItemId: ticketItemId
			};
			this.generateItemList();
			this.calculateWinnings();
			return this.coupon();
		};
		Calculator.prototype.removeItem = function (eventId, itemId) {
			if (itemId == 0) {
				delete this.couponData.Events[eventId];
			} else {
				delete this.couponData.Events[eventId][itemId];
				if (Object.keys(this.couponData.Events[eventId]).length == 0) {
					delete this.couponData.Events[eventId];
				}
			}
			this.checkCouponType();
			this.generateItemList();
			this.calculateWinnings();
			return this.coupon();
		};
		Calculator.prototype.setBanker = function (eventId, itemId) {

			if (this.couponData.Events[eventId][itemId].Banker == 1) {
				this.couponData.Events[eventId][itemId].Banker = 0;
				this.couponData.bankerCount -= 1;
			} else {
				this.couponData.Events[eventId][itemId].Banker = 1;
				this.couponData.bankerCount += 1;
			}
			this.generateItemList();
			this.calculateWinnings();
			return this.coupon();
		};
		Calculator.prototype.setSystem = function (systemGroupId, unSetStatus) {
			if (unSetStatus == 1) {
				this.couponData.Combinations[systemGroupId].Active = 0;
				this.couponData.Combinations[systemGroupId].ActiveS = 0;
			} else {
				if (this.couponData.Combinations[systemGroupId].Active == 1) {
					this.couponData.Combinations[systemGroupId].Active = 0;
				} else {
					this.couponData.Combinations[systemGroupId].Active = 1;
				}
				for (var systemOptionGroup in this.couponData.Combinations) {
					this.couponData.Combinations[systemOptionGroup].ActiveS = 0;
				}
			}
			this.calculateWinnings();
			this.reCalculateStakes('setSystem');
			return this.coupon();
		};
		Calculator.prototype.setSystemStake = function (systemGroupId, stake) {
			if (this.couponData.Combinations[systemGroupId].Active == 0) {
				this.setSystem(systemGroupId);
			}
			this.couponData.Combinations[systemGroupId].Stake = stake;
			this.fixSystemStakeWinnings(systemGroupId);
			this.reCalculateStakes('setSystemStake');
			return this.coupon();
		};
		Calculator.prototype.setStake = function (stake) {
			this.couponData.Stake = stake;
			this.reCalculateStakes('setStake');
			return this.coupon();
		};
		Calculator.prototype.checkout = function () {
			var status = true;
			return status;
		};
		Calculator.prototype.coupon = function () {
			this.couponData.Stake = Math.floor(this.couponData.Stake * 100) / 100;
			// Sum Winnings;
			this.couponData.Winning.Min = 0;
			this.couponData.Winning.Max = 0;
			this.couponData.Winning.BonusMax = 0;
			this.couponData.Winning.BonusMin = 99999;
			this.couponData.Winning.MaxAllCombWin = 0;
			this.couponData.Winning.BonusMaxAllCombWin = 0;
			for (var systemOptionGroup in this.couponData.Combinations) {
				if (this.couponData.Combinations[systemOptionGroup].Stake <= 0) {
					this.couponData.Combinations[systemOptionGroup].Stake = '';
				} else {
					var tempStake = '' + this.couponData.Combinations[systemOptionGroup].Stake;
					if ((tempStake.split('.')[1] || []).length > 3) {
						this.couponData.Combinations[systemOptionGroup].Stake = Math.floor(this.couponData.Combinations[systemOptionGroup].Stake * 10000) / 10000
					} else {
						this.couponData.Combinations[systemOptionGroup].Stake = Math.floor(this.couponData.Combinations[systemOptionGroup].Stake * 100) / 100;
					}
				}
				var optionGroup = this.couponData.Combinations[systemOptionGroup];
				if (optionGroup.Active == 1) {
					optionGroup.BonusMax = optionGroup.BonusMax * optionGroup.Stake;
					optionGroup.BonusMin = optionGroup.BonusMin * optionGroup.Stake;
					if ((this.couponData.Winning.Min >= optionGroup.Min) || (this.couponData.Winning.Min == 0)) {
						this.couponData.Winning.Min = parseFloat(optionGroup.Min);
					}

					if (this.itemCount == this.eventCount) {
						this.couponData.Winning.Max += (optionGroup.RealMaxWinning);
					} else {
						this.couponData.Winning.Max += (optionGroup.Max);
					}

					if (this.itemCount == this.eventCount) {
						this.couponData.Winning.BonusMax += optionGroup.BonusMax;
					} else {
						if (this.couponData.Winning.BonusMax < optionGroup.BonusMax) {
							this.couponData.Winning.BonusMax = optionGroup.BonusMax;
						}

					}
					if (this.couponData.Winning.BonusMin >= optionGroup.BonusMin) {
						this.couponData.Winning.BonusMin = this.couponData.Combinations[systemOptionGroup].BonusMin;
					}
					this.couponData.Combinations[systemOptionGroup].RealMaxBonusWinning = parseFloat(optionGroup.NewMaximumPercentagedBonusWinning);


				}


				this.couponData.Winning.MaxAllCombWin += this.couponData.Combinations[systemOptionGroup].Max;
				this.couponData.Winning.BonusMaxAllCombWin += this.couponData.Combinations[systemOptionGroup].BonusMax;
				this.couponData.Combinations[systemOptionGroup].StakeS = this.couponData.Combinations[systemOptionGroup].Stake;
				delete this.couponData.Combinations[systemOptionGroup].Combinations;
				this.couponData.Combinations[systemOptionGroup].Combinations = [];
			}

			if (this.couponData.Winning.BonusMin == 99999) {
				this.couponData.Winning.BonusMin = 0;
			}

			this.couponData.Winning.Min += this.couponData.Winning.BonusMin;
			this.couponData.Winning.Max += this.couponData.Winning.BonusMax;
			this.couponData.Winning.MaxAllCombWin += this.couponData.Winning.BonusMaxAllCombWin;
			// Floor winnings.
			this.couponData.Winning.BonusMin = Math.round(this.couponData.Winning.BonusMin * 100) / 100;
			this.couponData.Winning.BonusMax = Math.round(this.couponData.Winning.BonusMax * 100) / 100;
			this.couponData.Winning.Min = Math.round(this.couponData.Winning.Min * 100) / 100;
			this.couponData.Winning.Max = Math.round(this.couponData.Winning.Max * 100) / 100;
			if (this.couponData.totalOdds == 1) {
				this.couponData.totalOdds = 0;
			}
			this.couponData.Winning.MaxAllCombWin = Math.round(this.couponData.Winning.MaxAllCombWin * 100) / 100;
			this.couponData.Winning.BonusMaxAllCombWin = 0;
			// this.couponData.Winning.MaxAllCombWin = this.couponData.Winning.Max;
			this.couponData.totalOdds = Math.round(this.couponData.totalOdds * 100) / 100;
			//
			if (this.couponData.Winning.Max == 0) {
				this.couponData.Winning.MaxAllCombWin = 0;
			}
			this.defaultCouponObj = {};
			this.defaultCouponObj[this.couponId] = this.couponData;
			this.storage.setItem('coupons', JSON.stringify(this.defaultCouponObj));
			this.couponStorage = this.storage.getItem('coupons');
			if ((this.couponData.Stake <= 0) || (this.couponData.Stake == "NaN")) {
				this.couponData.Stake = '';
				this.couponData.Winning.BonusMax = 0;
				this.couponData.Winning.BonusMin = 0;
			}
			this.couponData.StakeS = this.couponData.Stake;
			return this.couponData;
		};
		return Calculator;
	}
	]);

'use strict';

angular.module('novusTerminal')
      .factory('BetCounter', ['$cookies', function ($cookies) {

            // cookie keys
            var _statusCookieName = 'betCounterStatus';
            var _totalBetsCookieName = 'betCounterTotalBets';
            var _totalStakeCookieName = 'betCounterTotalStake';
            var _startTimeCookieName = 'betCounterStartTime';

            /**
             *  -- init counter object
             * @type {{status: boolean, startTime: *, stats: {totalBets: (*|number), totalStake: (*|number)}}}
             */
            var counter = {
                  status: $cookies.get(_statusCookieName) == 1,
                  startTime: $cookies.get(_startTimeCookieName),
                  stats: {
                        totalBets: parseInt($cookies.get(_totalBetsCookieName)) || 0,
                        totalStake: parseFloat($cookies.get(_totalStakeCookieName)) || 0.0
                  },
                  enable: function () {
                  },
                  disable: function () {
                  },
                  reset: function () {
                  },
                  increaseBets: function () {
                  },
                  increaseStake: function () {
                  },
                  getStartTime: function () {
                  },
                  isEnabled: function () {
                  },
                  Pause: function () {
                  }
            };

            /**
             * - start counting..
             * @returns {{status: boolean, startTime: *, stats: {totalBets: (*|number), totalStake: (*|number)}}}
             */
            counter.enable = function () {
                  counter.status = true;
                  $cookies.put('counterPaused', 0);
                  $cookies.put(_statusCookieName, 1);

                  if (!$cookies.get(_startTimeCookieName)) {
                        counter.startTime = (new Date).toISOString();
                        $cookies.put(_startTimeCookieName, counter.startTime);
                  }

                  return counter;
            };

            /**
             * - stop counting..
             * @returns {{status: boolean, startTime: *, stats: {totalBets: (*|number), totalStake: (*|number)}}}
             */
            counter.disable = function () {
                  counter.status = false;
                  $cookies.put(_statusCookieName, 0);
                  return counter;
            };

            counter.pause = function () {
                  counter.status = false;
                  $cookies.put('counterPaused', 1);
            };
            /**
             *  - reset all stats
             */
            counter.reset = function () {
                  counter.startTime = null;
                  counter.stats = {totalBets: 0, totalStake: 0};
                  $cookies.remove(_startTimeCookieName);
                  $cookies.remove('counterPaused');
                  $cookies.put(_totalBetsCookieName, 0);
                  $cookies.put(_totalStakeCookieName, 0);
                  counter.disable();
            };

            /**
             *
             * @param n
             * @returns {{status: boolean, startTime: *, stats: {totalBets: (*|number), totalStake: (*|number)}}}
             */
            counter.increaseBets = function () {
                  counter.stats.totalBets++;
                  $cookies.put(_totalBetsCookieName, counter.stats.totalBets);
                  return counter;
            };

            /**
             *
             * @param n
             * @returns {{status: boolean, startTime: *, stats: {totalBets: (*|number), totalStake: (*|number)}}}
             */
            counter.increaseStake = function (n) {
                  counter.stats.totalStake += n;
                  $cookies.put(_totalStakeCookieName, counter.stats.totalStake);
                  return counter;
            };

            /**
             *
             * @returns {string}
             */
            counter.getStartTime = function () {
                  var rowDate = counter.startTime ? moment(counter.startTime).format('MMM D, YYYY HH:mm') : null;
                  // var sinceDate = rowDate !== null ? languageService.get('since_with_date', {"date": rowDate}) : '';
                  return rowDate
            };

            /**
             *
             * @returns {*}
             */
            counter.isEnabled = function () {
                  // counter.status;
                  return $cookies.get('betCounterStartTime');
            };

            //
            return counter;

      }])
      .controller('BetCounterCtrl', ['$scope', 'BetCounter', '$cookies', 'NotifyingService', function ($scope, BetCounter, $cookies, NotifyingService) {

            $scope.betCounter = BetCounter;
            $scope.start = true;
            $scope.pause = false;
            $scope.resume = false;
            $scope.checkCounterState = function () {
                  $scope.started = true;
                  if ($cookies.get('counterPaused') == 0) {
                        $scope.pause = true;
                        $scope.start = false;
                        $scope.resume = false;
                  } else if ($cookies.get('counterPaused') == 1) {
                        $scope.resetActive = true;
                        $scope.resume = true;
                        $scope.pause = false;
                        $scope.start = false;
                  } else {
                        $scope.start = true;
                        $scope.pause = false;
                        $scope.resume = false;
                  }
                  NotifyingService.notify('betCounter:been-touched');
            };
            NotifyingService.subscribe($scope, 'betCounter:been-changed', function () {
                  $scope.checkCounterState();
            });
            $scope.checkCounterState();
      }]);

/**
 * Created by unal on 18.05.2017.
 */



(function () {

      angular
            .module('novusTerminal')
            .factory('TicketModel', ServiceFn);


      ServiceFn.$inject = ['ApiService'];
      function ServiceFn(ApiService) {
            var rest = ApiService.serviceOne();

            return rest.service('ticket/');
      }


})();
/**
 * Created by unal on 23.05.2017.
 */



(function () {

	angular
		.module('novusTerminal')
		.factory('LiveService', ServiceFn);

	ServiceFn.$inject = [
		'LiveModel',
		'UtilsService',
		'LiveEngineService',
		'TranslateLiveModelService',
		'languageService'
	];
	function ServiceFn(LiveModel, UtilsService, LiveEngineService, TranslateLiveModelService, languageService) {


		var sports = [];

		// var liveData = {};

		var liveData = new LiveEngineService();

		var defaultMarkets = {};

		var liveNavBarSports = [];

		var liveSelectedSport = {};

		var liveEventViewEventData = {};

		var liveEventViewSport = {};

		var runLiveCheck = false;

		var displaySetting = {
			noDataInformation: false,
			loadingBar: false
		};

		var serviceObj = {


			loadInitLive: function () {
				_.merge(displaySetting, {loadingBar: true});

				return LiveModel.one().post('init', {
					from: 'live'
				}).then(function (data) {
					_.merge(displaySetting, {loadingBar: false});

					if (data.data.sports.length <= 0) {
						_.merge(displaySetting, {noDataInformation: true});
						return;
					}
					UtilsService.removeAndMerge(defaultMarkets, data.data.default_markets);
					UtilsService.removeAndMerge(liveData.data, data.data);
					setSportsData(data.data.sports);
					UtilsService.removeAndMerge(liveNavBarSports, data.data.sports);
					UtilsService.removeAndMerge(liveSelectedSport, data.data.sports[0]);
					_.merge(displaySetting, {noDataInformation: false});

					checkLive();
					// getFirebaseDt();
				})
			},

			getLiveData: function () {
				return sports;
			},

			getLiveEngineData: function () {
				return liveData;
			},

			getLiveSportNavBar: function () {
				return liveNavBarSports;
			},

			getSelectedSportNavBar: function () {
				return liveSelectedSport;
			},

			setSelectedLiveSport: function (sport) {
				UtilsService.removeAndMerge(liveSelectedSport, sport);
			},

			setInitialEventViewData: function (sport, event) {
				_.merge(liveEventViewEventData, event);
				_.merge(liveEventViewSport, sport);
			},

			getEventViewData: function () {
				return liveEventViewEventData;
			},

			getEventViewSportData: function () {
				return liveEventViewSport;
			},

			loadEventViewLiveData: function (paramValue) {
				var sportId = paramValue.sportId * 1;
				var eventId = paramValue.eventId * 1;
				if (_.has(liveData.data, 'sports')) {
					return;
				}

				serviceObj.loadInitLive().then(function () {
					_.merge(liveEventViewEventData, liveData.data.events[eventId]);
					_.merge(liveEventViewSport, setSportsTemplate(_.find(liveData.data.sports, {id: sportId})));
				})
			},

			setRunLiveCheckStatus: function (status) {
				runLiveCheck = status;
			},

			getDisplaySetting: function () {
				return displaySetting;
			},


		};

		function checkLive() {
			// if (!runLiveCheck) {
			//       return;
			// }
			LiveModel.one().post('check', {
				from: 'live'
			}).then(function (data) {
				sports.splice(0, sports.length);
				liveNavBarSports.splice(0, liveNavBarSports.length);
				UtilsService.removeAndMerge(liveNavBarSports, data.data.sports);
				UtilsService.removeAndMerge(liveData.data, data.data);
				setSportsData(data.data.sports);
				setEventViewData();
				checkLive();
			})
		}

        function analyseMarketsFn(eventMarkets) {
            angular.forEach(eventMarkets.liveMarkets, function(market) {
                var type = market.type;
                var typeId = market.type_id;
                var subType = market.sub_type;
                    angular.forEach(market.odds, function (odd) {
                        //var key = 'lo_' + (type ? type + '_' : '') + (typeId ? typeId + '_' : '') + (subType ? subType + '_' : '') + odd.code;
                        var key = 'lo_' + (type || '') + '_' + (typeId || '') + '_' + (subType || '') + '_' + odd.code;
                        var refactoredKey = languageService.refactorKey(key);
                        //odd.code = languageService.getLive(refactoredKey) || odd.code;   //// odd.code shouldnt be manipulated !!!!!
                        odd.codeTranslation = refactoredKey + '_liveodds_' + odd.code;

                    });

            });
            angular.forEach(eventMarkets.liveSubMarkets, function(market) {
                var type = market.type;
                var typeId = market.type_id;
                var subType = market.sub_type;
                    angular.forEach(market.liveSubOdds, function (odd) {
                        //var key = 'lo_' + (type ? type + '_' : '') + (typeId ? typeId + '_' : '') + (subType ? subType + '_' : '') + odd.code;
                        var key = 'lo_' + (type || '') + '_' + (typeId || '') + '_' + (subType || '') + '_' + odd.code;
                        var refactoredKey = languageService.refactorKey(key);
                        //odd.code = languageService.getLive(refactoredKey) || odd.code;   //// odd.code shouldnt be manipulated !!!!!
                        odd.codeTranslation = refactoredKey + '_liveodds_' + odd.code;

                    });

            });

        }

		function getFirebaseDt() {

			var ref = firebase.database().ref();
			// var obj = $firebaseObject(ref);
			ref.on('value', function (snap) {
				var fireData = snap.val().live.data;
				sports.splice(0, sports.length);
				liveNavBarSports.splice(0, liveNavBarSports.length);
				UtilsService.removeAndMerge(liveNavBarSports,
					fireData.sports);
				UtilsService.removeAndMerge(liveData.data, fireData);
				setSportsData(fireData.sports);
				setEventViewData();
			});

		}

		function setSportsData(liveSports) {
			_.forEach(liveSports, function (sport) {
				if (sport.tournaments.length > 0) {
					sport.liveTournaments = [];
				}

				_.merge(sport.liveTournaments, fillSportTournaments(sport));
				sports.push(setSportsTemplate(sport));
			})
		}

		function setSportsTemplate(sport) {
			switch (sport.id * 1) {
				case 1:
				case 2 :
				case 21:
				case 22:
				case 16:
				case 29:
				case 4 :
				case 19:
					sport.live_template = 1;
					break;
				case 3 :
				case 6 :
				case 12:
					sport.live_template = 2;
					break;
				case 5:
				case 31:
				case 34:
				case 32:
				case 20:
				case 23:
					sport.live_template = 3;
					break;
			}

			return sport;
		}

		function fillSportTournaments(sport) {
			var liveTournaments = [];
			_.forEach(sport.tournaments, function (tournamentId) {
				var liveTournament = liveData.data.tournaments[tournamentId];
				if (!liveTournament) {
					return;
				}
				if (liveTournament.event_count > 0) {
					liveTournament.liveEvents = [];
					_.merge(liveTournament.liveEvents, fillTournamentEvent(liveTournament.events));
					liveTournament.markets = [];
					_.merge(liveTournament, fillSportsMarkets(liveTournament, sport.id));

				}

				liveTournaments.push(liveTournament);
			});

			return liveTournaments;
		}

		function fillSportsMarkets(liveTournament, sportId) {
			if (_.isEmpty(defaultMarkets)) {
				return;
			}
			var markets = defaultMarkets[sportId].markets;
			liveTournament.marketsLength = 0;
			_.forEach(markets, function (market, marketKey) {
				market.typeKey = marketKey;
				liveTournament.markets.push(market);
				liveTournament.marketsLength += market.odd_count;
			});

			return liveTournament;
		}

		function fillTournamentEvent(events) {
			var liveEvents = [];

			_.forEach(events, function (eventId) {
				var liveEvent = liveData.data.events[eventId];

				if (!liveEvent) {
					return;
				}
				if (liveEvent.markets.length > 0) {
					liveEvent.liveMarkets = [];
					_.merge(liveEvent.liveMarkets, fillEventMarkets(liveEvent.markets, eventId));
				}
				liveEvents.push(liveEvent);
			});

			return liveEvents;
		}

		function fillEventMarkets(markets, eventId) {
			var liveMarkets = [];
			var eventMarkets = liveData.data.markets[eventId];
			_.forEach(markets, function (marketTypeId) {
				var liveMarket = eventMarkets[marketTypeId];
				liveMarket.typeKey = marketTypeId;
				liveMarket.odds = [];
				_.merge(liveMarket.odds, fillMarketOdds(liveMarket.odd_count, liveMarket.id));
				liveMarkets.push(liveMarket);
			});

			return liveMarkets;
		}

		function fillMarketOdds(oddsCount, marketId) {
			var odds = liveData.data.odds[marketId];
			if (!odds) {
				odds = [];
				for (var idx = 0; idx < oddsCount; idx++) {
					var newOdds = {
						active: false,
						value: '-'
					};
					odds.push(newOdds);
				}
			}
			return odds;
		}

		/**
		 *event view data
		 */

		function setEventViewData() {
			if (_.isEmpty(liveEventViewEventData) || _.isEmpty(liveEventViewSport)) {
				return;
			}

			UtilsService.removeAndMerge(liveEventViewEventData, liveData.data.events[liveEventViewEventData.id]);

			if (_.isEmpty(liveEventViewEventData) || _.isUndefined(liveEventViewEventData)) {
				return;
			}

			fillLiveEventViewDataSubMarkets()
            analyseMarketsFn(liveEventViewEventData);
		}

		function fillLiveEventViewDataSubMarkets() {
			liveEventViewEventData.liveSubMarkets = [];
			_.forEach(liveEventViewEventData.sub_markets, function (subMarketId) {
				var liveSubMarket = fillLiveEventViewDataSubMarketOdds(liveData.data.sub_markets[liveEventViewEventData.id][subMarketId]);
				liveEventViewEventData.liveSubMarkets.push(liveSubMarket);
			})
		}

		function fillLiveEventViewDataSubMarketOdds(subMarket) {
			subMarket.liveSubOdds = [];
			_.merge(subMarket.liveSubOdds, liveData.data.sub_odds[subMarket.id]);
			return subMarket;
		}

		return serviceObj;
	}

})();
/**
 * Created by unal on 18.05.2017.
 */



(function () {

      angular
            .module('novusTerminal')
            .factory('LiveModel', ServiceFn);



      ServiceFn.$inject = ['ApiService'];
      function ServiceFn(ApiService) {
            var rest =ApiService.serviceOne();

            return rest.service('live/');
      }


})();
(function () {
    'use strict';
    angular.module('novusTerminal')
        .factory('LiveEngineService', ['$rootScope', '$location', '$sce', function ($rootScope, $location, $sce) {
            function LiveEngine() {
                this.data = {
                    updated_at: moment().unix(),
                };
                this.storage = localStorage.getItem('NLE');
                if (this.storage === null) {
                    this.storage = {
                        'sports': {},
                        'tournaments': {},
                        'favorite_events': {},
                        'sportMarkets': {},
                        'markets': {}
                    };
                } else {
                    this.storage = JSON.parse(localStorage.getItem('NLE'));
                }
                this.selected_event = null;
                this.widget_event = null;
                this.selected_market_group = 0;
                this.current_view = "mixed";
                this.sidebar_odds = true;
                this.sidebar_details = true;
                this.sidebar_status = true;
                this.columnType = 'one-column';
                this.selectedSport = 0;
                // this.ticket = TicketService;
                this.calendar = [];
                this.selectedDateOnCalendar = null;
            }

            LiveEngine.prototype.changeColumnType = function (type) {
                this.columnType = type;
            };
            LiveEngine.prototype.getUrl = function (eventid) {
                return $sce.trustAsResourceUrl('https://widgetlive.indianaint.com/trakers.html?eventid=' + eventid);
            };
            LiveEngine.prototype.changeHeaderStatus = function () {
  
                    var el = document.documentElement,
                    rfs = el.requestFullscreen
                        || el.webkitRequestFullScreen
                        || el.mozRequestFullScreen
                        || el.msRequestFullscreen 
                    ;

                    rfs.call(el);

            };
            LiveEngine.prototype.selectDefaultEvent = function () {
                if ((typeof this.data.sports == "object") && (typeof this.data.sports[0] == "object") && (typeof this.data.sports[0].events != "undefined")) {
                    for (var firstEvent in this.data.sports[0].events) {
                        this.selected_event = this.data.sports[0].events[firstEvent];
                        break;
                    }

                    if (this.data.sports[0].name == "soccer") {
                        this.widget_event = this.selected_event;
                    }

                }
            };
            LiveEngine.prototype.getFirstMarkets = function () {
                for (var sportId in this.data.default_markets) {
                    for (var marketKey in this.data.default_markets[sportId].markets) {
                        this.data.default_markets[sportId].firstMarket = marketKey;
                        break;
                    }
                }
            };
            LiveEngine.prototype.changeDefaultMarketForSport = function (sport, marketKey) {
                this.data.default_markets[sport.id].firstMarket = marketKey;
            };
            LiveEngine.prototype.changeMarketGroup = function (sport_id, group_id) {
                this.selected_market_group = group_id;
            };
            LiveEngine.prototype.moveToEventView = function (event_id) {
                $location.path("/live");
                this.showEventDetails(event_id);
            };
            LiveEngine.prototype.parseScore = function (score, return_key) {
                if (typeof score == "string") {
                    return score.split(':')[return_key];
                }
            };
            LiveEngine.prototype.selectDateOnCalendar = function (date) {
                this.selectedDateOnCalendar = date;
            };
            LiveEngine.prototype.showEventDetails = function (event_id) {
                // console.log(event_id);
                this.current_view = "event";
                $rootScope.showStatic = true;
                return this.selectEvent(event_id);
            };
            LiveEngine.prototype.selectEvent = function (event_id) {
                this.selected_market_group = 0;
                return this.selected_event = event_id;
            };
            LiveEngine.prototype.selectSport = function (sport_id) {
                this.selectedSport = sport_id;
            };
            LiveEngine.prototype.changeView = function (view_name) {
                // console.log(view_name);
                if (view_name == "event") {
                    this.selectDefaultEvent();
                    $rootScope.showStatic = true;
                } else {
                    $rootScope.showStatic = false;
                }
                return this.current_view = view_name;
            };
            /*LiveEngine.prototype.manageItem = function (eventId, marketType, marketId, oddId, oddValue) {
                if (marketType) {
                    TicketService.manageLiveItem(this.data.events[eventId], this.data.markets[eventId][marketId], marketId, oddId, oddValue, marketType);
                } else {
                    TicketService.manageLiveItem(this.data.events[eventId], this.data.sub_markets[eventId][marketId], marketId, oddId, oddValue, marketType);
                }

            };*/
           /* LiveEngine.prototype.checkItem = function (event_id, market_id, odd_id, special_value) {
                if (angular.isUndefinedOrNull(special_value)) {
                    special_value = null;
                }
                return TicketService.active_live_items.hasOwnProperty(event_id + market_id + odd_id + special_value);
            };
*/
            LiveEngine.prototype.updateStorage = function () {
                localStorage.setItem('NLE', JSON.stringify(this.storage));
            };
            LiveEngine.prototype.manageFavorite = function (event_id) {
                if (typeof this.storage.favorite_events[event_id] != "object") {
                    this.storage.favorite_events[event_id] = {
                        'id': event_id,
                        'home': this.data.events[event_id].home,
                        'away': this.data.events[event_id].away
                    };
                } else {
                    delete this.storage.favorite_events[event_id];
                }
                this.updateStorage();

            };
            LiveEngine.prototype.checkSidebar = function () {
                return this.sidebar_status;
            };
            LiveEngine.prototype.manageSidebar = function () {
                this.sidebar_status = !this.sidebar_status;
            };
            LiveEngine.prototype.manageSidebarEvents = function () {
                for (var type in this.storage) {
                    for (var id in this.storage[type]) {
                        this.storage[type][id].isOpen = !this.storage[type][id].isOpen;
                        this.storage[type][id].style = (this.storage[type][id].isOpen) ? "direction-up" : "direction-down";
                    }
                }
                this.updateStorage();
            };
            LiveEngine.prototype.manageSidebarDetails = function () {
                this.sidebar_details = !this.sidebar_details;
            };
            LiveEngine.prototype.manageSidebarOdds = function () {
                this.sidebar_odds = !this.sidebar_odds;
            };
            LiveEngine.prototype.manageCollapse = function (type, id) {
                if (typeof this.storage[type][id] == "object") {
                    this.storage[type][id].isOpen = !this.storage[type][id].isOpen;
                } else {
                    this.storage[type][id] = {'isOpen': true, 'style': 'direction-up'};
                }
                this.storage[type][id].style = (this.storage[type][id].isOpen) ? "direction-up" : "direction-down";
                this.updateStorage();
            };
            LiveEngine.prototype.isCollapsed = function (type, id) {
                if (typeof this.storage[type] == "undefined") {
                    this.storage[type] = {};
                }
                if (typeof this.storage[type][id] != "object") {
                    this.storage[type][id] = {'isOpen': true, 'style': 'direction-up'};
                }
                return this.storage[type][id].isOpen;
            };
            return LiveEngine;
        }]);
})();

/**
 * Created by unal on 07.04.2017.
 */



(function () {

      var path = 'app/live/liveSportNavBar';

      angular.module('novusTerminal')
            .directive('aptLiveSportNavBar', DirectiveFn);

      function DirectiveFn() {
            return {
                  restrict: 'EA',
                  scope: {},
                  bindToController: true,
                  controller: ControllerFn,
                  controllerAs: 'vmLiveSportNavBar',
                  templateUrl: function (elem, attrs) {
                        if (attrs.template) {
                              return path + '/live-sport-nav-bar.' + attrs.template + '.html';
                        } else {
                              return path + '/live-sport-nav-bar.html';
                        }
                  }
            }
      }

      ControllerFn.$inject = [
            'LiveService',
            'NotifyingService',
            '$state'];
      function ControllerFn(LiveService, NotifyingService, $state) {
            var vm = this;

            vm.sportsNavBar = LiveService.getLiveSportNavBar();
            vm.selectedSportNavBar = LiveService.getSelectedSportNavBar();

            vm.setLiveSport = setLiveSportFn;

            function setLiveSportFn(sport) {
                  if ($state.is('eventView')) {
                        $state.go('live');
                  }
                  LiveService.setSelectedLiveSport(sport);
            }

            var screenWidth = document.body.offsetWidth;
            if (screenWidth <= 1024) {
                  vm.betslipOption = true;
            }
            vm.betslipOptions = betslipOptionsFn;
            function betslipOptionsFn() {
                  vm.betslipOption = !vm.betslipOption;
                  NotifyingService.notify('betslipChangeLive')
            }

      }
})();
/**
 * Created by Emre on 2.06.2017.
 */

(function () {
	'use strict';

	var path = 'app/live/liveEventList';

	angular.module('novusTerminal').directive('aptEventList', DirectiveFn);

	function DirectiveFn() {
		return {
			restrict: 'EA',
			scope: {},
			bindToController: true,
			controller: ControllerFn,
			controllerAs: 'vmEventList',
			templateUrl: function (elem, attrs) {
				if (attrs.template) {
					return path + '/live-event-list.' +
						attrs.template + '.html';
				} else {
					return path + '/live-event-list.html';
				}
			},
		};
	}

	ControllerFn.$inject = [
		'LiveService',
		'$state',
		'TicketEventService'
	];
	function ControllerFn(LiveService, $state,TicketEventService) {
		var vm = this;

		vm.liveSports = LiveService.getLiveData();
		vm.liveEngineData = LiveService.getLiveEngineData();
		vm.selectedSportNavBar = LiveService.getSelectedSportNavBar();
		vm.displaySetting = LiveService.getDisplaySetting();

		var ticketLiveItems = TicketEventService.getClickedOddsLiveEvents();

		vm.openEventLiveView = openEventLiveViewFn;
		vm.checkLiveOddsActive = checkLiveOddsActiveFn;
		vm.clickLive = clickLiveFn;

		function openEventLiveViewFn(sport, event) {
			$state.go('eventView',
				{sportId: sport.id, eventId: event.id});
			LiveService.setInitialEventViewData(sport, event);
		}

		function clickLiveFn(eventId, status, typeKey, oddsCode, oddsValue) {

			var liveEvent = vm.liveEngineData.data.events[eventId];
			var liveEventMarket = vm.liveEngineData.data.markets[eventId][typeKey];
			TicketEventService.manageClickedLiveItem(liveEvent, liveEventMarket, typeKey, oddsCode, oddsValue, status);
		}

		function checkLiveOddsActiveFn(eventId, odds, market) {
			if (ticketLiveItems.length <= 0) {
				return false;
			}
			var liveItemsKey = eventId + market.typeKey + odds.code + market.special_bet_value;

			var oIdx = _.findIndex(ticketLiveItems, {live_item_key: liveItemsKey});
			return oIdx >= 0 ? true : false;
		}

		var carouselStatus = 0;
		vm.topScroll = topScrollFn;
		function topScrollFn() {
			if (carouselStatus == 0) {
				return false;
			}
			carouselStatus--;
			document.getElementById(
				'event-list-content').style.transform = 'translateY(-' +
				carouselStatus * 100 + 'px)';
		}

		vm.bottomScroll = bottomScrollFn;
		function bottomScrollFn() {
			var scrollContainer = document.getElementById(
				'event-list-scroll').offsetHeight;
			var scrollContent = document.getElementById(
				'event-list-content').offsetHeight;
			var scrollDifference = scrollContent - scrollContainer;
			if (scrollDifference < 0) {
				return false;
			} else {
				var scrollIndex = scrollDifference / 100;
				scrollIndex = Math.floor(scrollIndex) + 1;
				if (carouselStatus >= scrollIndex) {
					return false;
				} else {
					carouselStatus++;
					document.getElementById(
						'event-list-content').style.transform = 'translateY(-' +
						carouselStatus * 100 + 'px)';
				}
			}
		}

	}

})();
/**
 * Created by Emre on 5.06.2017.
 */

(function () {
    'use strict';
    angular
        .module('novusTerminal')
        .controller('EventViewCtrl', ControllerFn);

    ControllerFn.$inject = [
        'LiveService',
        '$state',
        'NotifyingService',
        '$scope'
    ];
    function ControllerFn(LiveService, $state, NotifyingService, $scope) {
        var vm = this;

        var paramValue = $state.params;

        LiveService.loadEventViewLiveData(paramValue);

        NotifyingService.subscribe($scope, 'betslipChangeLive', function() {
            vm.betslipOption = !vm.betslipOption;
        })


    }

})();
/**
 * Created by Byn on 22.08.2017.
 */
(function () {
      'use strict';
      angular
            .module('novusTerminal')
            .directive('nvsUserType', DirectiveFn);

      function DirectiveFn() {
            return {
                  scope: {
                        user: '='
                  },
                  link: function link(scope, elem) {
                        var typeOfUser = scope.user;

                        var isOperator = function (user) {
                              return user.type == 1 && user.sub_type == 3;
                        };
                        var isPromoter = function (user) {
                              return user.type == 1 && user.sub_type == 4;
                        };
                        var isMaster = function (user) {
                              return user.type == 3;
                        };
                        var isShop = function (user) {
                              return user.type == 1 && user.sub_type == 2;
                        };
                        var isPlayer = function (user) {
                              return user.type == 2;
                        };
                        if (isShop(typeOfUser)) {
                              return elem.addClass('nvs-shop-label');
                        } else if (isPromoter(typeOfUser)) {
                              return elem.addClass('nvs-promoter-label');
                        } else if (isOperator(typeOfUser)) {
                              return elem.addClass('nvs-operator-label');
                        } else if (isMaster(typeOfUser)) {
                              return elem.addClass('nvs-master-label');
                        } else {
                              return elem.addClass('nvs-player-label');
                        }
                  }
            }
      }
})();
/**
 * Created by Byn on 22.08.2017.
 */
(function () {
      'use strict';
      angular
            .module('novusTerminal')
            .directive('nvsUserSymbol', DirectiveFn);

      function DirectiveFn() {
            return {
                  scope: {
                        typeof: '='
                  },
                  link: function link(scope, elem) {
                        var typeOfUser = scope.typeof;

                        var isOperator = function (user) {
                              return user.type == 1 && user.sub_type == 3;
                        };
                        var isPromoter = function (user) {
                              return user.type == 1 && user.sub_type == 4;
                        };
                        var isMaster = function (user) {
                              return user.type == 3;
                        };
                        var isShop = function (user) {
                              return user.type == 1 && user.sub_type == 2;
                        };
                        var isPlayer = function (user) {
                              return user.type == 2;
                        };
                        if (isShop(typeOfUser)) {
                              return elem.html('<span class="nvs-reports-shop-icon"></span>');
                        } else if (isPromoter(typeOfUser)) {
                              return elem.html('<span class="nvs-reports-promoter-icon"></span>');
                        } else if (isOperator(typeOfUser)) {
                              return elem.html('<span class="nvs-reports-operator-icon"></span>');
                        } else if (isMaster(typeOfUser)) {
                              return elem.html('<span class="nvs-reports-master-icon"></span>');
                        } else {
                              return elem.html('<i class="fa fa-lg fa-user" aria-hidden="true"></i>');
                        }
                  }
            }
      }
})();
/**
 * Created by unal on 23.05.2017.
 */



(function () {

      angular
              .module('novusTerminal')
              .factory('UpdateService', ServiceFn);

      ServiceFn.$inject = [
            'UpdateModel',
            '$timeout',
            '$cookies',
            'UserService',
            'DateClockService',
            'SessionTimeoutService',
            'LogoutService'
      ];
      function ServiceFn(UpdateModel, $timeout, $cookies, UserService, DateClockService, SessionTimeoutService, LogoutService) {


            var extendTimeoutStatus = '';

            var serviceObj = {

                  getUpdate: function () {
                        UpdateModel.post({extend_timeout: extendTimeoutStatus}).then(function (res) {
                              if (res.data.user && $cookies.get('UserLoggedIn') * 1) {
                                    UserService.setUserBalanceData(res.data.user);

                                    SessionTimeoutService.setSessionTime(res.data.user.session_expired_at, res.time);

                                    $timeout(function () {
                                          serviceObj.getUpdate();
                                    }, 5000)
                              }

                              if ((res.data && !_.has(res.data, 'user')) && ($cookies.get('UserLoggedIn')*1)) {
                                /**
                                 *user login other device and we need to logout
                                 */

                                LogoutService.logout();
                            }

                              /**
                               *set clock and date to server time
                               */

                              DateClockService.setClockAndDate(res.time);

                        });
                  },

                  setExtendTimeoutStatus: function (status) {
                        extendTimeoutStatus = status;
                  }
            };


            return serviceObj;
      }

})();
/**
 * Created by unal on 18.05.2017.
 */



(function () {

      angular
              .module('novusTerminal')
              .config(InterceptorFn)
              .factory('UpdateModel', ServiceFn);


      InterceptorFn.$inject = ['RestangularProvider'];
      function InterceptorFn(RestangularProvider) {

            /**
             * The responseInterceptor is called after we get each response from the server.
             * It's a function that receives this arguments:

             data: The data received got from the server
             operation: The operation made. It'll be the HTTP method used except for a GET which returns a list of element which will return getList so that you can distinguish them.
             what: The model that's being requested. It can be for example: accounts, buildings, etc.
             url: The relative URL being requested. For example: /api/v1/accounts/123
             response: Full server response including headers
             deferred: The deferred promise for the request.
             */
            RestangularProvider.addResponseInterceptor(function (data, operation, what, url, response, deferred) {

                  return data;

            });


            /**
             * The requestInterceptor is called before sending any data to the server.
             * It's a function that must return the element to be requested. This function receives the following arguments:

             element: The element to send to the server.
             operation: The operation made. It'll be the HTTP method used except for a GET which returns a list of element which will return getList so that you can distinguish them.
             what: The model that's being requested. It can be for example: accounts, buildings, etc.
             url: The relative URL being requested. For example: /api/v1/accounts/123

             */
            RestangularProvider.addRequestInterceptor(function (data, operation, what, url) {

                  return data;
            });

      }


      ServiceFn.$inject = ['ApiService'];
      function ServiceFn(ApiService) {
            var rest = ApiService.serviceTwo();

            return rest.service('updates');
      }


})();
/**
 * Created by unal on 18.05.2017.
 */



(function () {

      angular
            .module('novusTerminal')
            .config(InterceptorFn)
            .factory('TranslateModelService', ServiceFn);


      InterceptorFn.$inject = ['RestangularProvider'];
      function InterceptorFn(RestangularProvider) {

            /**
             * The responseInterceptor is called after we get each response from the server.
             * It's a function that receives this arguments:

             data: The data received got from the server
             operation: The operation made. It'll be the HTTP method used except for a GET which returns a list of element which will return getList so that you can distinguish them.
             what: The model that's being requested. It can be for example: accounts, buildings, etc.
             url: The relative URL being requested. For example: /api/v1/accounts/123
             response: Full server response including headers
             deferred: The deferred promise for the request.
             */
            RestangularProvider.addResponseInterceptor(function (data, operation, what, url, response, deferred) {


                  if (what != 'i18n/lang') {
                        return data;
                  }

                  return data;

            });


            /**
             * The requestInterceptor is called before sending any data to the server.
             * It's a function that must return the element to be requested. This function receives the following arguments:

             element: The element to send to the server.
             operation: The operation made. It'll be the HTTP method used except for a GET which returns a list of element which will return getList so that you can distinguish them.
             what: The model that's being requested. It can be for example: accounts, buildings, etc.
             url: The relative URL being requested. For example: /api/v1/accounts/123

             */
            RestangularProvider.addRequestInterceptor(function (data, operation, what, url) {

                  return data;
            });

      }

      ServiceFn.$inject = ['ApiService'];
      function ServiceFn(ApiService) {
            var rest = ApiService.serviceOne();

            return rest.service('i18n/lang');
      }


})();
(function () {

    angular
        .module('novusTerminal')
        .config(InterceptorFn)
        .factory('TranslateLiveModelService', ServiceFn);


    InterceptorFn.$inject = ['RestangularProvider'];
    function InterceptorFn(RestangularProvider) {

        /**
         * The responseInterceptor is called after we get each response from the server.
         * It's a function that receives this arguments:

         data: The data received got from the server
         operation: The operation made. It'll be the HTTP method used except for a GET which returns a list of element which will return getList so that you can distinguish them.
         what: The model that's being requested. It can be for example: accounts, buildings, etc.
         url: The relative URL being requested. For example: /api/v1/accounts/123
         response: Full server response including headers
         deferred: The deferred promise for the request.
         */
        RestangularProvider.addResponseInterceptor(function (data, operation, what, url, response, deferred) {


            if (what != 'i18n/lang-live') {
                return data;
            }

            return data;

        });


        /**
         * The requestInterceptor is called before sending any data to the server.
         * It's a function that must return the element to be requested. This function receives the following arguments:

         element: The element to send to the server.
         operation: The operation made. It'll be the HTTP method used except for a GET which returns a list of element which will return getList so that you can distinguish them.
         what: The model that's being requested. It can be for example: accounts, buildings, etc.
         url: The relative URL being requested. For example: /api/v1/accounts/123

         */
        RestangularProvider.addRequestInterceptor(function (data, operation, what, url) {

            return data;
        });

    }

    ServiceFn.$inject = ['ApiService'];
    function ServiceFn(ApiService) {
        var rest = ApiService.serviceOne();

        return rest.service('i18n/lang-live');
    }


})();
/**
 * Created by unal on 7/4/2017.
 */

(function () {

    angular.module('novusTerminal').factory('NvsBasicTranslateService', ServiceFn);


    function ServiceFn(UtilsService) {

        var jsonData = {};

        var serviceObj = {

            setJson: function (langJson) {
                UtilsService.removeAndMerge(jsonData, langJson);
                // NovusService.setOption('langLoaded', true);
            },

            getTranslateKeyValue: function (key) {
                return jsonData[key];
            }


        };

        return serviceObj;

    }

})();

/**
 * Created by unal on 23.05.2017.
 */



(function () {

      angular
              .module('novusTerminal')
              .factory('ToastrNotificationService', ServiceFn);

      ServiceFn.$inject = [
            'toastr',
            'NvsBasicTranslateService'
      ];
      function ServiceFn(toastr, NvsBasicTranslateService) {

            var notificationDefinition = [
                  {
                        type: 'success',
                        title: 'Success'
                  },
                  {
                        type: 'info',
                        title: 'Information'

                  },
                  {
                        type: 'error',
                        title: 'Error'

                  },
                  {
                        type: 'warning',
                        title: 'Warning'
                  }
            ];

            var notificationCloseButton = true;

            var serviceObj = {
                  notificationPopUp: function (message, type, title, closeButton) {
                      var translateMessage =  NvsBasicTranslateService.getTranslateKeyValue(message);
                      showNotification(translateMessage, type, title, closeButton);
                  }
            };

            function showNotification(translateMessage, type, title, closeButton) {
                  var notification = _.find(notificationDefinition, {type: type});

                  if (_.isUndefined(notification)) {
                        return;
                  }

                  var notificationTitle = _.isUndefined(title) ? notification.title : title;

                  notificationCloseButton = _.isUndefined(closeButton) ? notificationCloseButton : closeButton;

                  switch (type) {
                        case 'success':
                              toastr.success(translateMessage, notificationTitle, {closeButton: notificationCloseButton});
                              break;
                        case 'error':
                              toastr.error(translateMessage, notificationTitle, {closeButton: notificationCloseButton});
                              break;
                        case 'warning':
                              toastr.warning(translateMessage, notificationTitle, {closeButton: notificationCloseButton});
                              break;
                        case 'info':
                              toastr.info(translateMessage, notificationTitle, {closeButton: notificationCloseButton});
                              break;
                  }
            }


            return serviceObj;
      }

})();
/**
 * Created by unal on 07.04.2017.
 */



(function () {

      var path = 'app/common/sportNavBar';

      angular.module('novusTerminal')
            .directive('aptSportNavBar', DirectiveFn);
      DirectiveFn.$inject=['$window'];
      function DirectiveFn($window) {
            return {
                  restrict: 'EA',
                  scope: {},
                  bindToController: true,
                  controller: ControllerFn,
                  controllerAs: 'vmSportNavBar',
                  templateUrl: function (elem, attrs) {
                        if (attrs.template) {
                              return path + '/sport-nav-bar.' + attrs.template + '.html';
                        } else {
                              return path + '/sport-nav-bar.html';
                        }
                  },
                link: function( scope, elem, attrs ) {
                     var sportItem = document.querySelectorAll(".sport-categories-items");
                     var rightArrow = document.querySelectorAll(".sport-categories-right-arrow");
                     scope.widthStatus = sportItem[0].offsetWidth;
                     scope.rightArrowLeftStatus = rightArrow[0].offsetLeft - sportItem[0].offsetWidth -2.5;
                     scope.rightArrowTopStatus = rightArrow[0].offsetTop;
                     if(sportItem){
                         angular.element($window).resize(function () {
                             scope.widthStatus = sportItem[0].offsetWidth;
                             scope.rightArrowLeftStatus = rightArrow[0].offsetLeft - sportItem[0].offsetWidth -2.5;
                             scope.rightArrowTopStatus = rightArrow[0].offsetTop;

                         });
                     }

                }
            }
      }

      ControllerFn.$inject = ['CategoryService', 'NotifyingService', 'OddsService','$timeout','$scope'];
      function ControllerFn(CategoryService, NotifyingService, OddsService, $timeout, $scope) {
            var vm = this;


            var carouselContainer = document.getElementById("sportCarouselList");

            vm.prev = prevFn;
            vm.next = nextFn;

            var carouselStatus = 0;

            var val = 0;
            carouselContainer.addEventListener("scroll", scrollFn);


            function scrollFn() {
                  carouselStatus = carouselContainer.scrollLeft;
            }


            NotifyingService.subscribe($scope,'time-frame:changed', function () {
              vm.isShowOutright = false;
          });


            var click =1;
            function prevFn() {
                var carouselItemWidth = document.querySelectorAll(".sport-categories-items")[0].offsetWidth;
                carouselContainer.scrollLeft = carouselStatus - carouselItemWidth;

                if (click == vm.outrights.length){
                    vm.isShowOutright = false;
                 }else{
                    click++;
                }
            }

            function nextFn() {
                  var carouselItemWidth = document.querySelectorAll(".sport-categories-items")[0].offsetWidth;
                  carouselContainer.scrollLeft = carouselStatus + carouselItemWidth;
            }

            vm.setSportCategory = setSportCategoryFn;

            vm.sports = CategoryService.getNavBarSports();
            vm.outrights = CategoryService.getNavBarOutrights();
           vm.selectedSport = CategoryService.getSelectedNavBarSport();
           vm.selectedOutright= CategoryService.getSelectedNavBarOutright();


            function setSportCategoryFn(sport) {
                  OddsService.resetData();
                  CategoryService.setSelectedSportCategories(sport);
                  CategoryService.setSelectedNavBarSport(sport);
            }

            var screenWidth = document.body.offsetWidth;
            if (screenWidth <= 1024) {
                  vm.categoryOption = true;
                  vm.betslipOption = true;
            }

            //show Outright category
                vm.isShowOutright = false;

                vm.showOutrightCategory = function(){
                    vm.isShowOutright = !vm.isShowOutright;
                    click =1;
                    if(vm.isShowOutright == true){
                        var carouselContainer = document.getElementById("sportCarouselList");
                        var carouselItemWidth = document.querySelectorAll(".sport-categories-items")[0].offsetWidth-0.25;

                        var scrollStatusLeft = vm.sports.length - vm.outrights.length;

                        $timeout(function () {
                            carouselContainer.scrollLeft  = carouselItemWidth * scrollStatusLeft;
                        },100);
                    }
                }
                

           //show Outright category
      }
})();
/**
 * Created by unal on 23.05.2017.
 */



(function () {

      angular
              .module('novusTerminal')
              .factory('SessionTimeoutService', ServiceFn);

      ServiceFn.$inject = [
            'Idle'
      ];
      function ServiceFn(Idle) {


            var time = '';
            var serviceObj = {

                  setSessionTime: function (sessionTime, serverTime) {
                        if (_.isInteger(time)) {
                              return;
                        }
                        time = sessionTime - serverTime;
                        Idle.setIdle(time + 5);
                        Idle.watch();
                  },

                  setTime:function (logoutTime) {
                        time=logoutTime;
                  }
            };


            return serviceObj;
      }

})();
/**
 * Created by unal on 07.04.2017.
 */



(function () {


      angular
            .module('novusTerminal')
            .directive('aptSessionTimeout', DirectiveFn);

      function DirectiveFn() {
            return {
                  restrict: 'EA',
                  scope: {},
                  bindToController: true,
                  controller: ControllerFn,
                  controllerAs: 'vmSessionTimeout',
            }
      }

      ControllerFn.$inject = [
            '$scope',
            'CreatePopupComponentService',
            '$uibModal',
            'LogoutService',
            'UpdateService'];
      function ControllerFn($scope, CreatePopupComponentService, $uibModal, LogoutService,UpdateService) {
            var vm = this;


            function closeModals() {
                  if (vm.warning) {
                        vm.warning.close();
                        vm.warning = null;
                  }

                  if (vm.timedout) {
                        vm.timedout.close();
                        vm.timedout = null;
                  }
            }

            $scope.$on('IdleStart', function () {
                  UpdateService.setExtendTimeoutStatus(false);
                  vm.warning = $uibModal.open({
                        template: '<data-apt-idle-start></data-apt-idle-start>',
                        windowClass: 'modal-danger'
                  });
            });

            $scope.$on('IdleEnd', function () {
                  UpdateService.setExtendTimeoutStatus(true);
                  closeModals();
            });

            $scope.$on('IdleTimeout', function () {
                  closeModals();
                  logOut();
                  vm.timedout = $uibModal.open({
                        templateUrl: 'app/common/sessionTimeout/modalPopUps/timeout-popup.html',
                        windowClass: 'modal-danger',
                        backdrop: false,
                        controllerAs: 'vmTimeoutNotificationPopup',
                        controller: [function () {
                              var vm = this;

                              vm.close = closeFn;
                              vm.logIn = logInFn;

                              function closeFn() {
                                    closeModals();
                              }

                              function logInFn() {
                                    closeModals();
                                    openLogInPopup();
                              };
                        }]
                  });
            });


            function openLogInPopup() {
                  var componentSetting = {
                        name: 'login-form',
                  };

                  CreatePopupComponentService.createPopupComponent(componentSetting);
            };

            function logOut() {
                  LogoutService.logout();
            }


      }

})();
/**
 * Created by unal on 23.05.2017.
 */



(function () {

      angular
            .module('novusTerminal')
            .factory('UtilsService', ServiceFn);

      ServiceFn.$inject = [];
      function ServiceFn() {
            var serviceObj = {

                  removeObjectProperties: function (object) {
                        for (var member in object) delete object[member];
                  },

                  nullifyObjectProperties: function (object) {
                        for (var member in object) object[member] = null;
                  },

                  nullifyAndMerge: function (object, mergeWith) {
                        serviceObj.nullifyObjectProperties(object);
                        _.merge(object, mergeWith);
                  },

                  removeAndMerge: function (object, mergeWith) {
                        serviceObj.removeObjectProperties(object);
                        _.merge(object, mergeWith);
                  },

                  emptyAndMerge: function (target, source) {
                        serviceObj.emptyArray(target);
                        _.merge(target, _.uniq(source));
                  },

                  emptyArray: function (target) {
                        target.splice(0, target.length);
                  },

                  isEmptyObject: function (obj) {
                        var bar;
                        for (bar in obj) {
                              if (obj.hasOwnProperty(bar)) {
                                    return false;
                              }
                        }
                        return true;
                  }

            };


            return serviceObj;
      }

})();
/**
 * Created by Byn on 14.07.2017.
 */

(function () {
      angular.module('novusTerminal')
            .factory('UserTreeService', ServiceFn);

      ServiceFn.$inject = [];
      function ServiceFn() {

            var tree = {
                  users: {},
                  ownerId: -1,
                  level: 0
            };

            var productRequest;
            var serviceObj = {

                  UserTree: function (users) {
                        if (users) {
                              setData(users);
                              if (tree) {
                                    tree.level = 0;
                              }
                        }

                        return tree;
                  },
                  setProductRequest: function (product) {
                        productRequest = product;
                  },
                  getProductRequest: function () {
                        return productRequest;
                  }

            };

            var setData = function (users) {
                  setUser(users, -1);
                  setParentUser(users);

                  //angular.extend(this, tree);
            };

            var setParentUser = function (users) {
                  tree.ownerId = 0;
                  tree.users[tree.ownerId] = {
                        childUsers: [users[0].id],
                  }
            };

            var setUser = function (users, level) {
                  level = level + 1;
                  angular.forEach(users, function (user, i) {
                        user.level = level;
                        if (typeof(user.children) != "undefined") {
                              setUser(user.children, level);
                              user.childUsers = Object.keys(user.children);
                              delete user.children;

                        }
                        tree.users[user.id] = user;
                  });

            };

            return serviceObj;
      }

})();
/**
 * Created by unal on 17.11.2016.
 */



(function () {

    angular
        .module('novusTerminal')
        .factory('TranslateService', ServiceFn);

    ServiceFn.$inject = ['languageService', 'NotifyingService'];
    function ServiceFn(languageService, NotifyingService) {

        var messageText = '';
        var messageStatus = '';

        var serviceObj = {

            translate: function (key, status) {

                if (!status) {
                    messageStatus = 'error';
                } else {
                    messageStatus = status;
                }

                messageText = '';

                if (_.isArray(key)) {
                    angular.forEach(key, function (message) {
                        messageText += languageService.get(message) + '</br>';
                    });
                    showMessage();
                } else {
                    messageText += languageService.get(key) + '</br>';
                }

                showMessage();

                //if (window.translations) {
                //      var value = window.translations[key];
                //      if (value) {
                //            return params ? value.formatl(params) : value;
                //      } else {
                //            return key;
                //      }
                //} else {
                //      return key;
                //}


            }

        };

        var showMessage = function () {

            if (messageStatus == 'error') {
                NotifyingService.error({
                    title: '<div><i class="fa fa-warning"></i><span>' + '   ' + languageService.get(messageStatus) + '</span></div>',
                    message: messageText
                });
            }

            if (messageStatus == 'success') {
                NotifyingService.success({
                    title: '<div><i class="fa fa-check-square"></i><span>' + '  ' + languageService.get(messageStatus) + '</span></div>',
                    message: messageText
                });
            }
            if (messageStatus == 'warning') {
                NotifyingService.warning({
                    title: '<div><i class="fa fa-check-square"></i><span>' + '  ' + languageService.get(messageStatus) + '</span></div>',
                    message: messageText
                });
            }
        };

        return serviceObj;
    }

})();

/**
 * Created by Emre on 9.06.2017.
 */

(function () {
    'use strict';
    angular
        .module('novusTerminal')
        .factory('NotifyingService', ServiceFn);

    ServiceFn.$inject = ['$rootScope','$timeout'];
    function ServiceFn($rootScope, $timeout) {
        return {

            subscribe: function (scope, event, callback, once, lifo) {
                var handler;
                var eventName = 'notifying-service-event:' + event;

                handler = $rootScope.$on(eventName, once ? function (event, stay) {
                    //callback();
                    //callback.apply(arguments);
                    callback(event, stay);
                    handler();
                } : callback);

                /**
                 * event listeners are executed in the order of initialization.
                 * lifo means last in first out
                 * which means last added listener should be called first.
                 * here we manually change the listeners array of the angular's core.
                 *
                 */
                if (!angular.isUndefined(lifo) && lifo) {
                    var listener, listenersArray;
                    listenersArray = $rootScope.$$listeners[eventName];
                    listener = listenersArray[listenersArray.length - 1];
                    listenersArray.splice(listenersArray.length - 1, 1);
                    listenersArray.unshift(listener);
                }

                if (scope) {
                    scope.$on('$destroy', handler);
                }

                return handler;
            },

            notify: function (event, data, timeout) {
                var emit = function () {
                    $rootScope.$emit('notifying-service-event:' + event, data);
                };

                if (angular.isNumber(timeout)) {
                    $timeout(function () {
                        emit();
                    }, timeout);
                } else {
                    emit();
                }

            }

        }
    }

})();
'use strict';
angular.module('novusTerminal')
    .directive('ngTranslate', function ($filter, languageService, NotifyingService) {
        return {
            restrict: 'EA',
            scope: {
                translate: '@'
            },
            link: function (scope, elem) {

                NotifyingService.subscribe(scope, 'languageJson:set', function () {
                    setInnerHtml();
                });
                setInnerHtml();
                function setInnerHtml() {
                    scope.replacement = angular.copy(scope.translate);
                    scope.translate2 = languageService.refactorKey(scope.translate) || 'n/A';
                    elem.html($filter('translate')(scope.translate2, scope.replacement));
                }
                scope.$watch('translate', function (newVal, oldVal) {
                    if (newVal !== oldVal) {
                        scope.replacement = angular.copy(newVal);
                        scope.translate2 = languageService.refactorKey(newVal) || 'n/A';
                        elem.html($filter('translate')(scope.translate2, scope.replacement));
                    }
                });
            }
        };
    })
    .directive('ngTranslateLive', function ($filter, languageService, NotifyingService) {
        return {
            restrict: 'EA',
            scope: {
                translate: '@'
            },
            link: function (scope, elem) {

                NotifyingService.subscribe(scope, 'languageLiveJson:set', function () {
                    setInnerHtml();
                });
                setInnerHtml();

                function setInnerHtml() {
                    elem.html($filter('translateLive')(scope.translate));
                }
                scope.$watch('translate', function (newVal, oldVal) {
                    if (newVal !== oldVal) {
                        elem.html($filter('translateLive')(newVal));
                    }
                });
            }
        };
    })
    .directive('language', function (languageService, NotifyingService) {
        return {
            restrict: 'EA',
            controller: function ($scope, $rootScope, appConfig, commonServices) {
                $scope.languages = languageService.languages;
                $scope.selectedLanguage = languageService.getSelectedLanguage();
                $scope.selectLanguage = function (lang) {
                    languageService.setLanguage(lang);
                    function updateLang() {
                        NotifyingService.notify('languageChanged', $scope.selectedLanguage);
                        var cashierReqData = {};
                        if (!_.isEmpty(appConfig.cashierToken)) {
                            cashierReqData.mtoken = appConfig.cashierToken;
                        }
                        commonServices.init(cashierReqData).success(function (res) {
                            $rootScope.getGoldenraceURL(res);
                        });
                    }

                    if (_.includes(lang, 'ar')) {
                        languageService.addLocaleScript();
                        setTimeout(function () {
                            updateLang();
                        });
                    } else {
                        if (document.getElementById('moment_locale')) {
                            document.getElementById('moment_locale').remove();
                        }
                        updateLang();
                    }
                };
            }
        };
    })
    .directive('ngPlaceholder', function ($document, languageService, NotifyingService, $filter,NvsBasicTranslateService) {
        return {
            restrict: 'A',
            link: function (scope, elem, attr) {
                NotifyingService.subscribe(scope, 'languageJson:set', function () {
                    setElemPlaceholder();
                });
                setElemPlaceholder();
                function setElemPlaceholder() {
                    //console.log(attr.placeholder);
                    //console.log($filter('translate')(attr.placeholder, 'replacement'));
                    //elem[0].placeholder = $filter('translate')(attr.placeholder);
                    //console.log(NvsBasicTranslateService.getTranslateKeyValue(attr.placeholder))
                    //elem[0].placeholder = NvsBasicTranslateService.getTranslateKeyValue(attr.placeholder);
                    //elem[0].placeholder = languageService.get(attr.placeholder);
                    elem[0].placeholder = languageService.get(attr.placeholder);
                }
            }
        };
    })

    .filter('translate', filterFn)
    .filter('translateLive', filterLiveFn)
    .factory('languageService', languageFn);
   languageFn.$inject=[
       '$rootScope',
       '$cookies',
       'ApiService',
       'NotifyingService',
       'TranslateModelService',
       'TranslateLiveModelService',
       'DateSettingsService',
       'DateClockService',
       'DateRequirementSettingService',
       'DateRangeConstantSettings',
       'VKI_CONFIG',
       'NvsBasicTranslateService'
   ];
    function languageFn (
        $rootScope,
        $cookies,
        ApiService,
        NotifyingService,
        TranslateModelService,
        TranslateLiveModelService,
        DateSettingsService ,
        DateClockService,
        DateRequirementSettingService,
        DateRangeConstantSettings,
        VKI_CONFIG,
        NvsBasicTranslateService
    ) {

    return {

        languageCalled: false,
        languages: [],
        selectedLanguage: {},
        languageJson: {},
        languageLiveJson: {},
        languageCode: null,
        languageLength: false,
        setInitialLanguage: function (lang) {
            // this.languages = languages;
            _.merge(this.languages, lang);
            if ($cookies.get('terminalLanguageCode')) {
                this.languageCode = $cookies.get('terminalLanguageCode');
                _.merge(this.selectedLanguage, _.find(this.languages, { code: this.languageCode }) || null);
            } else {
                _.merge(this.selectedLanguage, _.find(lang, { is_default: true }));
                $cookies.put('terminalLanguageCode', this.selectedLanguage.code);
                $cookies.put('terminalLanguageId', this.selectedLanguage.id);
                this.languageCode = this.selectedLanguage.code;
            }
            if (!this.languageCalled) {
                this.setLanguage(this.languageCode, true);
            }
            ApiService.setLanguageId(this.selectedLanguage.id);

        },
        /**
         *
         * @param code
         */
        setJson: function (code, callInit) {
            var thisKey = this;
            var langCode = $cookies.get('terminalLanguageCode');
            TranslateModelService.post({
                code: code || langCode
            }).then(function (json) {
                thisKey.languageJson = json;
                NvsBasicTranslateService.setJson(json);
                NotifyingService.notify('languageJson:set');
                if (callInit) {
                    $rootScope.initialized = true;
                }
            });
        },
        setLiveJson: function (code) {

            var thisKey = this;
            var langCode = $cookies.get('terminalLanguageCode');
            TranslateLiveModelService.post({
                code: code || langCode
            }).then(function (json) {
                thisKey.languageLiveJson = json;
                //NvsBasicTranslateService.setLiveJson(json);
                NotifyingService.notify('languageLiveJson:set');
            });
        },
        setInitJson: function (json) {
            var thisKey = this;
            thisKey.languageJson = json;
            $rootScope.initialized = true;
            NotifyingService.notify('languageJson:set');
        },
        setLanguage: function (code, callInit) {
            var languageCalled = true;
            var languageCode = code;
            _.merge(this.selectedLanguage, _.find(this.languages, { code: code.code }) || null);
            ApiService.setLanguageId(this.selectedLanguage.id);

            VKI_CONFIG.kts = VKI_CONFIG.kt = languageCode.code;
            if (this.selectedLanguage.code && this.selectedLanguage.id) {
                $cookies.put('terminalLanguageCode', this.selectedLanguage.code);
                $cookies.put('terminalLanguageId', this.selectedLanguage.id);
            }
            this.setJson(code.code, callInit);
            this.setLiveJson(code.code);
            this.setDateTimeFormat();
            this.setDateRangePickerLocaleSettings();
            this.setDateSettingToLanguage();
        },
        get: function (fkey, replacements) {
            // replace any characters with underscore
            var thisKey = this;
            var key = fkey ? fkey.toLowerCase().replace(/[^a-zA-Z0-9]/g, '_') : 'n/A';

            if (angular.isUndefined(replacements) || replacements === null) {

                return thisKey.languageJson[key] || fkey;
            }
            replacements = replacements.replace(/\S*_liveodds_/g, ''); // removing for live odds
            replacements = replacements.replace(/lm_/g, '');    // removing for live markets

            var target = key.split('_liveodds_');
            target = target ? target[0] : null;
            var toTranslate = target || key;


            return thisKey.languageJson[toTranslate] || replacements;

        },
        getLive: function (key, replacements) {
            var thisKey = this;
            if (angular.isUndefined(replacements) || replacements === null) {
                return thisKey.languageLiveJson[key] || null;
            }

            return thisKey.languageLiveJson[key] || replacements;
            // var val = thisKey.languageLiveJson[key] || null;
            // var keys = Object.keys(replacements);
            // for (var i = 0; i < keys.length; i++) {
            //     var reg = new RegExp('\\{\\{' + keys[i] + '\\}\\}', 'gm');
            //     val = val.replace(reg, thisKey.languageLiveJson[eval("'" + replacements[keys[i]] + "'")] || replacements[keys[i]]);
            // }
            // return val;
        },
        getSelectedLanguage: function () {
            return this.selectedLanguage;
        },
        getLanguages:function () {
            return this.languages;
        },
        getLanguageJson: function () {
            return this.languageJson;
        },
        refactorKey: function (key) {
            return key.toString()
                .toLowerCase()
                .replace(/[^a-zA-Z0-9]/g, '_');
                // .replace('-', '_')
                // .replace(':', '_')
                // .replace(/\s+/g, '_')
                // .replace(/[^\w\-]+/g, '')
                // .replace(/\_\_+/g, '_')
                // .replace(/^_+/, '')
                // .replace(/_+$/, '');
        },
        addLocaleScript: function localeScript() {
            if (!document.getElementById('moment_locale')) {
                // var script = document.createElement('script');
                // setTimeout(function () {
                //     script.src = 'https://cdnjs.cloudflare.com/ajax/libs/moment.js/2.18.1/locale/ar-sa.js';
                //     script.type = 'text/javascript';
                //     script.id = 'moment_locale';
                //     document.getElementsByTagName('body')[0].appendChild(script);
                // });
            }
        },
        setDateSettingToLanguage: function() {
            DateSettingsService.setDateSetting(this.selectedLanguage.date_format);
            DateClockService.setDateAfterLanguageChange();
        },

        setDateTimeFormat: function() {
            DateRequirementSettingService.setDateTimeFormat(this.selectedLanguage.date_format);
        },

        setDateRangePickerLocaleSettings: function() {
            DateRangeConstantSettings.setDateFormat(this.selectedLanguage.date_format);
            DateRangeConstantSettings.setDayOfWeek(this.selectedLanguage.first_day);
        }
    }

    };



filterFn.$inject = ['languageService'];
function filterFn(languageService) {
    return function (items, replacement) {
        var TempItems = items ? languageService.refactorKey(items) : 'n/A';
        if (_.isUndefined(TempItems)) {
            return 'yazım yanlısı';
        }
        return languageService.get(TempItems || items, replacement);
    };
}
filterLiveFn.$inject = ['languageService'];
function filterLiveFn(languageService) {
    return function (items, replacement) {
        var category = items.split(' - ')[0];
        var tournament = items.split(' - ')[1];
        var categoryKey = languageService.refactorKey(category) || 'n/A';
        var tournamentKey = languageService.refactorKey(tournament) || 'n/A';
        category = languageService.getLive('category_' + categoryKey, category);
        tournament = languageService.getLive('tournament_' + tournamentKey, tournament);
        if (_.isUndefined(items)) {
            return 'yazım yanlısı';
        }
        return category || tournament ? category + ' - ' + tournament : items;
    };
}


/**
 *
 */

    angular
        .module('novusTerminal')
        .factory('GeneralPurposeService', ServiceFn);

    function ServiceFn() {

        var isClosed;

        var serviceObj = {

            setToolBar: function (value) {
                isClosed = value;
            },
            getToolBar: function () {
                return isClosed;
            }
        };

        return serviceObj;
    }

/**
 * Created by unal on 23.05.2017.
 */



(function () {

      angular
            .module('novusTerminal')
            .factory('DateFormatService', ServiceFn);

      ServiceFn.$inject = ['DateSettingsService'];
      function ServiceFn(DateSettingsService) {

            var timeZone;

            var dateSetting = DateSettingsService.getDateSetting();

            if(dateSetting.userTimezone!= ''){
                timeZone = dateSetting.userTimezone;
            }else{
                timeZone = dateSetting.bookmakerTimezone;
            }

            var serviceObj = {

                  addDate: function (i) {
                        var date = new Date();
                        date = date.setDate(this.init.getUTCDate() + i || 0);
                        return new Date(date);
                  },
                  subDate: function (i) {
                        var date = new Date();
                        date = date.setDate(this.init.getUTCDate() - i || 0);
                        return new Date(date);
                  },
                  requestFormat: function (date) {
                        return date.toISOString().substr(0, 10);
                  },

                  getDayMonthMoment: function (date) {
                        date = moment(date);
                        return date.format("DD.MM");
                  },
                  getMinuteHourMoment: function (date) {

                        return moment.utc(date).tz(timeZone).format("HH:mm");
                  },
                  getMinuteHourMomentSecond: function (date) {
                        return moment.utc(date).tz(timeZone).format("HH:mm:ss");
                  },
                  getDateForOddsDataEventGroups: function (date) {
                        return moment.utc(date).tz(timeZone).format("MMM D, YYYY");
                  },


            };


            return serviceObj;
      }

})();
/**
 * Created by unal on 9/11/2017.
 */


(function () {

    angular
        .module('novusTerminal')
        .factory('CurrencyService', FactoryFn);

    function FactoryFn($cookies, UtilsService, NotifyingService) {

        var currency = $cookies.getObject('defaultCurrencyData') || {};

        var serviceObj = {

            setCurrencyData: function (currencyData, status) {
                /*  currency.splice(0, currency.length);
                 _.merge(currency, currencyData);
                 */
                UtilsService.removeAndMerge(currency, currencyData);
                /**
                 * we set default button value in cookies
                 */
                if (_.isEqual(status, 'default')) {
                    $cookies.putObject('defaultCurrencyData', currencyData);
                }else{
                    NotifyingService.notify('currency-data:changed');
                }
            },

            getCurrencyData: function () {
                return currency;
            },

            /**
             * after logout we turn default setting
             */
            resetCurrencyData: function () {
                var defaultCurrencyData = $cookies.getObject('defaultCurrencyData');
                /*currency.splice(0, currency.length);
                 _.merge(currency, defaultCurrencyData);*/

                UtilsService.removeAndMerge(currency, defaultCurrencyData);
                NotifyingService.notify('currency-data:changed');
            }

        };


        return serviceObj;

    }

})();

/**
 * Created by unal on 10.04.2017.
 */



(function () {

    angular
        .module('novusTerminal')
        .factory('CreatePopupComponentService', ServiceFn);

    ServiceFn.$inject = ['$uibModal'];
    function ServiceFn($uibModal) {

        var closePopup = true;

        var serviceObj = {

            createPopupComponent: function (componentSetting) {
                $uibModal.open({
                    backdrop: 'static',
                    keyboard: false,
                    size: 'md',
                    template: '<div data-apt-' + componentSetting.name + ' close-popup="closePopup(data)"></div>',
                    controller: function ($scope, $uibModalInstance) {
                        $scope.closePopup = closePopupFn;
                        function closePopupFn(result) {
                            if (!result) {
                                $uibModalInstance.close();
                            }
                        }
                    }
                });
            }
        };

        return serviceObj;
    }

})();
/**
 * Created by unal on 22.05.2017.
 */



(function () {

      angular
            .module('novusTerminal')
            .factory('BookmakerService', ServiceFn);

      ServiceFn.$inject = [
            'UtilsService'
      ];
      function ServiceFn(UtilsService) {

            var bookmakerBonuses = {};

            var serviceObj = {
                  setBonuses: function (bonuses) {
                        UtilsService.removeAndMerge(bookmakerBonuses, bonuses);
                  },

                  getBonuses: function () {
                        return bookmakerBonuses;
                  }
            };

            return serviceObj;
      }

})();
/**
 * Created by unal on 22.05.2017.
 */



(function () {

	angular.module('novusTerminal').factory('ApiInterceptorService', ServiceFn);

	ServiceFn.$inject = ['$cookies'];
	function ServiceFn($cookies) {
		return {
			'request': function (config) {
				if(config.data) {
					config.data.platform = 'terminal';
				}
				var cookies = $cookies.get('NovusAuth');
				var langId = $cookies.get('terminalLanguageId');

				if (typeof cookies == 'undefined') {
					return config;
				} else {
					if (config.url) {
						if (!_.isEmpty(config.data)) {
							config.data.auth = cookies;
							config.data.language_id = langId * 1;
							config.data.platform='terminal';
						} else {
							config.data = {};
							config.data.auth = cookies;
							config.data.language_id = langId * 1;
							config.data.platform='terminal';
						}
					}
				}
				return config;
			},
			'response': function (response) {
				var cookies = response.headers('Auth');
				if (cookies != null || undefined) {
					$cookies.put('NovusAuth', cookies);
					return response;
				}
				return response;
			},
		};
	}

})();
/**
 * Created by Byn on 18.07.2017.
 */

(function () {

    angular
        .module('novusTerminal')
        .factory('PopupComponentService', ServiceFn);

    ServiceFn.$inject = ['$uibModal', '$q', '$timeout'];

    function ServiceFn($uibModal, $q, $timeout) {

        var icons = {
            'warning': 'fa fa-exclamation-circle',
            'danger': 'fa fa-exclamation-triangle',
            'success': 'fa fa-check-square'
        };

        var headerAlerts = {
            'warning': 'alert-warning',
            'danger': 'alert-danger',
            'success': 'alert-success'
        };

        var headerTexts = {
            'warning': 'Warnings',
            'danger': 'Danger',
            'success': 'Success'
        };
        var alertSetting = {
            icon: '',
            headerAlert: '',
            headerText: '',
            text: '',
        };

        var serviceObj = {
            createPopup: function (componentSetting) {
                $uibModal.open({
                    backdrop: 'static',
                    animation: true,
                    keyboard: false,
                    size: 'lg',
                    template: '<div data-nvs-' + componentSetting.name + ' close-popup="closePopup(data)" user="user"></div>',
                    controller: function ($scope, $uibModalInstance) {
                        $scope.closePopup = closePopupFn;
                        $scope.user = componentSetting.user;

                        function closePopupFn(result) {
                            if (!result) {
                                $uibModalInstance.close();
                            }
                        }
                    }
                });
            },
            openPinPopup: function (pinValue) {
                $uibModal.open({
                    backdropClass: 'my-modal-report',
                    backdrop: 'static',
                    keyboard: false,
                    size: 'lg',
                    template: '<div data-nvs-pin-verification  close-popup="closePopup(data)" pin-value="pinValue"></div>',
                    controller: function ($scope, $uibModalInstance) {
                        $scope.closePopup = closePopupFn;

                        function closePopupFn(result) {
                            if (!result) {
                                $uibModalInstance.close();
                            }
                        }

                        $scope.pinValue = pinValue;
                    }
                });
            },
            showCoupon: function (data) {
                $uibModal.open({
                    keyboard: false,
                    size: 'lg',
                    templateUrl: 'app/common/sidebarWidgets/checkCoupon/coupon-popup.html',
                    controller: function ($scope, $uibModalInstance, CheckCouponService) {
                        $scope.displaySetting = CheckCouponService.getDisplaySetting();
                        $scope.ticketItems = data.data.ticket;
                        $scope.ticketItems.runningItemCount = 0;
                        $scope.ticketItems.lostItemCount = 0;
                        $scope.ticketItems.itemCount = 0;
                        for (var item in  $scope.ticketItems.items) {
                            if ($scope.ticketItems.items[item].status == 1) {
                                $scope.ticketItems.runningItemCount++;
                            } else if ($scope.ticketItems.items[item].status == 8) {
                                $scope.ticketItems.lostItemCount++;
                            }
                            $scope.ticketItems.itemCount++;
                        }
                    }
                });
            },


            openBetCodePopup: function (data) {
                $uibModal.open({
                    keyboard: false,
                    size: 'lg',
                    templateUrl: 'app/common/fastBetting/betCodePopup/bet-code-popup.html',
                    controller: function ($scope, $uibModalInstance) {

                        $scope.betCodeList = data;
                    }
                });
            },


            openLoginPopup: function () {
                $uibModal.open({
                    keyboard: false,
                    size: 'sm',
                    template: '  <data-nvs-login-form></data-nvs-login-form>',
                    controller: function ($scope, $uibModalInstance) {

                    }
                });
            },


            openWarningPopup: function (text, status) {
                var deferred = $q.defer();
                setModalSetting(text, status);
                $timeout(function () {
                    $uibModal.open({
                        template: '<div data-nvs-warning-modal-component  modal-result="modalResult(data)"></div>',
                        size: 'sm',
                        backdrop: 'static',
                        keyboard: false,
                        controller: [
                            '$scope',
                            '$uibModalInstance',
                            function ($scope, $uibModalInstance) {
                                $scope.modalResult = function (data) {
                                    $uibModalInstance.close();
                                    deferred.resolve(data);

                                    /*  if(data){
                                     deferred.resolve(data);
                                     }else{
                                     deferred.reject(data);
                                     }*/
                                };
                            }]
                    });

                });
                return deferred.promise;
            },

            getWarningPopupSetting: function () {
                return alertSetting;
            },

            openWallet: function () {
                var modalInstance = $uibModal.open({
                    animation: true,
                    templateUrl: 'app/common/header/transfer.html',
                    size: 'lg',
                    controller: ['InitService', '$scope', '$rootScope', '$compile', 'transferModel', 'transferFromModel', 'transferToModel', 'assingBonusModel', 'transferConnectionModel', 'ToastrNotificationService',
                        function (InitService, $scope, $rootScope, $compile, transferModel, transferFromModel, transferToModel, assingBonusModel, transferConnectionModel, ToastrNotificationService) {

                            var noneBonusCode;
                            var transferCondition;
                            var providerCondition;
                            $scope.amount = '';
                            $scope.bonusCode = '';
                            $scope.transferFromProvider = {id: '', name: ''};
                            $scope.transferToProvider = {id: '', name: ''};
                            $scope.default = true;
                            var conditionApplyFn = function () {
                                noneBonusCode = $scope.bonusCode === '' || _.isUndefined($scope.bonusCode);
                                transferCondition = $scope.amount !== '' && !_.isUndefined($scope.amount) && $scope.transferFromProvider.id !== $scope.transferToProvider.id;
                                providerCondition = $scope.transferFromProvider.id !== $scope.transferToProvider.id;
                            };
                            transferModel.post().then(function (res) {
                                $scope.providers = res.data.providers;
                                _.merge($scope.transferFromProvider, $scope.providers[0]);
                                _.merge($scope.transferToProvider, $scope.providers[1]);
                                getTransferFromAmountFn($scope.transferFromProvider.id);
                                getTransferToAmountFn($scope.transferToProvider.id);
                            });
                            var getTransferFromAmountFn = function (provider) {
                                transferFromModel.one(provider).post().then(function (res) {
                                    $scope.amountOfTransferFrom = res.data.amount;
                                });
                            };
                            var getTransferToAmountFn = function (provider) {
                                transferToModel.one(provider).post().then(function (res) {
                                    $scope.amountOfTransferTo = res.data.amount;
                                });
                            };
                            $scope.selectTransferFromProvider = function (providerId) {
                                var newFromProvider = _.find($scope.providers, {id: providerId});
                                _.merge($scope.transferFromProvider, newFromProvider);
                                getTransferFromAmountFn(providerId);
                            };
                            $scope.selectTransferToProvider = function (providerId) {
                                var newToProvider = _.find($scope.providers, {id: providerId});
                                _.merge($scope.transferToProvider, newToProvider);
                                getTransferToAmountFn(providerId);
                            };
                            $scope.setBonus = function (bonusCode) {
                                conditionApplyFn();
                                if (!noneBonusCode) {
                                    assingBonusModel.post({code: bonusCode}).success(function () {
                                        ToastrNotificationService.notificationPopUp('bonus_applied_successfully',
                                            'success');
                                    }).error(function (res) {
                                        ToastrNotificationService.notificationPopUp(res.error_message);
                                    });
                                } else {
                                    ToastrNotificationService.notificationPopUp('send_a_valid_bonus_code');
                                }
                            };
                            $scope.transferProcess = function () {
                                conditionApplyFn();
                                if (transferCondition) {
                                    transferConnectionModel.post({
                                        fromProvider: $scope.default ? $scope.transferFromProvider.id : $scope.transferToProvider.id,
                                        toProvider: $scope.default ? $scope.transferToProvider.id : $scope.transferFromProvider.id,
                                        amount: $scope.amount
                                    }).then(function () {
                                        if ($scope.default) {
                                            $scope.amountOfTransferFrom -= Number($scope.amount);
                                            $scope.amountOfTransferTo += Number($scope.amount);
                                        } else {
                                            $scope.amountOfTransferTo -= Number($scope.amount);
                                            $scope.amountOfTransferFrom += Number($scope.amount);

                                        }
                                        ToastrNotificationService.notificationPopUp('transfer_successfull', 'success');


                                    }).catch(function (res) {
                                        ToastrNotificationService.notificationPopUp('not_enough_refund_for_transfer', 'error');
                                    });
                                } else if (!providerCondition) {
                                    ToastrNotificationService.notificationPopUp('providers_can_not_be_same');
                                } else {
                                    ToastrNotificationService.notificationPopUp('amount_can_not_be_zero_or_negative');
                                }
                            };
                            $scope.switchWallet = function () {
                                console.log($scope.default);
                                var inputsDom = document.querySelector('.transfer-inputs');
                                var fl = $(inputsDom).find('.fl').find('.select-container');
                                var fr = $(inputsDom).find('.fr').find('.select-container');
                                var transferFromContent = $(fl).html();
                                var transferToContent = $(fr).html();
                                $(fl).html($compile($(transferToContent))($scope));
                                $(fr).html($compile($(transferFromContent))($scope));


                                var fTop = $($('.transfer-balance-el')[0]);
                                var fBottom = $($('.transfer-balance-el')[1]);
                                var fTopContent = $(fTop).html();
                                var fBottomContent = $(fBottom).html();
                                $(fTop).html($compile($(fBottomContent))($scope));
                                $(fBottom).html($compile($(fTopContent))($scope));
                                $scope.default = !$scope.default;
                            };
                            $scope.closeModal = function () {
                                modalInstance.dismiss('cancel');
                            };
                        }]
                });
            }

        };

        function setModalSetting(text, status) {
            _.merge(alertSetting, {
                icon: icons[status],
                headerAlert: headerAlerts[status],
                headerText: headerTexts[status],
                text: text
            });

        }

        return serviceObj;
    }

})();

/**
 * Created by unal on 07.04.2017.
 */



(function () {

	var path = 'app/common/rightSideBar';

	angular.module('novusTerminal').directive('aptRightSideBar', DirectiveFn);

	function DirectiveFn() {
		return {
			restrict: 'EA',
			scope: {},
			bindToController: true,
			controller: ControllerFn,
			controllerAs: 'vmRightSideBar',
			templateUrl: function (elem, attrs) {
				if (attrs.template) {
					return path + '/right-side-bar-' +
						attrs.template + '.html';
				} else {
					return path + '/right-side-bar.html';
				}
			},
		};
	}

	ControllerFn.$inject = [
	];
	function ControllerFn() {
		var vm = this;
	}

})();
(function () {

      var path = 'app/common/reportsPinVerification/';

      angular
            .module('novusTerminal')
            .directive('nvsPinVerification', DirectiveFn);

      function DirectiveFn() {
            return {
                  restrict: 'EA',
                  scope: {},
                  bindToController: {
                        closePopup: '&',
                        pinValue: '<',
                  },
                  controller: ControllerFn,
                  controllerAs: 'vmPinVerification',
                  templateUrl: function (elem, attrs) {
                        if (attrs.template) {
                              return path + '/pin-verification.' + attrs.template + '.html';
                        } else {
                              return path + '/pin-verification.html';
                        }
                  }
            }
      }

      ControllerFn.$inject = ['NotifyingService','ToastrNotificationService'];
      function ControllerFn(NotifyingService,ToastrNotificationService) {
            var vm = this;

            vm.pin = null;
            vm.close = closeFn;
            vm.send = sendFn;

            function closeFn() {
                  if (_.isFunction(vm.closePopup)) {
                        vm.closePopup({data: false});
                  }
            }

            function sendFn() {
                  if (vm.pin*1 != vm.pinValue) {
                        ToastrNotificationService.notificationPopUp('pin_is_not_correct', 'error');
                        vm.pin = null;
                        return;
                  }
                  NotifyingService.notify('pinCode:set', vm.pin);
                  closeFn();
            }

      }
})();
/**
 * Created by Emre on 19.06.2017.
 */

(function () {
	'use strict';

	var path = 'app/common/menu';

	angular
		.module('novusTerminal')
		.directive('aptMenu', DirectiveFn);

	function DirectiveFn() {
		return {
			restrict: 'EA',
			scope: {},
			bindToController: true,
			controller: ControllerFn,
			controllerAs: 'vmMenu',
			templateUrl: function (elem, attrs) {
				if (attrs.template) {
					return path + '/menu' + attrs.template + '.html';
				} else {
					return path + '/menu.html';
				}
			}
		}
	}

	ControllerFn.$inject = [
		'LeftMenuService',
		'UserService',
		'$rootScope'
	];
	function ControllerFn(LeftMenuService, UserService, $rootScope) {
		var vm = this;

		vm.user = UserService.getUser();
		vm.isOpenSiteMenu = false;

		vm.menuSetting = LeftMenuService.getMenuSettings();
        vm.menuItems = UserService.getMenu();


	}

})();
(function () {
      'use strict';
      angular
            .module('novusTerminal')
            .directive('nvsLoadingBar', DirectiveFn);

      function DirectiveFn() {
            return {
                  restrict: 'E',
                  templateUrl: 'app/common/loadingBar/loading-bar.html',
                  transclude: true,
                  scope: {
                        modify: "=",
                        barHeight: "="
                  },
                  link: function (scope, elem, attr) {

                        var targetParent;
                        targetParent = elem.parent();
                        targetParent.css('min-height', '150px');
                        if (!scope.modify) {
                              var targetElement = angular.element(targetParent[0].querySelector('.nvs-loading-bar-wrapper'));
                              targetElement.css('top', '15%');
                        }
                        if (scope.modify) {
                              var loaderElement = angular.element(targetParent[0].querySelector('#nvsLoadingBarContainer'));
                              loaderElement.css('background-color', 'transparent');
                              var loaderWrapper = angular.element(loaderElement[0].querySelector('.nvs-loading-bar-wrapper'));
                              loaderWrapper.css('top', '10%');
                              var loaderCircleText = angular.element(loaderWrapper[0].querySelector('.nvs-loading-bar-circle-label'));
                              loaderCircleText[0].className = 'nvs-loading-bar-circle-label loader-label-update';
                        }
                        if (_.isUndefined(scope.modify)) {
                              var targetElement = angular.element(targetParent[0].querySelector('.nvs-loading-bar-wrapper'));
                              if (!_.isUndefined(scope.barHeight)) {
                                    targetParent.css('min-height', scope.barHeight + 'px');
                                    targetElement.css('top', '25%');
                                    return;
                              }
                              targetElement.css('top', '40%');
                        }
                  }
            }
      }
})();
/**
 * Created by Emre on 24.05.2017.
 */

(function () {
    'use strict';

    var path = 'app/common/loader';

    angular
        .module('novusTerminal')
        .directive('aptLoader', DirectiveFn);

    function DirectiveFn() {
        return {
            restrict: 'EA',
            scope: {},
            bindToController: true,
            controller: ControllerFn,
            controllerAs: 'vmLoader',
            templateUrl: function (elem, attrs) {
                if (attrs.template) {
                    return path + '/loader.' + attrs.template + '.html';
                } else {
                    return path + '/loader.html';
                }
            }
        }
    }

    ControllerFn.$inject = [];
    function ControllerFn() {
        var vm = this;
    }

})();
/**
 * Created by unal on 22.05.2017.
 */



(function () {

      angular
              .module('novusTerminal')
              .factory('LeftSideBarService', ServiceFn);

      ServiceFn.$inject = [
            'OddsService',
            '$location',
            '$state'];
      function ServiceFn(OddsService, $location, $state) {

            /**
             * for left side bar remove active class control
             * @type {Array}
             */
            var clickedTournaments = [];

            var tournamentIds = [];


            var serviceObj = {

                  loadClickedTournament: function (tournament) {
                        if (OddsService.checkTournamentSelected(tournament.id)) {

                              OddsService.removeSelectedTournament(tournament.id);
                              removeTournament(tournament.id);

                              var tIdx = _.indexOf(tournamentIds, tournament.id);

                              if (tIdx < 0) {
                                    return;
                              }

                              tournamentIds.splice(tIdx, 1);

                              tournament.clicked = false;

                              remoteUrlParamsWithIds();

                        } else {

                              OddsService.loadSelectedTournament(tournament.id).then(function (status) {

                                    /**
                                     * this control if we clicked tournament and tournament has no data we dont add tournament id route and
                                     * we dont give active class
                                     */
                                    if (status) {
                                          clickedTournaments.push(tournament);
                                          tournamentIds.push(tournament.id);
                                          tournament.clicked = true;

                                    } else {
                                          tournament.clicked = false;
                                          return;
                                    }

                                    remoteUrlParamsWithIds();
                              });

                        }


                        function remoteUrlParamsWithIds() {
                              if (tournamentIds.length == 0) {
                                    $state.go('sport');
                              } else {
                                    $location.search({tournamentIds: tournamentIds.join('-')});
                              }
                        }

                  },

                  removeActiveClassForClosedTournament: function (tournamentId) {
                        var closedTournament = _.find(clickedTournaments, {id: tournamentId});

                        if (!closedTournament) {
                              return;
                        }

                        closedTournament.clicked = !closedTournament.clicked;
                  },

                  removeClickedTournament: function (tournamentId) {
                        removeTournament(tournamentId);
                  }

            };

            function removeTournament(tournamentId) {
                  var tIdx = _.findIndex(clickedTournaments, {id: tournamentId});

                  if (tIdx < 0) {
                        return;
                  }

                  clickedTournaments.splice(tIdx, 1);
            }


            return serviceObj;
      }

})();
/**
 * Created by unal on 07.04.2017.
 */



(function () {

    var path = 'app/common/leftSideBar';

    angular
        .module('novusTerminal')
        .directive('aptLeftSideBar', DirectiveFn);

    function DirectiveFn() {
        return {
            restrict: 'EA',
            scope: {},
            bindToController: true,
            controller: ControllerFn,
            controllerAs: 'vmLeftSideBar',
            templateUrl: function (elem, attrs) {
                if (attrs.template) {
                    return path + '/left-side-bar.' + attrs.template + '.html';
                } else {
                    return path + '/left-side-bar.html';
                }
            }
        }
    }

    ControllerFn.$inject = ['CategoryService', 'LeftSideBarService'];
    function ControllerFn(CategoryService, LeftSideBarService) {
        var vm = this;

        vm.openSubItem = function (category) {
            category.isOpenSubItem = !category.isOpenSubItem;
        };

        vm.selectedSportCategories = CategoryService.getSelectedSportCategory();

        vm.loadClickedTournament = loadClickedTournamentFn;


        function loadClickedTournamentFn(tournament) {
            // tournament.clicked = !tournament.clicked;
            LeftSideBarService.loadClickedTournament(tournament);
        }

        // scroll  control///
        angular.element('.sport-left-sidebar-content').scroll(function (e) {
                vm.scrollH = e.currentTarget.scrollTop;
        });

        vm.upScroll = upScrollFn;
        function upScrollFn() {
            if (!angular.element('.sport-left-sidebar-content').scroll()){
                scrollTop = 0;
            }
            scrollTop = vm.scrollH - 65;
            angular.element('.sport-left-sidebar-content').scrollTop(scrollTop);

        }

        vm.downScroll = bottomScrollFn;
        function bottomScrollFn() {
            if (!angular.element('.sport-left-sidebar-content').scroll()){
                scrollTop = 0;
            }
            scrollTop = vm.scrollH + 65;
            angular.element('.sport-left-sidebar-content').scrollTop(scrollTop);

        }
        // scroll control ///

    }

})();
/**
 * Created by unal on 23.05.2017.
 */



(function () {

    angular
        .module('novusTerminal')
        .factory('InitService', ServiceFn);

    ServiceFn.$inject = [
        'InitModel',
        'languageService',
        'UpdateService',
        'UserService',
        '$cookies',
        'BookmakerService',
        'NotifyingService',
        'DateSettingsService',
        'CurrencyService',
        'OddsFormatService',
        '$cookies',
        '$sce',
        'logoService',
        'userCurrency',
        'TicketPrintLogoService',
        '$rootScope'
    ];

    function ServiceFn(InitModel, languageService, UpdateService, UserService, $cookies,
                       BookmakerService, NotifyingService,
                       DateSettingsService, CurrencyService, OddsFormatService, $cookies, $sce, logoService, userCurrency, TicketPrintLogoService, $rootScope) {

        var terminalRequestToken = {
            mtoken: $cookies.get('mtoken'),
            platform: 'terminal'
        };
        var serviceObj = {

            loadInit: function () {
                InitModel.post(terminalRequestToken).then(function (res) {
                    UpdateService.getUpdate();
                    logoService.setLogoUrl(res.data.bookmaker.terminal_logo);
                    setLanguages(res.data.bookmaker.languages);
                    BookmakerService.setBonuses(res.data.bookmaker.bonuses);
                    setInitialLanguage(res.data.bookmaker.languages);
                    userCurrency.setCurrencyIcon(res.data.bookmaker.currency.utf8_symbol);


                    if (_.has(res.data, 'user') && !_.isEmpty(res.data.user)) {

                        setUser(res.data.user);

                        setUserRequireData(res.data.user);

                        setExtendTimeout();
                        DateSettingsService.setUserTimezone(res.data.user.timezone_value);
                    }

                    //setVirtualGameUrl(res.data);
                    setBonusEnable(res.data.bookmaker.bonus_enabled);
                    NotifyingService.notify('terminal-system:ready');
                    DateSettingsService.setBookmakerTimezone(res.data.bookmaker.timezone);
                    DateSettingsService.setUserTimezone(res.data.user ? res.data.user.timezone_value  : '');
                    CurrencyService.setCurrencyData(res.data.bookmaker.currency, (res.data.user ? 'user' : 'default'));

                    OddsFormatService.setInitialOddsFormats(res.data.bookmaker.active_odds_formats);
                    OddsFormatService.setInitialOddsFormat(_.find(res.data.bookmaker.active_odds_formats, {selected: true}).id);
                    TicketPrintLogoService.readTicketLogo();

                });
            },

            initAfterLoggedIn: function () {
                InitModel.post().then(function (res) {
                    if (!_.has(res.data, 'user')) {
                        return;
                    }

                    setUserRequireData(res.data.user);

                    //setVirtualGameUrl(res.data);

                    DateSettingsService.setUserTimezone(res.data.user.timezone_value);
                    CurrencyService.setCurrencyData(res.data.bookmaker.currency, (res.data.user ? 'user' : 'default'));


                    /**
                     *simdilik gerekli degil sadece init calısıtgında
                     * init controllar icin show false durumunu set etmek yeterilidir.
                     */
                    // NotifyingService.notify('terminal-system:ready');


                });
            },

            setTerminalRequestToken: function (token) {
                if (_.isNull(token)) {
                    token = 'no_token_no_cry';
                }
                _.merge(terminalRequestToken, {mtoken: token});
            }
        };

        function setLanguages(languages) {
            languageService.getSelectedLanguage(languages);
        }

        function setInitialLanguage(lang) {
            languageService.setInitialLanguage(lang);
        }

        function setUser(user) {
            if ($cookies.get('UserLoggedIn')) {
                UserService.setUser(user);
            } else {
                UserService.resetUser();
            }
        }


        function setUserRequireData(user) {
            if (user.sub_accounts.length > 0) {
                UserService.setUserSubAccount(user.sub_accounts);
            }

            if (_.has(user, 'parameters')) {
                UserService.setUserParameters(user.parameters);
            }
        }

        // function setVirtualGameUrl(data) {
        //     if (_.has(data, 'golden_race')) {
        //         //
        //VirtualGameService.setVirtualGameUrl(data.golden_race);
        //     }
        // }

        function setExtendTimeout() {
            UpdateService.setExtendTimeoutStatus(true);
        }

        function setBonusEnable(bonusdata) {
            $rootScope.bonusDataEnable = bonusdata;
        }


        return serviceObj;
    }

})();
/**
 * Created by unal on 18.05.2017.
 */



(function () {

      angular
            .module('novusTerminal')
            .config(InterceptorFn)
            .factory('InitModel', ServiceFn);


      InterceptorFn.$inject = ['RestangularProvider'];
      function InterceptorFn(RestangularProvider) {

            /**
             * The responseInterceptor is called after we get each response from the server.
             * It's a function that receives this arguments:

             data: The data received got from the server
             operation: The operation made. It'll be the HTTP method used except for a GET which returns a list of element which will return getList so that you can distinguish them.
             what: The model that's being requested. It can be for example: accounts, buildings, etc.
             url: The relative URL being requested. For example: /api/v1/accounts/123
             response: Full server response including headers
             deferred: The deferred promise for the request.
             */
            RestangularProvider.addResponseInterceptor(function (data, operation, what, url, response, deferred) {


                  if (what != 'init') {
                        return data;
                  }

                  return data;

            });


            /**
             * The requestInterceptor is called before sending any data to the server.
             * It's a function that must return the element to be requested. This function receives the following arguments:

             element: The element to send to the server.
             operation: The operation made. It'll be the HTTP method used except for a GET which returns a list of element which will return getList so that you can distinguish them.
             what: The model that's being requested. It can be for example: accounts, buildings, etc.
             url: The relative URL being requested. For example: /api/v1/accounts/123

             */
            RestangularProvider.addRequestInterceptor(function (data, operation, what, url) {

                  if (what != 'init') {
                        return data;
                  }

                  return data;
            });

      }


      ServiceFn.$inject = ['ApiService'];
      function ServiceFn(ApiService) {
            var rest = ApiService.serviceOne();

            return rest.service('init');
      }


})();
(function () {
    'use strict';
    angular
        .module('novusTerminal')
        .config(InterceptorFn)
        .factory('transferToModel', ServiceFn);

    InterceptorFn.$inject = ['RestangularProvider'];
    function InterceptorFn(RestangularProvider) {

        RestangularProvider.addResponseInterceptor(function (data, operation, what, url, response, deferred) {


            // var auth = response.headers('auth');
            return data;

        });

        RestangularProvider.addRequestInterceptor(function (data, operation, what, url) {

            // var auth = $cookies.get('terminalAuth') || '';

            // var languageId = 1;
            // data.auth = auth;
            // data.language_id = languageId;
            return data;
        });

    }

    ServiceFn.$inject = ['ApiService'];
    function ServiceFn(ApiService) {
        var rest = ApiService.serviceOne();
        return rest.service('exchange/amount/');

    }

})();
(function () {
    'use strict';
    angular
        .module('novusTerminal')
        .config(InterceptorFn)
        .factory('transferFromModel', ServiceFn);

    InterceptorFn.$inject = ['RestangularProvider'];
    function InterceptorFn(RestangularProvider) {

        RestangularProvider.addResponseInterceptor(function (data, operation, what, url, response, deferred) {


            // var auth = response.headers('auth');
            return data;

        });

        RestangularProvider.addRequestInterceptor(function (data, operation, what, url) {

            // var auth = $cookies.get('terminalAuth') || '';

            // var languageId = 1;
            // data.auth = auth;
            // data.language_id = languageId;
            return data;
        });

    }

    ServiceFn.$inject = ['ApiService'];
    function ServiceFn(ApiService) {
        var rest = ApiService.serviceOne();
        return rest.service('exchange/amount');

    }

})();
(function () {
    'use strict';
    angular
        .module('novusTerminal')
        .config(InterceptorFn)
        .factory('transferConnectionModel', ServiceFn);

    InterceptorFn.$inject = ['RestangularProvider'];
    function InterceptorFn(RestangularProvider) {

        RestangularProvider.addResponseInterceptor(function (data, operation, what, url, response, deferred) {


            // var auth = response.headers('auth');
            return data;

        });

        RestangularProvider.addRequestInterceptor(function (data, operation, what, url) {

            // var auth = $cookies.get('terminalAuth') || '';

            // var languageId = 1;
            // data.auth = auth;
            // data.language_id = languageId;
            return data;
        });

    }

    ServiceFn.$inject = ['ApiService'];
    function ServiceFn(ApiService) {
        var rest = ApiService.serviceOne();
        return rest.service('exchange/transfer');

    }

})();
/**
 * Created by Emre on 17.06.2017.
 */

(function () {
    'use strict';
    angular
        .module('novusTerminal')
        .config(InterceptorFn)
        .factory('transferModel', ServiceFn);

    InterceptorFn.$inject = ['RestangularProvider'];
    function InterceptorFn(RestangularProvider) {

        RestangularProvider.addResponseInterceptor(function (data, operation, what, url, response, deferred) {


            // var auth = response.headers('auth');
            return data;

        });

        RestangularProvider.addRequestInterceptor(function (data, operation, what, url) {

            // var auth = $cookies.get('terminalAuth') || '';

            // var languageId = 1;
            // data.auth = auth;
            // data.language_id = languageId;
            return data;
        });

    }

    ServiceFn.$inject = ['ApiService'];
    function ServiceFn(ApiService) {
        var rest = ApiService.serviceOne();
        return rest.service('exchange/providers');

    }

})();
(function(){
    angular
        .module('novusTerminal')
        .service('userCurrency',function () {
           var currency;
            var serviceObj= {
                setCurrencyIcon: function (data) {

                    currency=data;
                },

                getCurrencyIcon:function(){

                    return currency;
                }
            }
            return serviceObj;


        });

})();
/**
 * Created by unal on 07.04.2017.
 */


(function () {

    var path = 'app/common/header';

    angular.module('novusTerminal')
        .directive('aptPageHeader', directiveFn);

    function directiveFn() {
        return {
            restrict: 'EA',
            controller: controllerFn,
            controllerAs: 'vmPageHeader',
            scope: true,
            bindToController: true,
            templateUrl: function (elem, attrs) {
                if (attrs.template) {
                    return path + '/header-page.' + attrs.template + '.html';
                } else {
                    return path + '/header-page.html';
                }
            }
        }
    }

    controllerFn.$inject = [
        'PopupComponentService',
        'languageService',
        'UserService',
        'LogoutService',
        'CreatePopupComponentService',
        'DateClockService',
        'LeftMenuService',
        '$state',
        '$stateParams',
        'OddsFormatService',
        'NotifyingService',
        'userCurrency',
        'logoService',
        '$uibModal',
        'DateSettingsService'
    ];

    function controllerFn(PopupComponentService, languageService, UserService, LogoutService, CreatePopupComponentService, DateClockService, LeftMenuService,
                          $state, $stateParams, OddsFormatService, NotifyingService, userCurrency, logoService, $uibModal, DateSettingsService) {

        var vm = this;
        vm.userDefaultCurrency = userCurrency.getCurrencyIcon();
        vm.mainlogo = logoService.getLogoUrl();
        vm.openLanguageMenu = openLanguageMenuFn;

        function openLanguageMenuFn() {
            vm.openLanguageOptions = !vm.openLanguageOptions;
        }

        vm.languages = languageService.getLanguages();
        vm.selectedLanguage = languageService.getSelectedLanguage();

        vm.changeLanguage = changeLanguageFn;

        function changeLanguageFn(language) {
            vm.openLanguageOptions = !vm.openLanguageOptions;
            languageService.setLanguage(language);
            $state.transitionTo($state.current, $stateParams, {
                reload: true, inherit: false, notify: true
            });
        }


        vm.userDropDown = userDropDownFn;

        function userDropDownFn() {
            vm.userDropDownMenu = !vm.userDropDownMenu;
        }

        vm.dateData = DateClockService.getClockAndDate();
        // vm.bookmakerTZ = DateSettingsService.getBookmakerTZ();
        vm.user = UserService.getUser();
        vm.userBalanceData = UserService.getUserBalanceData();

        vm.logout = logoutFn;
        vm.logIn = logInFn;
        vm.changeUserDropMenu = changeUserDropMenuFn;
        vm.openTransferModal = function () {
            PopupComponentService.openWallet();
        };

        function logoutFn() {
            LogoutService.logout();
            vm.userDropDownMenu = false;
            $state.go('main');
        }

        function changeUserDropMenuFn() {
            vm.userDropDownMenu = false;
        }

        function logInFn() {
            var componentSetting = {
                name: 'login-form'
            };

            CreatePopupComponentService.createPopupComponent(componentSetting);
        }

        vm.openSiteMenu = openSiteMenuFn;
        vm.menuSetting = LeftMenuService.getMenuSettings();

        function openSiteMenuFn() {
            LeftMenuService.setMenuSettings({
                menuDisplay: !vm.menuSetting.menuButton,
                menuButton: !vm.menuSetting.menuButton
            });
        }

        vm.oddsFormats = OddsFormatService.getOddsFormats();
        vm.selectedOddsFormat = OddsFormatService.getSelectedOddsFormat();
        vm.selectOddsFormat = selectOddsFormatFn;

        function selectOddsFormatFn() {
            OddsFormatService.setSelectedOddsFormat(vm.selectedOddsFormat.id * 1);
            NotifyingService.notify('odds-format:changed');
        }


    }

})();
(function () {
    'use strict';
    angular
        .module('novusTerminal')
        .config(InterceptorFn)
        .factory('assingBonusModel', ServiceFn);

    InterceptorFn.$inject = ['RestangularProvider'];
    function InterceptorFn(RestangularProvider) {

        RestangularProvider.addResponseInterceptor(function (data, operation, what, url, response, deferred) {


            // var auth = response.headers('auth');
            return data;

        });

        RestangularProvider.addRequestInterceptor(function (data, operation, what, url) {

            // var auth = $cookies.get('terminalAuth') || '';

            // var languageId = 1;
            // data.auth = auth;
            // data.language_id = languageId;
            return data;
        });

    }

    ServiceFn.$inject = ['ApiService'];
    function ServiceFn(ApiService) {
        var rest = ApiService.serviceOne();
        return rest.service('exchange/get-bonus');

    }

})();
/**
 * Created by unal on 07.04.2017.
 */


(function () {

      var path = 'app/common/footer';

      angular.module('novusTerminal')
            .directive('aptPageFooter', directiveFn);

      function directiveFn() {
            return {
                  restrict: 'EA',
                  controller: controllerFn,
                  controllerAs: 'vmPageFooter',
                  scope: true,
                  bindToController: true,
                  templateUrl: function (elem, attrs) {
                        if (attrs.template) {
                              return path + '/footer' + attrs.template + '.html';
                        } else {
                              return path + '/footer.html';
                        }
                  }
            }
      }

      controllerFn.$inject = ['DateClockService'];

      function controllerFn(DateClockService) {

            var vm = this;

            vm.dateData = DateClockService.getClockAndDate()

      }

})();
/**
 * Created by unal on 8/19/2017.
 */


(function () {
    angular.module('novusTerminal').factory('DateRequirementSettingService', ServiceFn);

    function ServiceFn() {


        var timezone = 'Europe/Malta';
        var dateFormat = 'MMM DD, YYYY';
        var dateTimeFormat = 'MMM DD, YYYY HH:mm:ss';

        var requirementSetting = {
            timezone: timezone,
            dateFormat: dateFormat,
            dateTimeFormat: dateTimeFormat
        };

        var serviceObj = {
            setTimezone: function (timezoneValue) {
                if (!timezoneValue) {
                    return;
                }
                _.merge(requirementSetting, {timezone: timezoneValue});
            },

            setDateTimeFormat: function (dateTimeFormat) {
                if (!dateTimeFormat) {
                    return;
                }
                _.merge(requirementSetting, {dateTimeFormat: dateTimeFormat});
                var languageDateFormat = dateTimeFormat.substring(0, dateTimeFormat.indexOf('HH'));
                _.merge(requirementSetting, {dateFormat: languageDateFormat});

            },

            getDateSetting: function () {
                return requirementSetting;
            },

            resetTimezone: function () {
                _.merge(requirementSetting, {timezone: timezone});
            }

        };

        return serviceObj;
    }
})();

/**
 * Created by unal on 9/15/2017.
 */

(function () {

	angular
		.module('novusTerminal')
		.factory('DateSettingsService', ServiceFn);

	ServiceFn.$inject = [];
	function ServiceFn() {


		var settings = {
			dateFormat: 'MM/DD/YYYY',
			timeFormat: 'HH:mm:ss',
			dateTimeFormat: 'MMM DD, YYYY HH:mm:ss',
			bookmakerTimezone: '',
			userTimezone: ''
		};


		var serviceObj = {

            setDateSetting: function (dateTimeFormat) {
                _.merge(settings, {dateTimeFormat: dateTimeFormat});

                var selectedLanguageDateFormat = dateTimeFormat.substring(0, dateTimeFormat.indexOf(" H"));

                var selectedLanguageTimeFormat = dateTimeFormat.substring(dateTimeFormat.indexOf(" H") + 1);
                _.merge(settings, {dateFormat: selectedLanguageDateFormat});
                _.merge(settings, {timeFormat: selectedLanguageTimeFormat});
            },

            getDateSetting: function () {
                return settings;
            },

            setUserTimezone: function (data) {

                settings.userTimezone = data;
            },
            setBookmakerTimezone: function (data) {

              settings.bookmakerTimezone = data;

            }

        }
		return serviceObj;
	}

})();
/**
 * Created by unal on 23.05.2017.
 */



(function () {

	angular
		.module('novusTerminal')
		.factory('DateClockService', ServiceFn);

	ServiceFn.$inject = [
		'$interval',
		'DateSettingsService'
	];
	function ServiceFn($interval, DateSettingsService) {

		var dateTimeData = {
			clock: '',
			date: '',
			unixTime: '',
		};


        var dateSetting = DateSettingsService.getDateSetting();

		var runIntervalStatus = false;



		var serviceObj = {

			setClockAndDate: function (time) {
				if (runIntervalStatus) {
					return;
				}

				_.merge(dateTimeData, {unixTime: time + 2000});

				var date = moment.unix(dateTimeData.unixTime).format('MMM DD, YYYY');
                var clock = moment.tz(dateSetting.userTimezone || dateSetting.bookmakerTimezone).format('HH:mm:ss');
				_.merge(dateTimeData, {date: date});
				_.merge(dateTimeData, {clock: clock});
				runInterval();

			},

			getClockAndDate: function () {

				return dateTimeData;
			},

			setDateAfterLanguageChange: function () {

				var newFormatData = moment.tz(dateSetting.userTimezone || dateSetting.bookmakerTimezone).utc(dateTimeData.date).format(dateSetting.dateFormat);
				_.merge(dateTimeData, {date: newFormatData});
			}


		};

		function setClock() {

			_.merge(dateTimeData, {unixTime: dateTimeData.unixTime + 1000});
			var clock = moment.tz(dateSetting.userTimezone || dateSetting.bookmakerTimezone).utc(dateTimeData.unixTime).format(dateSetting.timeFormat);
			_.merge(dateTimeData, {clock: clock});
		}

		function runInterval() {
			runIntervalStatus = true;
			$interval(setClock, 1000);
		}


		return serviceObj;

	}


})();

    angular.module('novusTerminal').directive("scrollView", ScrollFn);

    function ScrollFn() {
        return {
            restrict: 'AE',
            link: linkFn
        }
        function linkFn(scope, element) {
            var scrollElement = angular.element(document.getElementById('odds-page-content'));
            var wrapperElement = angular.element(element);
            var parentElement = wrapperElement.parent();

                scrollElement.on('scroll',function () {

                    var wrapperElementHeight = parentElement.context.offsetHeight;
                    var scrollStatus = wrapperElement.offset().top;

                        if (scrollStatus < 184 && scrollStatus + wrapperElementHeight > 250) {
                            angular.element(element).addClass('fixed-odds-page');
                        }
                        else
                        {
                            angular.element(element).removeClass('fixed-odds-page');

                        }

                });

        }

    }



/**
 * Created by unal on 8/11/2017.
 */


(function () {

    angular.module('novusTerminal').factory('OddsFormatService', ServiceFn);

    
    ServiceFn.$inject = [
        '$cookies',
        'UtilsService',
        'NotifyingService'
    ];
    function ServiceFn($cookies, UtilsService, NotifyingService) {

        var oddsFormats = [];

        var selectedOddsFormat = {};

        var formatsData = [
            {
                id: 1,
                name: 'Decimal',
                value: 'decimal'
            },
            {
                id: 2,
                name: 'Fractional',
                value: 'fractional'
            },
            {
                id: 3,
                name: 'American',
                value: 'american'
            },
            {
                id: 4,
                name: 'Honk Kong',
                value: 'honk_kong'
            },
            {
                id: 5,
                name: 'Malay',
                value: 'Malay'
            }
        ];


        var serviceObj = {

            setInitialOddsFormats: function (bookmakerOddsFormats) {
                _.forEach(bookmakerOddsFormats, function (oddsFormat) {
                    oddsFormats.push(_.find(formatsData, {id: oddsFormat.id}))
                });
            },

            getOddsFormats: function () {
                return oddsFormats;
            },

            setInitialOddsFormat: function (bookmakerOddsFormatId) {
                var cookiesOddsFormatId = $cookies.get('nvsDesktopOddsFormat') * 1;

                if (cookiesOddsFormatId) {
                    setSelectedOddsFormatToParams(cookiesOddsFormatId);
                } else {
                    setSelectedOddsFormatToParams(bookmakerOddsFormatId);
                }
            },

            setSelectedOddsFormat: function (clickedOddsFormatId) {
                setSelectedOddsFormatToParams(clickedOddsFormatId);
                NotifyingService.notify('odds-format:changed');
            },

            getSelectedOddsFormat: function () {
                return selectedOddsFormat;
            },


        };

        function setSelectedOddsFormatToParams(oddsFormatParamId) {
            var initialOddsFormat = _.find(oddsFormats, {id: oddsFormatParamId}) || _.find(oddsFormats, {id: 1});
            UtilsService.removeAndMerge(selectedOddsFormat, initialOddsFormat);
            $cookies.put('nvsDesktopOddsFormat', selectedOddsFormat.id * 1);
        }

        // function createDynamicOddsFormats() {
        //     var formatsData = [
        //         {
        //             id: 1,
        //             name: 'Decimal',
        //             value: 'decimal'
        //         },
        //         {
        //             id: 2,
        //             name: 'Fractional',
        //             value: 'fractional'
        //         },
        //         {
        //             id: 3,
        //             name: 'American',
        //             value: 'american'
        //         },
        //         {
        //             id: 4,
        //             name: 'Honk Kong',
        //             value: 'honk_kong'
        //         },
        //         {
        //             id: 5,
        //             name: 'Malay',
        //             value: 'Malay'
        //         }
        //     ];
        //
        //     _.merge(oddsFormats, formatsData);
        //
        // }

        return serviceObj;
    }

})();

/**
 * Created by unal on 8/11/2017.
 */


(function () {

    angular.module('novusTerminal').factory('OddsFormatConvertService', ServiceFn);


    ServiceFn.$inject = [
        'OddsFormatService',
        '$cookies',
    ];
    function ServiceFn(OddsFormatService, $cookies) {

        var oddsFormatId;
        var transformedOddsFormat;

        var serviceObj = {

            getTransformedOddsFormat: function (oddsValue) {
                oddsFormatId = OddsFormatService.getSelectedOddsFormat().id || $cookies.get('nvsDesktopOddsFormat');
                switch (oddsFormatId) {
                    case 1:
                        transformedOddsFormat = oddsValue * 1;
                        transformedOddsFormat = parseFloat(transformedOddsFormat).toFixed(2)
                        break;
                    case 2:
                        setFractionalOddsFormat(oddsValue);
                        break;
                    case 3:
                        setAmericanOddsFormat(oddsValue);
                        break;
                    case 4:
                        setHonkKongOddsFormat(oddsValue);
                        break;
                    case 5:
                        setMalayOddsFormat(oddsValue);
                        break;
                }

                return transformedOddsFormat;

            },

        };


        function setFractionalOddsFormat(oddsValue) {
            oddsValue = oddsValue * 1;
            var numerator = (oddsValue - 1) * 1000;
            numerator = numerator.toFixed() * 1;
            var denominator = 1000;
            var gcdNum = gcd(numerator, denominator);

            numerator = (numerator / gcdNum);
            denominator = (denominator / gcdNum);

            transformedOddsFormat = (numerator + '/' + denominator);

        };
        function setAmericanOddsFormat(oddsValue) {

            oddsValue = oddsValue * 1;
            if (oddsValue <= 2) {
                transformedOddsFormat = ((-100) / (oddsValue - 1)).toFixed(2);
            } else {
                transformedOddsFormat = '+' + ((oddsValue - 1) * 100).toFixed(2);
            }

        };

        function setHonkKongOddsFormat(oddsValue) {
            transformedOddsFormat = (oddsValue - 1).toFixed(2);
        };

        function setMalayOddsFormat(oddsValue) {

            oddsValue = oddsValue * 1;

            if (oddsValue >= 2) {
                transformedOddsFormat = ((-1) / (oddsValue - 1)).toFixed(4);
            }
            else {
                transformedOddsFormat = (oddsValue - 1).toFixed(4);
            }
        };

        function gcd(num, den) {
            var largeNum;
            var smallNum;
            var divisors = [];

            if (num > den) {
                largeNum = num;
                smallNum = den;
            } else if (den > num) {
                largeNum = den;
                smallNum = num;
            } else {
                largeNum = num;
                smallNum = num;
            }


            if (largeNum % smallNum === 0) {
                return smallNum;
            }

            for (var idx = 1; idx <= smallNum; idx++) {
                if (largeNum % idx === 0 && smallNum % idx === 0) {
                    divisors.push(idx);
                }
            }

            return divisors[divisors.length - 1];

        }

        return serviceObj;
    }

})();

/**
 * Created by unal on 8/11/2017.
 */


(function () {
      angular.module('novusTerminal')
            .directive('nvsPalimpsestOddsFormat', PalimpsestDirectiveFn)
            .directive('nvsLiveOddsFormat', LiveDirectiveFn);

      function PalimpsestDirectiveFn(OddsFormatConvertService, NotifyingService) {
            return {
                  restrict: 'EA',
                  scope: {
                        odds: '@',
                  },
                  link: function (scope, elem, attr) {

                        if (_.isEqual((scope.odds * 1), 0) || _.isEqual(scope.odds, '-')) {
                              return elem.html('-');
                        }
                        function setOddsFormat() {
                              return elem.html(OddsFormatConvertService.getTransformedOddsFormat(scope.odds));
                        }

                        setOddsFormat();
                        NotifyingService.subscribe(scope, 'odds-format:changed', function () {
                              setOddsFormat();
                        })

                  }

            }
      }

      function LiveDirectiveFn(OddsFormatConvertService, NotifyingService) {
            return {
                  restrict: 'EA',
                  scope: {
                        odds: '@',
                  },
                  link: function (scope, elem, attr) {

                        function setOddsFormat() {

                              if (_.isEqual((scope.odds * 1), 0) || _.isEqual(scope.odds, '-')) {
                                    return elem.html('');
                              }

                              return elem.html(OddsFormatConvertService.getTransformedOddsFormat(scope.odds));
                        }

                        NotifyingService.subscribe(scope, 'odds-format:changed', function () {
                              setOddsFormat();
                        });

                        attr.$observe('odds', function (value) {
                              setOddsFormat();
                        });
                        // scope.$watch(function () {
                        //     return scope.odds;
                        // }, function (newVal, oldVal) {
                        //     if (_.isEqual(newVal, oldVal)) {
                        //         return;
                        //     }
                        //
                        //     setOddsFormat();
                        // });

                        setOddsFormat();


                  }

            }
      }


})();

(function () {
    angular.module('novusTerminal').directive('aptOddsFormat', DirectiveFn);
    DirectiveFn.$inject = [
        '$rootScope',
        'OddsFormatConvertService',
        'NotifyingService'
    ];
    function DirectiveFn($rootScope,OddsFormatConvertService, NotifyingService) {
        return {
            restrict: 'EA',
            scope: {
                oddsValue: '='
            },
            link: linkFn
        };
        function linkFn(scope, elem) {
            function oddsFormatFilter() {
                var newOddsValue = '-';
                if (typeof scope.oddsValue === 'undefined') {
                    newOddsValue = '-';
                    return elem.html(newOddsValue);
                }
                if (parseInt(scope.oddsValue, 10) === 0) {
                    newOddsValue = '-';
                    return elem.html(newOddsValue);
                }
                if (scope.oddsValue === '-') {
                    newOddsValue = '-';
                    return elem.html(newOddsValue);
                }
                if (scope.oddsValue > 100) {
                    newOddsValue = parseFloat(scope.oddsValue).toFixed(1);
                    return elem.html(newOddsValue);
                }

                newOddsValue = parseFloat(scope.oddsValue).toFixed(2);


                newOddsValue = OddsFormatConvertService.getTransformedOddsFormat(newOddsValue);


                return elem.html(newOddsValue);
            }


            NotifyingService.subscribe(scope, 'odds-format:changed', function () {
                oddsFormatFilter();
            });
            return oddsFormatFilter();
        }
    }
})();
/**
 * Created by unal on 8/24/2017.
 */


(function () {
    angular.module('novusTerminal')
        .factory('DateTimeToReqConvertService', ServiceFn);

    function ServiceFn(DateRequirementSettingService) {


        var serviceObj={


            getDateTimeForDbRequest:function (date) {
                var dateSettings=DateRequirementSettingService.getDateSetting();

                var dbDate = {
                    startDate: moment.utc(date.startDate).tz(dateSettings.timezone).format(),
                    endDate: moment.utc(date.endDate).tz(dateSettings.timezone).format()
                };
                if (moment(dbDate.endDate).seconds() == 0) {
                    dbDate.endDate = moment(dbDate.endDate).add(59, 'seconds').format();
                }
                return dbDate;
            }
        };


        return serviceObj;
    }
})();

/**
 * Created by unal on 9/11/2017.
 */


(function () {
	angular.module('novusTerminal')
		.factory('CurrencyFormatService', ServiceFn);


	function ServiceFn(CurrencyService) {

		var serviceObj = {

			getTransformedCurrencyFormat: function (data) {

				var currency = CurrencyService.getCurrencyData();
				var currencyValue = getCurrencyValue(data);


				if (currency.symbol_location == 'L') {
					return currency.symbol + currencyValue;
				} else {
					return currencyValue + currency.symbol
				}

			}
		};


		function getCurrencyValue(item) {
			var currency = CurrencyService.getCurrencyData();

			if (_.isUndefined(item) || _.isNaN(item) || !item || item <= 0) {
				return (_.indexOf(item, '0') < 0 ? '0' : item) + currency.seperator_decimal + '00';
			} else {
				var itemNumber = item * 1;
				itemNumber = itemNumber.toString().replace('.', currency.seperator_decimal);
				var itemNumberSplitArray = itemNumber.split(currency.seperator_decimal);
				var itemNumberOfDecimalPart = itemNumberSplitArray[0];
				if (itemNumberOfDecimalPart.length <= 3) {
					return itemNumber;
				}
				var itemNumberDecimalThousandSeperator = itemNumberOfDecimalPart.toString().replace(/\B(?=(\d{3})+(?!\d))/g, currency.seperator_thousand);
				return itemNumberDecimalThousandSeperator + (itemNumberSplitArray[1] ? currency.seperator_decimal + itemNumberSplitArray[1] : '');

			}


		}

		return serviceObj;

	}


})();

/**
 * Created by unal on 9/11/2017.
 */


(function () {
    angular.module('novusTerminal')
        .directive('nvsCurrencyFormat', DirectiveFn)
        .directive('nvsCurrencyFormatFilter', DirectiveFilFn)
        .filter('nvsCurrencyFilter', FilterFn);


    function DirectiveFn(CurrencyFormatService, NotifyingService) {
        return {
            restrict: 'EA',
            scope: {
                value: '@',
            },
            link: function (scope, elem, attr) {

                /* if (_.isEqual((scope.value * 1), 0) || _.isEqual(scope.value, '-')) {
                 return elem.html('-');
                 }*/
                function setCurrencyFormat() {
                    return elem.html(CurrencyFormatService.getTransformedCurrencyFormat(scope.value));
                }

                setCurrencyFormat();
                NotifyingService.subscribe(scope, 'currency-data:changed', function () {
                    setCurrencyFormat();
                })

            }

        }
    }

    function DirectiveFilFn() {
        return {
            restrict: 'EA',
            scope: {},
            controller: controllerFn,
            bindToController: {
                value: '=',
            },
            controllerAs: 'vmFormatFilter',
            template: '{{vmFormatFilter.value | nvsCurrencyFilter:vmFormatFilter.currency}}'

        }
    }

    function controllerFn(NotifyingService, $scope, CurrencyService) {
        var vm = this;

        vm.currency = CurrencyService.getCurrencyData();

        NotifyingService.subscribe($scope, 'currency-data:changed', function () {
            vm.currency = CurrencyService.getCurrencyData();
        })
    }

    function FilterFn(CurrencyFormatService) {
        return function (item, currency) {

            function setCurrencyFormat() {
                return CurrencyFormatService.getTransformedCurrencyFormat(item);
            }

            return setCurrencyFormat();


        }
    }


})();

/**
 * Created by unal on 23.05.2017.
 */



(function () {

        angular
                  .module('novusTerminal')
                  .factory('CalendarConfigurationService', ServiceFn);

        ServiceFn.$inject = [
                'DateSettingsService',
                'dateRangeConfig'
        ];
        function ServiceFn(DateSettingsService,  dateRangeConfig) {


                var dateSetting = DateSettingsService.getDateSetting();

                var dateOptions = dateRangeConfig.dateRangeOptions;

              /*  var newOptions = {
                        locale: {
                                applyClass: 'btn-green',
                                applyLabel: translateKey('apply'),
                                fromLabel: translateKey('from'),
                                format: LanguageService.getSelectedLanguage().date_format,
                                toLabel: translateKey('to'),
                                cancelLabel: translateKey('cancel'),
                                customRangeLabel: translateKey('custom_range'),
                                opens: 'center',
                                "weekLabel": "W",
                                "daysOfWeek": [
                                        translateKey('day_short2_sunday'),
                                        translateKey('day_short2_monday'),
                                        translateKey('day_short2_tuesday'),
                                        translateKey('day_short2_wednesday'),
                                        translateKey('day_short2_friday'),
                                        translateKey('day_short2_thursday'),
                                        translateKey('day_short2_saturday'),
                                ],
                                "monthNames": [
                                        translateKey('month_full_january'),
                                        translateKey('month_full_february'),
                                        translateKey('month_full_march'),
                                        translateKey('month_full_april'),
                                        translateKey('month_full_may'),
                                        translateKey('month_full_june'),
                                        translateKey('month_full_july'),
                                        translateKey('month_full_august'),
                                        translateKey('month_full_september'),
                                        translateKey('month_full_october'),
                                        translateKey('month_full_november'),
                                        translateKey('month_full_december')
                                ],
                                "firstDay": LanguageService.getSelectedLanguage().first_day
                        }
                };*/

                var serviceObj = {

                        getCalendarOptions: function () {
                                return dateOptions;
                        },

                    /*    setCalendarOptions: function () {
                                _.merge(dateOptions, newOptions);
                        },
*/
                        getTimeForDbRecord: function (date) {

                                var dbDate = {
                                        startDate: moment.utc(date.startDate).tz(dateSetting.userTimezone || dateSetting.bookmakerTimezone).format(),
                                        endDate: moment.utc(date.endDate).tz(dateSetting.userTimezone || dateSetting.bookmakerTimezone).format()
                                };
                                if (moment(dbDate.endDate).seconds() == 0) {
                                        dbDate.endDate = moment(dbDate.endDate).add(59, 'seconds').format();
                                }
                                return dbDate;
                        },

                        getInitTimeForCalendar: function () {
                                return {
                                        startDate: moment().startOf('date').subtract(1, 'week').tz(dateSetting.userTimezone || dateSetting.bookmakerTimezone).format(),
                                        endDate: moment().endOf('date').tz(dateSetting.userTimezone || dateSetting.bookmakerTimezone).format()
                                }
                        }

                };


                // function translateKey(key) {
                //         $translate(key).then(function () {
                //                 _.merge(dateOptions, newOptions);
                //         }).catch(function (translateKey) {
                //                 return translateKey;
                //         })
                // }

                return serviceObj;
        }

})();

(function () {

	angular
		.module('novusTerminal')
		.factory('AuthorizationService', ServiceFn);

	ServiceFn.$inject = [
		'AuthModel',
		'$sessionStorage',
		'UserService',
		'$cookies',
		'$rootScope'
	];
	function ServiceFn(AuthModel, $sessionStorage, UserService, $cookies, $rootScope) {


		var serviceObj = {

			loadAuth: function () {
				return AuthModel.one().post().then(function (res) {

					$sessionStorage.Auth = res.data.permissions;
					UserService.setMenu(res.data.menus.sub_navbar_menu);

				})
			},

			checkRoutePermissions: function (urlData) {

				var loggedCondition = true;
				var authenticatedCondition = true;

				if (_.has(urlData, 'isLoginRequired') && urlData.isLoginRequired) {
					loggedCondition = isLoggedInCondition();
				}

				if (_.has(urlData, 'authenticate') && urlData.authenticate) {
					authenticatedCondition = isAuthenticated(urlData.authenticate);
				}

				if (loggedCondition && authenticatedCondition) {
					return false;
				} else {
					return true;
				}

			}

		};

		function isAuthenticated(route) {
			var auth = $sessionStorage.Auth;
			var idx = _.indexOf(auth, route);
			return (idx >= 0) ? true : false;
		};






		function isLoggedInCondition() {
			var userData = UserService.getUser();
			var userCookieValue = $cookies.get('UserLoggedIn') * 1;

			if (_.has(userData, 'id') || _.isEqual(userCookieValue, 1)) {
				return true;
			} else {
				return false;
			}

		};


		return serviceObj;
	}

})();

/**
 * Created by unal on 18.05.2017.
 */



(function () {

      angular
            .module('novusTerminal')
            .factory('AuthModel', ServiceFn);


      ServiceFn.$inject = ['ApiService'];
      function ServiceFn(ApiService) {
            var rest = ApiService.serviceOne();

            return rest.service('site-user-permissions');
      }


})();
/**
 * Created by Emre on 17.06.2017.
 */

(function () {
      'use strict';
      angular
          .module('novusTerminal')
          .config(InterceptorFn)
          .factory('CasinoGameModelService', ServiceFn);

      InterceptorFn.$inject = ['RestangularProvider'];
      function InterceptorFn(RestangularProvider) {

            RestangularProvider.addResponseInterceptor(function (data, operation, what, url, response, deferred) {

                  return data;

            });

            RestangularProvider.addRequestInterceptor(function (data, operation, what, url) {

                  return data;
            });

      }

      ServiceFn.$inject = ['ApiService'];
      function ServiceFn(ApiService) {

            var rest = ApiService.serviceOne();

            return rest.service('casino/game/play/');
      }

})();
/**
 * Created by Emre on 17.06.2017.
 */

(function () {
    'use strict';
    angular
        .module('novusTerminal')
        .factory('CasinoService', ServiceFn);

    ServiceFn.$inject = ['CasinoModelService', 'CasinoGameModelService', '$sce'];

    function ServiceFn(CasinoModelService, CasinoGameModelService, $sce) {

        var casinoGameList = [];

        var vipGame = [];

        var vipTableGame = [];

        var repo = [];

        var gameData = {};


        var ServiceObject;
        ServiceObject = {

            getCasinoGames: function () {
                  CasinoModelService.post()
                      .then(function (response) {
                            _.forEach(response.data.list, function(value) {
                               if(value.type == "NETENT") {
                                     vipGame.push(value);
                               }else if(value.type == "NETENT_TABLE") {
                                     vipTableGame.push(value);
                               }
                            });
                            _.merge(casinoGameList, response.data.list);
                            _.merge(repo, response.data.list);
                      });
                  return casinoGameList;
            },


            getAllGames: function () {
                casinoGameList.splice(0, casinoGameList.length);
                _.merge(casinoGameList, repo);
            },

            getVipGames: function () {
                casinoGameList.splice(0, casinoGameList.length);
                _.merge(casinoGameList, vipGame);
            },

            getVipTableGames: function () {
                casinoGameList.splice(0, casinoGameList.length);
                _.merge(casinoGameList, vipTableGame);
            },

            playCasinoGame: function (id, data) {
                CasinoGameModelService.one(id).post(undefined, data)
                    .then(function (response) {
                        response.data.game.url = $sce.trustAsResourceUrl(response.data.game.url);

                        _.merge(gameData, response.data);
                    })
            },

            getGameData: function () {
                return gameData;
            }

        };

        return ServiceObject;
    }

})();
/**
 * Created
 */

(function() {
    'use strict';
    angular
        .module('novusTerminal')
        .config(InterceptorFn)
        .factory('CasinoModelPlayService', ServiceFn);

    InterceptorFn.$inject = ['RestangularProvider'];

    function InterceptorFn(RestangularProvider) {

        RestangularProvider.addResponseInterceptor(function(data, operation, what, url, response, deferred) {


            // var auth = response.headers('auth');
            return data;

        });

        RestangularProvider.addRequestInterceptor(function(data, operation, what, url) {

            // var auth = $cookies.get('terminalAuth') || '';

            // var languageId = 1;
            // data.auth = auth;
            // data.language_id = languageId;
            return data;
        });

    }

    ServiceFn.$inject = ['ApiService'];

    function ServiceFn(ApiService) {

        var rest = ApiService.serviceOne();
        return rest.service('casino/game/play/');
    }




})();
/**
 * Created by Emre on 17.06.2017.
 */

(function () {
      'use strict';
      angular
          .module('novusTerminal')
          .config(InterceptorFn)
          .factory('CasinoModelService', ServiceFn);

      InterceptorFn.$inject = ['RestangularProvider'];
      function InterceptorFn(RestangularProvider) {

            RestangularProvider.addResponseInterceptor(function (data, operation, what, url, response, deferred) {


                  // var auth = response.headers('auth');
                  return data;

            });

            RestangularProvider.addRequestInterceptor(function (data, operation, what, url) {

                  // var auth = $cookies.get('terminalAuth') || '';

                  // var languageId = 1;
                  // data.auth = auth;
                  // data.language_id = languageId;
                  return data;
            });

      }

    ServiceFn.$inject = ['ApiService'];
    function ServiceFn(ApiService) {


        var rest = ApiService.serviceOne();

        return rest.service('casino/game/list');

    }

})();
/**
 * Created by Emre on 17.06.2017.
 */

(function() {
    'use strict';
    angular
        .module('novusTerminal')
        .config(InterceptorFn)
        .factory('CasinoModelGameService', ServiceFn);

    InterceptorFn.$inject = ['RestangularProvider'];

    function InterceptorFn(RestangularProvider) {

        RestangularProvider.addResponseInterceptor(function(data, operation, what, url, response, deferred) {


            // var auth = response.headers('auth');
            return data;

        });

        RestangularProvider.addRequestInterceptor(function(data, operation, what, url) {

            // var auth = $cookies.get('terminalAuth') || '';

            // var languageId = 1;
            // data.auth = auth;
            // data.language_id = languageId;
            return data;
        });

    }

    ServiceFn.$inject = ['ApiService'];

    function ServiceFn(ApiService) {

        var rest = ApiService.serviceOne();
        return rest.service('casino/game/menu');
    }




})();
/**
 * Created by Emre on 17.06.2017.
 */

(function() {
    'use strict';
    angular
        .module('novusTerminal')
        .config(InterceptorFn)
        .factory('CasinoModelFavouiriteService', ServiceFn);

    InterceptorFn.$inject = ['RestangularProvider'];

    function InterceptorFn(RestangularProvider) {

        RestangularProvider.addResponseInterceptor(function(data, operation, what, url, response, deferred) {


            // var auth = response.headers('auth');
            return data;

        });

        RestangularProvider.addRequestInterceptor(function(data, operation, what, url) {

            // var auth = $cookies.get('terminalAuth') || '';

            // var languageId = 1;
            // data.auth = auth;
            // data.language_id = languageId;
            return data;
        });

    }

    ServiceFn.$inject = ['ApiService'];

    function ServiceFn(ApiService) {

        var rest = ApiService.serviceOne();
        return rest.service('casino/favourite');
    }




})();
/**
 * Created by Emre on 17.06.2017.
 */

(function() {
    'use strict';
    angular
        .module('novusTerminal')
        .factory('CasinoGameService', ServiceFn);

    ServiceFn.$inject = ['CasinoModelGameService'];

    function ServiceFn(CasinoModelGameService) {

        var casinoGameplay = [];

        var ServiceObject;
        ServiceObject = {

            getplayGames: function() {
                CasinoModelGameService.post()
                    .then(function(response) {
                        _.merge(casinoGameplay, response.data);
                    });
                return casinoGameplay;

            }


        };

        return ServiceObject;







    }







})();
/**
 * Created by Emre on 19.06.2017.
 */

(function () {
      'use strict';
      angular
          .module('novusTerminal')
          .controller('CasinoPlayCtrl', ControllerFn);

      ControllerFn.$inject = ['NotifyingService'];
      function ControllerFn( NotifyingService) {
            var vm = this;


            vm.closeGame = closeGameFn;
            function closeGameFn() {
                  NotifyingService.notify('closeGame');
            }
      }
})();
/**
 * Created
 */

(function () {
    'use strict';
    angular
        .module('novusTerminal')
        .config(InterceptorFn)
        .factory('VirtualsModelService', ServiceFn);

    InterceptorFn.$inject = ['RestangularProvider'];
    function InterceptorFn(RestangularProvider) {

        RestangularProvider.addResponseInterceptor(function (data, operation, what, url, response, deferred) {


            // var auth = response.headers('auth');
            return data;

        });

        RestangularProvider.addRequestInterceptor(function (data, operation, what, url) {

            // var auth = $cookies.get('terminalAuth') || '';

            // var languageId = 1;
            // data.auth = auth;
            // data.language_id = languageId;
            return data;
        });

    }

    ServiceFn.$inject = ['ApiService'];
    function ServiceFn(ApiService) {


        var rest = ApiService.serviceOne();

        return rest.service('integration/newgoldenrace/hash');

    }

})();
/**
 * Created
 */
(function () {
    angular.module('novusTerminal').controller('VirtualCtrl', CtrlFn);
    CtrlFn.$inject = ['$sce', '$location', '$scope','UserService','VirtualsModelService','ToastrNotificationService'];
    function CtrlFn( $sce, $location, $scope,UserService,VirtualsModelService,ToastrNotificationService) {
        window.removeEventListener('message', function handleRemove() { return false; }, true);
        var vm = this;
        vm.gamesInit = function initializeGame(res) {
            window.grLoader = grOnlineLoader({
                onlineHash: res.hash,
                language: res.language,
                skin: res.skin || ''
            });
        };
        // $scope.openLoginModal = function openLoginModalName() {
        //     UserService.openLoginModal();
        // };
        VirtualsModelService.post().then(function (res) {
            vm.hashValue = res.url;
            vm.gameUrl = $sce.trustAsResourceUrl(vm.hashValue);
            vm.scriptSrc = (res.domain || res.game_url) + 'web-v2/golden-race-online-loader.js';
            if (!document.getElementById('golden-race-online-loader')) {
                var script = document.createElement('script');
                setTimeout(function () {
                    script.type = 'text/javascript';
                    script.id = 'golden-race-online-loader';
                    document.getElementsByTagName('body')[0].appendChild(script);
                    script.onload = function onLoadToDo() {
                        vm.gamesInit(res);
                    };
                    script.src = vm.scriptSrc;
                });
            } else {
                vm.gamesInit(res);
            }
            setTimeout(function () {

            });
        }).catch(function (response) {

            ToastrNotificationService.notificationPopUp(response.data.error_message,'warning');

        });
        window.addEventListener('message', function (event) {
            var iFrameID = document.getElementById('GLVirtual');
            if (event.data && iFrameID) {
                vm.iframeData = JSON.parse(event.data);
                iFrameID.height = vm.iframeData.resizeBody;
            }
        });
        $scope.$on('$stateChangeStart', function () {
            var goldenRaceScriptElement = document.getElementById('golden-race-online-loader');
            return goldenRaceScriptElement ? document.getElementById('golden-race-online-loader').remove() : false;
        });
        // scroll control ///
        var scrollStatus = 0;
        vm.uptoScroll = upScrollFn;
        vm.downtoScroll = bottomScrollFn;

        function upScrollFn() {

            var element = $('#golden-container')[0];

            var odsScrollHeight = element.scrollHeight;
            scrollStatus = element.scrollTop;

            if(scrollStatus >= 0 && odsScrollHeight >= scrollStatus ){
                scrollStatus -=  100;

            }else {
                scrollStatus = 0;
            }

            element.scrollTop=scrollStatus;

        }

        function bottomScrollFn() {
            var element = $('#golden-container')[0];

            var odsScrollHeight = element.scrollHeight;
            scrollStatus = element.scrollTop;

            if(scrollStatus >= 0 && odsScrollHeight >= scrollStatus ){
                scrollStatus +=  100;

            }else {
                scrollStatus = 0;
            }

            element.scrollTop=scrollStatus;

        }
        // scroll control ///
    }
})();

'use strict';

/**
 * @ngdoc function
 * @name sportsbookApp.controller:TicketCtrl
 * @description
 * # TicketCtrl
 * Controller of the sportsbookApp
 */
angular.module('novusTerminal').controller('TicketCtrl',
    ['$scope', '$element', '$rootScope', 'ticketService', 'Ticket', 'TranslateService', '$timeout', 'Calculator', 'NotifyingService', 'BetCounter', '$cookies', 'TicketStakeButtonService', '$location', 'languageService', 'ToastrNotificationService','TicketPrintLogoService',
        function ($scope, $element, $rootScope, ticketService, Ticket, TranslateService, $timeout, Calculator, NotifyingService, BetCounter, $cookies, TicketStakeButtonService, $location, languageService, ToastrNotificationService,TicketPrintLogoService) {

            $scope.ticket = Ticket;
            // $scope.user = $rootScope.user;
            $scope.betCounter = BetCounter;
            $scope.ticket.checkoutTime = 0;
            $scope.error = {
                load_ticket_error: false
            };
            $scope.isBonusSelected = false;
            $scope.start = true;
            $scope.pause = false;
            $scope.resume = false;
            $scope.checkCounterState = function () {
                $scope.started = $location.path() != '/settings' ? true : false;
                if ($cookies.get('counterPaused') == 0) {
                    $scope.pause = true;
                    $scope.start = false;
                    $scope.resume = false;
                } else if ($cookies.get('counterPaused') == 1) {
                    $scope.resetActive = true;
                    $scope.resume = true;
                    $scope.pause = false;
                    $scope.start = false;
                } else {
                    $scope.start = true;
                    $scope.pause = false;
                    $scope.resume = false;
                }
            };
            $scope.ticketLogo = TicketPrintLogoService.getTicketLogo();
            $scope.checkCounterState();

            $scope.stakeButtons = TicketStakeButtonService.getTicketStakeButtons();
            $scope.hideCombinations = false;
            $scope.hiddenCombinations = function () {
                $scope.hideCombinations = !$scope.hideCombinations;
            };

            var checkoutTime = function () {//Set time of checkout time;
                $scope.ticket.checkoutTime = 0;

                if ($scope.ticket.hasLiveItem()) {//Only Show live event

                    if ($rootScope.user && $rootScope.user.parameters.getCheckoutTime()) {
                        $scope.ticket.checkoutTime = $rootScope.user.parameters.getCheckoutTime();
                        $rootScope.$broadcast('ticketCheckoutTime', $scope.ticket.checkoutTime);
                    }
                }
            };
            var clearCheckoutTime = function () {
                $scope.ticket.checkoutTime = 0;
            };

            $scope.ticketCode = '';
            $scope.error.load_ticket_error = false;
            $scope.getTicketByCode = function (code) {
                // check user is logged in

                /**
                 * login olmadanda ticket load edilebilecek
                 */

                if (code.length < 4) {
                    $scope.error.load_ticket_error = true;
                    return false;
                }

                ticketService.getTicketByCode(code).success(function (res) {
                    //console.log(res);
                    $scope.ticket.setData(res.data.ticket);
                    $scope.ticket.calculator = new Calculator(res.data.ticket.id, res.data.ticket);
                    $scope.error.load_ticket_error = false;
                    NotifyingService.notify('ticket-get:by-code');
                }).error(function (res) {
                    $scope.error.load_ticket_error = false;
                });
            };

            $scope.setReferenceUser = function (userId) {
                $scope.ticket.reference_user_id = userId;
            };

            $scope.checkout = function () {
                // check user is logged in
                if (!$rootScope.user) {
                    //  TranslateService.translate('you_must_login_to_check_out');
                    ToastrNotificationService.notificationPopUp('you_must_login_to_check_out', 'warning');

                    return;
                }
                // update coupon data
                // Ticket.calculator.coupon();

                // get coupon data
                var ticketData = Ticket.calculator.couponData;
                ticketData.accept_withdraw = $scope.ticket.accept_withdraw ? 1 : 0;
                ticketData.useBonus = $scope.isBonusSelected ? 1 : 0;
                //Ticket Stake
                if (!ticketData.Stake || ticketData.Stake == "" || parseFloat(ticketData.Stake) <= 0) {
                    // TranslateService.translate('enter_a_valid_stake_greater_than_zero');
                    ToastrNotificationService.notificationPopUp('enter_a_valid_stake_greater_than_zero', 'error');

                    return false
                }

                // confirm calculations for checkout
                if ($scope.ticket.calculator.checkout()) {
                    // set that the checkout is in progress
                    $scope.ticket.checkoutProgress = true;

                    checkoutTime();
                    ticketData.liveItems = Ticket.localLiveItems[Ticket.id];
                    ticketService.checkout(Ticket.reference_user_id, ticketData).then(function (res) {
                        var filtered = _.findIndex($rootScope.user.sub_accounts, function (o) {
                            return o.id === res.data.ticket.user.id;
                        });
                        if ($rootScope.user.sub_accounts[filtered]) {
                            $rootScope.user.sub_accounts[filtered].balance = res.data.ticket.user.balance;
                        }
                        if ($cookies.get('betCounterStatus') == 1) {
                            BetCounter.increaseStake(res.data.ticket.stake);
                            BetCounter.increaseBets();
                        }
                        $scope.ticket.checkoutProgress = false;
                        // unset checkout state variable

                        // keep a copy of the ticket
                        $scope.ticket.previousTicket = res.data.ticket;


                        // for printing ticket
                        /**
                         *betting last ticket data change with ticket which is come with updates tickets
                         * so we keep last ticket for printing other variable.
                         * we need assign res data ticket this variable
                         */
                        Ticket.lastBettingTicket = res.data.ticket;
                        // for printing ticket

                        if ($rootScope.autoprint_enabled) {
                            Ticket.printPreviousTicket();
                        }
                        // load a new ticket
                        Ticket.load();

                        clearCheckoutTime();

                        /**
                         *for clean selected odds for new odds page refactoring
                         */
                        NotifyingService.notify('ticket-play:successfully');

                    }).error(function (res) {
                        console.log(sdfsdfsdf);
                        if (res.error_code == 4990) {
                            // Max Winning Error;

                            Ticket.checkoutStatus = 1;
                            // Ticket.calculator = new Calculator(res.data.ticket.id, res.data.ticket);
                            for (var systemOption in res.data.set_stakes.systems) {
                                Ticket.calculator.setSystemStake(systemOption, res.data.set_stakes.systems[systemOption]);
                            }
                            Ticket.calculator.couponData.accept_winning = 1;
                            Ticket.calculator.couponData.win_confirmed = 1;

                        } else if (res.error_code == 9001) {
                            // If one of item has error, we should update ticket object to show error on view level.

                            $scope.ticket.setData(res.data.ticket);

                        }
                        $scope.ticket.checkoutProgress = false;

                        clearCheckoutTime();
                    });
                }
                else {
                    $scope.ticket.checkoutProgress = false;

                    clearCheckoutTime();
                }

            };


            /*
             |--------------------------------------------------------------------------
             | init component on page load
             |--------------------------------------------------------------------------
             |
             */

            Ticket.load();


            /**
             * unal delil
             * bet again fonksiyonu
             */

            $scope.betAgain = function (code) {
                ticketService.reloadTicket(code).success(function (res) {
                    $scope.ticket.previousTicket = null;
                    $scope.ticket.setData(res.data.ticket);
                    $scope.ticket.calculator = new Calculator(res.data.ticket.id, res.data.ticket);
                    $scope.error.load_ticket_error = false;
                    NotifyingService.notify('ticket:bet-again');
                });
            };

            $scope.stickyBetslip = function (status) {
                if (status) {
                    $scope.ticket.sticky = false;
                    $("#betSlip").unstick();

                } else {
                    $scope.ticket.sticky = true;
                }
            };

        }]).directive('ticket', function () {
            return {
                controller: 'TicketCtrl',
                templateUrl: 'views/components/ticket.html'
            };
        });

/**
 * Created by unal on 07.04.2017.
 */



(function () {

      angular
              .module('novusTerminal')
              .controller('SportManagerCtrl', ControllerFn);

      ControllerFn.$inject = [
            'CategoryService',
            '$location',
            'OddsService',
            'GeneralPurposeService',
            'NotifyingService'
      ];
      function ControllerFn(CategoryService, $location, OddsService, GeneralPurposeService, NotifyingService) {
            var vm = this;

            CategoryService.resetCategoryData();
            CategoryService.loadCategoryData();
            OddsService.resetData();

            var paramValue = $location.search();

            if (!_.isEmpty(paramValue) && _.has(paramValue, 'tournamentIds')) {
                  var paramIds = paramValue.tournamentIds.split('-');
                  var selectedTournamentIds = [];
                  _.forEach(paramIds, function (paramId) {
                        selectedTournamentIds.push(paramId * 1);
                  });
                  OddsService.loadReloadPageTournaments(selectedTournamentIds);
            }


          vm.leftSidebarOptions = leftSidebarOptionsFn;
            function leftSidebarOptionsFn() {
                  vm.leftSidebarOption = !vm.leftSidebarOption;
                  GeneralPurposeService.setToolBar(vm.leftSidebarOption);
                  NotifyingService.notify('sport-left-odds-content-header-show:click');

            }

      }

})();
/**
 *
 */


(function () {
    angular
        .module('novusTerminal')
        .directive('profileAuthDirective',function () {

            var directive = {
                restrict: 'EA',
                scope: {},
                controller: directiveContFn,
                controllerAs: 'vmProfileAuthentication',
                templateUrl: 'app/profile/profile.authentication.html'
            };
            return directive;
        });
        directiveContFn.$inject = ['$sessionStorage'];
        function directiveContFn($sessionStorage) {
            var vm = this;
            vm.authData = [
                {
                    href: 'moneyDeposit',
                    name: 'money_deposit',
                    isHere:false
                },
                {
                    href: 'moneyWithdraw',
                    name: 'money_withdraw',
                    isHere:false
                },
                {
                    href: 'betHistory',
                    name: 'bet_history',
                    isHere:false
                },
                {
                    href: 'sessions',
                    name: 'sessions',
                    isHere:false
                },
                {
                    href: 'personalDetail',
                    name: 'personal_detail',
                    isHere:false
                },
                {
                    href: 'transactionHistory',
                    name: 'transaction_history',
                    isHere:false
                },
                {
                    href: 'revenueReport',
                    name: 'revenue_report',
                    isHere:false
                }

            ];
            vm.arr1 = $sessionStorage.Auth;
            _.forEach(vm.authData, function(item){
                 _.forEach(vm.arr1, function(dat){
                     if(item.href==dat){
                         item.isHere=true;
                     }
                })
            })
        }

})();

/**
 * Created by Emre on 20.06.2017.
 */

(function () {
      'use strict';
      angular
          .module('novusTerminal')
          .controller('ProfileCtrl', ControllerFn);

      ControllerFn.$inject = ['UserService'];
      function ControllerFn(UserService) {
            var vm = this;
            vm.isUser = UserService.getUser();


      }

})();
(function () {
	'use strict';
	angular.module('novusTerminal').controller('printManagerCtrl', printManagerCtrlFn);
	printManagerCtrlFn.$inject = ['$stateParams'];
	function printManagerCtrlFn($stateParams) {
		var vm = this;
		var params = $stateParams;
		vm.whatToPrint = params.whatToPrint;
		vm.printViewData = params.printViewData;
		vm.previousState = params.previousState;
	}
})();
/**
 * Created by unal on 9/15/2017.
 */

(function () {

	var path = 'app/nvsTicket';

	angular.module('novusTerminal').directive('aptNovusTicket', DirectiveFn);

	function DirectiveFn() {
		return {
			restrict: 'EA',
			scope: {

			},
			bindToController: true,
			controller: ControllerFn,
			controllerAs: 'vmNovusTicket',
			templateUrl: function (elem, attrs) {
				if (attrs.template) {
					return path + '/novus-ticket-' + attrs.template + '.html';
				} else {
					return path + '/novus-ticket.html';
				}
			},
		};
	}

	ControllerFn.$inject = [
		'TicketEventService',
		'NotifyingService'

	];
	function ControllerFn(TicketEventService, NotifyingService) {
		var vm = this;

        vm.comboStatus = false;
        vm.showCombo = showComboFunction;


        function showComboFunction() {

            vm.comboStatus = !vm.comboStatus;


			if(vm.comboStatus == true){

				// scroll animation
                $('#ticket-scroll').animate({
                    scrollTop: $('#scrollItem').offset().top
                }, 1000);


			}
            angular.element('#ticket-scroll').scrollTop(0);
        }

		TicketEventService.loadTicketId();

		vm.ticketShowStatusOptions = TicketEventService.getTicketDisplayOption();

		vm.ticketShowSettings = TicketEventService.getDisplaySetting();



        // scroll  control///
        angular.element('.ticket-show-events').scroll(function (e) {
            vm.scrollH = e.currentTarget.scrollTop;

        });


        vm.upContent = upContentFn;
        function upContentFn() {
            if (!angular.element('.ticket-show-events').scroll()){
                scrollTop = 0;
            }
            scrollTop = vm.scrollH - 55;
            angular.element('.ticket-show-events').scrollTop(scrollTop);

        }

        vm.downContent = downContentFn;
        function downContentFn() {
            if (!angular.element('.ticket-show-events').scroll()){
                scrollTop = 0;
            }
            scrollTop = vm.scrollH + 55;
            angular.element('.ticket-show-events').scrollTop(scrollTop);

        }
        // scroll control ///

	}

})();
(function () {
	'use strict';

	angular
		.module('novusTerminal')
		.controller('MainController', MainController);

	/** @ngInject */
	MainController.$inject = [
		'CreatePopupComponentService',
		'UserService',
		'languageService',
		'logoService',
		'$rootScope',
		'$cookies'
	];
	function MainController(CreatePopupComponentService, UserService, languageService, logoService,$rootScope,$cookies) {

		var vm = this;

		vm.mainlogo = logoService.getLogoUrl();
        vm.mainMenuItems = UserService.getMenu();

		vm.logIn = logInFn;
		vm.joinOn = joinOnFn;

		function logInFn() {
			var componentSetting = {
				name: 'login-form',
			};

			CreatePopupComponentService.createPopupComponent(componentSetting);
		}


		function joinOnFn() {
			var componentSetting = {
				name: 'register-form',
			};

			CreatePopupComponentService.createPopupComponent(componentSetting);
		}

		vm.user = UserService.getUser();
		vm.languages = languageService.getLanguages();
		vm.selectedLanguage = languageService.getSelectedLanguage();

		vm.changeLanguage = changeLanguageFn;

		function changeLanguageFn(language) {
			languageService.setLanguage(language);
		}

        // set odds format
        // $rootScope.setOddsFormat = function (format) {
        //     $rootScope.oddsFormat = format;
        //     NotifyingService.notify('odds-format:changed');
        // };


	}
})();

/**
 *
 */

(function () {
    'use strict';
    angular
        .module('novusTerminal')
        .factory('logoService', ServiceFn);

    ServiceFn.$inject = ['CasinoModelService', 'CasinoGameModelService', '$sce'];

    function ServiceFn(CasinoModelService, CasinoGameModelService, $sce) {

        var mainLogo;
        var ServiceObject;
        ServiceObject = {

            setLogoUrl: function(url){
                 mainLogo=url;
            },
            getLogoUrl: function () {
                return mainLogo;
            }

        };

        return ServiceObject;
    }

})();
/**
 * Created by Emre on 2.06.2017.
 */

(function () {
    'use strict';
    angular
        .module('novusTerminal')
        .controller('LiveManagerCtrl', ControllerFn);

    ControllerFn.$inject = ['LiveService', 'NotifyingService', '$scope'];
    function ControllerFn(LiveService, NotifyingService, $scope) {
        var vm = this;

        LiveService.loadInitLive();

        NotifyingService.subscribe($scope, 'betslipChangeLive', function() {
            vm.betslipOption = !vm.betslipOption;
        })

    }

})();
/**
 * Created by unal on 23.05.2017.
 */



(function () {

	angular.module('novusTerminal').factory('FirebaseLiveService', ServiceFn);

	ServiceFn.$inject = [
		'LiveModel',
		'UtilsService',
		'LiveEngineService',
		'$timeout',
		'$firebaseObject',
	];
	function ServiceFn(LiveModel, UtilsService, LiveEngineService) {

		var sports = [];

		var liveData = new LiveEngineService();

		var defaultMarkets = {};

		var liveNavBarSports = [];

		var liveSelectedSport = {};

		var liveEventViewEventData = {};

		var liveEventViewSport = {};

		var runLiveCheck = false;

		var serviceObj = {

			loadInitLive: function () {
				return LiveModel.one().post('init', {
					from: 'live',
				}).then(function (data) {
					UtilsService.removeAndMerge(defaultMarkets,
						data.data.default_markets);
					UtilsService.removeAndMerge(liveData.data,
						data.data);
					setSportsData(data.data.sports);
					UtilsService.removeAndMerge(liveNavBarSports,
						data.data.sports);
					UtilsService.removeAndMerge(liveSelectedSport,
						data.data.sports[0]);
					getFirebaseDt();
				});
			},

			getLiveData: function () {
				return sports;
			},

			getLiveEngineData: function () {
				return liveData;
			},

			getLiveSportNavBar: function () {
				return liveNavBarSports;
			},

			getSelectedSportNavBar: function () {
				return liveSelectedSport;
			},

			setSelectedLiveSport: function (sport) {
				UtilsService.removeAndMerge(liveSelectedSport, sport);
			},

			setInitialEventViewData: function (sport, event) {
				_.merge(liveEventViewEventData, event);
				_.merge(liveEventViewSport, sport);
			},

			getEventViewData: function () {
				return liveEventViewEventData;
			},

			getEventViewSportData: function () {
				return liveEventViewSport;
			},

			loadEventViewLiveData: function (paramValue) {
				var sportId = paramValue.sportId * 1;
				var eventId = paramValue.eventId * 1;
				if (_.has(liveData.data, 'sports')) {
					return;
				}

				serviceObj.loadInitLive().then(function () {
					_.merge(liveEventViewEventData,
						liveData.data.events[eventId]);
					_.merge(liveEventViewSport, setSportsTemplate(
						_.find(liveData.data.sports,
							{id: sportId})));
				});
			},

			setRunLiveCheckStatus: function (status) {
				runLiveCheck = status;
			},

		};

		function checkLive() {
			if (!runLiveCheck) {
				return;
			}
			LiveModel.one().post('check', {
				from: 'live',
			}).then(function (data) {
				sports.splice(0, sports.length);
				liveNavBarSports.splice(0, liveNavBarSports.length);
				UtilsService.removeAndMerge(liveNavBarSports,
					data.data.sports);
				UtilsService.removeAndMerge(liveData.data, data.data);
				setSportsData(data.data.sports);
				setEventViewData();
				checkLive();
			});
		}

		function setSportsData(liveSports) {
			_.forEach(liveSports, function (sport) {
				if (sport.tournaments.length > 0) {
					sport.liveTournaments = [];
				}

				_.merge(sport.liveTournaments,
					fillSportTournaments(sport));
				sports.push(setSportsTemplate(sport));
			});
		}

		function setSportsTemplate(sport) {
			switch (sport.id * 1) {
				case 1:
				case 2 :
				case 21:
				case 22:
				case 16:
				case 29:
				case 4 :
				case 19:
					sport.live_template = 1;
					break;
				case 3 :
				case 6 :
				case 12:
					sport.live_template = 2;
					break;
				case 5:
				case 31:
				case 34:
				case 32:
				case 20:
				case 23:
					sport.live_template = 3;
					break;
			}

			return sport;
		}

		function fillSportTournaments(sport) {
			var liveTournaments = [];
			_.forEach(sport.tournaments, function (tournamentId) {
				var liveTournament = liveData.data.tournaments[tournamentId];
				if (!liveTournament) {
					return;
				}
				if (liveTournament.event_count > 0) {
					liveTournament.liveEvents = [];
					_.merge(liveTournament.liveEvents,
						fillTournamentEvent(liveTournament.events));
					liveTournament.markets = [];
					_.merge(liveTournament,
						fillSportsMarkets(liveTournament,
							sport.id));

				}

				liveTournaments.push(liveTournament);
			});

			return liveTournaments;
		}

		function fillSportsMarkets(liveTournament, sportId) {
			if (_.isEmpty(defaultMarkets)) {
				return;
			}
			var markets = defaultMarkets[sportId].markets;
			liveTournament.marketsLength = 0;
			_.forEach(markets, function (market, marketKey) {
				market.typeKey = marketKey;
				liveTournament.markets.push(market);
				liveTournament.marketsLength += market.odd_count;
			});

			return liveTournament;
		}

		function fillTournamentEvent(events) {
			var liveEvents = [];

			_.forEach(events, function (eventId) {
				var liveEvent = liveData.data.events[eventId];

				if (!liveEvent) {
					return;
				}
				if (!_.has(liveEvent, 'markets')) {
					return;
				}
				if (liveEvent.markets.length > 0) {
					liveEvent.liveMarkets = [];
					_.merge(liveEvent.liveMarkets,
						fillEventMarkets(liveEvent.markets,
							eventId));
				}
				liveEvents.push(liveEvent);
			});

			return liveEvents;
		}

		function fillEventMarkets(markets, eventId) {
			var liveMarkets = [];
			var eventMarkets = liveData.data.markets[eventId];
			_.forEach(markets, function (marketTypeId) {
				var liveMarket = eventMarkets[marketTypeId];
				liveMarket.typeKey = marketTypeId;
				liveMarket.odds = [];
				_.merge(liveMarket.odds,
					fillMarketOdds(liveMarket.odd_count,
						liveMarket.id));
				liveMarkets.push(liveMarket);
			});

			return liveMarkets;
		}

		function fillMarketOdds(oddsCount, marketId) {
			var odds = liveData.data.odds[marketId];
			if (!odds) {
				odds = [];
				for (var idx = 0; idx < oddsCount; idx++) {
					var newOdds = {
						active: false,
						value: '-',
					};
					odds.push(newOdds);
				}
			}
			return odds;
		}

		/**
		 *event view data
		 */

		function setEventViewData() {
			if (_.isEmpty(liveEventViewEventData) ||
				_.isEmpty(liveEventViewSport)) {
				return;
			}

			UtilsService.removeAndMerge(liveEventViewEventData,
				liveData.data.events[liveEventViewEventData.id]);

			if (_.isEmpty(liveEventViewEventData) ||
				_.isUndefined(liveEventViewEventData)) {
				return;
			}

			fillLiveEventViewDataSubMarkets();
		}

		function fillLiveEventViewDataSubMarkets() {
			liveEventViewEventData.liveSubMarkets = [];
			_.forEach(liveEventViewEventData.sub_markets,
				function (subMarketId) {
					var liveSubMarket = fillLiveEventViewDataSubMarketOdds(
						liveData.data.sub_markets[liveEventViewEventData.id][subMarketId]);
					liveEventViewEventData.liveSubMarkets.push(
						liveSubMarket);
				});
		}

		function fillLiveEventViewDataSubMarketOdds(subMarket) {
			subMarket.liveSubOdds = [];
			_.merge(subMarket.liveSubOdds,
				liveData.data.sub_odds[subMarket.id]);
			return subMarket;
		}

		function setDb() {
			return firebase.database().ref('data');
		}

		function getFirebaseDt() {

			var ref = firebase.database().ref();
			// var obj = $firebaseObject(ref);
			ref.on('value', function (snap) {
				var fireData = snap.val().live.data;
				sports.splice(0, sports.length);
				liveNavBarSports.splice(0, liveNavBarSports.length);
				UtilsService.removeAndMerge(liveNavBarSports,
					fireData.sports);
				UtilsService.removeAndMerge(liveData.data, fireData);
				setSportsData(fireData.sports);
				setEventViewData();
			});

		}

		return serviceObj;
	}

})();
/**
 * Created by unal on 7/6/2017.
 */

(function () {
    'use strict';

    angular
        .module('novusTerminal')
        .config(config);

    /** @ngInject */
    function config() {
        /*       var config = {
         apiKey: "AIzaSyBGoAey168cSYwJApalmr3oOpavTXFACY4",
         authDomain: "luminous-torch-9.firebaseapp.com",
         databaseURL: "https://luminous-torch-9.firebaseio.com",
         projectId: "luminous-torch-9",
         storageBucket: "luminous-torch-9.appspot.com",
         messagingSenderId: "734689824666"
         };
         firebase.initializeApp(config);*/

        var config = {
            apiKey: "AIzaSyBz8hipmTmn9Rj4jLbaN2p_o76nRSIcUhY",
            authDomain: "beyn-fire.firebaseapp.com",
            databaseURL: "https://beyn-fire.firebaseio.com",
            projectId: "beyn-fire",
            storageBucket: "beyn-fire.appspot.com",
            messagingSenderId: "895923950739"
        };
        //firebase.initializeApp(config);


    }

})();

(function () {
	'use strict';

	angular
		.module('novusTerminal')
		.config(TranslateConfig)
		.factory('TranslateAsyncLoader', FactoryFn);


	/** @ngInject */
	function TranslateConfig() {
		var defaultCode = getCookie('terminalLanguageCode') || 'en-Us';

		function getCookie(name) {
			var value = "; " + document.cookie;
			var parts = value.split("; " + name + "=");
			if (parts.length == 2) return parts.pop().split(";").shift();
		}

		// $translateProvider.preferredLanguage(defaultCode);
		// $translateProvider.useLoader('TranslateAsyncLoader');
		// $translateProvider.useSanitizeValueStrategy('escape');
	}

	function FactoryFn(TranslateModelService,TranslateLiveModelService, $q, UtilsService, $cookies, NvsBasicTranslateService,DateRangeConstantSettings, NotifyingService) {


		return function (options) {
			var deferred = $q.defer();
			var translations = {};
            var translationsLive = {};

			var code = $cookies.get('terminalLanguageCode') || '';

			TranslateModelService.post({code: code}).then(function (data) {
                UtilsService.removeAndMerge(translations, data);
                NvsBasicTranslateService.setJson(translations);
                DateRangeConstantSettings.setDateRangePicker();
                NotifyingService.notify('languageJson:set');
                deferred.resolve(translations);
            });

            TranslateLiveModelService.post({code: code}).then(function (data) {
                UtilsService.removeAndMerge(translationsLive, data);
                NvsBasicTranslateService.setLiveJson(translationsLive);
                DateRangeConstantSettings.setDateRangePicker();
                NotifyingService.notify('languageLiveJson:set');
                deferred.resolve(translationsLive);
            });



			return deferred.promise;
		};
	}

})();


(function () {
      'use strict';

      angular
            .module('novusTerminal')
            .config(TranslateConfig);

      /** @ngInject */
      function TranslateConfig(KeepaliveProvider, IdleProvider) {

            IdleProvider.idle(1);
            IdleProvider.interrupt('mousemove keydown DOMMouseScroll mousewheel mousedown touchstart touchmove scroll');
            IdleProvider.timeout(30);
      }



})();


/**
 * Created by unal on 22.05.2017.
 */


/**
 *
 * @param a
 * @param b
 * @returns {Array}
 */
function reduce(a, b) {
      var n = new Array(2);
      var f = GCD(a, b);
      n[0] = a / f;
      n[1] = b / f;
      return n;
}

/**
 *
 * @param num1
 * @param num2
 * @returns {*}
 * @constructor
 */
function GCD(num1, num2) {
      var a;
      var b;
      if (num1 < num2) {
            a = num2;
            b = num1;
      }
      else if (num1 > num2) {
            a = num1;
            b = num2;
      }
      else if (num1 == num2) {
            return num1;
      }
      while (1) {
            if (b == 0) {
                  return a;
            }
            else {
                  var temp = b;
                  b = a % b;
                  a = temp;
            }
      }
}

/**
 *
 * @param decimal
 * @returns {string}
 */
function fractionalOddsFromDecimal(decimal) {
      decimal = parseFloat(decimal).toFixed(2);
      var num = (decimal - 1) * 10000;
      var dom = 10000;

      num = Math.round(num);
      dom = Math.round(dom);

      var a = reduce(num, dom);
      num = a[0];
      dom = a[1];

      return (num + '/' + dom);
}

/**
 *
 * @param decimal
 * @returns {string}
 */
function usOddsFromDecimal(decimal) {
      decimal -= 1;
      if (decimal < 1) {
            return ('-' + (100 / decimal).toFixed(2));
      } else {
            return ('+' + (decimal * 100).toFixed(2));
      }
}

Date.prototype.getTimezoneOffsetHour = function () {
      return ((this.getTimezoneOffset() * -1) / 60);
};
Date.prototype.getUTCTime = function () {
      var date = new Date(this.getUTCFullYear(), this.getUTCMonth(), this.getUTCDate(), this.getUTCHours(), this.getUTCMinutes(), this.getUTCSeconds());
      return Math.floor(date.getTime() / 1000);
};
Date.prototype.getToday = function () {
      var date = this.setHours(23 + this.getTimezoneOffsetHour(), 59, 59, 999);
      return new Date(date);
};
Date.prototype.addHours = function (hours) {
      var date = this.setHours(this.getHours() + (hours || 0), this.getMinutes(), this.getSeconds(), this.getMilliseconds());
      return new Date(date);
};
Date.prototype.addDays = function (days) {
      var date = this.setDate(this.getUTCDate() + (days || 0));
      return new Date(date);
};

/**
 * Created by unal on 8/22/2017.
 */


(function () {
    angular
        .module('novusTerminal')
        .factory('DateRangeConstantSettings', ServiceFn);

    function ServiceFn(NvsBasicTranslateService, UtilsService, DateRequirementSettingService) {

        var dateRangeOptions = {
            locale: {},
            showDropdowns: true,
            showWeekNumbers: false,
            showISOWeekNumbers: false,
            autoApply: true,
            alwaysShowCalendars: true,
            timePicker: true,
            timePicker24Hour: true,
            timePickerSeconds: true
        };

        var dateRangeDateInitialValue = {
            startDate: '',
            endDate: ''
        };

        var localeSettings = {
            dateFormat: '',
            dayOfWeek: ''
        };

        var setInitialDate = false;

        var serviceObj = {

            setDateRangePicker: function () {
                var days = getDaysOfWeekKeysValue();
                var months = getMonthsKeysValue();
                var localeSettings = getLocaleSettingsKeysValue();
                _.merge(localeSettings.daysOfWeek, days);
                _.merge(localeSettings.monthNames, months);
                UtilsService.removeAndMerge(dateRangeOptions.locale, localeSettings);
                setDateRangeInitialDateValue();
            },

            getDateRangePicker: function () {
                return dateRangeOptions;
            },

            getDateRangePickerInitialDateValue: function () {
                return dateRangeDateInitialValue;
            },

            setDateFormat: function (dateFormatData) {
                _.merge(localeSettings, {dateFormat: dateFormatData});
                _.merge(dateRangeOptions.locale, {format: dateFormatData});
            },

            setDayOfWeek: function (dayOfWeekData) {
                _.merge(localeSettings, {dayOfWeek: dayOfWeekData});
                _.merge(dateRangeOptions.locale, {firstDay: dayOfWeekData});

            },

            getDateRangeDateValue: function (dateTime) {
                return setAndGetDateRangeDateValue(dateTime);
            }

        };

        function getDaysOfWeekKeysValue() {
            return [
                NvsBasicTranslateService.getTranslateKeyValue('day_short2_sunday'),
                NvsBasicTranslateService.getTranslateKeyValue('day_short2_monday'),
                NvsBasicTranslateService.getTranslateKeyValue('day_short2_tuesday'),
                NvsBasicTranslateService.getTranslateKeyValue('day_short2_wednesday'),
                NvsBasicTranslateService.getTranslateKeyValue('day_short2_friday'),
                NvsBasicTranslateService.getTranslateKeyValue('day_short2_thursday'),
                NvsBasicTranslateService.getTranslateKeyValue('day_short2_saturday'),
            ];
        };


        function getMonthsKeysValue() {
            return [
                NvsBasicTranslateService.getTranslateKeyValue('month_full_january'),
                NvsBasicTranslateService.getTranslateKeyValue('month_full_february'),
                NvsBasicTranslateService.getTranslateKeyValue('month_full_march'),
                NvsBasicTranslateService.getTranslateKeyValue('month_full_april'),
                NvsBasicTranslateService.getTranslateKeyValue('month_full_may'),
                NvsBasicTranslateService.getTranslateKeyValue('month_full_june'),
                NvsBasicTranslateService.getTranslateKeyValue('month_full_july'),
                NvsBasicTranslateService.getTranslateKeyValue('month_full_august'),
                NvsBasicTranslateService.getTranslateKeyValue('month_full_september'),
                NvsBasicTranslateService.getTranslateKeyValue('month_full_october'),
                NvsBasicTranslateService.getTranslateKeyValue('month_full_november'),
                NvsBasicTranslateService.getTranslateKeyValue('month_full_december')
            ];
        };


        function getLocaleSettingsKeysValue() {
            return {
                applyClass: 'btn-green',
                applyLabel: NvsBasicTranslateService.getTranslateKeyValue('apply'),
                fromLabel: NvsBasicTranslateService.getTranslateKeyValue('from'),
                format: localeSettings.dateFormat,
                toLabel: NvsBasicTranslateService.getTranslateKeyValue('to'),
                cancelLabel: NvsBasicTranslateService.getTranslateKeyValue('cancel'),
                customRangeLabel: NvsBasicTranslateService.getTranslateKeyValue('custom_range'),
                opens: 'center',
                weekLabel: 'W',
                daysOfWeek: [],
                monthNames: [],
                firstDay: localeSettings.dayOfWeek
            };

        };

        function setDateRangeInitialDateValue() {
            if (setInitialDate) {
                return;
            }
            var requirementSetting = DateRequirementSettingService.getDateSetting();
            var dateTimeValue = {
                startDate: moment().startOf('date').subtract(1, 'week').tz(requirementSetting.timezone),
                endDate: moment().endOf('date').tz(requirementSetting.timezone)
            };

            UtilsService.removeAndMerge(dateRangeDateInitialValue, dateTimeValue);
            setInitialDate = true;
        };

        function setAndGetDateRangeDateValue(dateTime) {

            var requirementSetting = DateRequirementSettingService.getDateSetting();
            return {
                startDate: moment(dateTime.startDate).tz(requirementSetting.timezone),
                endDate: moment(dateTime.endDate).tz(requirementSetting.timezone)
            };

        };

        return serviceObj;

    }
})();


/**
 * Created by Emre on 16.06.2017.
 */

(function () {
    'use strict';
    angular
        .module('novusTerminal')
        .filter('provider', function () {
            return function (games, criteria) {
                var output = [];
                _.forEach(games, function (game) {
                    _.forEach(game.tags, function (tag) {
                        if (tag === criteria) {
                            output.push(game);
                        }
                    })
                });
                return output;
            }
        })
        .controller('CasinoCtrl', ControllerFn);


    ControllerFn.$inject = ['PopupComponentService', 'UserService', '$scope', 'CasinoService', '$state', '$uibModal', 'NotifyingService', 'ApiService', '$window', 'providerFilter', '$sce', 'CasinoModelService', 'CasinoModelGameService', 'CasinoModelPlayService', 'CasinoModelFavouiriteService'];

    function ControllerFn(PopupComponentService, UserService, $scope, CasinoService, $state, $uibModal, NotifyingService, ApiService, $window, providerFilter, $sce, CasinoModelService, CasinoModelGameService, CasinoModelPlayService, CasinoModelFavouiriteService) {
        var vm = this;
        vm.gameMenu = [];
        vm.gameData = [];
        vm.providersData = [];
        vm.showprovider = 'select_providers';
        vm.is_favourite = 0;

        vm.openCloseCasinoMenu = openCloseCasinoFunction;

        vm.onOff=true;
        function openCloseCasinoFunction() {
            if(vm.onOff){
                angular.element(document.querySelector('#casino-sidebar-area')).addClass('open-menu');
                vm.onOff=false;
            }else {
                angular.element(document.querySelector('#casino-sidebar-area')).removeClass('open-menu');
                vm.onOff=true;
            }

        }
        vm.casinoGameMenu = casinoGameMenuFunction();
        vm.userBalanceData = UserService.getUserBalanceData();
        if (vm.userBalanceData.casino_balance == 0) {
            PopupComponentService.openWallet();
        }

        function casinoGameMenuFunction() {

            CasinoModelGameService.post({platform: 'terminal'}).then(function (res) {
                vm.gameMenu = res.data.menu;
                vm.gameData = res.data.games;
                vm.orginalData = res.data.games;
                vm.filteredGameData = res.data.games;
                vm.providersData = res.data.filters.providers;
            });

        }

        vm.selectCasinoGameFunction = function (tags) {
            CasinoModelService.post({platform: 'terminal', tags: tags}).then(function (res) {

                vm.gameData = res.data.list;
                vm.filteredGameData = res.data.list;


            });

        }

        vm.showFavorite = function () {
            vm.favoriGameList = [];
            vm.nonfavoriteGameList = [];

            if (vm.is_favourite == 0) {
                _.forEach(vm.filteredGameData, function (item) {
                    if (item.is_favourite == 1) {
                        vm.favoriGameList.push(item);
                    }
                })
                vm.is_favourite = 1;
                vm.filteredGameData = vm.favoriGameList;
            } else {
                _.forEach(vm.orginalData, function (item) {
                    if (item.is_favourite == 0) {
                        vm.nonfavoriteGameList.push(item);
                    }
                })
                vm.is_favourite = 0;
                vm.filteredGameData = vm.nonfavoriteGameList;
            }
        }

        vm.filterProviderFunction = function (provider) {

            vm.showprovider = provider.name;
            vm.filteredGameData = providerFilter(vm.gameData, provider.name);

        }

        vm.openSelectGame = function (id) {
            if (vm.userBalanceData.casino_balance == 0) {
                PopupComponentService.openWallet();
            }
            else {
                vm.fullScreen();
                vm.selectGameData = '';
                vm.selectGameName = '';
                angular.element(document.querySelector('#myModalGame')).modal();
                CasinoModelPlayService.one(id).post().then(function (res) {

                    vm.gamePlayUrl = res.data.game.url;
                    vm.selectGameData = $sce.trustAsResourceUrl(res.data.game.url);

                    if (vm.gamePlayUrl.search('https') < 0) {
                        vm.selectGameData = '';
                    }
                    vm.selectGameName = res.data.game.name;

                })
            }
        };
        vm.onOffFavourite = function (game) {
            CasinoModelFavouiriteService.post({
                action: !game.is_favourite, game_id: game.id
            }).then(function () {
                game.is_favourite = !game.is_favourite;
            });
        };

        vm.fullScreen = function () {

            angular.element(document.querySelector('#mdialogFull')).addClass('modal-full');
            angular.element(document.querySelector('#mcontentFull')).addClass('content-full');
            angular.element(document.querySelector('#iframeGame')).addClass('frameFull');
            angular.element(document.querySelector('#myModalGame')).addClass('fullScrollNone');
            vm.onOffScreen = 1;

        }
        vm.normalScreen = function () {

            angular.element(document.querySelector('#mdialogFull')).removeClass('modal-full');
            angular.element(document.querySelector('#mcontentFull')).removeClass('content-full');
            angular.element(document.querySelector('#iframeGame')).removeClass('frameFull');
            angular.element(document.querySelector('#myModalGame')).removeClass('fullScrollNone');
            vm.onOffScreen = 0;

        }
        vm.close = function () {
            angular.element(document.querySelector('#mdialogFull')).removeClass('modal-full');
            angular.element(document.querySelector('#mcontentFull')).removeClass('content-full');
            angular.element(document.querySelector('#iframeGame')).removeClass('frameFull');
            angular.element(document.querySelector('#myModalGame')).removeClass('fullScrollNone');
            vm.selectGameData = '';
        }

        // scroll control ///
        var scrollStatus = 0;
        vm.topScroll = upScrollFn;
        vm.bottomScroll = bottomScrollFn;

        function upScrollFn() {

            var element = $('#casino-game-container')[0];

            var odsScrollHeight = element.scrollHeight;
            scrollStatus = element.scrollTop;

            if(scrollStatus >= 0 && odsScrollHeight >= scrollStatus ){
                scrollStatus -=  415;

            }else {
                scrollStatus = 0;
            }

            element.scrollTop=scrollStatus;

        }

        function bottomScrollFn() {

            var element = $('#casino-game-container')[0];

            var odsScrollHeight = element.scrollHeight;
            scrollStatus = element.scrollTop;

            if(scrollStatus >= 0 && odsScrollHeight >= scrollStatus ){
                scrollStatus +=  415;

            }else {
                scrollStatus = 0;
            }

            element.scrollTop=scrollStatus;

        }
        // scroll control ///
    }
})();
/**
 * Created by unal on 6/23/2017.
 */

(function () {

      angular
              .module('novusTerminal')
              .controller('InitCtrl', MainController);

      /** @ngInject */
      MainController.$inject = [
            '$scope',
            'NotifyingService',
            'languageService'
      ];
      function MainController($scope, NotifyingService, languageService) {
            var vm = this;
            vm.show = false;
            vm.selectedLanguage = languageService.getSelectedLanguage();
            NotifyingService.subscribe($scope, 'terminal-system:ready', function () {
                  vm.show = true;
            });


      }
})();

(function () {
	'use strict';

	angular
		.module('novusTerminal')
		.run(runBlock);

	/** @ngInject */
	function runBlock(InitService, $rootScope,
				LiveService, UserService, AuthorizationService, $state,LeftMenuService) {

		var _scope = $rootScope;
		var getQueryString = function (field, url) {
			var href = url ? url : window.location.href;
			var reg = new RegExp('[?&]' + field + '=([^&#]*)', 'i');
			var string = reg.exec(href);
			return string ? string[1] : null;
		};

		InitService.setTerminalRequestToken(getQueryString('mtoken'));
		AuthorizationService.loadAuth();
		InitService.loadInit();

		var user = UserService.getUser();

		_scope.$on("$stateChangeStart", function (event, toState, toParams, fromState, fromParams) {

			/**
			 *control authenticate and isLoginRequired
			 */

			if (AuthorizationService.checkRoutePermissions(toState)) {
				redirectNewUrl();
				return;
			}


			/**
			 *close menu when change route
			 */
			LeftMenuService.setMenuSettings({
				menuDisplay: false,
				menuButton: false
			});

			/**
			 *this control for virtual game iframe
			 */
			var virtualStatus = null;

			if (_.isEqual(toState.name, 'virtualGame')) {
				virtualStatus = true;
			} else {
				virtualStatus = false;
			}

			//VirtualGameService.setVirtualGameDisplayStatus(virtualStatus);

			/**
			 *live check run control
			 */

			var liveCheckStatus = null;

			if (_.isEqual(toState.name, 'live')) {
				liveCheckStatus = true;
			} else {
				liveCheckStatus = false;
			}

			LiveService.setRunLiveCheckStatus(liveCheckStatus);

			// if (_.isEqual(toState.name, 'firebase') || _.isEqual(toState.name, 'ngReact') || _.isEqual(toState.name, 'live') || _.isEqual(toState.name, 'ngReactFirebase')) {
			// 	firebase.database().goOnline();
			// } else {
			// 	firebase.database().goOffline();
            //
			// }


			function redirectNewUrl() {

				event.preventDefault();

				/**
				 *for write url to browser after
				 * browser refresh page fromState was be null
				 * and this point we need to redirect url to main
				 */
				if (_.isEmpty(fromState.name)) {
					$state.go('sport')
				}

			}

		});
	}

})();

(function () {
    'use strict';

    angular.module('novusTerminal').config(routerConfig);

    /** @ngInject */
    function routerConfig($stateProvider, $urlRouterProvider) {
        $stateProvider.state('main', {
            url: '/',
            templateUrl: 'app/main/main.html',
            controller: 'MainController',
            controllerAs: 'vmMainController'
        }).state('sport', {
            url: '/sports',
            templateUrl: 'app/sport/sport-manager.html',
            controller: 'SportManagerCtrl',
            controllerAs: 'vmManagerController'
        }).state('mixedView', {
            url: '/live',
            templateUrl: 'app/live/live-manager.html',
            controller: 'LiveManagerCtrl',
            controllerAs: 'vmLiveManagerCtrl'
        }).state('eventView', {
            url: '/event-view/:sportId/:eventId',
            templateUrl: 'app/live/eventView/event-view.html',
            controller: 'EventViewCtrl',
            controllerAs: 'vmEventViewCtrl'
        }).state('virtuals', {
            url: '/virtual',
            templateUrl: 'app/virtual/virtual.html',
            controller: 'VirtualCtrl',
            controllerAs: 'virtualsCtrl',
            isLoginRequired: true
        }).state('casino', {
            url: '/casino',
            templateUrl: 'app/casino/casino.html',
            controller: 'CasinoCtrl',
            controllerAs: 'vmCasinoCtrl',
            authenticate: 'casino',
            isLoginRequired: true

        }).state('LiveCasino', {
            url: '/live_casino',
            templateUrl: 'app/liveCasino/live_casino.html',
            controller: 'LiveCasinoCtrl',
            controllerAs: 'vmLiveCasinoCtrl',
            authenticate: 'live_casino',
            isLoginRequired: true
        }).state('profile', {
            abstract: true,
            url: '/profile',
            templateUrl: 'app/profile/profile.html',
            controller: 'ProfileCtrl',
            controllerAs: 'vmProfileCtrl',
            authenticate: 'profile',
            isLoginRequired: true

        }).state('betHistory', {
            parent: 'profile',
            url: '/bet-history',
            templateUrl: 'app/profile/betHistory/bet-history-manager.html',
            controller: 'BetHistoryManagerCtrl',
            controllerAs: 'vmBetHistoryManagerCtrl',
            authenticate: 'betHistory',
            isLoginRequired: true
        }).state('betHistoryDetail', {
            parent: 'profile',
            url: '/bet-history-detail/:ticketCode',
            templateUrl: 'app/profile/betHistory/betHistoryDetail/bet-history-detail.html',
            controller: 'BetHistoryDetailCtrl',
            controllerAs: 'vmBetHistoryDetailCtrl',
            isLoginRequired: true
        }).state('sessions', {
            parent: 'profile',
            url: '/sessions',
            templateUrl: 'app/profile/sessions/sessions.html',
            controller: 'SessionsCtrl',
            controllerAs: 'vmSessionsCtrl',
            authenticate: 'sessions',
            isLoginRequired: true

        })
        // 	.state('personalDetail', {
        // 	parent: 'profile',
        // 	url: '/personal-detail',
        // 	templateUrl: 'app/profile/personalDetails/personal-details.html',
        // 	controller: 'PersonalDetailsCtrl',
        // 	controllerAs: 'vmPersonalDetailsCtrl',
        // 	authenticate: 'personalDetails',
        // 	isLoginRequired: true
        //
        // })
            .state('transactionHistory', {
                parent: 'profile',
                url: '/transactions',
                templateUrl: 'app/profile/transactions/transactions-manager.html',
                controller: 'TransactionsManagerCtrl',
                controllerAs: 'vmTransactionsManagerCtrl',
                authenticate: 'transactionHistory',
                isLoginRequired: true
            }).state('transactionsDetail', {
            parent: 'profile',
            url: '/transaction-detail/:transactionId',
            templateUrl: 'app/profile/transactions/directives/transactionDetail/transactionDetail.html',
            controller: 'transactionsDetail',
            controllerAs: 'vmTransactionsDetailCtrl'
        }).state('moneyDeposit', {
            parent: 'profile',
            url: '/money/money-deposit',
            templateUrl: 'app/profile/money/money-deposit-manager.html',
            controller: 'MoneyDepositManagerCtrl',
            controllerAs: 'VmMoneyDepositManager',
            authenticate: 'moneyDeposit',
            isLoginRequired: true
        }).state('moneyWithdraw', {
            parent: 'profile',
            url: '/money/money-withdraw',
            templateUrl: 'app/profile/money/withdraw/money-withdraw-manager.html',
            controller: 'MoneywithdrawManagerCtrl',
            controllerAs: 'VmMoneywithdrawManager',
            authenticate: 'transactionHistory',
            isLoginRequired: true
        }).state('deposit', {
            parent: 'profile',
            url: '/voucher/deposit',
            templateUrl: 'app/profile/money/voucher/voucher-manager.html',
            controller: 'VoucherManagerCtrl',
            controllerAs: 'vmVoucherManagerCtrl',
            authenticate: 'voucherDeposit',
            isLoginRequired: true
        }).state('withdraw', {
            parent: 'profile',
            url: '/voucher/withdraw',
            templateUrl: 'app/profile/money/voucher/voucher-manager.html',
            controller: 'VoucherManagerCtrl',
            controllerAs: 'vmVoucherManagerCtrl',
            authenticate: 'voucherWithdraw',
            isLoginRequired: true
        }).state('printManager', {
            url: '/print-manager/:whatToPrint/:printViewData/:previousState',
            templateUrl: 'app/printManager/print-manager.html',
            controller: 'printManagerCtrl',
            controllerAs: 'vmPrintManager'
        });

        $urlRouterProvider.otherwise('/');
    }

})();


/* global malarkey:false, moment:false */
(function () {
      'use strict';

      angular
          .module('novusTerminal')
          .constant('dateRangeConfig', {
                dateRangeOptions: {
                      locale: {
                            applyClass: 'btn-green',
                            applyLabel: 'Apply',
                            fromLabel: 'From',
                            format: 'MMM D, YYYY HH:mm',
                            toLabel: 'To',
                            cancelLabel: 'Cancel',
                            customRangeLabel: 'Custom range',
                            opens: 'center',
                            weekLabel: 'W',
                            daysOfWeek: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
                            monthNames: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
                            firstDay: 1
                      },
                      showDropdowns: true,
                      showWeekNumbers: false,
                      showISOWeekNumbers: false,
                      autoApply: true,
                      alwaysShowCalendars: true
                }
          });

})();

/**
 * Created by noneo on 9/17/2017.
 */
(function () {
    'use strict';
    angular.module('novusTerminal').constant('nvsConstant', {
        ticketBarcodeUnique: 'A',
        ticketQrCodeUnique: '{T}',
        voucherBarcodeUnique: 'O',
        voucherQrCodeUnique: '{@}'
    });
})();

(function () {
      'use strict';

      angular
              .module('novusTerminal')
              .config(config);

      /** @ngInject */
      function config($logProvider, toastrConfig, RestangularProvider, $httpProvider, VKI_CONFIG) {



          // Vitrual keyboard -- genel ayarlar
          VKI_CONFIG.relative = false;
          VKI_CONFIG.showVersion = false;
          VKI_CONFIG.deadkeysOn = false;
          VKI_CONFIG.deadBox = false;
          VKI_CONFIG.dead = false;// Show the dead keys checkbox
          VKI_CONFIG.numberPad = true;  // Allow user to open and close the number pad
          VKI_CONFIG.numberPadOn = true;  // Show number pad by default
          VKI_CONFIG.kts = VKI_CONFIG.kt = "en-US";  // Default keyboard layout
          VKI_CONFIG.langAdapt = true;  // Use lang attribute of input to select keyboard
          VKI_CONFIG.size = 4;  // Default keyboard size (1-5)
          VKI_CONFIG.sizeAdj = true;  // Allow user to adjust keyboard size
          VKI_CONFIG.clearPasswords = false;  // Clear password fields on focus
          VKI_CONFIG.activeTab = 0;  // Tab moves to next: 1 = element, 2 = keyboard enabled element
          VKI_CONFIG.enterSubmit = true;  // Submit forms when Enter is pressed


          /* CHANGE TEXT LANGUAGE */
          // VKI_CONFIG.i18n = {
          // 	'00': "Exibir teclado numérico",
          // 	'01': "Exibir teclado virtual",
          // 	'02': "Selecionar layout do teclado",
          // 	'03': "Teclas mortas",
          // 	'04': "Ligado",
          // 	'05': "Desligado",
          // 	'06': "Fechar teclado",
          // 	'07': "Limpar",
          // 	'08': "Limpar campo",
          // 	'09': "Versão",
          // 	'10': "Diminuir tamanho do teclado",
          // 	'11': "Aumentar tamanho do teclado"
          // };


          // portekizce klavye düzeni

          VKI_CONFIG.layout['pt-PT'] = {
              'name': "Portuguese (Brazil)", 'keys': [
                  [["'", '"'], ["1", "!", "\u00b9"], ["2", "@", "\u00b2"], ["3", "#", "\u00b3"], ["4", "$", "\u00a3"], ["5", "%", "\u00a2"], ["6", "\u00a8", "\u00ac"], ["7", "&"], ["8", "*"], ["9", "("], ["0", ")"], ["-", "_"], ["=", "+", "\u00a7"], ["Bksp", "Bksp"]],
                  [["Tab", "Tab"], ["q", "Q", "/"], ["w", "W", "?"], ["e", "E", "\u20ac"], ["r", "R"], ["t", "T"], ["y", "Y"], ["u", "U"], ["i", "I"], ["o", "O"], ["p", "P"], ["\u00b4", "`"], ["[", "{", "\u00aa"], ["Enter", "Enter"]],
                  [["Caps", "Caps"], ["a", "A"], ["s", "S"], ["d", "D"], ["f", "F"], ["g", "G"], ["h", "H"], ["j", "J"], ["k", "K"], ["l", "L"], ["\u00e7", "\u00c7"], ["~", "^"], ["]", "}", "\u00ba"], ["/", "?"]],
                  [["Shift", "Shift"], ["\\", "|"], ["z", "Z"], ["x", "X"], ["c", "C", "\u20a2"], ["v", "V"], ["b", "B"], ["n", "N"], ["m", "M"], [",", "<"], [".", ">"], [":", ":"], ["Shift", "Shift"]],
                  [[" ", " ", " ", " "], ["AltGr", "AltGr"]]
              ], 'lang': ["pt-BR"] };

            // arapça klavye düzeni

          VKI_CONFIG.layout['ar-AR'] = {
              'name': "Arabic", 'keys': [
                  [["\u0630", "\u0651 "], ["1", "!", "\u00a1", "\u00b9"], ["2", "@", "\u00b2"], ["3", "#", "\u00b3"], ["4", "$", "\u00a4", "\u00a3"], ["5", "%", "\u20ac"], ["6", "^", "\u00bc"], ["7", "&", "\u00bd"], ["8", "*", "\u00be"], ["9", "(", "\u2018"], ["0", ")", "\u2019"], ["-", "_", "\u00a5"], ["=", "+", "\u00d7", "\u00f7"], ["Bksp", "Bksp"]],
                  [["Tab", "Tab"], ["\u0636", "\u064e"], ["\u0635", "\u064b"], ["\u062b", "\u064f"], ["\u0642", "\u064c"], ["\u0641", "\u0644"], ["\u063a", "\u0625"], ["\u0639", "\u2018"], ["\u0647", "\u00f7"], ["\u062e", "\u00d7"], ["\u062d", "\u061b"], ["\u062c", "<"], ["\u062f", ">"], ["\\", "|"]],
                  [["Caps", "Caps"], ["\u0634", "\u0650"], ["\u0633", "\u064d"], ["\u064a", "]"], ["\u0628", "["], ["\u0644", "\u0644"], ["\u0627", "\u0623"], ["\u062a", "\u0640"], ["\u0646", "\u060c"], ["\u0645", "/"], ["\u0643", ":"], ["\u0637", '"'], ["Enter", "Enter"]],
                  [["Shift", "Shift"], ["\u0626", "~"], ["\u0621", "\u0652"], ["\u0624", "}"], ["\u0631", "{"], ["\u0644", "\u0644"], ["\u0649", "\u0622"], ["\u0629", "\u2019"], ["\u0648", ","], ["\u0632", "."], ["\u0638", "\u061f"], ["Shift", "Shift"]],
                  [[" ", " ", " ", " "], ["Alt", "Alt"]]
              ], 'lang': ["ar"] };

          // almanca klavye düzeni

          VKI_CONFIG.layout['Deutsch'] = {
              'name': "German", 'keys': [
                  [["^", "\u00b0"], ["1", "!"], ["2", '"', "\u00b2"], ["3", "\u00a7", "\u00b3"], ["4", "$"], ["5", "%"], ["6", "&"], ["7", "/", "{"], ["8", "(", "["], ["9", ")", "]"], ["0", "=", "}"], ["\u00df", "?", "\\"], ["\u00b4", "`"], ["Bksp", "Bksp"]],
                  [["Tab", "Tab"], ["q", "Q", "@"], ["w", "W"], ["e", "E", "\u20ac"], ["r", "R"], ["t", "T"], ["z", "Z"], ["u", "U"], ["i", "I"], ["o", "O"], ["p", "P"], ["\u00fc", "\u00dc"], ["+", "*", "~"], ["#", "'"]],
                  [["Caps", "Caps"], ["a", "A"], ["s", "S"], ["d", "D"], ["f", "F"], ["g", "G"], ["h", "H"], ["j", "J"], ["k", "K"], ["l", "L"], ["\u00f6", "\u00d6"], ["\u00e4", "\u00c4"], ["Enter", "Enter"]],
                  [["Shift", "Shift"], ["<", ">", "\u00a6"], ["y", "Y"], ["x", "X"], ["c", "C"], ["v", "V"], ["b", "B"], ["n", "N"], ["m", "M", "\u00b5"], [",", ";"], [".", ":"], ["-", "_"], ["Shift", "Shift"]],
                  [[" ", " ", " ", " "], ["AltGr", "AltGr"]]
              ], 'lang': ["de"] };

          // rusça klavye düzeni

          VKI_CONFIG.layout['ru-RU'] = {
              'name': "Russian", 'keys': [
                  [["\u0451", "\u0401"], ["1", "!"], ["2", '"'], ["3", "\u2116"], ["4", ";"], ["5", "%"], ["6", ":"], ["7", "?"], ["8", "*"], ["9", "("], ["0", ")"], ["-", "_"], ["=", "+"], ["Bksp", "Bksp"]],
                  [["Tab", "Tab"], ["\u0439", "\u0419"], ["\u0446", "\u0426"], ["\u0443", "\u0423"], ["\u043A", "\u041A"], ["\u0435", "\u0415"], ["\u043D", "\u041D"], ["\u0433", "\u0413"], ["\u0448", "\u0428"], ["\u0449", "\u0429"], ["\u0437", "\u0417"], ["\u0445", "\u0425"], ["\u044A", "\u042A"], ["\\", "/"]],
                  [["Caps", "Caps"], ["\u0444", "\u0424"], ["\u044B", "\u042B"], ["\u0432", "\u0412"], ["\u0430", "\u0410"], ["\u043F", "\u041F"], ["\u0440", "\u0420"], ["\u043E", "\u041E"], ["\u043B", "\u041B"], ["\u0434", "\u0414"], ["\u0436", "\u0416"], ["\u044D", "\u042D"], ["Enter", "Enter"]],
                  [["Shift", "Shift"], ["/", "|"], ["\u044F", "\u042F"], ["\u0447", "\u0427"], ["\u0441", "\u0421"], ["\u043C", "\u041C"], ["\u0438", "\u0418"], ["\u0442", "\u0422"], ["\u044C", "\u042C"], ["\u0431", "\u0411"], ["\u044E", "\u042E"], [".", ","], ["Shift", "Shift"]],
                  [[" ", " "]]
              ], 'lang': ["ru"] };

          //  ispanyolca klavye düzeni

          VKI_CONFIG.layout['es-ES'] = {
              'name': "Spanish", 'keys': [
                  [["\u00ba", "\u00aa", "\\"], ["1", "!", "|"], ["2", '"', "@"], ["3", "'", "#"], ["4", "$", "~"], ["5", "%", "\u20ac"], ["6", "&", "\u00ac"], ["7", "/"], ["8", "("], ["9", ")"], ["0", "="], ["'", "?"], ["\u00a1", "\u00bf"], ["Bksp", "Bksp"]],
                  [["Tab", "Tab"], ["q", "Q"], ["w", "W"], ["e", "E"], ["r", "R"], ["t", "T"], ["y", "Y"], ["u", "U"], ["i", "I"], ["o", "O"], ["p", "P"], ["`", "^", "["], ["+", "*", "]"], ["\u00e7", "\u00c7", "}"]],
                  [["Caps", "Caps"], ["a", "A"], ["s", "S"], ["d", "D"], ["f", "F"], ["g", "G"], ["h", "H"], ["j", "J"], ["k", "K"], ["l", "L"], ["\u00f1", "\u00d1"], ["\u00b4", "\u00a8", "{"], ["Enter", "Enter"]],
                  [["Shift", "Shift"], ["<", ">"], ["z", "Z"], ["x", "X"], ["c", "C"], ["v", "V"], ["b", "B"], ["n", "N"], ["m", "M"], [",", ";"], [".", ":"], ["-", "_"], ["Shift", "Shift"]],
                  [[" ", " ", " ", " "], ["AltGr", "AltGr"]]
              ], 'lang': ["es"] };

          //  türkçe q klavye düzeni

          VKI_CONFIG.layout['tr-TR'] = {
              'name': "Turkish Q", 'keys': [
                  [['"', "\u00e9", "<"], ["1", "!", ">"], ["2", "'", "\u00a3"], ["3", "^", "#"], ["4", "+", "$"], ["5", "%", "\u00bd"], ["6", "&"], ["7", "/", "{"], ["8", "(", '['], ["9", ")", ']'], ["0", "=", "}"], ["*", "?", "\\"], ["-", "_", "|"], ["Bksp", "Bksp"]],
                  [["Tab", "Tab"], ["q", "Q", "@"], ["w", "W"], ["e", "E", "\u20ac"], ["r", "R"], ["t", "T"], ["y", "Y"], ["u", "U"], ["\u0131", "I", "i", "\u0130"], ["o", "O"], ["p", "P"], ["\u011f", "\u011e", "\u00a8"], ["\u00fc", "\u00dc", "~"], [",", ";", "`"]],
                  [["Caps", "Caps"], ["a", "A", "\u00e6", "\u00c6"], ["s", "S", "\u00df"], ["d", "D"], ["f", "F"], ["g", "G"], ["h", "H"], ["j", "J"], ["k", "K"], ["l", "L"], ["\u015f", "\u015e", "\u00b4"], ["i", "\u0130"], ["Enter", "Enter"]],
                  [["Shift", "Shift"], ["<", ">", "|"], ["z", "Z"], ["x", "X"], ["c", "C"], ["v", "V"], ["b", "B"], ["n", "N"], ["m", "M"], ["\u00f6", "\u00d6"], ["\u00e7", "\u00c7"], [".", ":"], ["Shift", "Shift"]],
                  [[" ", " ", " ", " "],  ["AltGr", "AltGr"]]
              ], 'lang': ["tr"] };

          //  ingilizce klavye düzeni

          VKI_CONFIG.layout['en-US'] = {
              'name': "US Standard", 'keys': [
                  [["`", "~"], ["1", "!"], ["2", "@"], ["3", "#"], ["4", "$"], ["5", "%"], ["6", "^"], ["7", "&"], ["8", "*"], ["9", "("], ["0", ")"], ["-", "_"], ["=", "+"], ["Bksp", "Bksp"]],
                  [["Tab", "Tab"], ["q", "Q"], ["w", "W"], ["e", "E"], ["r", "R"], ["t", "T"], ["y", "Y"], ["u", "U"], ["i", "I"], ["o", "O"], ["p", "P"], ["[", "{"], ["]", "}"], ["\\", "|"]],
                  [["Caps", "Caps"], ["a", "A"], ["s", "S"], ["d", "D"], ["f", "F"], ["g", "G"], ["h", "H"], ["j", "J"], ["k", "K"], ["l", "L"], [";", ":"], ["'", '"'], ["Enter", "Enter"]],
                  [["Shift", "Shift"], ["z", "Z"], ["x", "X"], ["c", "C"], ["v", "V"], ["b", "B"], ["n", "N"], ["m", "M"], [",", "<"], [".", ">"], ["/", "?"], ["Shift", "Shift"]],
                  [[" ", " "]]
              ], 'lang': ["en-us"] };

          //  çince klavye düzeni

          VKI_CONFIG.layout['zh-CN'] = {
              'name': "Chinese Bopomofo IME", 'keys': [
                  [["\u20AC", "~"], ["\u3105", "!"], ["\u3109", "@"], ["\u02C7", "#"], ["\u02CB", "$"], ["\u3113", "%"], ["\u02CA", "^"], ["\u02D9", "&"], ["\u311A", "*"], ["\u311E", ")"], ["\u3122", "("], ["\u3126", "_"], ["=", "+"], ["Bksp", "Bksp"]],
                  [["Tab", "Tab"], ["\u3106", "q"], ["\u310A", "w"], ["\u310D", "e"], ["\u3110", "r"], ["\u3114", "t"], ["\u3117", "y"], ["\u3127", "u"], ["\u311B", "i"], ["\u311F", "o"], ["\u3123", "p"], ["[", "{"], ["]", "}"], ["\\", "|"]],
                  [["Caps", "Caps"], ["\u3107", "a"], ["\u310B", "s"], ["\u310E", "d"], ["\u3111", "f"], ["\u3115", "g"], ["\u3118", "h"], ["\u3128", "j"], ["\u311C", "k"], ["\u3120", "l"], ["\u3124", ":"], ["'", '"'], ["Enter", "Enter"]],
                  [["Shift", "Shift"], ["\u3108", "z"], ["\u310C", "x"], ["\u310F", "c"], ["\u3112", "v"], ["\u3116", "b"], ["\u3119", "n"], ["\u3129", "m"], ["\u311D", "<"], ["\u3121", ">"], ["\u3125", "?"], ["Shift", "Shift"]],
                  [[" ", " "]]
              ], 'lang': ["zh-Bopo"] };

          VKI_CONFIG.layout['\u4e2d\u6587\u4ed3\u9889\u8f93\u5165\u6cd5'] = {
              'name': "Chinese Cangjie IME", 'keys': [
                  [["\u20AC", "~"], ["1", "!"], ["2", "@"], ["3", "#"], ["4", "$"], ["5", "%"], ["6", "^"], ["7", "&"], ["8", "*"], ["9", ")"], ["0", "("], ["-", "_"], ["=", "+"], ["Bksp", "Bksp"]],
                  [["Tab", "Tab"], ["\u624B", "q"], ["\u7530", "w"], ["\u6C34", "e"], ["\u53E3", "r"], ["\u5EFF", "t"], ["\u535C", "y"], ["\u5C71", "u"], ["\u6208", "i"], ["\u4EBA", "o"], ["\u5FC3", "p"], ["[", "{"], ["]", "}"], ["\\", "|"]],
                  [["Caps", "Caps"], ["\u65E5", "a"], ["\u5C38", "s"], ["\u6728", "d"], ["\u706B", "f"], ["\u571F", "g"], ["\u7AF9", "h"], ["\u5341", "j"], ["\u5927", "k"], ["\u4E2D", "l"], [";", ":"], ["'", '"'], ["Enter", "Enter"]],
                  [["Shift", "Shift"], ["\uFF3A", "z"], ["\u96E3", "x"], ["\u91D1", "c"], ["\u5973", "v"], ["\u6708", "b"], ["\u5F13", "n"], ["\u4E00", "m"], [",", "<"], [".", ">"], ["/", "?"], ["Shift", "Shift"]],
                  [[" ", " "]]
              ], 'lang': ["zh"] };

          // numerik klavye düzeni
          VKI_CONFIG.layout.Numerico = {
              'name': "Numerik", 'keys': [
                  [["1", '1'], ["2", "2"], ["3", "3"], ["Bksp", "Bksp"]],
                  [["4", "4"], ["5", "5"], ["6", '6'], ["Enter", "Enter"]],
                  [["7", "7"], ["8", "8"], ["9", "9"], []],
                  [["0", "0"], ["-"], ["+"], [","]]
              ], 'lang': ["pt-BR-num"] };

          // Vitrual keyboard

            // Enable log
            $logProvider.debugEnabled(true);

            $httpProvider.interceptors.push('ApiInterceptorService');

            RestangularProvider.setDefaultHeaders({'Content-Type': 'text/plain'});

            /**
             *set-cookie send request headers
             */
            RestangularProvider.setDefaultHttpFields({
                  withCredentials: true
            });

            /**
             *
             * toastr config setting
             */
            toastrConfig.allowHtml = true;
            toastrConfig.timeOut = 6000;
            toastrConfig.positionClass = 'toast-top-right';
            toastrConfig.progressBar = true;

      }

})();

/**
 * Created by unal on 22.05.2017.
 */



(function () {

	angular
		.module('novusTerminal')
		.factory('ApiService', ServiceFn);

	ServiceFn.$inject = ['Restangular','$http','$cookies','$interval','$location'];

	function ServiceFn(Restangular, $http, $cookies,$interval,$location) {

		var selectApi = ['.rioapostas.com','-mybetarena.novusbet.net','.desktop.dev.betnovus.tech', '-terminal.novusbet.net', '-mybetarena.novusbet.net', '.mybetarena.com'];


		var apiUrl = '';

		var _location = window.location;
        this.languageId = 1 || null;


		var serviceObj = {
			serviceOne: function () {

				setApiURL();

				return Restangular.withConfig(function (RestangularConfigurer) {

					RestangularConfigurer.setBaseUrl(apiUrl + "/api/v1/");

				});
			},
			serviceTwo: function () {

				setApiURL();

				return Restangular.withConfig(function (RestangularConfigurer) {

					RestangularConfigurer.setBaseUrl(apiUrl + ":8080/api/v2");

				});
			},


            setLanguageId : function (languageId) {
            this.languageId = languageId;
        }



    };

        var getQueryString = function (field, url) {
            var href = url || window.location.href;
            var reg = new RegExp('[?&]' + field + '=([^&#]*)', 'i');
            var string = reg.exec(href);
            return string ? string[1] : null;
        };

		function setApiURL() {

			var hostName = _location.hostname;
			var protocol = _location.protocol + '//';
			/**
			 *for local set api url
			 */
            // if (hostName.indexOf('terminal') === 0) {
            if (getQueryString('cashier') !== null) {
                apiUrl = decodeURIComponent(getQueryString('cashier'));
                var mtoken = decodeURIComponent(getQueryString('mtoken'));
                $cookies.put("cashier", apiUrl);
                $cookies.put("mtoken", mtoken);

            } else if (_.isEqual(hostName, 'localhost')) {
				var partOfApi = ['http://api', 'https://api'];
				apiUrl = partOfApi[1] + selectApi[1];
			}

            return apiUrl;
		}

        $interval(intervalPingFunction, 30000);
        function intervalPingFunction (){
            setApiURL();
            data = {
                auth : $cookies.get('NovusAuth'),
                platform :'terminal',
                language_id:$cookies.get('language_id'),
                ref :$location.url()
            };

            return $http.post(apiUrl + "/api/v1/machine-client/ping", data);

        };

        // Interval ping function
		return serviceObj;
	}

})();
angular.module("novusTerminal").run(["$templateCache", function($templateCache) {$templateCache.put("app/casino/casino.html","<div id=casino><div class=casino-title-area><div class=casino-title><div class=row><div class=\"col-md-7 col-md-offset-1\"><h2 ng-translate translate=slots></h2></div><div class=\"col-md-2 text-right\"><div class=btn-group><!--<button--><!--type=\"button\"--><!--id=\"comboBoxBtn\"--><!--class=\"btn  btn-lg dropdown-toggle btn-costom\"--><!--data-toggle=\"dropdown\"--><!--aria-haspopup=\"true\"--><!--aria-expanded=\"false\" translate=\"{{vmCasinoCtrl.showprovider}}\">--><!--{{vmCasinoCtrl.showprovider | translate}}--><!--<span class=\"caret\" style=\"margin-left:40px;\"></span>--><!--</button>--><!--<ul class=\"dropdown-menu\">--><!--<li ng-repeat=\"provider in vmCasinoCtrl.providersData\">--><!--<button  class=\"btn btn-success btn-md\" ng-click=\"vmCasinoCtrl.filterProviderFunction(provider)\">--><!--<i ng-class=\"provider.isChecked ? \'fa fa-check\' : \'\'\"></i>--><!--<label>{{provider.name}}</label>--><!--</button>--><!--</li>--><!--</ul>--></div></div><div class=col-md-2><!--<button class=\"btn  btn-lg btn-costom\"  type=\"button\" ng-click=\"vmCasinoCtrl.showFavorite()\">--><!--<span ng-class=\"vmCasinoCtrl.is_favourite == 1 ? \'fa fa-heart\' :\'fa fa-heart-o\'\" style=\"margin-right:10px;\"></span>  {{\'show_favorites_only\' | translate}}--><!--</button>--></div></div></div></div><div class=casino-content-area><div class=casino-sidebar-area id=casino-sidebar-area><div class=openMenuBtn><button class=\"btn btn-basic openClose-btn\" ng-click=vmCasinoCtrl.openCloseCasinoMenu()><i ng-class=\"vmCasinoCtrl.onOff ? \'fa fa-arrow-right\' :\'fa fa-arrow-left\'\" aria-hidden=true></i></button></div><div class=casino-search-form><label><input type=text ng-model=vmCasinoCtrl.gameSearch ng-placeholder placeholder=casino></label></div><div class=casino-menu><ul><li ng-repeat=\"menu in vmCasinoCtrl.gameMenu \"><button ng-click=vmCasinoCtrl.selectCasinoGameFunction(menu.tags) ng-translate translate={{menu.name}}><!--<span class=\"badge pull-right\">{{menu.game_count}}</span>--></button></li></ul></div></div><div class=casino-game-container><div id=casino-game-container><div id=casino-game-wrap><div class=casino-game ng-repeat=\"game in vmCasinoCtrl.filteredGameData |  filter:vmCasinoCtrl.gameSearch\"><div class=casino-game-inner><div class=casino-game-image><img ng-src={{game.image}} alt=\"\"><div class=casino-play-btn><button class=play-btn ng-click=vmCasinoCtrl.openSelectGame(game.id) ng-translate translate=play></button></div></div><div class=casino-description><h4 ng-bind=game.name></h4><div class=favorite-game><!--<button class=\"favorite-game-btn\" ng-click=\"vmCasinoCtrl.onOffFavourite(game)\" ng-checked=\"game.is_favourite\">--><!--&lt;!&ndash;<span class=\"is-fav\" ng-class=\"game.isFavourite ? \'is-fav\' : \'favorite\'\"></span>&ndash;&gt;--><!--<span ng-class=\"game.is_favourite ?  \'fa fa-heart\' : \'fa fa-heart-o\'\" class=\"fa fa-heart\"></span>--><!--</button>--></div></div></div></div></div></div><div class=casino-scroll-button-group><button ng-click=vmCasinoCtrl.topScroll()><i class=\"fa fa-caret-up\" aria-hidden=true></i></button> <button ng-click=vmCasinoCtrl.bottomScroll()><i class=\"fa fa-caret-down\" aria-hidden=true></i></button></div></div></div></div><!-- Modal --><div class=\"modal fade\" id=myModalGame role=dialog><div class=\"modal-dialog modal-lg modal-game\" id=mdialogFull><div class=\"modal-content modal-costom\" id=mcontentFull><div class=modal-header><button type=button class=close style=\"margin-left: 10px\" data-dismiss=modal ng-click=vmCasinoCtrl.close()><i class=\"fa fa-times\"></i></button> <button type=button class=\"close fullScreen\" style=\"margin-left: 10px\" ng-click=\"vmCasinoCtrl.onOffScreen==1? vmCasinoCtrl.normalScreen() :vmCasinoCtrl.fullScreen() \"><img width=21 ng-src=\"{{vmCasinoCtrl.onOffScreen==1? \'../assets/images/main-icon/icon.png\':\'../assets/images/main-icon/expand.png\'}}\"></button><!--<button type=\"button\" class=\"close\">--><!--<i ng-class=\"vmCasinoCtrl.is_favourite ?  \'fa fa-heart\' : \'fa fa-heart-o\'\"></i>--><!--</button>--><h4 class=modal-title>{{vmCasinoCtrl.selectGameName}}</h4></div><div class=modal-body><iframe id=iframeGame src={{vmCasinoCtrl.selectGameData}} class=frameScreen></iframe></div></div></div></div>");
$templateCache.put("app/casino/game.html","<!-- casino games modal--><div class=casino-games><div class=game><!--game-window--><div class=\"game-window clearfix\"><iframe ng-src={{playingGame.lobby}} frameborder=0 class=game-iframe id=game-iframe scrolling=no allowfullscreen></iframe></div></div></div>");
$templateCache.put("app/live/live-manager.html","<div id=live><div id=live-manager-content><div class=live-manager-container><data-apt-live-sport-nav-bar></data-apt-live-sport-nav-bar><apt-event-list></apt-event-list></div><div class=live-manager-right-sidebar><data-apt-right-side-bar></data-apt-right-side-bar></div></div></div>");
$templateCache.put("app/main/main.html","<div class=terminal-main-bg-overlay></div><div class=terminal-main-container></div><div class=terminal-main-flex-container><div class=terminal-main-left-area><div class=terminal-main-logo-container><a ui-sref=main class=main-logo-direct><img ng-src={{vmMainController.mainlogo}} alt=\"\"></a></div><div class=terminal-main-language-container><ul id=main-language-select><li data-ng-repeat=\"language in vmMainController.languages\"><a href=\"\" data-ng-click=vmMainController.changeLanguage(language) data-ng-class=\"{active:vmMainController.selectedLanguage.code==language.code}\"><span class=\"flag-icon flag-{{language.code}}\"></span></a></li></ul></div></div><div class=terminal-main-right-area><div class=terminal-main-button-group-container><div ng-if=!vmMainController.user.id class=terminal-main-login-join-btn-group style=\"width: 480px\"><button type=button class=terminal-main-join-btn data-ng-click=vmMainController.joinOn()><span class=main-join-btn-bg></span> <span ng-translate translate=register></span></button> <button type=button class=terminal-main-login-btn data-ng-click=vmMainController.logIn()><span class=main-login-btn-bg></span> <span ng-translate translate=sign_in></span></button> <a style=\"text-decoration: none\" ui-sref=sport ng-translate translate=sports></a> <a style=\"text-decoration: none\" ui-sref=mixedView ng-translate translate=live></a></div><div class=terminal-main-sport-live-btn-group ng-if=vmMainController.user.id ng-style=\"vmMainController.user.id ? {\'width\': \'230px\'} : null\"><a data-ng-repeat=\"item in vmMainController.mainMenuItems\" ui-sref={{item.route}} ng-translate translate={{item.name}}></a></div></div></div></div>");
$templateCache.put("app/nvsTicket/novus-ticket.html","<div class=sport-right-sidebar-header><div class=sport-right-sidebar-title><h3 ng-translate translate=betslip></h3></div></div><div class=sport-right-sidebar-content><nvs-loading-bar class=ticket-loader data-ng-show=vmNovusTicket.ticketShowSettings.loadingBar></nvs-loading-bar><!-- Ticket Show Event Content --><div class=ticket-show-events id=ticket-scroll style=\"{{vmNovusTicket.ticketShowStatusOptions.ticketCouponSaved==true? \'overflow-y:visible;\': \'\'}}\"><!-- Ticket Event List --><data-apt-ticket-events-list data-ng-if=vmNovusTicket.ticketShowStatusOptions></data-apt-ticket-events-list><!-- ./Ticket Event List --><!-- Ticket Show Combinations Content --><data-apt-ticket-event-combinations data-ng-show=\"vmNovusTicket.comboStatus && vmNovusTicket.ticketShowStatusOptions.ticketHasEvents\"></data-apt-ticket-event-combinations><!-- ./Ticket Show Combinations Content --><!-- scroll animation div --><div style=\"visibility: hidden; width: 100%\" id=scrollItem></div><!-- scroll animation div --></div><!--ticket checkout--><data-apt-ticket-checkout data-ng-if=vmNovusTicket.ticketShowStatusOptions.ticketPlaceBet></data-apt-ticket-checkout><!--ticket checkout--><!-- ./Ticket Show Event Content --><!-- Ticket Scroll Arrow Button Group --><div class=ticket-scroll-arrow-button data-ng-if=vmNovusTicket.ticketShowStatusOptions.ticketHasEvents><button class=up data-ng-click=vmNovusTicket.upContent()><i class=\"fa fa-caret-up\" aria-hidden=true></i></button> <button class=down data-ng-click=vmNovusTicket.downContent()><i class=\"fa fa-caret-down\" aria-hidden=true></i></button></div><!-- ./Ticket Scroll Arrow Button Group --><!-- Ticket Show Combinations Content --><!--<data-apt-ticket-event-combinations data-ng-if=\"vmNovusTicket.ticketShowStatusOptions.ticketHasEvents\"></data-apt-ticket-event-combinations>--><!-- ./Ticket Show Combinations Content --><!-- Ticket Combinations Show Button --> <button class=ticket-show-combinations-btn data-ng-click=vmNovusTicket.showCombo() data-ng-if=vmNovusTicket.ticketShowStatusOptions.ticketHasEvents><span ng-if=!vmNovusTicket.comboStatus ng-translate translate=show_combinations></span> <span ng-if=vmNovusTicket.comboStatus ng-translate translate=hide_combinations></span></button><!-- ./Ticket Combinations Show Button --><!-- Ticket Footer  --><data-apt-ticket-event-bonuses data-ng-if=vmNovusTicket.ticketShowStatusOptions.ticketHasEvents></data-apt-ticket-event-bonuses><!-- ./Ticket Footer  --></div>");
$templateCache.put("app/printManager/print-manager.html","<data-apt-ticket-printer ng-if=\"vmPrintManager.whatToPrint === \'ticket\'\" ticket-code=vmPrintManager.printViewData previous-state=vmPrintManager.previousState></data-apt-ticket-printer><data-apt-coupon-printer ng-if=\"vmPrintManager.whatToPrint === \'coupon\'\" coupon-code=vmPrintManager.printViewData previous-state=vmPrintManager.previousState></data-apt-coupon-printer><data-apt-voucher-printer ng-if=\"vmPrintManager.whatToPrint === \'voucher\'\" voucher-code=vmPrintManager.printViewData previous-state=vmPrintManager.previousState></data-apt-voucher-printer><data-apt-copy-ticket-printer ng-if=\"vmPrintManager.whatToPrint === \'copyTicket\'\" ticket-code=vmPrintManager.printViewData previous-state=vmPrintManager.previousState></data-apt-copy-ticket-printer>");
$templateCache.put("app/profile/profile.authentication.html","<div id=profile-menu><ul class=profile-menu-container><li ng-repeat=\"tab in vmProfileAuthentication.authData | filter:tab.isHere=true \"><a ui-sref={{tab.href}} ui-sref-active=active ng-translate translate={{tab.name}}></a></li></ul></div>");
$templateCache.put("app/profile/profile.html","<div id=profile-wrapper><!-- Profile Header Menu --><div id=profile-menu><profile-auth-directive></profile-auth-directive></div><!-- ./Profile Header Menu --><!-- Profile Header Menu Line --><div id=profile-menu-line></div><!-- ./Profile Header Menu Line --><!-- Profile Page Dynamic Content --><div ui-view></div><!-- ./Profile Page Dynamic Content --></div>");
$templateCache.put("app/sport/sport-manager.html","<div id=sport-manager><div id=left-content-area><div class=sport-left-odds-content-header><div class=sport-left-odds-header-left><div class=sport-left-odds-header-left-container><div class=sport-left-odds-content-header-show><button class=sport-left-odds-sidebar-show-btn ng-click=vmManagerController.leftSidebarOptions()></button></div><div class=sport-left-odds-content-time-frame><data-apt-tournaments-time-frame></data-apt-tournaments-time-frame></div></div></div><div class=sport-left-odds-header-right><data-apt-sport-nav-bar></data-apt-sport-nav-bar></div></div><div class=sport-left-odds-content-container><div class=sport-left-odds-container-left ng-class=\"{\'close\': vmManagerController.leftSidebarOption}\"><data-apt-left-side-bar></data-apt-left-side-bar></div><div class=sport-left-odds-container-right ng-class=\"{\'open-left-sidebar\': vmManagerController.leftSidebarOption}\"><div class=sport-odds-container-content><data-apt-odds-page></data-apt-odds-page></div></div></div></div><div id=right-content-area><data-apt-right-side-bar></data-apt-right-side-bar></div></div>");
$templateCache.put("app/virtual/virtual.html","<div class=golden-container id=golden-container><div id=golden-race-online-app></div></div><div class=casino-scroll-button-group><button ng-click=virtualsCtrl.uptoScroll()><i class=\"fa fa-caret-up\" aria-hidden=true></i></button> <button ng-click=virtualsCtrl.downtoScroll()><i class=\"fa fa-caret-down\" aria-hidden=true></i></button></div>");
$templateCache.put("app/casino/casinoPlayGame/casino-play.html","<div class=game-modal-content><button class=close-game-btn ng-click=vmCasinoCtrl.closeGame()><i class=\"fa fa-times\"></i></button><iframe src={{vmCasinoCtrl.selectGameData}} class=game-iframe frameborder=0></iframe></div>");
$templateCache.put("app/common/footer/footer.html","<div id=footer><p class=footer-copyright>Copyright © 2015 Sportsbook Terminal. All Rights Reserved.</p><div class=footer-date-container><span class=footer-date>{{vmPageFooter.dateData.date}}</span></div><div class=footer-time-container><span class=footer-time>{{vmPageFooter.dateData.clock}}</span></div></div>");
$templateCache.put("app/common/header/header-page.html","<header id=main-header><div class=header-left-area><div class=header-menu-container data-ng-class=\"{\'active\': vmPageHeader.menuSetting.menuButton}\"><button class=bar-menu-btn data-ng-click=vmPageHeader.openSiteMenu()><span class=menu-icon></span></button></div><div class=header-logo-container><a ui-sref=main><img ng-src={{vmPageHeader.mainlogo}} alt=\"\"></a></div></div><div class=header-right-area><div class=header-option-container><!--<div class=\"header-search-area\">--><!--<form class=\"header-search-form\">--><!--<label class=\"search-input-label\">--><!--<input type=\"text\" name=\"searchForm\" class=\"search-input\" placeholder=\"Search...\">--><!--</label>--><!--<label class=\"search-button-container\">--><!--<button class=\"search-button\">--><!--<span class=\"search-icon\"></span>--><!--</button>--><!--</label>--><!--</form>--><!--</div>--><div class=header-language-area><button class=header-language-btn ng-disabled=\"vmPageHeader.languages.length==1\" ng-click=vmPageHeader.openLanguageMenu()><span class=\"header-language-icon selected flag-{{vmPageHeader.selectedLanguage.code}}\"></span></button><div class=header-language-options-container ng-class=\"{\'open\': vmPageHeader.openLanguageOptions}\"><ul class=header-language-options><li data-ng-repeat=\"language in vmPageHeader.languages\" data-ng-click=vmPageHeader.changeLanguage(language) data-ng-class=\"{active:vmPageHeader.selectedLanguage.code==language.code}\"><a class=\"language-icon flag-{{language.code}}\"></a></li></ul></div></div><label class=header-selected-odds-area><ui-select theme=bootstrap name=odds_format ng-model=vmPageHeader.selectedOddsFormat.id ng-model-options=\" {getterSetter: true }\" data-ng-change=vmPageHeader.selectOddsFormat() ng-required=true><ui-select-match><span ng-translate translate={{$select.selected.name}}></span></ui-select-match><ui-select-choices repeat=\"oddsFormat.id as oddsFormat in vmPageHeader.oddsFormats| filter: $select.search\"><span ng-translate translate=\"{{oddsFormat.name | highlight: $select.search}}\"></span></ui-select-choices></ui-select></label><div class=header-date-time-container><div class=header-date-container><span class=header-date>{{vmPageHeader.dateData.date}}</span> <span class=header-time>{{vmPageHeader.dateData.clock}}</span></div><!--<div class=\"header-date-container\">--><!--<span class=\"header-tz\">--><!--TZ: {{vmPageHeader.bookmakerTZ}}--><!--</span>--><!--</div>--></div><div class=header-user-area><button data-ng-if=vmPageHeader.user.id class=header-user-button ng-click=vmPageHeader.userDropDown() ng-class=\"{\'isLogin\': vmPageHeader.user.id}\"><span class=user-icon></span> <span class=user-name data-ng-if=vmPageHeader.user.id>{{vmPageHeader.user.username}}</span></button> <button data-ng-if=!vmPageHeader.user.id class=header-user-button data-ng-click=vmPageHeader.logIn()><span class=user-icon></span></button><!--<div class=\"user-choose-menu\" ng-class=\"{\'open\': vmPageHeader.userDropDownMenu}\">--><!--<ul>--><!--<li><a href=\"\" data-ng-click=\"vmPageHeader.logout()\">--><!--<span translate=\"logout\">{{\'logout\' | translate}}</span>--><!--</a></li>--><!--&lt;!&ndash;<li><a href=\"\" ui-sref=\"sessions\" data-ng-click=\"vmPageHeader.changeUserDropMenu()\">&ndash;&gt;--><!--&lt;!&ndash;<span translate=\"sessions\">{{\'sessions\' | translate}}</span>&ndash;&gt;--><!--&lt;!&ndash;</a></li>&ndash;&gt;--><!--</ul>--><!--</div>--></div><div class=header-deposit-area data-ng-if=vmPageHeader.user.id><button class=\"btn btn-basic deposit-btn\" ng-click=vmPageHeader.openTransferModal()><span class=ng-binding></span> <span class=\"fa fa-money\"></span> <span ng-translate translate=wallet class=ng-isolate-scope></span></button></div><div class=header-deposit-area data-ng-if=vmPageHeader.user.id><button class=\"btn btn-basic deposit-btn\" ui-sref=moneyDeposit><span class=ng-binding></span><!--<span>{{vmPageHeader.userDefaultCurrency}}</span>--> <i class=\"fa fa-bars\" aria-hidden=true></i> <span ng-translate translate=menu class=ng-isolate-scope></span></button></div><div class=header-balance-area data-ng-if=vmPageHeader.userBalanceData.balance><div class=header-balance-content><div class=header-balance><span class=header-balance-name ng-translate translate=balance></span> <span class=header-balance-amount><nvs-currency-format-filter value=vmPageHeader.userBalanceData.balance></nvs-currency-format-filter></span></div></div></div><div class=header-user-area><button data-ng-if=vmPageHeader.user.id class=header-user-button data-ng-click=vmPageHeader.logout()><i class=\"fa fa-sign-out logout-icon\" aria-hidden=true></i></button></div></div></div></header>");
$templateCache.put("app/common/header/transfer.html","<div class=transfer-container style=z-index:99999><button type=button class=\"close-modal-wallet fa fa-times\" ng-click=closeModal()></button><div class=transfer-balance-container><div class=transfer-balance-el><div class=fl><span ng-bind=transferFromProvider.title></span></div><nvs-currency-format-filter value=amountOfTransferFrom class=\"fr ng-binding ng-isolate-scope\"></nvs-currency-format-filter></div><div class=clearfix></div><div class=line></div><div class=transfer-balance-el><div class=fl><span ng-bind=transferToProvider.title></span></div><nvs-currency-format-filter value=amountOfTransferTo class=\"fr ng-binding ng-isolate-scope\"></nvs-currency-format-filter></div></div><div class=transfer-inputs-container><div class=transfer-inputs><div class=fl><div class=\"form-group profile-form-group\"><label class=\"control-label col-xs-12\" ng-translate translate=transfer_from></label><div class=\"col-xs-12 select-container\"><select class=\"form-control custom-form\" name=transferFrom id=transferFrom data-ng-model=transferFromProvider.id data-ng-change=selectTransferFromProvider(transferFromProvider.id) ng-options=\"provider.id as provider.name for provider in providers\" required></select></div></div></div><div class=switch-area><div class=\"form-group profile-form-group\"><label class=\"control-label col-xs-12\">&nbsp;</label><button type=button ng-click=switchWallet() class=\"btn set-bonus-btn fa fa-exchange fa-2x\"></button></div></div><div class=fr><div class=\"form-group profile-form-group\"><label class=\"control-label col-xs-12\" ng-translate translate=transfer_to></label><div class=\"col-xs-12 select-container\"><select class=\"form-control custom-form\" name=transferTo id=transferTo data-ng-model=transferToProvider.id data-ng-change=selectTransferToProvider(transferToProvider.id) ng-options=\"provider.id as provider.name for provider in providers\" required></select></div></div></div><div class=clearfix></div></div><div class=transfer-inputs><div class=fl ng-show=\"bonusDataEnable ===1\"><div class=\"form-group profile-form-group\"><div class=col-xs-8><label class=\"control-label col-xs-12\" ng-translate translate=bonus_code></label><input ng-model=bonusCode ng-placeholder placeholder=enter_code ng-virtual-keyboard class=\"form-control custom-form\" name=bonus_code type=button required></div><div class=col-xs-4><button ng-click=setBonus(bonusCode) class=\"btn set-bonus-btn\" name=bonus_code type=text required ng-translate translate=apply></button></div></div></div><div class=fr ng-class=\"{\'transfer-full\': bonusDataEnable !==1}\"><div class=\"form-group profile-form-group\"><label class=\"control-label col-xs-12\" ng-translate translate=amount></label><div class=col-xs-12><input ng-model=amount ng-placeholder placeholder=enter_amount ng-virtual-keyboard=\"{kt: \'Numerico\'}\" class=\"form-control custom-form\" name=amount type=text required></div></div></div><div class=clearfix></div></div><div class=transfer-button-container><div style=\"width: 100%\"><button ng-click=transferProcess() type=submit class=save-btn ng-translate translate=transfer_now></button></div></div></div></div>");
$templateCache.put("app/common/leftSideBar/left-side-bar.html","<div id=sport-left-sidebar-container><div class=sport-left-sidebar-content><div id=left-sidebar-scroll-content><div class=sport-left-sidebar-item data-ng-repeat=\"category in vmLeftSideBar.selectedSportCategories\"><button class=sport-left-sidebar-item-header ng-click=vmLeftSideBar.openSubItem(category)><span class=sport-left-sidebar-item-header-name>{{category.name}}</span> <span class=sport-left-sidebar-item-header-count>{{category.count}}</span></button><div class=sport-left-sidebar-item-detail ng-class=\"{\'opened\': category.isOpenSubItem}\"><ul class=sport-left-sidebar-item-list><li data-ng-repeat=\"tournament in category.tournaments\"><a data-ng-class={active:tournament.clicked} data-ng-click=vmLeftSideBar.loadClickedTournament(tournament)><span class=sport-left-sidebar-item-name>{{tournament.name}}</span> <span class=sport-left-sidebar-item-count>{{tournament.count}}</span></a></li></ul></div></div><div class=sport-left-sidebar-item ng-if=category data-ng-repeat=\"category in vmLeftSideBar.selectedOutrightCategories\"><button class=sport-left-sidebar-item-header ng-click=vmLeftSideBar.openSubItem(category)><span class=sport-left-sidebar-item-header-name ng-translate translate={{category.name}}></span> <span class=sport-left-sidebar-item-header-count>{{category.count}}</span></button><div class=sport-left-sidebar-item-detail ng-class=\"{\'opened\': category.isOpenSubItem}\"><ul class=sport-left-sidebar-item-list><li data-ng-repeat=\"tournament in category.tournaments\"><a data-ng-class={active:tournament.clicked} data-ng-click=vmLeftSideBar.loadClickedTournament(tournament)><span class=sport-left-sidebar-item-name ng-translate translate={{tournament.name}}></span> <span class=sport-left-sidebar-item-count>{{tournament.count}}</span></a></li></ul></div></div></div></div></div><div id=sport-left-sidebar-footer><button class=up ng-click=vmLeftSideBar.upScroll()><i class=\"fa fa-caret-up\" aria-hidden=true></i></button> <button class=down ng-click=vmLeftSideBar.downScroll()><i class=\"fa fa-caret-down\" aria-hidden=true></i></button></div>");
$templateCache.put("app/common/loader/loader.html","<div class=terminal-loader><div class=bounce1></div><div class=bounce2></div><div class=bounce3></div></div>");
$templateCache.put("app/common/loadingBar/loading-bar.html","<div id=nvsLoadingBarContainer><div class=nvs-loading-bar-wrapper><div class=nvs-loading-circle></div><div class=nvs-loading-bar-circle-label ng-translate translate=loading_data></div></div></div>");
$templateCache.put("app/common/menu/menu.html","<div id=terminal-menu><div class=terminal-wrapper ng-class=\"{\'open\': vmMenu.menuSetting.menuDisplay}\"><div class=terminal-menu-container><ul><li data-ng-repeat=\"item in vmMenu.menuItems\"><a ui-sref={{item.route}} ui-sref-active=active menu-close ng-translate translate={{item.name}}></a></li></ul></div></div></div>");
$templateCache.put("app/common/reportsPinVerification/pin-verification.html","<div id=nvs-pinVerificationContainer class=my-modal-container><div class=\"nvs-pinVerification-header modal-header\"><button type=button data-ng-click=vmPinVerification.close() class=nvs-pinVerification-header--close-btn data-dismiss=modal aria-label=Close><span class=nvs-pinVerification-header--close-icon aria-hidden=true>&times;</span></button><h4 class=nvs-pinVerification-title translate=report_pin></h4></div><div class=\"nvs-pinVerification-body modal-body\"><label class=nvs-pinVerification-body-label for=modal-for-pin ng-translate translate=pin></label><input type=password class=nvs-pinVerification-body-input id=modal-for-pin ng-placeholder placeholder=pin ng-model=vmPinVerification.pin autocomplete=off></div><div class=\"nvs-pinVerification-footer modal-footer\"><button type=button data-ng-click=vmPinVerification.send() class=nvs-pinVerification-footer--send-btn ng-translate translate=send></button></div></div>");
$templateCache.put("app/common/rightSideBar/right-side-bar.html","<div id=sport-right-sidebar-container><data-apt-novus-ticket></data-apt-novus-ticket></div>");
$templateCache.put("app/common/sessionTimeout/session-timeout.html","<div><div class=modal-header><h3>You\'re Idle. Do Something!</h3></div><div idle-countdown=countdown ng-init=\"countdown=5\" class=modal-body><uib-progressbar max=5 value=5 animate=false class=\"progress-striped active\">You\'ll be logged out in {{countdown}} second(s).</uib-progressbar></div><div class=modal-header><h3>You\'ve Timed Out!</h3></div><div class=modal-body><p>You were idle too long. Normally you\'d be logged out, but in this demo just do anything and you\'ll be reset.</p></div></div>");
$templateCache.put("app/common/sportNavBar/sport-nav-bar.html","<div id=sport-navbar><div class=sport-categories-container><div class=sport-categories-left-arrow><button class=sport-categories-left-arrow-btn ng-click=vmSportNavBar.prev()></button></div><div class=sport-categories-content id=sportCarouselContent><div class=sport-categories-list id=sportCarouselList><div class=sport-categories-items data-ng-repeat=\"sport in vmSportNavBar.sports | filter:{outright:0}\"><a data-ng-class=\"$index == vmSportNavBar.selectedSport.indx && vmSportNavBar.selectedSport.outright === 0 ? \'active sport-categories-item\' : \'sport-categories-item\'\" data-ng-click=vmSportNavBar.setSportCategory(sport)><span class=\"sport-categories-item-icon sport-{{sport.id}}\"></span> <span class=sport-categories-item-title>{{sport.name}}</span></a></div><div ng-show=\"vmSportNavBar.outrights.length > 0\" class=sport-categories-items ng-style=\"vmSportNavBar.isShowOutright ? {\'display\': \'none\'}:{\'visibility\':\'hidden\'} \"><a data-ng-class=\"$index == vmSportNavBar.selectedSport.indx && vmSportNavBar.selectedSport.outright === 0 ? \'active sport-categories-item\' : \'sport-categories-item\'\"><span class=\"sport-categories-item-icon sport-{{sport.id}}\"></span> <span class=sport-categories-item-title>{{sport.name}}</span></a></div><div ng-show=\"vmSportNavBar.outrights.length > 0\" class=sport-categories-items data-ng-class=\"vmSportNavBar.isShowOutright== false ? \'outrightFixed\' : \'\'\" style=\"width:{{widthStatus}}px !important; left:{{rightArrowLeftStatus}}px !important; top:{{rightArrowTopStatus}}px !important\"><a class=outright-item data-ng-click=vmSportNavBar.showOutrightCategory()><span class=sport-categories-right-arrow-btn ng-class=\"vmSportNavBar.isShowOutright== false ? \'outrightButtonLeft\' : \'outrightButtonRight\'\"></span> <span class=sport-categories-item-title ng-translate translate=outrights></span></a></div><div data-ng-show=vmSportNavBar.isShowOutright class=sport-categories-items data-ng-repeat=\"sport in vmSportNavBar.sports | filter:{outright:1}\"><a data-ng-class=\"$index == vmSportNavBar.selectedSport.indx && vmSportNavBar.selectedSport.outright === 1 ? \'active outright-item\' : \'outright-item\'\" data-ng-click=vmSportNavBar.setSportCategory(sport)><span class=\"sport-categories-item-icon sport-{{sport.id}}\"></span> <span class=sport-categories-item-title>{{sport.name}}</span></a></div></div></div><div class=sport-categories-right-arrow><button class=sport-categories-right-arrow-btn ng-click=vmSportNavBar.next()></button></div></div></div>");
$templateCache.put("app/live/eventView/event-view.html","<div id=live><div id=live-manager-content><div class=live-manager-container><apt-live-sport-nav-bar></apt-live-sport-nav-bar><apt-event-detail></apt-event-detail></div><div class=live-manager-right-sidebar><data-apt-right-side-bar></data-apt-right-side-bar></div></div></div>");
$templateCache.put("app/live/liveEventList/live-event-list.html","<div id=event-list-container><!-- Loader --><nvs-loading-bar data-ng-show=vmEventList.displaySetting.loadingBar></nvs-loading-bar><!-- ./Loader --><!-- Live Event Container --><div id=event-list-scroll><div id=event-list-content data-ng-repeat=\"sport in vmEventList.liveSports track by $index\" data-ng-show=\"sport.id==vmEventList.selectedSportNavBar.id\"><!-- Live Event List --><div class=event-list-sport-type data-ng-repeat=\"tournament in sport.liveTournaments track by $index\"><!-- Event List Top (Match, Markets vs.) --><div class=event-list-header-container><div class=event-header-content><!-- Event Header Name --><div class=\"event-header-name market-{{tournament.marketsLength}}\"><span class=sport-tournament-name ng-translate-live translate={{tournament.name}}></span> <span class=sport-event-type ng-translate translate=match></span></div><!-- ./Event Header Name --><!-- Event Header Name --><div class=event-market-container><div class=event-market-item data-ng-repeat=\"market in tournament.markets track by $index\"><div class=event-market-name-wrap><span class=event-market-name ng-translate translate=lm_{{market.name}}></span></div><ul><li data-ng-repeat=\"odds in market.odds track by $index\"><span class=odds-name ng-translate translate=\"lm_{{odds.name || odds.code}}\"></span></li></ul></div></div><!-- Event Header Name --><!-- Event Header Extra Odds  --><div class=event-header-extra-odds><span class=event-header-extra-odds-btn></span></div><!-- ./Event Header Extra Odds  --></div></div><!-- ./Event List Top (Match, Markets vs.) --><!-- Event List Content (Event Name, Odds vs.) --><div class=event-list-content-wrapper><!-- Event Odds Items Live Template 1 --><div class=\"event-list-content-container sport-soccer\" data-ng-show=\"sport.live_template == 1\" data-ng-repeat=\"event in tournament.liveEvents track by $index\"><!-- Event Time --> <span class=event-content-time>{{event.time}}<i class=blink></i></span><!-- ./Event Time --><!-- Event Name --><div class=\"event-content-name market-{{tournament.marketsLength}}\"><span class=event-content-item>{{event.home}} - {{event.away}}</span><div class=event-content-score><span>{{event.score}}</span></div></div><!-- ./Event Name --><!-- Event Market Odds Container --><div class=event-market-container><!-- Event Odds Row  --><div class=event-market-item data-ng-repeat=\"market in event.liveMarkets track by $index\"><ul><li data-ng-repeat=\"odds in market.odds track by $index\"><button class=\"odds-rate odds-{{odds.io_status}}\" data-ng-class=\"{\'lock\': !odds.active,\'active\':vmEventList.checkLiveOddsActive(event.id,odds,market)}\" data-ng-click=\"vmEventList.clickLive(event.id, true, market.typeKey, odds.code, odds.value)\" data-ng-disabled=\"{{!odds.active || odds.value==\'-\' || odds.value==\'0\'}}\"><!--<data-apt-live-odds-button\n                                                    odds-value=\"odds.value\"></data-apt-live-odds-button>--> {{odds.value}}</button><!--<data-apt-live-odds-button\n                                                odds-value=\"odds.value\"></data-apt-live-odds-button>--></li></ul></div><!-- ./Event Odds Row  --></div><!-- ./Event Market Odds Container --><!-- Event Extra Odds --><div class=event-extra-odds><button class=event-extra-odds-btn data-ng-click=vmEventList.openEventLiveView(sport,event)>+{{event.sub_market_count}}</button></div><!-- Event Extra Odds --></div><!-- ./Event Odds Items Live Template 1 --><!-- Event Odds Items Live Template 2--><div class=\"event-list-content-container sport-handball\" data-ng-show=\"sport.live_template == 2\" data-ng-repeat=\"event in tournament.liveEvents track by $index\"><!-- Event Time --> <span class=event-content-time>{{event.status}}</span><!-- ./Event Time --><!-- Event Name --><div class=\"event-content-name market-{{tournament.marketsLength}}\"><span class=event-content-item>{{event.home}} - {{event.away}}</span><div class=event-content-score><span>{{event.score}}</span></div></div><!-- ./Event Name --><!-- Event Market Odds Container --><div class=event-market-container><!-- Event Odds Row  --><div class=event-market-item data-ng-repeat=\"market in event.liveMarkets track by $index\"><ul><li data-ng-repeat=\"odds in market.odds track by $index\"><button class=\"odds-rate odds-{{odds.io_status}}\" ng-class=\"{\'lock\': !odds.active}\" data-ng-click=\"vmEventList.clickLive(event.id, true, market.typeKey, odds.code, odds.value)\">{{odds.value}}</button></li></ul></div><!-- ./Event Odds Row  --></div><!-- ./Event Market Odds Container --><!-- Event Extra Odds --><div class=event-extra-odds><button class=event-extra-odds-btn data-ng-click=vmEventList.openEventLiveView(sport,event)>+{{event.sub_market_count}}</button></div><!-- Event Extra Odds --></div><!-- ./Event Odds Items Live Template 2 --><!-- Event Odds Items Live Template 3 --><div class=\"event-list-content-container sport-tennis\" data-ng-show=\"sport.live_template == 3\" data-ng-repeat=\"event in tournament.liveEvents track by $index\"><!-- Event Time --> <span class=event-content-time><i class=live-template-3-time ng-bind=event.status></i></span><!-- ./Event Time --><!-- Event Name --><div class=\"event-content-name market-{{tournament.marketsLength}}\"><span class=event-content-item>{{event.home}} - {{event.away}}</span><div class=event-content-score><ul data-ng-repeat=\"score in event.set_score track by $index\"><li data-ng-class=\"{\'win\' :score.home[0]==\'winner\'}\">{{score.home[1]}}</li><li data-ng-class=\"{\'win\' :score.away[0]==\'winner\'}\">{{score.away[1]}}</li></ul></div><div class=event-content-game-score><ul><li>{{event.game_score[0] || \'-\'}}</li><li>{{event.game_score[1] || \'-\'}}</li></ul></div></div><!-- ./Event Name --><!-- Event Market Odds Container --><div class=event-market-container><!-- Event Odds Row  --><div class=event-market-item data-ng-repeat=\"market in event.liveMarkets track by $index\"><ul><li data-ng-repeat=\"odds in market.odds track by $index\"><button class=\"odds-rate odds-{{odds.io_status}}\" ng-class=\"{\'lock\': !odds.active}\" data-ng-click=\"vmEventList.clickLive(event.id, true, market.typeKey, odds.code, odds.value)\">{{odds.value}}</button></li></ul></div><!-- ./Event Odds Row  --></div><!-- ./Event Market Odds Container --><!-- Event Extra Odds --><div class=event-extra-odds><button class=event-extra-odds-btn data-ng-click=vmEventList.openEventLiveView(sport,event)>+{{event.sub_market_count}}</button></div><!-- Event Extra Odds --></div><!-- ./Event Odds Items Live Template 3 --></div><!-- ./Event List Content (Event Name, Odds vs.) --></div><!-- ./Live Event List --></div></div><!-- ./Live Event Container --><!-- Scroll Button Container ---><div class=event-list-scroll-button-group><button ng-click=vmEventList.topScroll()><i class=\"fa fa-caret-up\" aria-hidden=true></i></button> <button ng-click=vmEventList.bottomScroll()><i class=\"fa fa-caret-down\" aria-hidden=true></i></button></div><!-- ./Scroll Button Container --></div>");
$templateCache.put("app/live/liveSportNavBar/live-sport-nav-bar.html","<div id=live-sport-navbar><div class=sport-categories-container><div class=sport-categories-left-arrow><button class=sport-categories-left-arrow-btn data-ng-click=vmLiveSportNavBar.prev()></button></div><div class=sport-categories-content id=sportCarouselContent><div class=sport-categories-list id=sportCarouselList><div class=sport-categories-items data-ng-repeat=\"sport in vmLiveSportNavBar.sportsNavBar track by $index\"><a class=sport-categories-item data-ng-click=vmLiveSportNavBar.setLiveSport(sport) data-ng-class=\"{\'active\':sport.id==vmLiveSportNavBar.selectedSportNavBar.id}\"><span class=\"sport-categories-item-icon sport-{{sport.id}}\"></span> <span class=sport-categories-item-title>{{sport.name}}</span></a></div></div></div><div class=sport-categories-right-arrow><button class=sport-categories-right-arrow-btn ng-click=vmSportNavBar.next()></button></div></div></div>");
$templateCache.put("app/profile/betHistory/bet-history-manager.html","<div id=bet-history-manager-wrapper><!-- Bet History Manager Header Area --><div id=bet-history-manager-header><!-- Bet History Header Left Area --><apt-bet-history-header-left></apt-bet-history-header-left><!-- Bet History Header Left Area --><!-- Bet History Header Right Area --><apt-bet-history-header-right></apt-bet-history-header-right><!-- Bet History Header Right Area --></div><!-- ./Bet History Manager Header Area --><div id=bet-history-manager-container><apt-bet-history-content-list></apt-bet-history-content-list></div></div>");
$templateCache.put("app/profile/money/money-deposit-manager.html","<section class=\"main-wrap clearfix deposit-container\"><div class=col-xs-12><div class=\"clearfix main-box\" id=money_container style=\"margin-top: 30px\"></div><div class=methodContainer></div></div></section>");
$templateCache.put("app/profile/personalDetails/personal-details.html","<data-apt-personal-detail-form></data-apt-personal-detail-form>");
$templateCache.put("app/profile/revenueReport/revenue-report-manager.html","<section id=nvsRevenueReportContainer><div class=nvs-revenue-report-filter-wrapper><h4 class=nvs-balanceReport--filter-header><span translate=revenue_report></span></h4><nvs-revenue-report-filter></nvs-revenue-report-filter></div><div class=nvs-revenue-report-list-wrapper><nvs-revenue-report-list></nvs-revenue-report-list></div></section>");
$templateCache.put("app/profile/transactions/transactions-manager.html","<div id=transactions-manager><apt-transaction-form></apt-transaction-form><apt-transaction-list></apt-transaction-list></div>");
$templateCache.put("app/profile/sessions/sessions.html","<data-apt-session-filter></data-apt-session-filter><data-apt-session-list></data-apt-session-list>");
$templateCache.put("app/sport/oddsPage/odds-page.html","<div class=odds-page-container><data-nvs-loading-bar data-ng-show=vmOddsPage.settings.loadingBar></data-nvs-loading-bar><div id=odds-page-content class=odds-page-content data-ng-if=\"vmOddsPage.tournaments.length>0\"><div id=odds-page-scroll-content><!-- Market ngRepeat Started --><div class=odds-page-row data-ng-repeat=\"tournament in vmOddsPage.tournaments | orderBy:\'-\' track by $index\"><div id=odds-page-market-groups class=odds-page-market-groups data-ng-hide=\"tournament.marketGroupEvents[0].name==\'Outright\' || tournament.market_groups.length == 1 \"><div class=market-groups-container ng-class=\"{\'open\': tournament.allMarketGroupItems}\"><div class=market-groups-container-content><ul><li class=market-groups-all-items><button class=all-market-groups ng-click=vmOddsPage.allMarketGroups(tournament) ng-class=\"{\'active\': vmOddsPage.allMarketGroupItems}\"><span class=all-market-text ng-translate translate=all_select></span> <i class=all-market-icons></i></button></li><li class=market-groups-items ng-repeat=\"marketGroup in tournament.market_groups\"><button class=market-groups-btn data-ng-class=\"{\'active\':marketGroup.selected}\" data-ng-click=vmOddsPage.loadMarketGroup(marketGroup,tournament.tournament_id) ng-translate translate={{marketGroup.term}}></button></li></ul></div></div></div><nvs-loading-bar ng-show=vmOddsPage.settings.loadingBarMarketGroup></nvs-loading-bar><div ng-style=\"tournament.market_groups.length == 1 ? {\'margin-top\':\'25px\'}:{}\" class=odds-page-wrapper-center id=odds-page-wrapper-center data-ng-repeat=\"marketGroupEvent in tournament.marketGroupEvents | orderBy:\'-\'\" scroll-view><div class=odds-page-market-group-name><h2 class=rotate-market-name ng-style=\"vmOddsPage.isShowLeftSideBar != true ? {\'left\':\'18.85%\'} : {\'left\':\'2.3%\'}\"><span ng-translate translate=mg_{{marketGroupEvent.name}}></span></h2></div><div class=odds-page-wrapper id=odds-page-wrapper><!-- Odds Page Header (Market vs.)--><div class=odds-page-content-header ng-style=\"vmOddsPage.isShowLeftSideBar == true ? {\'left\':\'3.68%\'}:{\'left\':\'19.85%\'}\"><!-- Display Template 0 --><div class=\"odds-page-content-header-event market-{{marketGroupEvent.marketNavBarLength}}\"><h2>{{tournament.tournament_name}}</h2></div><!-- Display Template 0 --><!-- Display Template 0 --><div class=\"odds-page-content-market-name market-name-{{$index + 1}}\" data-ng-repeat=\"market in marketGroupEvent.markets\" data-ng-if=\"market.display_template == 0 || market.display_template == 2 \" data-ng-hide=\"market.code==\'Winner\' \"><div style=\"{{marketGroupEvent.marketNavBarLength >= 12 ? \'width:\'+market.odds.length*60+\'px;\' : \'width:\'+market.odds.length*66+\'px;\'}}\" class=market-name-header>{{market.code}}</div><ul><li data-ng-repeat=\"odds in market.odds\" ng-style=\"marketGroupEvent.marketNavBarLength > 11 ? {\'width\':\'60px\'}:{\'width\':\'66px\'}\"><span class=market-name ng-style=\"marketGroupEvent.name==\'3 Combo\' || marketGroupEvent.name ==\'1st Goal+1X2\'  ? {\'font-size\':\'12px\',\'font-weight\':\'600\'}:{\'font-size\':\'14px\'}\">{{odds.name}}</span></li></ul></div><!-- Display Template 0 --><!-- Display Template 1 --><div class=\"odds-page-content-market-name market-name-{{$index + 1}}\" data-ng-repeat=\"market in marketGroupEvent.markets\" data-ng-if=\"market.display_template == 1\"><h2 class=market-name-selection style=\"margin-left: 100px\">Selection</h2></div><!-- Display Template 1 --><div class=odds-page-content-extra-odds style=\"{{marketGroupEvent.marketNavBarLength > 11 ? \'width:60px;\':\'width:66px;\'}}\"><!-- Close This Tournament --> <button class=close-tournament data-ng-click=\"vmOddsPage.closeTournamentMarketGroup(tournament , marketGroupEvent)\"></button></div></div><!-- ./Odds Page Header (Market vs.)--><!-- Odds Page ngRepeat Started --><div class=odds-page-content-wrapper><!-- Odds Page Content (Market vs.)--><div class=odds-page-content-container data-ng-repeat=\"eventGroup in marketGroupEvent.eventGroups\"><div class=odds-page-content-tournament-date><h3>{{eventGroup.event_group_id}}</h3></div><div class=odds-page-items-content data-ng-repeat=\"event in eventGroup.events\"><!-- Display Template - 0 --><div class=display-template-0 ng-if=\"event.markets[0].display_template == 0\"><div data-ng-class=\"{\'open\':event.eventExtraOdds}\" class=odds-page-main-items-content><div ng-class=\"marketGroupEvent.marketNavBarLength > 11 ? \'odds-page-content-container-time-status\':\'odds-page-content-container-time\'\"><h2>{{event.time}}</h2></div><div class=\"odds-page-content-container-event market-{{event.odds_count==1 ? marketGroupEvent.marketNavBarLength-1 : marketGroupEvent.marketNavBarLength}}\"><h2>{{event.name}}</h2></div><div class=\"odds-page-content-container-odds market-name-{{$index + 1}}\" data-ng-repeat=\"market in event.markets\"><ul data-ng-repeat=\"row in market.rows\"><li data-ng-repeat=\"odds in row.odds\" style=\"{{marketGroupEvent.marketNavBarLength > 11 ? \'width:60px;\':\'width:66px;\'}}\"><button class=\"odds-rate combinability-{{odds.combinability}}\" data-ng-class=\"{\'active\':vmOddsPage.checkOdds(odds)}\" data-ng-click=vmOddsPage.clickOdds(event,odds,market,tournament) data-ng-disabled=\"(odds.value==\'-\')\"><apt-odds-format odds-value=odds.value></apt-odds-format></button></li></ul></div><div class=odds-page-content-container-extra-odds data-ng-hide=\"event.odds_count==1\" style=\"{{marketGroupEvent.marketNavBarLength > 11 ? \'width:60px;\':\'width:66px;\'}}\"><button class=extra-odds-button data-ng-click=vmOddsPage.openExtraOdds(event)>+{{event.odds_count}}</button></div></div></div><!-- ./Display Template - 0 --><!-- ./Display Template - 1 --><div class=display-template-{{event.markets[0].display_template}} ng-if=\"event.markets[0].display_template == 1\" ng-style=\"event.markets[0].row < 2 ?{\'height\':\'50px\'}:{\'height\':\'80px\'}\"><div data-ng-class=\"{\'open\':event.eventExtraOdds}\" class=odds-page-main-items-content><div ng-class=\"marketGroupEvent.marketNavBarLength > 11 ? \'odds-page-content-container-time-status\':\'odds-page-content-container-time\'\" ng-style=\"event.markets[0].row < 2 ?{\'width\':\'80px\'}:{\'width\':\'60px\'}\"><h2 ng-style=\"{\'height\':+(50*(event.markets[0].rows[0].odds.length/12 | roundUp))+(5*(event.markets[0].rows[0].odds.length/12 | roundUp)-1)-5+\'px\',\n                                                \'line-height\':+(50*(event.markets[0].rows[0].odds.length/12 | roundUp))+(5*(event.markets[0].rows[0].odds.length/12 | roundUp)-1)-5+\'px\'}\">{{event.time}}</h2></div><div class=odds-page-content-container-event ng-style=\"event.markets[0].row < 2 ? {\'width\':\'440px\'}:{\'width\':\'270px\'}\"><h2 ng-style=\"{\'height\':+(50*(event.markets[0].rows[0].odds.length/12 | roundUp))+(5*(event.markets[0].rows[0].odds.length/12 | roundUp)-1)-5+\'px\',\n                                                \'line-height\':+(50*(event.markets[0].rows[0].odds.length/12 | roundUp))+(5*(event.markets[0].rows[0].odds.length/12 | roundUp)-1)-5+\'px\'}\">{{event.name}}</h2></div><div class=\"odds-page-content-container-odds market-name-{{$index + 1}}\" data-ng-repeat=\"market in event.markets\" ng-style=\"event.markets[0].row < 2 ? {\'width\':\'530px\'}:{\'width\':\'720px\'}\"><ul data-ng-repeat=\"row in market.rows\"><li data-ng-repeat=\"odds in row.odds track by $index\" class=li-{{row.length}} ng-style=\"event.markets[0].row < 2 ? {\'width\':\'66px\'}:{\'width\':\'60px\'}\"><button class=odds-rate data-ng-class=\"{\'active\':vmOddsPage.checkOdds(odds)}\" data-ng-click=vmOddsPage.clickOdds(event,odds,market,tournament) data-ng-disabled=\"(odds.value==\'-\')\" ng-style=\"event.markets[0].row < 2 ? {\'width\':\'64px\'}:{}\"><span class=odds-name>{{odds.name}}</span> <span class=odds-value>{{odds.value}}</span></button></li></ul></div><div class=odds-page-content-container-extra-odds><button class=extra-odds-button data-ng-click=vmOddsPage.openExtraOdds(event) style=width:58px ng-style=\"{\'height\':+(50*(event.markets[0].rows[0].odds.length/12 | roundUp))+(5*(event.markets[0].rows[0].odds.length/12 | roundUp)-1)-5+\'px\',\n                                                        \'line-height\':+(50*(event.markets[0].rows[0].odds.length/12 | roundUp))+(5*(event.markets[0].rows[0].odds.length/12 | roundUp)-1)-5+\'px\'}\">+318</button></div></div></div><!--./Display Template - 1 --><!-- Display Template - 2 --><div class=display-template-0 ng-if=\"event.markets[0].display_template == 2\"><div data-ng-class=\"{\'open\':event.eventExtraOdds}\" class=odds-page-main-items-content><div ng-class=\"marketGroupEvent.marketNavBarLength > 11 ? \'odds-page-content-container-time-status\':\'odds-page-content-container-time\'\"><h2>{{event.time}}</h2></div><div class=\"odds-page-content-container-event market-{{event.odds_count==1 ? marketGroupEvent.marketNavBarLength-1 : marketGroupEvent.marketNavBarLength}}\"><h2>{{event.name}}</h2></div><div class=\"odds-page-content-container-odds market-name-{{$index + 1}}\" data-ng-repeat=\"market in event.markets\"><ul data-ng-repeat=\"row in market.rows\"><li data-ng-repeat=\"odds in row.odds\" style=\"{{marketGroupEvent.marketNavBarLength > 11 ? \'width:60px;\':\'width:66px;\'}}\"><button class=odds-rate data-ng-class=\"{\'active\':vmOddsPage.checkOdds(odds)}\" data-ng-click=vmOddsPage.clickOdds(event,odds,market,tournament) data-ng-disabled=\"(odds.value==\'-\')\"><apt-odds-format odds-value=odds.value></apt-odds-format></button></li></ul></div><div class=odds-page-content-container-extra-odds data-ng-hide=\"event.odds_count==1\" style=\"{{marketGroupEvent.marketNavBarLength > 11 ? \'width:60px;\':\'width:66px;\'}}\"><button class=extra-odds-button data-ng-click=vmOddsPage.openExtraOdds(event)>+{{event.odds_count}}</button></div></div></div><!-- ./Display Template - 2 --><div class=odds-page-content-extra-odds-wrapper data-ng-hide=\"event.odds_count==1\"><data-apt-extra-odds-page ng-if=event.eventExtraOdds event=event></data-apt-extra-odds-page></div></div></div><!-- ./Odds Page Content (Market vs.)--></div><!-- Odds Page ngRepeat Finished --></div></div></div><!-- Market ngRepeat Finished --></div></div><div class=odds-page-scroll-button-group data-ng-if=\"vmOddsPage.tournaments.length>0\"><div class=combinability><div class=combinabilityHeader ng-translate translate=combinability></div><div class=\"comb combinability-0\" ng-translate translate=unique><span></span></div><div class=\"comb combinability-1\" ng-translate translate=single style=\"padding: 6px 11px\"></div><div class=\"comb combinability-2\" ng-translate translate=double></div><div class=\"comb combinability-3\" ng-translate translate=treble></div><div class=\"comb combinability-5\" ng-translate translate=min5></div></div><button ng-click=vmOddsPage.downOddsScroll()><i class=\"fa fa-caret-down\" aria-hidden=true></i></button> <button ng-click=vmOddsPage.upOddsScroll()><i class=\"fa fa-caret-up\" aria-hidden=true></i></button></div></div>");
$templateCache.put("app/sport/tournamentsTimeframe/tournaments-timeFrame.html","<div class=odds-page-header><div class=odds-page-header-options><div class=time-frame-dropdown><button class=selected-value data-ng-click=vmTournamentsTimeFrame.selectMenu() ng-translate translate={{vmTournamentsTimeFrame.selectedTimeFrameDataName}}></button><div class=time-frame-options data-ng-class=\"{\'open\':vmTournamentsTimeFrame.selectMenuStatus}\"><ul><li data-ng-repeat=\"timeFrame in vmTournamentsTimeFrame.timeFrames\"><button class=time-frame-option data-ng-click=vmTournamentsTimeFrame.setTimeFrame(timeFrame) ng-translate translate={{timeFrame.name}}></button></li></ul></div></div></div></div>");
$templateCache.put("app/ticketNovus/directives/events-ticket.html","<div class=ticket-event-content id=ticket-event-content><!-- Ticket No Items --><div class=ticket-no-item ng-if=\"vmTicketTerminal.ticket.eventCount<=0\"><p>Click on the odds to add to your betslip</p></div><!-- Ticket No Items --><!-- Ticket Item ngRepeat Started --><div class=event-list-container data-ng-repeat=\"ticketEvent in vmTicketTerminal.ticket.events track by $index\"><!-- Event Ticket Header (Event, Odds, Remove Ticket) --><div class=event-list-content-header data-ng-repeat=\"item in ticketEvent.items track by $index\"><!-- Ticket Details Event Name vs.--><div class=event-ticket-details data-ng-if=\"$index==0\"><div class=event-ticket-detail><span class=event-ticket-code data-ng-if=!item.is_live>{{item.event_code}}</span> <span class=event-ticket-is-live data-ng-if=item.is_live>Live</span><!-- Ticket Event Name --> <span class=event-ticket-name>{{ticketEvent.name}}</span><!-- ./Ticket Event Name --></div></div><!-- ./Ticket Details Event Name vs.--><!-- Remove Item in Ticket --><div class=event-ticket-remove-container data-ng-if=\"$index==0\"><button class=\"event-ticket-remove-btn remove\" data-ng-if=!item.is_live data-ng-click=vmTicketTerminal.ticket.removeEvent(ticketEvent.id)></button> <button class=\"event-ticket-remove-btn remove\" data-ng-if=item.is_live data-ng-click=vmTicketTerminal.ticket.manageLiveItem(ticketEvent)></button></div><!-- ./Remove Item in Ticket --></div><!-- ./Event Ticket Header (Event, Odds, Remove Ticket) --><!-- Ticket Item Odds Details --><div class=event-list-content-container data-ng-repeat=\"item in ticketEvent.items track by $index\"><!-- Ticket ngRepeat --><div class=event-ticket-item-check><!-- Ticket Banker Button --> <button class=event-ticket-banker>B</button><!-- ./Ticket Banker Button --><div class=event-ticket-play-odds><span class=event-ticket-play data-ng-if=!item.is_live>{{item.market_name}} - {{item.odds_code}}</span> <span class=event-ticket-play data-ng-if=item.is_live>{{item.live_market.name}} - {{item.odds_code}}</span></div><div class=event-ticket-play-odds-rate><span class=event-ticket-odds-rate>{{item.odds_value}}</span></div><div class=event-ticket-play-remove><button class=event-ticket-remove-btn data-ng-if=!item.is_live data-ng-click=\"vmTicketTerminal.ticket.removeItem(ticketEvent.id, item.event_odds_id)\"></button> <button class=event-ticket-remove-btn data-ng-if=item.is_live data-ng-click=vmTicketTerminal.ticket.manageLiveItem(ticketEvent)></button></div></div><!-- ./Ticket ngRepeat --></div><!-- ./Ticket Item Odds Details --></div><!-- ./Ticket Item ngRepeat Finished --></div>");
$templateCache.put("app/ticketNovus/directives/ticket-bonuses.html","<nvs-loading-bar class=ticket-loader data-ng-show=vmTicketBonuses.placeBetStatus.loadingBar></nvs-loading-bar><div class=ticket-footer><div class=ticket-footer-description-container><div class=ticket-footer-description-left><ul><li><span class=description-left ng-translate translate=Min_Bonus></span> <span class=description-right>{{vmTicketBonuses.ticketCalculator.calculator.couponData.Winning.BonusMin}}</span></li><li><span class=description-left ng-translate translate=Max_Bonus></span> <span class=description-right>{{vmTicketBonuses.ticketCalculator.calculator.couponData.Winning.BonusMax}}</span></li><li class=bonus-max-all-comb><span class=\"description-left bold\" ng-translate translate=Total_Bonus></span> <span class=\"description-left bold\">:</span> <span class=\"description-right bold\">{{vmTicketBonuses.ticketCalculator.calculator.couponData.Winning.BonusMaxAllCombWin}}</span></li></ul></div><div class=ticket-footer-description-right><ul><li><span class=description-left ng-translate translate=Min_Payout></span> <span class=description-right>{{vmTicketBonuses.ticketCalculator.calculator.couponData.Winning.Min}}</span></li><li><span class=description-left ng-translate translate=Max_Payout></span> <span class=description-right>{{vmTicketBonuses.ticketCalculator.calculator.couponData.Winning.Max}}</span></li><li class=all-comb-win><span class=\"description-left bold\" ng-translate translate=all_combination_wins></span> <span class=\"description-right bold\">{{vmTicketBonuses.ticketCalculator.calculator.couponData.Winning.MaxAllCombWin}}</span></li></ul></div></div><div class=ticket-footer-description-total-odds><span class=description-left ng-translate translate=Total_Odds></span> <span class=description-right>{{vmTicketBonuses.ticketCalculator.calculator.couponData.totalOdds}}</span></div><!-- Ticket Live Event Accept Odds --><div class=ticket-accept-menu><div class=accept-odds-change><label class=check-item-options><input type=checkbox data-ng-change=\"vmTicketBonuses.ticketCalculator.update(\'accept_odds_changes\',vmTicketBonuses.ticketCalculator.accept_odds_changes)\" data-ng-model=vmTicketBonuses.ticketCalculator.accept_odds_changes data-ng-checked=vmTicketBonuses.ticketCalculator.accept_odds_changes> <span class=custom-check-icon></span> <span class=options-value ng-translate translate=Accept_Odds_Change></span></label></div><div class=accept-stake-change><label class=check-item-options><input type=checkbox data-ng-change=\"vmTicketBonuses.ticketCalculator.update(\'accept_counter_offer\',vmTicketBonuses.ticketCalculator.accept_counter_offer)\" data-ng-model=vmTicketBonuses.ticketCalculator.accept_counter_offer data-ng-checked=vmTicketBonuses.ticketCalculator.accept_counter_offer> <span class=custom-check-icon></span> <span class=options-value ng-translate translate=Accept_Stake_Change></span></label></div></div><!-- ./Ticket Live Event Accept Odds --><div class=ticket-footer-stake-group><div class=ticket-footer-stake-content><!--<div class=\"ticket-minus\">--><!--<button class=\"ticket-minus-btn\"--><!--data-ng-click=\"vmTicketBonuses.ticketCalculator.setStake(vmTicketBonuses.ticketCalculator.calculator.couponData.Stake - 10)\"></button>--><!--</div>--><div class=ticket-stake-input><label><input type=text ng-placeholder placeholder=Stake data-ng-focus=vmTicketBonuses.showStakeKeyboard() data-ng-model-options=\"{debounce: 500}\" data-ng-change=vmTicketBonuses.ticketCalculator.setStake(vmTicketBonuses.ticketCalculator.calculator.couponData.Stake) data-ng-model=vmTicketBonuses.ticketCalculator.calculator.couponData.Stake></label></div><!--<div class=\"ticket-plus\">--><!--<button class=\"ticket-plus-btn\"--><!--data-ng-click=\"vmTicketBonuses.ticketCalculator.setStake(vmTicketBonuses.ticketCalculator.calculator.couponData.Stake + 10)\"></button>--><!--</div>--></div></div><div class=ticket-footer-checkout><div class=ticket-footer-checkout-container><div class=ticket-footer-reset><button class=ticket-footer-reset-btn data-ng-click=vmTicketBonuses.ticketCalculator.reset() ng-translate translate=reset></button></div><div class=ticket-footer-place><button class=ticket-footer-place-btn data-ng-click=vmTicketBonuses.checkout() ng-translate translate=place_bet></button></div></div></div></div><div class=stake-keyboard-container data-ng-if=vmTicketBonuses.stakeKeyboard><div class=stake-keyboard-close ng-click=vmTicketBonuses.closeStake()><button class=close-keyboard><i class=\"fa fa-times\" aria-hidden=true></i></button></div><div class=stake-input><label><input type=text data-ng-model=vmTicketBonuses.ticketCalculator.calculator.couponData.Stake ng-placeholder placeholder=Stake></label></div><div class=stake-num-pad-container><div class=stake-num-pad><div class=num-key><button class=num-key-btn ng-click=vmTicketBonuses.setKeyboard(1)>1</button></div><div class=num-key><button class=num-key-btn ng-click=vmTicketBonuses.setKeyboard(2)>2</button></div><div class=num-key><button class=num-key-btn ng-click=vmTicketBonuses.setKeyboard(3)>3</button></div></div><div class=stake-num-pad><div class=num-key><button class=num-key-btn ng-click=vmTicketBonuses.setKeyboard(4)>4</button></div><div class=num-key><button class=num-key-btn ng-click=vmTicketBonuses.setKeyboard(5)>5</button></div><div class=num-key><button class=num-key-btn ng-click=vmTicketBonuses.setKeyboard(6)>6</button></div></div><div class=stake-num-pad><div class=num-key><button class=num-key-btn ng-click=vmTicketBonuses.setKeyboard(7)>7</button></div><div class=num-key><button class=num-key-btn ng-click=vmTicketBonuses.setKeyboard(8)>8</button></div><div class=num-key><button class=num-key-btn ng-click=vmTicketBonuses.setKeyboard(9)>9</button></div></div><div class=stake-num-pad><div class=num-key><button class=num-key-btn ng-click=vmTicketBonuses.setKeyboard()>.</button></div><div class=num-key><button class=num-key-btn ng-click=vmTicketBonuses.setKeyboard(0)>0</button></div><div class=num-key><button class=\"num-key-btn edit-btn\" ng-click=vmTicketBonuses.removeKeyboard()>C</button></div></div></div><div class=set-stake-container><button class=set-stake-btn ng-click=vmTicketBonuses.setTotalStake() ng-translate translate=ok></button></div></div>");
$templateCache.put("app/ticketNovus/directives/ticket-combinations.html","<div class=ticket-show-combinations><div class=ticket-combination-content-wrapper data-ng-class=\"{\'open\':vmTicketCombinations.displaySystemStatus}\"><!-- Ticket Combination List --><div class=ticket-combination-container><div class=ticket-combination-header><div class=g><span>G</span></div><div class=c><span>C</span></div><div class=amount><span>Amount</span></div><div class=pot-winning-container><div class=pot-winnings-content><span class=pot-winnings>Pot. Winnings</span></div><div class=pot-winnings-min-max><div class=min><span>Min.</span></div><div class=max><span>Max.</span></div></div></div></div><div class=ticket-combination-content><div class=ticket-combination-row data-ng-repeat=\"system in vmTicketCombinations.ticket.calculator.couponData.Combinations\"><div class=g><div class=g-content><label><input type=checkbox data-ng-click=vmTicketCombinations.ticket.calculator.setSystem(system.Code) data-ng-checked=system.Active> <span class=input-check></span> <span class=g-combination>{{system.Code}}</span></label></div></div><div class=c><span>{{system.Count}}</span></div><div class=amount><label><input data-ng-model-options=\"{debounce: 500}\" data-ng-change=vmTicketCombinations.ticket.setSystemStake(system.Code,system.Stake) data-ng-model=system.Stake type=text value=system.Stake></label></div><div class=pot-winning-container><div class=pot-winnings-min-max><div class=min><span>{{system.Min}}</span></div><div class=max><span>{{system.Max}}</span></div></div></div></div></div></div><!-- Ticket Combination List --></div><!-- Ticket Combinations Show Button --> <button class=ticket-show-combinations-btn data-ng-click=vmTicketCombinations.showSystem()><span ng-if=!vmTicketCombinations.displaySystemStatus>show systems</span> <span ng-if=vmTicketCombinations.displaySystemStatus>close systems</span></button><!-- ./Ticket Combinations Show Button --></div>");
$templateCache.put("app/user/forgotPasswordForm/forgot-password-form.html","<div class=forgot-password-container><button type=button class=\"forgot-pwd-close form-modal-close\" data-ng-click=vmForgotPasswordForm.close()><span class=close-icon></span></button><div class=\"row forgot-pwd-modal-header\"><button class=login-button ng-click=vmForgotPasswordForm.loginForm() ng-translate translate=login></button> <a ui-sref=register class=join-button ng-click=vmForgotPasswordForm.registerForm() ng-translate translate=register></a></div><div class=\"row forgot-pwd-form-group\"><label><input type=text class=forgot-pwd-form-input data-ng-model=vmForgotPasswordForm.data.username ng-placeholder placeholder=username_or_email ng-virtual-keyboard></label></div><div class=\"row forgot-pwd-form-group\"><div class=row><div class=col-xs-6><!--<a href=\"\" class=\"remember-my-pwd\" data-ng-click=\"vmForgotPasswordForm.loginForm()\" translate=\"Did_you_remember_your_password\">{{\'Did_you_remember_your_password?\' |translate}}</a>--></div><div class=col-xs-6><button class=send-pwd-btn data-ng-click=vmForgotPasswordForm.sendMyPassword()><span ng-translate translate=send></span> <span class=arrow-icon></span></button></div></div></div></div>");
$templateCache.put("app/user/login/login-form.html","<div class=login-form-container><button type=button class=\"login-close form-modal-close\" data-ng-click=vmLoginForm.close()><span class=close-icon></span></button><div class=\"row login-modal-header\"><button class=\"login-button active\"><span ng-translate translate=login></span></button> <button class=join-button data-ng-click=vmLoginForm.registerForm()><span ng-translate translate=register></span></button></div><form data-ng-submit=vmLoginForm.login() novalidate name=vmLoginForm.loginValidationForm><div class=\"row login-form-group\"><label><input type=text class=login-form-input name=email data-ng-model=vmLoginForm.data.email ng-placeholder placeholder=username ng-virtual-keyboard required><p ng-show=\"vmLoginForm.loginValidationForm.email.$invalid  &&( !vmLoginForm.loginValidationForm.email.$pristine||!vmLoginForm.isEmail)\" class=text-danger ng-translate translate=required_username></p></label></div><div class=\"row login-form-group\"><label><input type=password name=password class=login-form-input data-ng-model=vmLoginForm.data.password ng-placeholder placeholder=password ng-virtual-keyboard required><div ng-show=\"(vmLoginForm.loginValidationForm.password.$invalid &&(!vmLoginForm.loginValidationForm.password.$pristine||!vmLoginForm.isPassword))\" class=text-danger><span class=text-danger ng-translate translate=required_password></span></div><div ng-show=\"!vmLoginForm.isPasswordsConditions && vmLoginForm.data.password.length<8 \"><span class=text-danger ng-translate translate=password_must_be_at_least_8_characters></span></div></label></div><div class=\"row login-form-group\"><div class=row><div class=col-xs-6><!--<a href=\"\" class=\"forgot-password-text\" data-ng-click=\"vmLoginForm.forgotPassword()\" ng-translate translate=\"forgot_your_password\"></a>--></div><div class=col-xs-6><button class=login-user-btn type=submit><span ng-translate translate=login></span> <span class=arrow-icon></span></button></div></div></div></form></div>");
$templateCache.put("app/user/register/register.html","<apt-register-form></apt-register-form>");
$templateCache.put("app/common/rightSideBar/directives/print-saved-ticket.html","<div class=saved-ticket-container><div class=saved-ticket-inner><div class=log><img ng-src={{vmPrintSavedTicket.couponLogoPrint}} alt=\"BookMaker Logo\"></div><div class=date><span ng-translate translate=date></span> <span>{{vmPrintSavedTicket.currentDate | timeZoneFilter}}</span></div><div class=booking-code><span ng-translate translate=booking_code></span><h1>{{vmPrintSavedTicket.savedTicketData.save_code}}</h1></div><div class=barcode><barcode type=code128b string={{vmPrintSavedTicket.savedTicketData.save_code}} render=img options=vmPrintSavedTicket.barcodeOptions></barcode></div></div></div><div class=col-xs-6><button class=\"btn btn-primary col-xs-12\" ng-click=vmPrintSavedTicket.back()><i class=\"fa fa-arrow-left\"></i> <span ng-translate translate=back></span></button></div><div class=col-xs-6><button class=\"btn btn-success col-xs-12\" ng-click=vmPrintSavedTicket.print(vmPrintSavedTicket.savedTicketData.save_code)><i class=\"fa fa-print\"></i> <span ng-translate translate=print></span></button></div>");
$templateCache.put("app/common/sessionTimeout/modalPopUps/idle-start-popup.html","<div><div class=modal-header style=\"background-color: #fcf8e3\"><h3>You\'ll be logged out in <span style=\"padding: 0 5px;background-color: #f0ad4e;color: white;font-size: 15px\">{{vmIdleStart.timeout}}</span> seconds!</h3></div><div idle-countdown=vmIdleStart.timeout class=modal-body><uib-progressbar value=vmIdleStart.timeout max=30 animate=true type=warning class=\"progress-striped active\">{{vmIdleStart.timeout}}</uib-progressbar></div></div>");
$templateCache.put("app/common/sessionTimeout/modalPopUps/timeout-popup.html","<div><div class=modal-header style=\"background-color: #f2dede; border-color: #ebccd1; color: #a94442\"><h3 style=\"width: 90%; margin: 0px;float: left\">You\'ve Timed Out!</h3><button class=\"btn btn-danger\" style=\"float: right; width: 8%\" type=button ng-click=vmTimeoutNotificationPopup.close()><i class=\"fa fa-times\"></i></button></div><div class=modal-body><p>Close pop up or you have to be logged in to the system to continue your previous actions.</p></div><div class=modal-footer><button class=\"btn btn-info\" type=button ng-click=vmTimeoutNotificationPopup.logIn()>Sign In</button></div></div>");
$templateCache.put("app/live/eventView/eventDetail/event-detail.html","<div id=event-detail-container><!-- Loader  --><nvs-loading-bar data-ng-if=!vmEventDetail.event.liveSubMarkets></nvs-loading-bar><!-- Loader  --><!-- Event Detail Container --><div class=event-detail-container><!-- Event Detail Header live template 1 --><div class=\"event-detail-header sport-soccer\" data-ng-show=\"vmEventDetail.sport.live_template == 1\"><!-- Home Team Container --><div class=home-team-container><div class=home-team-content><span class=team-name>{{vmEventDetail.event.home}}</span><div class=notify-area></div></div></div><!-- ./Home Team Container --><!-- Score Area Container --><div class=score-area-container><div class=score-content><div class=event-time>{{vmEventDetail.event.time}} <i class=blink></i></div><div class=event-score><span class=score-type-1>{{vmEventDetail.event.score}}</span></div></div></div><!-- ./Score Area Container --><!-- Away Team Container --><div class=away-team-container><div class=away-team-content><span class=team-name>{{vmEventDetail.event.away}}</span><div class=notify-area></div></div></div><!-- ./Away Team Container --></div><!-- ./Event Detail Header --><!-- Event Detail Header live template 2 --><div class=\"event-detail-header sport-handball\" data-ng-show=\"vmEventDetail.sport.live_template == 2\"><!-- Home Team Container --><div class=home-team-container><div class=home-team-content><span class=team-name>{{vmEventDetail.event.home}}</span><div class=notify-area></div></div></div><!-- ./Home Team Container --><!-- Score Area Container --><div class=score-area-container><div class=score-content><div class=event-time>{{vmEventDetail.event.status_text}}</div><div class=event-score><span class=score-type-1>{{vmEventDetail.event.score}}</span></div></div></div><!-- ./Score Area Container --><!-- Away Team Container --><div class=away-team-container><div class=away-team-content><span class=team-name>{{vmEventDetail.event.away}}</span><div class=notify-area></div></div></div><!-- ./Away Team Container --></div><!-- ./Event Detail Header --><!-- Event Detail Header live template 3 --><div class=\"event-detail-header sport-tennis\" data-ng-show=\"vmEventDetail.sport.live_template == 3\"><!-- Home Team Container --><div class=home-team-container><div class=home-team-content><span class=team-name>{{vmEventDetail.event.home}}</span><div class=notify-area></div></div></div><!-- ./Home Team Container --><!-- Score Area Container --><div class=score-area-container><div class=score-content><div class=event-time>{{vmEventDetail.event.status}}</div><div class=event-score><div class=score-type-2><ul data-ng-repeat=\"scoreIndex in [0, 1, 2, 3, 4] track by $index\"><li>{{vmEventDetail.event.set_score[scoreIndex].home[1] || \'-\'}}</li><li>{{vmEventDetail.event.set_score[scoreIndex].away[1] || \'-\'}}</li></ul></div><div class=game-score><ul><li>{{vmEventDetail.event.game_score[0] || \'-\'}}</li><li>{{vmEventDetail.event.game_score[1] || \'-\'}}</li></ul></div></div></div></div><!-- ./Score Area Container --><!-- Away Team Container --><div class=away-team-container><div class=away-team-content><span class=team-name>{{vmEventDetail.event.away}}</span><div class=notify-area></div></div></div><!-- ./Away Team Container --></div><!-- ./Event Detail Header --><!-- Event Detail Content --><div class=event-detail-wrapper id=event-detail-wrapper><!------------------------------------><div id=event-detail-inner><div class=event-detail-content data-ng-show=vmEventDetail.event.liveMarkets data-ng-repeat=\"market in vmEventDetail.event.liveMarkets track by $index\"><div class=event-market-header><div class=event-market-show><button class=\"event-market-show-btn active\" data-ng-click=vmEventDetail.openMarket(market.id) data-ng-class=\"{\'active\': !vmEventDetail.isOpen[market.id]}\"></button></div><div class=event-market-title><h2><span data-ng-show=market.special_bet_value ng-translate translate=lm_{{market.free_text}}></span> <span data-ng-show=market.special_bet_value>- ({{market.special_bet_value}})</span> <span data-ng-show=!market.special_bet_value ng-translate translate=lm_{{market.free_text}}></span></h2></div></div><div class=\"event-market-wrapper open\" data-ng-class=\"{\'open\': !vmEventDetail.isOpen[market.id]}\"><!-- Add Class Market Item Length ex: market-{{market.length}} --><div class=\"event-market-odds-container market-{{market.odds.length}}\"><!-- Live Market Extra Odds Repeat --><div class=event-market-odds data-ng-repeat=\"odds in market.odds track by $index\"><button class=\"event-market-odds-btn odds-{{odds.io_status}}\" data-ng-class=\"{\'lock\': !odds.active,\'active\':vmEventDetail.checkLiveOddsActive(market,odds)}\" data-ng-click=\"vmEventDetail.clickLive(false, market, odds)\"><!--{{subOdds.io_status}}--> <span class=odds-name ng-translate translate={{odds.codeTranslation}}><i ng-if=live.data.markets[event_id][market_id].special_bet_value>({{live.data.markets[event_id][market_id].special_bet_value}})</i></span> <span class=odds-rate ng-translate translate={{odds.value.toFixed(2)}}></span></button></div><!-- Live Market Extra Odds Repeat --></div></div></div></div><!-------------------------------------><div id=event-detail-inner><div class=event-detail-content data-ng-show=vmEventDetail.event.liveSubMarkets data-ng-repeat=\"subMarket in vmEventDetail.event.liveSubMarkets track by $index\"><div class=event-market-header><div class=event-market-show><button class=\"event-market-show-btn active\" data-ng-click=vmEventDetail.openMarket(subMarket.id) data-ng-class=\"{\'active\': !vmEventDetail.isOpen[subMarket.id]}\"></button></div><div class=event-market-title><h2><span data-ng-show=subMarket.special_bet_value ng-translate translate=lm_{{subMarket.free_text}}></span> <span data-ng-show=subMarket.special_bet_value>- ({{subMarket.special_bet_value}})</span> <span data-ng-show=!subMarket.special_bet_value ng-translate translate=lm_{{subMarket.free_text}}></span></h2></div></div><div class=\"event-market-wrapper open\" data-ng-class=\"{\'open\': !vmEventDetail.isOpen[subMarket.id]}\"><!-- Add Class Market Item Length ex: market-{{market.length}} --><div class=\"event-market-odds-container market-{{subMarket.liveSubOdds.length}}\"><!-- Live Market Extra Odds Repeat --><div class=event-market-odds data-ng-repeat=\"subOdds in subMarket.liveSubOdds track by $index\"><button class=\"event-market-odds-btn odds-{{subOdds.io_status}}\" data-ng-class=\"{\'lock\': !odds.active,\'active\':vmEventDetail.checkLiveOddsActive(subMarket,subOdds)}\" data-ng-click=\"vmEventDetail.clickLive(false, subMarket, subOdds)\"><!--{{subOdds.io_status}}--> <span class=odds-name ng-translate translate={{subOdds.codeTranslation}}></span> <span class=odds-rate>{{subOdds.value.toFixed(2)}}</span></button></div><!-- Live Market Extra Odds Repeat --></div></div></div></div></div><!-- ./Event Detail Content --></div><!-- ./Event Detail Container --><!-- Scroll Event View Button Group --><div class=event-view-scroll-button-group><button data-ng-click=vmEventDetail.topScroll()><i class=\"fa fa-caret-up\" aria-hidden=true></i></button> <button data-ng-click=vmEventDetail.bottomScroll()><i class=\"fa fa-caret-down\" aria-hidden=true></i></button></div><!-- ./Scroll Event View Button Group --></div>");
$templateCache.put("app/nvsTicket/directives/novusBonuses/ticket-event-bonuses.html","<nvs-loading-bar class=ticket-loader data-ng-show=vmTicketEventBonuses.placeBetStatus.loadingBar></nvs-loading-bar><div class=ticket-footer><div class=ticket-footer-description-container><div class=ticket-footer-description-left><ul><li><span class=description-left ng-translate translate=min_bonus></span> <span class=description-right><nvs-currency-format-filter value=vmTicketEventBonuses.ticketCalculator.calculator.couponData.Winning.BonusMin></nvs-currency-format-filter></span></li><li><span class=description-left ng-translate translate=max_bonus></span> <span class=description-right><nvs-currency-format-filter value=vmTicketEventBonuses.ticketCalculator.calculator.couponData.Winning.BonusMax></nvs-currency-format-filter></span></li><li class=bonus-max-all-comb><span class=\"description-left bold\" ng-translate translate=bonus_max_all_comb_win></span> <span class=\"description-left bold\">:</span> <span class=\"description-right bold\"><nvs-currency-format-filter value=vmTicketEventBonuses.ticketCalculator.calculator.couponData.Winning.BonusMaxAllCombWin></nvs-currency-format-filter></span></li></ul></div><div class=ticket-footer-description-right><ul><li><span class=description-left ng-translate translate=min_payout></span> <span class=description-right><nvs-currency-format-filter value=vmTicketEventBonuses.ticketCalculator.calculator.couponData.Winning.Min></nvs-currency-format-filter></span></li><li><span class=description-left ng-translate translate=all_combination_wins></span> <span class=description-right><nvs-currency-format-filter value=vmTicketEventBonuses.ticketCalculator.calculator.couponData.Winning.Max></nvs-currency-format-filter></span></li><li class=all-comb-win><span class=\"description-left bold\" ng-translate translate=max_payout></span> <span class=\"description-right bold\"><nvs-currency-format-filter value=vmTicketEventBonuses.ticketCalculator.calculator.couponData.Winning.MaxAllCombWin></nvs-currency-format-filter></span></li></ul></div></div><div class=ticket-footer-description-total-odds><span class=description-left ng-translate translate=total_odds></span> <span class=description-right>{{vmTicketEventBonuses.ticketCalculator.calculator.couponData.totalOdds}}</span></div><div class=ticket-footer-select-user data-ng-if=\"vmTicketEventBonuses.user.length>0\"><ui-select ng-model=vmTicketEventBonuses.referenceUserId class=ticket-user-select-menu ng-model-options=\" {getterSetter: true }\" theme=bootstrap ng-change=vmTicketEventBonuses.setTicketReferenceUserId()><ui-select-match ng-placeholder placeholder=\"Select User\">{{$select.selected.username}}</ui-select-match><ui-select-choices repeat=\"user.id as user in vmTicketEventBonuses.user | filter: $select.search\"><span>{{user.username}}</span> <span ng-bind-html=user.balance></span></ui-select-choices></ui-select></div><!-- Ticket Live Event Accept Odds --><div class=ticket-accept-menu><div class=accept-odds-change><label class=check-item-options><input type=checkbox data-ng-change=\"vmTicketEventBonuses.updateTicketChangeStatus(\'accept_odds_changes\')\" data-ng-model=vmTicketEventBonuses.ticketChangeStatus.accept_odds_changes data-ng-checked=vmTicketEventBonuses.ticketChangeStatus.accept_odds_changes*1> <span class=custom-check-icon></span> <span class=options-value ng-translate translate=accept_odds_change></span></label></div><div class=accept-stake-change><label class=check-item-options><input type=checkbox data-ng-change=\"vmTicketEventBonuses.updateTicketChangeStatus(\'accept_counter_offer\')\" data-ng-model=vmTicketEventBonuses.ticketChangeStatus.accept_counter_offer data-ng-checked=vmTicketEventBonuses.ticketChangeStatus.accept_counter_offer*1> <span class=custom-check-icon></span> <span class=options-value ng-translate translate=accept_stake_change></span></label></div></div><!-- ./Ticket Live Event Accept Odds --><div class=ticket-footer-stake-group><div class=ticket-footer-stake-content><div class=ticket-stake-input><button data-ng-click=vmTicketEventBonuses.showStakeKeyboard()><nvs-currency-format-filter value=vmTicketEventBonuses.ticketCalculator.calculator.couponData.Stake></nvs-currency-format-filter></button></div></div></div><div class=ticket-footer-checkout><div class=ticket-footer-checkout-container><div class=ticket-footer-save><button class=ticket-footer-save-btn data-ng-click=vmTicketEventBonuses.saveBet() ng-translate translate=save_coupon></button></div><div class=ticket-footer-reset><button class=ticket-footer-reset-btn data-ng-disabled=vmTicketEventBonuses.placeBetStatus.disablePlaceBet data-ng-click=vmTicketEventBonuses.resetBet() ng-translate translate=reset></button></div><div class=ticket-footer-place><button class=ticket-footer-place-btn data-ng-disabled=vmTicketEventBonuses.placeBetStatus.disablePlaceBet data-ng-click=vmTicketEventBonuses.placeBet() ng-translate translate=place_bet></button></div></div></div></div><div class=stake-keyboard-container data-ng-if=vmTicketEventBonuses.stakeKeyboard><div class=stake-keyboard-close ng-click=vmTicketEventBonuses.closeStake()><button class=close-keyboard><i class=\"fa fa-times\" aria-hidden=true></i></button></div><div class=stake-input><label><input type=text data-ng-model=vmTicketEventBonuses.ticketCalculator.calculator.couponData.Stake placeholder=Stake></label></div><div class=stake-num-pad-container><div class=stake-num-pad><div class=num-key><button class=num-key-btn ng-click=vmTicketEventBonuses.setKeyboard(1)>1</button></div><div class=num-key><button class=num-key-btn ng-click=vmTicketEventBonuses.setKeyboard(2)>2</button></div><div class=num-key><button class=num-key-btn ng-click=vmTicketEventBonuses.setKeyboard(3)>3</button></div></div><div class=stake-num-pad><div class=num-key><button class=num-key-btn ng-click=vmTicketEventBonuses.setKeyboard(4)>4</button></div><div class=num-key><button class=num-key-btn ng-click=vmTicketEventBonuses.setKeyboard(5)>5</button></div><div class=num-key><button class=num-key-btn ng-click=vmTicketEventBonuses.setKeyboard(6)>6</button></div></div><div class=stake-num-pad><div class=num-key><button class=num-key-btn ng-click=vmTicketEventBonuses.setKeyboard(7)>7</button></div><div class=num-key><button class=num-key-btn ng-click=vmTicketEventBonuses.setKeyboard(8)>8</button></div><div class=num-key><button class=num-key-btn ng-click=vmTicketEventBonuses.setKeyboard(9)>9</button></div></div><div class=stake-num-pad><div class=num-key><button class=num-key-btn ng-click=vmTicketEventBonuses.setKeyboard()>.</button></div><div class=num-key><button class=num-key-btn ng-click=vmTicketEventBonuses.setKeyboard(0)>0</button></div><div class=num-key><button class=\"num-key-btn edit-btn\" ng-click=vmTicketEventBonuses.removeKeyboard()>C</button></div></div></div><div class=set-stake-container><button class=set-stake-btn ng-click=vmTicketEventBonuses.setTotalStake() ng-translate translate=ok></button></div></div>");
$templateCache.put("app/nvsTicket/directives/novusCheckout/ticket-checkout.html","<div><div class=placed-ticket-show><div class=placed-ticket-show-content><div class=placed-ticket-caption><p ng-translate translate=your_ticket_has_been_successfully_placed></p></div><div class=placed-ticket-code-container><div class=placed-ticket-code-area><div class=placed-ticket-code><p>{{vmTicketCheckout.placedTicketData.code}}</p></div></div><div class=placed-ticket-button-container><button class=placed-ticket-button data-ng-click=vmTicketCheckout.reloadTicket(vmTicketCheckout.placedTicketData.code) ng-translate translate=reload_ticket></button></div></div><div class=placed-ticket-buttons-area><button class=\"placed-ticket-buttons bet-again-button\" data-ng-click=vmTicketCheckout.setTicketToBetAgain() ng-translate translate=bet_again></button> <button class=\"placed-ticket-buttons print-button\" data-ng-disabled=vmTicketCheckout.isprinted data-ng-click=vmTicketCheckout.printTicket() ng-translate translate=print></button></div></div></div></div>");
$templateCache.put("app/nvsTicket/directives/novusCombinations/ticket-event-combinations.html","<div class=ticket-show-combinations><div class=\"ticket-combination-content-wrapper open\"><!-- Ticket Combination List --><div class=ticket-combination-container><div class=ticket-combination-header><div class=g><span>G</span></div><div class=c><span>C</span></div><div class=amount><span ng-translate translate=amount></span></div><div class=pot-winning-container><div class=pot-winnings-content><span class=pot-winnings ng-translate translate=\"Pot. Winnings\"></span></div><div class=pot-winnings-min-max><div class=min><span ng-translate translate=min></span></div><div class=max><span ng-translate translate=max></span></div></div></div></div><div class=ticket-combination-content><div class=ticket-combination-row data-ng-repeat=\"system in vmTicketEventCombinations.ticket.calculator.couponData.Combinations\"><div class=g><div class=g-content><label><input type=checkbox data-ng-click=vmTicketEventCombinations.ticket.calculator.setSystem(system.Code) data-ng-checked=system.Active> <span class=input-check></span> <span class=g-combination>{{system.Code}}</span></label></div></div><div class=c><span>{{system.Count}}</span></div><div class=amount><label><input data-ng-model-options=\"{debounce: 500}\" data-ng-change=vmTicketEventCombinations.setSystemStake(system.Code,system.Stake) data-ng-model=system.Stake type=text value=system.Stake ng-virtual-keyboard=\"{kt: \'Numerico\'}\"></label></div><div class=pot-winning-container><div class=pot-winnings-min-max><div class=min><span>{{system.Min}}</span></div><div class=max><span>{{system.Max}}</span></div></div></div></div></div></div><!-- Ticket Combination List --></div><!-- Ticket Combinations Show Button --><!--<button class=\"ticket-show-combinations-btn\" data-ng-click=\"vmTicketEventCombinations.showSystem()\">--><!--<span ng-if=\"!vmTicketEventCombinations.displaySystemStatus\">{{\'show_combinations\' | translate}}</span>--><!--<span ng-if=\"vmTicketEventCombinations.displaySystemStatus\">{{\'hide_combinations\' | translate}}</span>--><!--</button>--><!-- ./Ticket Combinations Show Button --></div>");
$templateCache.put("app/nvsTicket/directives/novusEvents/ticket-events-list.html","<div class=ticket-event-content id=ticket-event-content style=\"{{vmTicketEventsList.ticketOptions.ticketCouponSaved==true? \'float:left; padding-bottom:15px; width:100%;\':vmTicketEventsList.ticketOptions.ticketPlaceBet?\'padding:0;\':\'\'}}\"><!-- Ticket No Items --><div class=ticket-no-item data-ng-if=vmTicketEventsList.ticketOptions.ticketHasNoEvents><span ng-translate translate=betslip_usage_content style=\"{{vmTicketEventsList.ticketOptions.ticketCouponSaved==true? \'display: none;\':\'\'}}\" tabindex=betslip_usage_content ng-translate translate=betslip_usage_content></span><!-- search coupon ---><div class=search-container ng-show=!vmTicketEventsList.ticketOptions.ticketCouponSaved><h4><span ng-translate translate=load_ticket></span></h4><div class=input-group><input class=\"form-control search-input\" ng-model=checkCode ng-placeholder placeholder=your_coupon_id ng-virtual-keyboard> <span class=input-group-btn><button class=\"btn btn-default search-btn\" type=button ng-disabled=!checkCode ng-click=vmTicketEventsList.ticketLoadByCode(checkCode)><i class=\"fa fa-arrow-right\"></i></button></span></div></div><!-- search coupon ---><div class=ticket-no-item data-ng-if=vmTicketEventsList.ticketOptions.ticketCouponSaved><apt-print-saved-ticket></apt-print-saved-ticket></div><!--data-ng-if=\"!vmTicketEventsList.ticketOptions.ticketCouponSaved\"--></div><!-- Ticket No Items --><!-- Ticket Item ngRepeat Started --><div class=event-list-container data-ng-if=vmTicketEventsList.ticketOptions.ticketHasEvents data-ng-repeat=\"ticketEvent in vmTicketEventsList.ticketEvents track by $index\"><!-- Event Ticket Header (Event, Odds, Remove Ticket) --><div class=event-list-content-header><!-- Ticket Details Event Name vs.--><div class=event-ticket-details><div class=event-ticket-detail><span class=event-ticket-code>{{ticketEvent.code}}</span> <span class=event-ticket-is-live data-ng-if=ticketEvent.is_live ng-translate translate=live></span><!-- Ticket Event Name --> <span class=event-ticket-name>{{ticketEvent.name}}</span><!-- ./Ticket Event Name --></div></div><!-- ./Ticket Details Event Name vs.--><!-- Remove Item in Ticket --><div class=event-ticket-remove-container><button class=\"event-ticket-remove-btn remove\" data-ng-click=vmTicketEventsList.removeTicketEvent(ticketEvent)></button></div><!-- ./Remove Item in Ticket --></div><!-- ./Event Ticket Header (Event, Odds, Remove Ticket) --><!-- Ticket Item Odds Details --><div class=event-list-content-container><!-- Ticket ngRepeat --><div class=event-ticket-item-check data-ng-repeat=\"item in ticketEvent.items\"><!-- Ticket Banker Button --> <button class=event-ticket-banker data-ng-click=vmTicketEventsList.setBanker(ticketEvent,item) data-ng-class=\"{\'active\':item.is_banker}\" data-ng-if=!event.is_live>B</button><!-- ./Ticket Banker Button --><div class=event-ticket-play-odds><span class=event-ticket-play ng-if=!ticketEvent.is_live>{{item.market_name}}</span> <span class=event-ticket-play ng-if=!ticketEvent.is_live>{{item.name}}</span> <span class=event-ticket-play ng-if=ticketEvent.is_live ng-translate translate=lm_{{item.market_name}}></span> <span class=event-ticket-play ng-if=ticketEvent.is_live ng-translate translate={{item.odds_code_translation}}></span> <span class=\"pull-right itemError\" data-ng-if=\"ticketEvent.is_live && item.error\" data-ng-click=vmTicketEventsList.showItemError(item.error)><i class=\"fa fa-exclamation-triangle\" style=\"color: red\"></i></span></div><div class=event-ticket-play-odds-rate><apt-odds-format class=event-ticket-odds-rate odds-value=item.value></apt-odds-format></div><div class=event-ticket-play-remove><button class=event-ticket-remove-btn data-ng-click=vmTicketEventsList.removeTicketEventItem(ticketEvent,item)></button></div></div><!-- ./Ticket ngRepeat --></div><!-- ./Ticket Item Odds Details --></div><!-- ./Ticket Item ngRepeat Finished --></div><style type=text/css>.search-container{\n        background: #1c2330;\n        padding:5px 20px 20px 20px;\n        margin-top: 20px;\n    }\n    .search-container h4{\n        text-align: left;\n    }\n    .search-container h4 span{\n        font-size: 0.95em;\n        font-weight: 700;\n        text-transform: uppercase;\n    }\n    .search-container .search-btn{\n        margin: 0;\n        padding: 10px 20px;\n        background: #18641b;\n        font-size:14px;\n        font-weight: 700;\n        border: none;\n        color: white;\n        text-transform: uppercase;\n    }\n    .search-container .search-btn:active{\n        background: #218825;\n    }\n    .search-container .search-btn:hover{\n        background: #218825;\n    }\n    .search-container .search-input{\n        padding: 9px 12px;\n        height: auto;\n    }</style>");
$templateCache.put("app/printManager/directives/copyticket/print-copyTicket.html","<div id=print-view-template><style>/**Modal Styles for Print**/\n        #headerArea,\n        #main-header,\n        #footerArea,\n        #back2Top,\n        .alert-warning,\n        .success,\n        .error,\n        .info ,\n        .toast {\n            display: none !important;\n            overflow: hidden;\n        }\n        @page {\n            size: auto;\n            margin: 0;\n            padding: 0;\n        }\n\n        body * {\n            visibility: hidden;\n        }\n\n        @media print {\n            body * {\n                visibility: visible;\n            }\n        }\n        .nvs-ticket-print-main-container {\n            font-size: 9px;\n            font-family: \"Arial\", sans-serif;\n            width: 100%;\n            overflow: visible;\n            position: relative;\n        }\n\n        .nvs-ticket-print-main-container .nvs-ticket-print-main-container * #ticket-content * {\n            visibility: visible;\n            height: 100%;\n            font-family: \"Arial\", sans-serif;\n            margin: 0;\n        }\n\n        .nvs-ticket-print-main-container .nvs-ticket-print-info-area {\n            border: 2px solid black;\n            width: 100%;\n            display: inline-block;\n            text-transform: uppercase;\n        }\n\n        .nvs-ticket-print-main-container .nvs-ticket-print-info-area .nvs-ticket-print-id {\n            float: left;\n            width: 100%;\n            border-bottom: 2px dotted black;\n        }\n\n        .nvs-ticket-print-main-container .nvs-ticket-print-info-area .nvs-ticket-print-id .nvs-print-id-caption {\n            float: left;\n            font-weight: 700;\n        }\n\n        .nvs-ticket-print-main-container .nvs-ticket-print-info-area .nvs-ticket-print-id .nvs-print-id {\n            float: right;\n        }\n\n        .nvs-ticket-print-main-container .nvs-ticket-print-info-area .nvs-ticket-user-id {\n            float: left;\n            width: 100%;\n        }\n\n        .nvs-ticket-print-main-container .nvs-ticket-print-info-area .nvs-ticket-user-id .nvs-print-user-id-caption {\n            float: left;\n            font-weight: 700;\n        }\n\n        .nvs-ticket-print-main-container .nvs-ticket-print-info-area .nvs-ticket-user-id .nvs-print-user-id {\n            float: right;\n        }\n\n        .nvs-ticket-print-main-container .nvs-ticket-print-multiple-combined {\n            border: 2px solid black;\n            width: 100%;\n            display: inline-block;\n            text-align: center;\n            text-transform: uppercase;\n            font-weight: 700;\n            margin: 2px 0px;\n        }\n\n        .nvs-ticket-print-main-container .nvs-ticket-print-copy-ticket {\n            text-align: center;\n            font-weight: bolder;\n            font-size: 14px;\n        }\n\n        .nvs-ticket-print-main-container .nvs-ticket-print-container {\n            border: 2px solid black;\n            width: 100%;\n        }\n\n        .nvs-ticket-print-main-container .nvs-ticket-print-container .nvs-ticket-print-event-container {\n            padding: 0;\n            border-bottom: 1px solid black;\n            line-height: 14px;\n        }\n\n        .nvs-ticket-print-main-container .nvs-ticket-print-container .nvs-ticket-print-event-container:last-child {\n            border-bottom: none;\n        }\n\n        .nvs-ticket-print-main-container .nvs-ticket-print-container .nvs-ticket-print-event-container .nvs-ticket-print-event-category-name {\n            font-weight: 700;\n            border-bottom: 1px dotted black;\n            padding: 5px 0;\n            margin: 0;\n            text-indent:10px;\n        }\n\n        .nvs-ticket-print-main-container .nvs-ticket-print-container .nvs-ticket-print-event-container .nvs-ticket-tournament-events-separate .nvs-ticket-print-event-name {\n            text-transform: uppercase;\n            font-weight: 700;\n            padding-left: 10px;\n            padding-top: 5px;\n        }\n\n        .status-live {\n            margin-right: 2px;\n        }\n\n        .status-live:before {\n            content: \'LIVE\';\n            border: 1px solid;\n            font-weight: 500;\n        }\n        .nvs-ticket-print-main-container .nvs-ticket-print-container .nvs-ticket-print-event-container .nvs-ticket-tournament-events-separate .nvs-ticket-print-event-date {\n            width: 100%;\n            display: inline-block;\n            padding-left: 10px;\n        }\n\n        .nvs-ticket-print-main-container .nvs-ticket-print-container .nvs-ticket-print-event-container .nvs-ticket-tournament-events-separate .nvs-ticket-print-selected-odds {\n            width: 100%;\n            display: inline-block;\n            padding-left: 10px;\n            padding-right: 10px;\n        }\n\n        .nvs-ticket-print-main-container .nvs-ticket-print-container .nvs-ticket-print-event-container .nvs-ticket-tournament-events-separate.nvs-ticket-print-selected-odds .ticket-odds-name {\n            float: left;\n        }\n\n        .nvs-ticket-print-main-container .nvs-ticket-print-container .nvs-ticket-print-event-container .nvs-ticket-tournament-events-separate .nvs-ticket-print-selected-odds .ticket-odds {\n            float: right;\n        }\n\n        .nvs-ticket-info-container {\n            width: 100%;\n            display: inline-block;\n            text-align: center;\n            margin: 2px 0px;\n        }\n\n        .nvs-ticket-print-type-area {\n            width: 15%;\n        }\n\n        .nvs-ticket-print-stake-area {\n            width: 45%;\n            float: left;\n        }\n\n        .nvs-ticket-print-min-profit-area {\n            width: 20%;\n            float: left;\n        }\n\n        .nvs-ticket-print-max-profit-area {\n            width: 20%;\n            float: left;\n        }\n\n        .nvs-ticket-print-currency-area {\n            width: 100%;\n            display: inline-block;\n            border: 2px solid;\n            text-align: center;\n            margin: 2px 0;\n        }\n\n        .nvs-ticket-print-currency-name {\n            float: left;\n            width: 50%;\n            text-align: right;\n        }\n\n        .nvs-ticket-print-currency-value {\n            float: right;\n            width: 50%;\n            text-align: left;\n        }\n\n        .nvs-ticket-info-container > div > span {\n            display: block;\n            border: 2px solid;\n            margin: 1px 1px 0px 0px;\n            text-transform: uppercase;\n            width: 99%;\n        }\n\n        .nvs-ticket-total-odds {\n            border: 2px solid;\n            width: 100%;\n            display: inline-block;\n            padding: 3px 10px;\n\n        }\n\n        .nvs-total-odds-name {\n            float: left;\n        }\n\n        .nvs-total-odds-value {\n            float: right;\n        }\n\n        .nvs-ticket-print-stake {\n            border: 2px solid;\n            width: 100%;\n            display: inline-block;\n            padding: 3px 10px;\n\n        }\n\n        .nvs-ticket-print-coupon-stake-name {\n            float: left;\n        }\n\n        .nvs-ticket-print-coupon-stake-value {\n            float: right;\n        }\n\n        .nvs-ticket-print-bonus {\n            border: 2px solid;\n            width: 100%;\n            font-weight: 700;\n            text-align: center;\n            text-transform: uppercase;\n        }\n\n        .nvs-ticket-print-bonus-name {\n            display: block;\n            border-bottom: 2px solid;\n            padding: 3px 0;\n\n        }\n\n        .nvs-ticket-print-bonus-value {\n            display: block;\n            padding: 3px 0;\n\n        }\n\n        .nvs-ticket-print-winnings-caption {\n            border: 2px solid;\n            width: 100%;\n            font-weight: 700;\n            text-align: center;\n            display: inline-block;\n            margin: 2px 0;\n            padding: 3px 0;\n            text-transform: uppercase;\n\n        }\n\n        .nvs-ticket-print-min-winnings-name {\n            float: left;\n            width: 50%;\n        }\n\n        .nvs-ticket-print-max-winnings-name {\n            float: right;\n            width: 50%;\n        }\n\n        .nvs-ticket-print-winnings-value {\n            border: 2px solid;\n            width: 100%;\n            font-weight: 700;\n            text-align: center;\n            display: inline-block;\n            padding: 3px 0;\n\n        }\n\n        .nvs-ticket-print-min-winnings-value {\n            float: left;\n            width: 50%;\n        }\n\n        .nvs-ticket-print-max-winnings-value {\n            float: right;\n            width: 50%;\n        }\n\n        .nvs-ticket-print-digit-code {\n            text-align: center;\n            border: 2px solid;\n            width: 100%;\n            margin: 2px 0px;\n\n        }\n\n        .nvs-ticket-print-coupon-info {\n            text-align: center;\n            border: 2px solid;\n            width: 100%;\n            margin: 2px 0px;\n\n        }\n        .nvs-ticket-print-coupon-info .print-cupon-date{\n            width: 100%;\n            padding: 3px 0;\n        }\n\n        .nvs-ticket-tournament-events-separate {\n            border-bottom: 2px dotted;\n        }\n\n        .nvs-ticket-tournament-events-separate:last-child {\n            border-bottom: none;\n        }\n\n        .nvs-ticket-print-main-container .barcodeArea {\n            margin-top: 10px;\n            width: 100%;\n            text-align: center;\n        }\n\n        .nvs-ticket-print-main-container .logo-area {\n            width: 100%;\n            overflow: hidden;\n            border-bottom: 3px solid black;\n            padding-bottom: 10px;\n        }\n\n        .nvs-ticket-print-main-container .logo-area img.logo {\n            margin-top: 20px;\n            width: 60%;\n            float: left;\n        }\n        .nvs-ticket-print-main-container .logo-area img.qr {\n            width: 30%;\n            margin-top: 15px;\n            float: right;\n        }\n        .nvs-ticket-info-container table{\n            width: 100%;\n            margin: 5px 0;\n        }\n        .nvs-ticket-info-container table tbody{\n              width: 100%;\n          }\n        .nvs-ticket-info-container table thead{\n            width: 100%;\n        }\n        .nvs-ticket-info-container table thead tr th{\n            border:2px solid #000000;\n            padding: 3px;\n            text-align: center;\n        }\n        .nvs-ticket-info-container table tbody tr td{\n            border:2px solid #000000;\n            padding: 3px;\n            text-align: center;\n        }\n\n\n\n        @media print {\n            .ui-notification {\n                display: none;\n            }\n\n            .loader.loader1 {\n                display: none;\n            }\n\n            .voucher-print-container {\n                visibility: visible;\n            }\n\n            .voucher-print-container * {\n                visibility: visible;\n            }\n        }</style><div class=\"loader loader1\"><div><div><div><div><div><div></div></div></div></div></div></div></div><div class=modal-body><div class=nvs-ticket-print-main-container><div class=logo-area><img class=logo data-ng-src={{vmCopyTicketCtrl.couponLogo}} alt=ticketLogo> <img class=qr data-ng-src={{vmCopyTicketCtrl.qrCodeImage}} alt=qrcode style=\"margin-top: 10px\"></div><div class=nvs-ticket-print-info-area><div class=nvs-ticket-print-id><span class=nvs-print-id-caption translate=betslip_id></span> <span class=nvs-print-id>{{vmCopyTicketCtrl.printData.code}}</span></div><div class=nvs-ticket-user-id><span class=nvs-print-user-id-caption translate=user></span> <span class=nvs-print-user-id>{{vmCopyTicketCtrl.printData.operator.id}} - {{vmCopyTicketCtrl.printData.operator.username}}</span></div></div><div class=nvs-ticket-print-multiple-combined>{{vmCopyTicketCtrl.printData.bets_type}} - {{vmCopyTicketCtrl.printData.type}}</div><div class=nvs-ticket-print-copy-ticket>*** Copy Ticket ***</div><div class=nvs-ticket-print-container><div class=nvs-ticket-print-event-container data-ng-repeat=\"item in vmCopyTicketCtrl.printData.items track by $index\"><div class=nvs-ticket-print-event-category-name><span>{{item.sport.name}} - {{item.category.name}} - {{item.tournament.name}}</span></div><div class=nvs-ticket-tournament-events-separate><div class=nvs-ticket-print-event-name data-ng-class=\"{\'status-live\':item.is_live}\"><span>{{item.event_name}}</span></div><div class=nvs-ticket-print-event-date><span>{{item.event_date | date:\"MM/dd/yyyy h:mm a\"}}</span></div><div class=nvs-ticket-print-selected-odds><span class=ticket-odds-name>{{item.market_name}} - ( {{item.odds_code}} )</span> <span class=ticket-odds>Odds : {{item.odds_value}}</span></div></div></div></div><div class=nvs-ticket-info-container><table><thead><tr><th class=nvs-ticket-print-type-name translate=type></th><th class=nvs-ticket-print-stake-name translate=stake></th><th class=nvs-ticket-print-min-profit-name translate=min></th><th class=nvs-ticket-print-max-profit-name translate=max></th><th class=nvs-ticket-print-currency-area data-ng-if=\"vmCopyTicketCtrl.printData.ticket_currency.symbol.length>1\"></th></tr></thead><tbody data-ng-repeat=\"sys in vmCopyTicketCtrl.printData.systems track by $index\"><tr><td class=nvs-ticket-print-type-value>{{sys.code}}</td><td class=nvs-ticket-print-stake-value>{{sys.combinations}} X {{vmCopyTicketCtrl.printData.ticket_currency.symbol}} {{sys.stake}} = {{vmCopyTicketCtrl.printData.ticket_currency.symbol}} {{sys.combinations*sys.stake}}</td><td class=nvs-ticket-print-min-profit-value>{{vmCopyTicketCtrl.printData.ticket_currency.symbol}} {{sys.min_win}}</td><td class=nvs-ticket-print-max-profit-value>{{vmCopyTicketCtrl.printData.ticket_currency.symbol}} {{sys.max_win}}</td></tr></tbody></table></div><div class=nvs-ticket-total-odds><span class=nvs-total-odds-name translate=total_odds></span> <span class=nvs-total-odds-value>{{vmCopyTicketCtrl.printData.total_odds}}</span></div><div class=nvs-ticket-print-stake><span class=nvs-ticket-print-coupon-stake-name translate=stake></span> <span class=nvs-ticket-print-coupon-stake-value>{{vmCopyTicketCtrl.printData.ticket_currency.symbol}} {{vmCopyTicketCtrl.printData.stake}}</span></div><div class=nvs-ticket-print-bonus><span class=nvs-ticket-print-bonus-name translate=bonus></span> <span class=nvs-ticket-print-bonus-value>||| {{vmCopyTicketCtrl.printData.ticket_currency.symbol}} {{vmCopyTicketCtrl.printData.min_bonus | currency}} |||</span></div><div class=nvs-ticket-print-winnings-caption><span class=nvs-ticket-print-min-winnings-name translate=min_winning></span> <span class=nvs-ticket-print-max-winnings-name translate=max_winning></span></div><div class=nvs-ticket-print-winnings-value><span class=nvs-ticket-print-min-winnings-value>||| {{vmCopyTicketCtrl.printData.ticket_currency.symbol}} {{vmCopyTicketCtrl.printData.min_win}} ||| </span><span class=nvs-ticket-print-max-winnings-value>||| {{vmCopyTicketCtrl.printData.ticket_currency.symbol}} {{vmCopyTicketCtrl.printData.max_win}} |||</span></div><div class=nvs-ticket-print-digit-code><span class=nvs-digit-code-name>Type the 4 digit code</span> <span class=nvs-digit-code-value>2241</span></div><div class=nvs-ticket-print-coupon-info><div class=print-cupon-date><span translate=checkout_at></span> : {{vmCopyTicketCtrl.printData.checkout_time | date:\"MM/dd/yyyy h:mm a\"}}</div><div class=print-cupon-date><span translate=printed_at></span> : {{vmCopyTicketCtrl.printData.checkout_time | date:\"MM/dd/yyyy h:mm a\"}}</div><span translate=information_area></span></div><div class=barcodeArea><barcode type=code128b string={{vmCopyTicketCtrl.barCode}} render=img options=vmCopyTicketCtrl.barcodeOptions></barcode></div></div></div></div>");
$templateCache.put("app/printManager/directives/coupon/print-coupon.html","<div id=print-view-template><style id=custom-saved-ticket-print-style>#main-header, #__bs_notify__, #back2Top {\n            display: none !important;\n        }\n\n        .saved-ticket-container {\n            visibility: hidden;\n        }\n\n        .saved-ticket-container {\n            visibility: hidden;\n            width: 69mm;\n            overflow: hidden;\n            font-family: sans-serif;\n            position: fixed;\n            top: 0;\n            left: 5px;\n            z-index: 500;\n            background-color: white;\n        }\n\n        .saved-ticket-container * {\n            -webkit-print-color-adjust: exact;\n            color: black;\n        }\n\n        .saved-ticket-container .saved-ticket-inner {\n            margin: 15px;\n            border: 1px dotted black;\n            float: left;\n            width: calc(100% - 30px);\n        }\n\n        .saved-ticket-container .saved-ticket-inner .log {\n            float: left;\n            width: 100%;\n            height: 100px;\n            text-align: center;\n        }\n\n        .saved-ticket-container .saved-ticket-inner .log img {\n            -webkit-filter: brightness(1);\n            filter: brightness(1);\n            margin-top: 20px;\n        }\n\n        .saved-ticket-container .saved-ticket-inner .date {\n            float: left;\n            width: 90%;\n            margin: 0 5%;\n            border-width: 2px 0 2px 0;\n            border-color: black;\n            border-style: solid;\n            height: 40px;\n            line-height: 40px;\n            overflow: hidden;\n        }\n\n        .saved-ticket-container .saved-ticket-inner .date span {\n            font-size: 14px;\n            text-transform: uppercase;\n            font-weight: 600;\n        }\n\n        .saved-ticket-container .saved-ticket-inner .date span.text {\n            float: left;\n        }\n\n        .saved-ticket-container .saved-ticket-inner .date span.value {\n            float: right;\n        }\n\n        .saved-ticket-container .saved-ticket-inner .booking-code {\n            float: left;\n            width: 100%;\n            text-align: center;\n            height: 140px;\n            text-transform: uppercase;\n        }\n\n        .saved-ticket-container .saved-ticket-inner .booking-code span {\n            height: 70px;\n            line-height: 70px;\n            font-size: 20px;\n        }\n\n        .saved-ticket-container .saved-ticket-inner .booking-code h1 {\n            font-size: 35px;\n            font-weight: bolder;\n            margin: 0;\n        }\n\n        .saved-ticket-container .saved-ticket-inner .barcode {\n            float: left;\n            width: 100%;\n            padding-bottom: 20px;\n        }\n\n        .saved-ticket-container .saved-ticket-inner .barcode img {\n            width: 90%;\n            height: 70px;\n            margin: 0 5%;\n        }\n\n        @media print {\n            .ui-notification {\n                display: none;\n            }\n\n            .loader.loader1 {\n                display: none;\n            }\n\n            .saved-ticket-container {\n                visibility: visible;\n            }\n\n            .saved-ticket-container * {\n                visibility: visible;\n            }\n        }</style><div class=\"loader loader1\"><div><div><div><div><div><div></div></div></div></div></div></div></div><div class=saved-ticket-container><div class=saved-ticket-inner><div class=log><img ng-src={{vmCouponPrinter.couponLogo}} alt=\"BookMaker Logo\"></div><div class=date><span class=text ng-translate translate=date></span> <span class=value>{{vmCouponPrinter.currentDate | timeZoneFilter}}</span></div><div class=booking-code><span ng-translate translate=booking_code></span><h1>{{vmCouponPrinter.couponCode}}</h1></div><div class=barcode><barcode type=code128b string={{vmCouponPrinter.couponCode}} render=img options=vmCouponPrinter.barcodeOptions></barcode></div></div></div></div>");
$templateCache.put("app/printManager/directives/ticket/print-ticket.html","<div id=print-view-template><style id=custom-saved-ticket-print-style type=text/css>#main-header, #__bs_notify__, #back2Top {\n            display: none !important;\n        }\n        #headerArea,\n        #main-header,\n        #footerArea,\n        #back2Top,\n        .alert-warning,\n        .success,\n        .error,\n        .info ,\n        .toast {\n            display: none !important;\n            overflow: hidden;\n        }\n        .event-ticket-remove-btn{\n            display: none !important;\n        }\n        .ticket-print-container {\n            visibility: hidden;\n        }\n\n        .ticket-print-container {\n            width: 69mm;\n            overflow: hidden;\n            font-family: sans-serif;\n            position: absolute;\n            left: 5px;\n            background-color: white;\n            padding: 5px;\n        }\n        .ticket-print-container * {\n            -webkit-print-color-adjust: exact;\n            color: black;\n            overflow: hidden;\n        }\n        .ticket-print-container .row {\n            margin: 0;\n        }\n        .ticket-print-container .logo {\n            overflow: hidden;\n            margin-bottom: 5px;\n            width: 100%;\n        }\n        .ticket-print-container .logo .logo-container {\n            float: left;\n            width: 60%;\n            padding-left: 10px;\n            padding-top: 15px;\n        }\n        .ticket-print-container .logo .logo-container img {\n            width: 100%;\n        }\n        .ticket-print-container .logo .qr-code-container {\n            float: right;\n            width: 25%;\n        }\n        .ticket-print-container .logo .qr-code-container img {\n            width: 100%;\n        }\n        .ticket-print-container .mainInfo {\n            border: 1px solid black;\n            font-size: 11px;\n            margin-bottom: 3px;\n            float: left;\n            width: 100%;\n        }\n        .ticket-print-container .mainInfo .row.ticket-border {\n            border-bottom: 1px dotted black;\n            line-height: 20px;\n            padding: 0 5px;\n            overflow: hidden;\n            height: 22px;\n        }\n        .ticket-print-container .mainInfo .row.ticket-border .left.bold {\n            text-transform: uppercase;\n            font-weight: bold;\n            float: left;\n        }\n        .ticket-print-container .mainInfo .row.ticket-border .right {\n            float: right;\n        }\n        .ticket-print-container .mainInfo .row.ticket-border:last-child {\n            border: 0;\n        }\n        .ticket-print-container .bet-type.printable {\n            border: 1px solid black;\n            line-height: 20px;\n            text-align: center;\n            font-weight: bold;\n            font-size: 12px;\n        }\n        .ticket-print-container .copyTicket {\n            text-align: center;\n            font-size: 13px;\n            float: left;\n            width: 100%;\n        }\n        .ticket-print-container .itemList {\n            border: 1px solid black;\n            font-size: 10px;\n            line-height: 15px;\n            float: left;\n            width: 100%;\n            border-bottom: 0;\n            margin-top: -1px;\n        }\n        .ticket-print-container .itemList .tournamentArea {\n            border-bottom: 1px dotted black;\n            padding: 0 5px;\n            font-weight: bolder;\n        }\n        .ticket-print-container .itemList .eventDetails {\n            border-bottom: 1px solid black;\n        }\n        .ticket-print-container .itemList .eventDetails .eventName {\n            font-weight: bold;\n            padding: 0 5px;\n        }\n        .ticket-print-container .itemList .eventDetails .eventDate {\n            line-height: inherit;\n            font-size: 10px;\n            padding: 0 5px;\n        }\n        .ticket-print-container .itemList .eventDetails .eventMarket {\n            position: relative;\n        }\n        .ticket-print-container .itemList .eventDetails .eventMarket .eventLiveBankerWrap {\n            float: right;\n            position: absolute;\n            right: 0;\n            top: -15px;\n            padding: 0 2px;\n            border: 1px solid black;\n            line-height: 10px;\n        }\n        .ticket-print-container .itemList .eventDetails .eventMarket .eventOddsContainer {\n            float: left;\n            width: 100%;\n            border-bottom: 1px solid black;\n            padding: 0 5px;\n        }\n        .ticket-print-container .itemList .eventDetails .eventMarket .eventOddsContainer .eventOddsCode {\n            float: left;\n        }\n        .ticket-print-container .itemList .eventDetails .eventMarket .eventOddsContainer .eventOddsRate {\n            width: 50%;\n            float: right;\n            text-align: right;\n        }\n        .ticket-print-container .itemList .eventDetails:last-child .eventOddsContainer {\n            border: 0;\n        }\n        .ticket-print-container .combinationList {\n            float: left;\n            width: 100%;\n            margin: 5px 0;\n            border: 1px solid;\n        }\n        .ticket-print-container .combinationList table {\n            border-collapse: separate;\n            border-spacing: 1px;\n            width: 100%;\n        }\n        .ticket-print-container .combinationList table tr {\n            text-align: center;\n        }\n        .ticket-print-container .combinationList table tr td, .ticket-print-container .combinationList table tr th {\n            border: 1px solid black;\n            font-size: 10px;\n        }\n        .ticket-print-container .combinationList table tr th {\n            text-align: center;\n        }\n        .ticket-print-container .stake {\n            border: 1px solid black;\n            float: left;\n            width: 100%;\n        }\n        .ticket-print-container .stake.first {\n            border-bottom: 0;\n            margin-top: 1px;\n        }\n        .ticket-print-container .stake.last {\n            margin-bottom: 2px;\n        }\n        .ticket-print-container .stake .stake-container table tr .stake-title {\n            white-space: nowrap;\n            padding: 0 3px;\n            font-size: 10px;\n        }\n        .ticket-print-container .stake .stake-container table tr .stake-dotted {\n            vertical-align: middle;\n            width: 100%;\n        }\n        .ticket-print-container .stake .stake-container table tr .stake-dotted div {\n            display: block;\n            width: 100%;\n            height: 0;\n            border-bottom: 2px dotted black;\n        }\n        .ticket-print-container .stake .stake-container table tr .stake-value {\n            white-space: nowrap;\n            padding: 0 3px;\n            text-align: right;\n            font-size: 10px;\n        }\n        .ticket-print-container .summerizeInfo {\n            margin-bottom: 1px;\n            float: left;\n            width: 100%;\n        }\n        .ticket-print-container .summerizeInfo .potential-max-winning, .ticket-print-container .summerizeInfo .potential-min-winning, .ticket-print-container .summerizeInfo .min-max-bonus, .ticket-print-container .summerizeInfo .total-win {\n            border: 1px solid black;\n            text-align: center;\n            padding: 0;\n            font-weight: bold;\n            font-size: 16px;\n        }\n        .ticket-print-container .summerizeInfo .potential-max-winning h4, .ticket-print-container .summerizeInfo .potential-min-winning h4, .ticket-print-container .summerizeInfo .min-max-bonus h4, .ticket-print-container .summerizeInfo .total-win h4 {\n            text-align: center;\n            text-transform: uppercase;\n            border-bottom: 1px solid black;\n            font-size: 12px;\n            font-weight: bold;\n            margin: 0;\n            line-height: 15px;\n        }\n        .ticket-print-container .summerizeInfo .potential-max-winning > div, .ticket-print-container .summerizeInfo .potential-min-winning > div, .ticket-print-container .summerizeInfo .min-max-bonus > div, .ticket-print-container .summerizeInfo .total-win > div {\n            font-size: 11px;\n            line-height: 15px;\n        }\n        .ticket-print-container .summerizeInfo .potential-min-winning .maxMinBonus {\n            float: left;\n            width: 50%;\n            border-bottom: 1px solid black;\n            border-left: 1px solid black;\n        }\n        .ticket-print-container .summerizeInfo .potential-min-winning .maxMinBonus:first-child {\n            border-left: none;\n        }\n        .ticket-print-container .summerizeInfo .total-win {\n            border-top: 0;\n            float: left;\n            width: 100%;\n        }\n        .ticket-print-container .summerizeInfo .total-win .fXXL {\n            float: left;\n            width: 50%;\n            text-align: center;\n            font-size: 10px;\n        }\n        .ticket-print-container .summerizeInfo .total-win .row h4 {\n            width: 50%;\n            float: left;\n            text-align: center;\n            display: inline-block;\n            font-size: 10px;\n        }\n        .ticket-print-container .security {\n            float: left;\n            width: 100%;\n            text-align: center;\n            margin: 0;\n            line-height: 20px;\n            font-size: 12px;\n        }\n        .ticket-print-container .security p {\n            margin: 0;\n        }\n        .ticket-print-container .informationArea {\n            float: left;\n            width: 100%;\n            text-align: center;\n            padding: 5px;\n            font-size: 10px;\n            border: 1px solid black;\n            margin: 1px 0 0 0;\n        }\n        .ticket-print-container .barcodeArea {\n            float: left;\n            width: 100%;\n            margin: 0;\n            height: 90px;\n            overflow: hidden;\n        }\n        .ticket-print-container .barcodeArea img {\n            width: 90%;\n            margin: 0 5%;\n        }\n\n\n        @media print {\n            .ui-notification {\n                display: none;\n            }\n            .loader.loader1 {\n                display: none;\n            }\n            .ticket-print-container  {\n                visibility: visible;\n            }\n            .ticket-print-container  * {\n                visibility: visible;\n            }\n        }</style><div class=\"loader loader1\"><div><div><div><div><div><div></div></div></div></div></div></div></div><div class=ticket-print-container><div class=content-container style=\"width: 100%; overflow: hidden\"><div class=logo><div class=logo-container><img data-ng-src={{vmTicketPrinter.ticketLogo}} alt=\"\" class=img-base-64></div><div class=qr-code-container><img data-ng-src={{vmTicketPrinter.base64Src}} alt=qrcode style=\"margin-top: 10px\"></div></div><div class=mainInfo><div class=\"row ticket-border\"><span class=\"left bold\" ng-translate translate=betslip_id></span> <span class=right>{{vmTicketPrinter.ticketData.code}}</span></div><div class=\"row ticket-border\"><span class=\"left bold\" ng-translate translate=user></span> <span class=right>{{vmTicketPrinter.ticketData.user.id}} - {{vmTicketPrinter.ticketData.user.username}}</span></div><div class=\"row ticket-border\" ng-if=\"!(vmTicketPrinter.ticketData.operator.sub_type == 1 && vmTicketPrinter.ticketData.operator.type == 2)\"><span class=\"left bold\" ng-translate translate=operator></span> <span class=right>{{vmTicketPrinter.ticketData.operator.id}} - {{vmTicketPrinter.ticketData.operator.username}}</span></div></div><div class=\"bet-type printable\"><div class=row ng-translate translate={{vmTicketPrinter.ticketData.type}}></div></div><div class=copyTicket ng-if=\"vmTicketPrinter.ticketData.is_printed==1 && vmTicketPrinter.ticketData.status != 7\"><div class=\"row center\">*** <span ng-translate translate=copy_ticket></span> ***</div></div><div class=copyTicket ng-if=\"vmTicketPrinter.ticketData.status == 7\"><div class=\"row center\">*** <span ng-translate translate=winning_ticket></span> ***</div></div><div class=itemList ng-repeat=\"item in vmTicketPrinter.ticketData.items\" ng-class=\"{\'last\': $last}\"><div class=tournamentArea><span data-ng-if=item.category_name>{{item.sport_name}} - {{item.category_name}} - {{item.tournament_name}}</span> <span style=\"text-transform: capitalize\" data-ng-if=!item.category_name>{{item.sport_name}} - {{item.tournament_name}}</span></div><div ng-repeat=\"event in item.events\" class=\"eventDetails clearfix\" ng-class=\"{\'last\': $last}\"><div data-ng-if=event.is_live class=eventName><span>{{event.event_name}}</span></div><div data-ng-if=!event.is_live class=eventName><span>{{event.code}} {{event.event_name}}</span></div><div class=eventDate>{{ event.event_date | timeZoneFilter}}</div><div class=eventMarket ng-repeat=\"item in event.items\"><div class=eventLiveBankerWrap ng-if=\"item.banker || item.is_live\"><span ng-if=item.banker class=eventBanker>B</span> <span ng-if=item.is_live class=eventLive ng-translate translate=live></span></div><div class=\"eventOddsContainer clearfix\"><div class=eventOddsCode><span>{{item.market_name}}</span> - <span>({{item.odds_name}}{{item.special_value ? \' / \' + item.special_value : \'\'}})</span></div><div class=eventOddsRate><span ng-translate translate=odds></span>: <span><data-nvs-palimpsest-odds-format odds={{item.odds_value}}></data-nvs-palimpsest-odds-format></span></div></div></div></div></div><div class=combinationList><table><tr><td ng-translate translate=type></td><td ng-translate translate=stake></td><td ng-if=\"vmTicketPrinter.ticketData.status != 7\" ng-translate translate=min></td><td ng-if=\"vmTicketPrinter.ticketData.status != 7\" ng-translate translate=max></td></tr><tr ng-repeat=\"system in vmTicketPrinter.ticketData.systems\"><td>{{system.code}}</td><td>{{system.combinations}} X<nvs-currency-format-filter value=system.stake></nvs-currency-format-filter>=<nvs-currency-format-filter value=\"(system.stake * system.combinations)\"></nvs-currency-format-filter></td><td ng-if=\"vmTicketPrinter.ticketData.status != 7\"><nvs-currency-format-filter value=system.min_win></nvs-currency-format-filter></td><td ng-if=\"vmTicketPrinter.ticketData.status != 7\"><nvs-currency-format-filter value=system.max_win></nvs-currency-format-filter></td></tr></table></div><div class=\"stake fXL first\"><div class=\"stake-container clearfix\"><table><tr><td class=stake-title><div ng-translate translate=total_odds></div></td><td class=stake-dotted><div></div></td><td class=stake-value><div>{{vmTicketPrinter.ticketData.total_odds}}</div></td></tr></table></div></div><div class=\"stake fXL last\"><div class=\"stake-container clearfix\"><table><tr><td class=stake-title><div ng-translate translate=stake></div></td><td class=stake-dotted><div></div></td><td class=stake-value><div><nvs-currency-format-filter value=vmTicketPrinter.ticketData.stake></nvs-currency-format-filter></div></td></tr></table></div></div><div class=summerizeInfo ng-if=\"vmTicketPrinter.ticketData.type_id != 3\"><div class=potential-max-winning><h4 ng-translate translate=bonus></h4><div><span>|||</span><nvs-currency-format-filter value=vmTicketPrinter.ticketData.min_bonus></nvs-currency-format-filter><span>|||</span></div></div><div class=\"total-win clearfix\" ng-if=\"vmTicketPrinter.ticketData.status != 7\"><div class=row><h4 ng-translate translate=min_winning></h4><h4 ng-translate translate=max_winning></h4></div><div class=fXXL><span>|||</span><nvs-currency-format-filter value=vmTicketPrinter.ticketData.min_win></nvs-currency-format-filter><span>|||</span></div><div class=fXXL><span>|||</span><nvs-currency-format-filter value=vmTicketPrinter.ticketData.max_win></nvs-currency-format-filter><span>|||</span></div></div><div class=potential-max-winning ng-if=\"vmTicketPrinter.ticketData.status == 6 || vmTicketPrinter.ticketData.status == 7\"><h4 ng-translate translate=winnings></h4><div><span>|||</span><nvs-currency-format-filter value=vmTicketPrinter.ticketData.winnings></nvs-currency-format-filter><span>|||</span></div></div></div><div class=summerizeInfo ng-if=\"vmTicketPrinter.ticketData.type_id == 3\"><div class=\"potential-min-winning clearfix\"><div class=maxMinBonus><h4 ng-translate translate=bonus></h4><div>Min:<nvs-currency-format-filter value=vmTicketPrinter.ticketData.min_bonus></nvs-currency-format-filter></div></div><div class=maxMinBonus><h4 ng-translate translate=bonus></h4><div>Max:<nvs-currency-format-filter value=vmTicketPrinter.ticketData.max_bonus></nvs-currency-format-filter></div></div></div><div class=\"potential-min-winning clearfix\" ng-if=\"vmTicketPrinter.ticketData.status != 7 || vmTicketPrinter.ticketData.status != 6\"><div class=maxMinBonus><h4 ng-translate translate=min_potential_win></h4><div><span>|||</span><nvs-currency-format-filter value=vmTicketPrinter.ticketData.min_win></nvs-currency-format-filter><span>|||</span></div></div><div class=maxMinBonus><h4 ng-translate translate=max_potential_win></h4><div><span>|||</span><nvs-currency-format-filter value=vmTicketPrinter.ticketData.max_win></nvs-currency-format-filter><span>|||</span></div></div></div><div class=\"total-win clearfix\"><h4 ng-translate translate=max_potential_winnings_bonus></h4><div class=\"fXXL clearfix\"><span>|||</span><nvs-currency-format-filter value=\"(vmTicketPrinter.ticketData.max_win + vmTicketPrinter.ticketData.max_bonus)\"></nvs-currency-format-filter><span>|||</span></div></div><div class=total-win ng-if=\"vmTicketPrinter.ticketData.status == 7 || vmTicketPrinter.ticketData.status == 6\"><h4 ng-translate translate=max_potential_winnings_bonus></h4><div class=fXXL><span>|||</span><nvs-currency-format-filter value=vmTicketPrinter.ticketData.winnings></nvs-currency-format-filter><span>|||</span></div></div></div><div class=security ng-if=\"vmTicketPrinter.ticketData.print_code && !vmTicketPrinter.ticketData.is_printed\"><p><span ng-translate translate=security_payment_code></span>:<storage>{{vmTicketPrinter.ticketData.print_code}}</storage></p></div></div><div class=informationArea><div class=\"row center\"><span class=my-bold><span ng-translate translate=checkout_at></span> : {{vmTicketPrinter.ticketData.checkout_time | timeZoneFilter}}<br><span ng-translate translate=printed_at></span> : {{vmTicketPrinter.ticketData.printDate | timeZoneFilter}}</span></div><div class=\"row center\"><span ng-translate translate=information_area></span></div></div><div class=copyTicket ng-if=\"vmTicketPrinter.ticketData.is_printed && vmTicketPrinter.ticketData.status != 7\"><div class=\"row center\">*** <span ng-translate translate=copy_ticket></span> ***</div></div><div class=copyTicket ng-if=\"vmTicketPrinter.ticketData.status == 7\"><div class=\"row center\">*** <span ng-translate translate=winning_ticket></span> ***</div></div><div class=barcodeArea ng-style=\"{\'margin-top\': !vmTicketPrinter.ticketData.is_printed ? \'15px\' : \'\'}\"><barcode type=code128b string={{vmTicketPrinter.ticketData.qcode}} render=img options=vmTicketPrinter.barcodeOptions></barcode></div></div></div>");
$templateCache.put("app/printManager/directives/voucher/print-voucher.html","<div id=print-view-template><style id=custom-saved-ticket-print-style>#headerArea,\n        #main-header,\n        #footerArea,\n        #back2Top,\n        .alert-warning,\n        .success,\n        .error,\n        .info ,\n        .toast {\n            display: none !important;\n            overflow: hidden;\n        }\n\n        @page {\n            margin: 0px;\n        }\n\n        .voucher-print-container {\n            visibility: hidden;\n        }\n\n        .voucher-print-container {\n            width: 69mm;\n            overflow: hidden;\n            font-family: sans-serif;\n            position: absolute;\n            left: 5px;\n            background-color: white;\n            padding: 0;\n            margin: 0;\n        }\n\n        .voucher-print-container * {\n            -webkit-print-color-adjust: exact;\n            color: black;\n        }\n\n        .voucher-print-container .logo-area {\n            width: 100%;\n            border-bottom: 3px solid black;\n            padding-bottom: 10px;\n            overflow: hidden;\n        }\n\n        .voucher-print-container .logo-area img.logo {\n            margin-top: 20px;\n            width: 60%;\n            float: left;\n        }\n\n        .voucher-print-container .logo-area img.qr {\n            width: 30%;\n            margin-top: 15px;\n            float: right;\n        }\n\n        .voucher-print-container .date_area .printed_at,\n        .voucher-print-container .date_area .expires_at {\n            width: 100%;\n            float: left;\n            border-bottom: 2px dotted black;\n            padding: 5px 0;\n        }\n\n        .voucher-print-container .date_area .printed_at p,\n        .voucher-print-container .date_area .expires_at p {\n            margin: 0;\n            font-size: 12px;\n            font-weight: 600;\n        }\n\n        .voucher-print-container .date_area .printed_at p:first-child,\n        .voucher-print-container .date_area .expires_at p:first-child {\n            width:45%;\n        }\n        .voucher-print-container .date_area .printed_at p:last-child,\n        .voucher-print-container .date_area .expires_at p:last-child {\n            width:55%;\n            text-align: right;\n        }\n\n        .voucher-print-container .date_area .printed_at p.text,\n        .voucher-print-container .date_area .expires_at p.text {\n            float: left;\n            text-transform: uppercase;\n        }\n\n        .voucher-print-container .date_area .printed_at p.value,\n        .voucher-print-container .date_area .expires_at p.value {\n            float: right;\n            text-transform: uppercase;\n        }\n\n        .voucher-print-container .amount-info-area-container {\n            float: left;\n        }\n\n        .voucher-print-container .amount-info-area-container .amount-info-area {\n            float: left;\n            width: 100%;\n            font-size: 25px;\n            text-align: center;\n            text-transform: uppercase;\n            border-bottom: 2px solid black;\n            height: 40px;\n        }\n\n        .voucher-print-container .amount-info-area-container .amount-info-area p,\n        .voucher-print-container .amount-info-area-container .amount-info-area span {\n            margin: 0;\n            line-height: 40px;\n        }\n\n        .voucher-print-container .amount-info-area-container .amount-info-area p b,\n        .voucher-print-container .amount-info-area-container .amount-info-area span b {\n            line-height: 40px;\n            font-weight: 900;\n            margin: 0 5px;\n        }\n\n        .voucher-print-container .information-area {\n            float: left;\n            padding: 15px 0;\n            font-size: 14px;\n            text-align: center;\n        }\n\n        .voucher-print-container .information-area span {\n            text-align: center;\n        }\n\n        .voucher-print-container .code-area-container {\n            width: 100%;\n            float: left;\n        }\n\n        .voucher-print-container .code-area-container p {\n            text-align: center;\n            font-size: 30px;\n            font-weight: 900;\n            margin: 0 5px;\n            line-height: 25px;\n        }\n\n        .voucher-print-container .barcode-area {\n            float: left;\n            width: 100%;\n            margin: 15px 0;\n            padding: 15px 0;\n            border-top: 2px dotted black;\n        }\n\n        .voucher-print-container .barcode-area img {\n            width: 90%;\n            margin: 0 5%;\n        }\n\n        @media print {\n            .ui-notification {\n                display: none;\n            }\n\n            .loader.loader1 {\n                display: none;\n            }\n\n            .voucher-print-container {\n                visibility: visible;\n            }\n\n            .voucher-print-container * {\n                visibility: visible;\n            }\n        }</style><div class=\"loader loader1\"><div><div><div><div><div><div></div></div></div></div></div></div></div><div class=voucher-print-container style=\"padding:0px; margin:0px\"><div class=modal-body><div class=voucher-wrapper><div class=header-top-info><div class=logo-area><img class=logo data-ng-src={{vmVoucherPrinter.couponLogo}} alt=ticketLogo> <img class=qr data-ng-src={{vmVoucherPrinter.base64Src}} alt=qrCode></div><div class=date_area><div class=printed_at><p ng-translate translate=printed_at class=\"uppercase text\"></p><p class=value>{{vmVoucherPrinter.voucherPrintData.created_at | timeZoneFilter}}</p></div><div class=expires_at><p ng-translate translate=expires_at class=\"expire-date uppercase text\"></p><p class=value>{{vmVoucherPrinter.voucherPrintData.expiration_date | timeZoneFilter}}</p></div></div><div class=amount-info-area-container><div class=amount-info-area><p>#<b>{{vmVoucherPrinter.voucherPrintData.amount | currency}}</b>#</p></div><div class=amount-info-area><span ng-if=\"vmVoucherPrinter.voucherPrintData.transfer_type == \'0\'\" ng-translate translate=withdraw></span> <span ng-if=\"vmVoucherPrinter.voucherPrintData.transfer_type == \'1\'\" ng-translate translate=deposit></span></div></div></div><div class=information-area><span ng-translate translate=voucher_information_area></span></div><div class=code-area-container><p class=voucher-code>{{vmVoucherPrinter.voucherPrintData.code}}</p></div><div class=barcode-area><barcode type=code128b string={{vmVoucherPrinter.barcode}} render=img options=vmVoucherPrinter.barcodeOptions></barcode></div></div></div></div></div>");
$templateCache.put("app/profile/accountTreeTable/views/account-tree-balance.html","<div class=nvs-BalanceReportTable-header nvs-user-type user=vmAccountTreeTable.reports.users[vmAccountTreeTable.ownerId] ng-if=vmAccountTreeTable.reports.users[vmAccountTreeTable.ownerId].isOpen><div class=\"nvs-BalanceReportTable-header-cell sub-level{{vmAccountTreeTable.reports.users[vmAccountTreeTable.ownerId].level}}\"><span ng-click=vmAccountTreeTable.toggleOpen(vmAccountTreeTable.ownerId) ng-if=\"vmAccountTreeTable.reports.users[vmAccountTreeTable.ownerId].childUsers.length > 0\" ng-class=\"{\'nvs-BalanceReportTable-header--cell-open\': !vmAccountTreeTable.reports.users[vmAccountTreeTable.ownerId].isOpen, \'nvs-BalanceReportTable-header--cell-close\': vmAccountTreeTable.reports.users[vmAccountTreeTable.ownerId].isOpen}\" aria-hidden=true></span></div><div class=\"nvs-BalanceReportTable-header-cell symbol-labels\">L{{vmAccountTreeTable.reports.users[vmAccountTreeTable.ownerId].level}}</div><div class=\"nvs-BalanceReportTable-header-cell symbol-labels\" nvs-user-symbol typeof=vmAccountTreeTable.reports.users[vmAccountTreeTable.ownerId]></div><div class=nvs-BalanceReportTable-header-cell>{{vmAccountTreeTable.reports.users[vmAccountTreeTable.ownerId].username}}</div><div class=nvs-BalanceReportTable-header-cell>{{vmAccountTreeTable.reports.users[vmAccountTreeTable.reports.users[vmAccountTreeTable.ownerId].owner_id].username ? vmAccountTreeTable.reports.users[vmAccountTreeTable.reports.users[vmAccountTreeTable.ownerId].owner_id].username : \'\'}}</div><div class=nvs-BalanceReportTable-header-cell ng-class=\"{\'nvs-negative-number\':vmAccountTreeTable.reports.users[vmAccountTreeTable.ownerId].report.balance<0}\"><data-nvs-currency-format value={{vmAccountTreeTable.reports.users[vmAccountTreeTable.ownerId].balance}}></data-nvs-currency-format></div><div class=nvs-BalanceReportTable-header-cell ng-class=\"{\'nvs-negative-number\':vmAccountTreeTable.reports.users[vmAccountTreeTable.ownerId].report.credit_limit<0}\"><data-nvs-currency-format value={{vmAccountTreeTable.reports.users[vmAccountTreeTable.ownerId].credit_limit}}></data-nvs-currency-format></div><div class=nvs-BalanceReportTable-header-cell ng-class=\"{\'nvs-negative-number\':vmAccountTreeTable.reports.users[vmAccountTreeTable.ownerId].report.available_balance<0}\"><!--Av.--><data-nvs-currency-format value={{vmAccountTreeTable.reports.users[vmAccountTreeTable.ownerId].available_balance}}></data-nvs-currency-format></div><div class=nvs-BalanceReportTable-header-cell ng-class=\"{\'nvs-negative-number\':vmAccountTreeTable.reports.users[vmAccountTreeTable.ownerId].report.total_balance<0}\"><data-nvs-currency-format value={{vmAccountTreeTable.reports.users[vmAccountTreeTable.ownerId].total_balance}}></data-nvs-currency-format></div><div class=nvs-BalanceReportTable-header-cell ng-class=\"{\'nvs-negative-number\':vmAccountTreeTable.reports.users[vmAccountTreeTable.ownerId].report.total_trust<0}\"><data-nvs-currency-format value={{vmAccountTreeTable.reports.users[vmAccountTreeTable.ownerId].total_trust}}></data-nvs-currency-format></div><div class=nvs-BalanceReportTable-header-cell ng-class=\"{\'nvs-negative-number\':vmAccountTreeTable.reports.users[vmAccountTreeTable.ownerId].report.total_available_balance<0}\"><data-nvs-currency-format value={{vmAccountTreeTable.reports.users[vmAccountTreeTable.ownerId].total_available_balance}}></data-nvs-currency-format></div></div><div class=nvs-BalanceReportTable-body ng-repeat=\"userId in vmAccountTreeTable.reports.users[vmAccountTreeTable.ownerId].childUsers track by $index\"><div class=nvs-BalanceReportTable-body-row ng-if=!vmAccountTreeTable.reports.users[userId].isOpen nvs-user-type user=vmAccountTreeTable.reports.users[userId]><div class=\"nvs-BalanceReportTable-body-cell sub-level{{vmAccountTreeTable.reports.users[userId].level}}\"><span ng-click=vmAccountTreeTable.toggleOpen(userId) ng-if=\"vmAccountTreeTable.reports.users[userId].childUsers.length > 0\" ng-class=\"{\'nvs-BalanceReportTable-body--cell-open\': !vmAccountTreeTable.reports.users[userId].isOpen, \'nvs-BalanceReportTable-body--cell-close\': vmAccountTreeTable.reports.users[userId].isOpen}\" aria-hidden=true></span></div><div class=\"nvs-BalanceReportTable-body-cell symbol-labels\">L{{vmAccountTreeTable.reports.users[userId].level}}</div><div class=\"nvs-BalanceReportTable-body-cell symbol-labels\" nvs-user-symbol typeof=vmAccountTreeTable.reports.users[userId]></div><div class=nvs-BalanceReportTable-body-cell>{{vmAccountTreeTable.reports.users[userId].username}}</div><div class=nvs-BalanceReportTable-body-cell>{{vmAccountTreeTable.reports.users[userId].owner_id}} - {{vmAccountTreeTable.reports.users[vmAccountTreeTable.reports.users[userId].owner_id].username}}</div><div class=nvs-BalanceReportTable-body-cell ng-class=\"{\'nvs-negative-number\':vmAccountTreeTable.reports.users[userId].report.balance<0}\"><data-nvs-currency-format value={{vmAccountTreeTable.reports.users[userId].balance}}></data-nvs-currency-format></div><div class=nvs-BalanceReportTable-body-cell ng-class=\"{\'nvs-negative-number\':vmAccountTreeTable.reports.users[userId].report.credit_limit<0}\"><data-nvs-currency-format value={{vmAccountTreeTable.reports.users[userId].credit_limit}}></data-nvs-currency-format></div><div class=nvs-BalanceReportTable-body-cell ng-class=\"{\'nvs-negative-number\':vmAccountTreeTable.reports.users[userId].report.available_balance<0}\"><data-nvs-currency-format value={{vmAccountTreeTable.reports.users[userId].available_balance}}></data-nvs-currency-format></div><div class=nvs-BalanceReportTable-body-cell ng-class=\"{\'nvs-negative-number\':vmAccountTreeTable.reports.users[userId].report.total_balance<0}\"><data-nvs-currency-format value={{vmAccountTreeTable.reports.users[userId].total_balance}}></data-nvs-currency-format></div><div class=nvs-BalanceReportTable-body-cell ng-class=\"{\'nvs-negative-number\':vmAccountTreeTable.reports.users[userId].report.total_trust<0}\"><data-nvs-currency-format value={{vmAccountTreeTable.reports.users[userId].total_trust}}></data-nvs-currency-format></div><div class=nvs-BalanceReportTable-body-cell ng-class=\"{\'nvs-negative-number\':vmAccountTreeTable.reports.users[userId].report.total_available_balance<0}\"><data-nvs-currency-format value={{vmAccountTreeTable.reports.users[userId].total_available_balance}}></data-nvs-currency-format></div></div><div class=nvs-BalanceReportTable-body-row ng-if=\"vmAccountTreeTable.reports.users[userId].childUsers.length > 0 && vmAccountTreeTable.reports.users[userId].isOpen\"><nvs-account-tree-table owner-id=userId template=balance reports=vmAccountTreeTable.reports class=nvs-BalanceReportTable></nvs-account-tree-table></div></div>");
$templateCache.put("app/profile/accountTreeTable/views/account-tree-list.html","<div class=nvs-AccountListTable-header nvs-user-type user=vmAccountTreeTable.reports.users[vmAccountTreeTable.ownerId] ng-if=vmAccountTreeTable.reports.users[vmAccountTreeTable.ownerId].isOpen><div class=\"nvs-AccountListTable-header-cell sub-level{{vmAccountTreeTable.reports.users[vmAccountTreeTable.ownerId].level}}\"><span ng-click=vmAccountTreeTable.toggleOpen(vmAccountTreeTable.ownerId) ng-if=\"vmAccountTreeTable.reports.users[vmAccountTreeTable.ownerId].childUsers.length > 0\" ng-class=\"{\'nvs-AccountListTable-header--cell-open\': !vmAccountTreeTable.reports.users[vmAccountTreeTable.ownerId].isOpen, \'nvs-AccountListTable-header--cell-close\': vmAccountTreeTable.reports.users[vmAccountTreeTable.ownerId].isOpen}\" aria-hidden=true></span></div><div class=\"nvs-AccountListTable-header-cell symbol-labels\">L{{vmAccountTreeTable.reports.users[vmAccountTreeTable.ownerId].level}}</div><div class=\"nvs-AccountListTable-header-cell symbol-labels\" nvs-user-symbol typeof=vmAccountTreeTable.reports.users[vmAccountTreeTable.ownerId]></div><div class=nvs-AccountListTable-header-cell>{{vmAccountTreeTable.reports.users[vmAccountTreeTable.ownerId].username}}</div><div class=nvs-AccountListTable-header-cell>{{vmAccountTreeTable.reports.users[vmAccountTreeTable.reports.users[vmAccountTreeTable.ownerId].owner_id].username ? vmAccountTreeTable.reports.users[vmAccountTreeTable.reports.users[vmAccountTreeTable.ownerId].owner_id].username : \'\'}}</div><div class=nvs-AccountListTable-header-cell ng-class=\"{\'nvs-negative-number\':vmAccountTreeTable.reports.users[vmAccountTreeTable.ownerId].report.balance<0}\"><data-nvs-currency-format-filter value=vmAccountTreeTable.reports.users[vmAccountTreeTable.ownerId].balance></data-nvs-currency-format-filter></div><div class=nvs-AccountListTable-header-cell ng-class=\"{\'nvs-negative-number\':vmAccountTreeTable.reports.users[vmAccountTreeTable.ownerId].report.credit_limit<0}\"><data-nvs-currency-format-filter value=vmAccountTreeTable.reports.users[vmAccountTreeTable.ownerId].credit_limit></data-nvs-currency-format-filter></div><div class=nvs-AccountListTable-header-cell>enabled</div><div class=nvs-AccountListTable-header-cell><div class=nvs-AffiliateTransferTable-body--btn-wrapper><button class=nvs-AffiliateTransferTable-body--transfer-withdraw uib-tooltip=\"{{\'withdraw\'| translate}}\" ng-click=vmAccountTreeTable.withdrawTransfer(vmAccountTreeTable.transferAmounts[vmAccountTreeTable.ownerId],vmAccountTreeTable.ownerId)><span class=nvs-AffiliateTransferTable-body--transfer-withdraw-icon></span></button> <input type=number class=nvs-AffiliateTransferTable-body--transfer-value ng-model=vmAccountTreeTable.transferAmounts[vmAccountTreeTable.ownerId] ng-placeholder placeholder=type_in_amount> <button class=nvs-AffiliateTransferTable-body--transfer-deposit uib-tooltip=\"{{\'deposit\'| translate}}\" ng-click=vmAccountTreeTable.depositTransfer(vmAccountTreeTable.transferAmounts[vmAccountTreeTable.ownerId],vmAccountTreeTable.ownerId)><span class=nvs-AffiliateTransferTable-body--transfer-deposit-icon></span></button></div></div><div class=\"nvs-AccountListTable-header-cell actions\"><button class=\"nvs-AccountListTable-header-cell--action-btn editPassword-btn\" ng-click=vmAccountTreeTable.changePassword(userId)><i class=\"fa fa-key\"></i></button> <button class=\"nvs-AccountListTable-header-cell--action-btn cancel-user-btn\" ng-click=vmAccountTreeTable.disableUser(userId)><i class=\"fa fa-user-times\"></i></button> <button class=\"nvs-AccountListTable-header-cell--action-btn transfer-btn\" ng-if=\"vmAccountTreeTable.reports.users[userId].childUsers.length >= 0\" ng-click=vmAccountTreeTable.transfer(userId)><i class=\"fa fa-money\"></i></button></div></div><div class=nvs-AccountListTable-body data-ng-repeat=\"userId in vmAccountTreeTable.reports.users[vmAccountTreeTable.ownerId].childUsers | filter:vmAccountTreeTable.filterById(vmAccountTreeTable.data.userId) track by $index\"><div class=nvs-AccountListTable-body-row ng-if=!vmAccountTreeTable.reports.users[userId].isOpen nvs-user-type user=vmAccountTreeTable.reports.users[userId]><div class=\"nvs-AccountListTable-body-cell sub-level{{vmAccountTreeTable.reports.users[userId].level}}\"><span ng-click=vmAccountTreeTable.toggleOpen(userId) ng-if=\"vmAccountTreeTable.reports.users[userId].childUsers.length > 0\" ng-class=\"{\'nvs-AccountListTable-body--cell-open\': !vmAccountTreeTable.reports.users[userId].isOpen, \'nvs-AccountListTable-body--cell-close\': vmAccountTreeTable.reports.users[userId].isOpen}\" aria-hidden=true></span></div><div class=\"nvs-AccountListTable-body-cell symbol-labels\">L{{vmAccountTreeTable.reports.users[userId].level}}</div><div class=\"nvs-AccountListTable-body-cell symbol-labels\" nvs-user-symbol typeof=vmAccountTreeTable.reports.users[userId]></div><div class=nvs-AccountListTable-body-cell>{{vmAccountTreeTable.reports.users[userId].username}}</div><div class=nvs-AccountListTable-body-cell>{{vmAccountTreeTable.reports.users[userId].owner_id}} - {{vmAccountTreeTable.reports.users[vmAccountTreeTable.reports.users[userId].owner_id].username}}</div><div class=nvs-AccountListTable-body-cell ng-class=\"{\'nvs-negative-number\':vmAccountTreeTable.reports.users[userId].report.balance<0}\"><data-nvs-currency-format-filter value=vmAccountTreeTable.reports.users[userId].balance></data-nvs-currency-format-filter></div><div class=nvs-AccountListTable-body-cell ng-class=\"{\'nvs-negative-number\':vmAccountTreeTable.reports.users[userId].report.credit_limit<0}\"><data-nvs-currency-format-filter value=vmAccountTreeTable.reports.users[userId].credit_limit></data-nvs-currency-format-filter></div><div class=nvs-AccountListTable-body-cell>disabled</div><div class=nvs-AccountListTable-body-cell><div class=nvs-AffiliateTransferTable-body--btn-wrapper><button class=nvs-AffiliateTransferTable-body--transfer-withdraw uib-tooltip=\"{{\'withdraw\'| translate}}\" ng-click=vmAccountTreeTable.withdrawTransfer(vmAccountTreeTable.transferAmounts[userId],userId)><span class=nvs-AffiliateTransferTable-body--transfer-withdraw-icon></span></button> <input type=number class=nvs-AffiliateTransferTable-body--transfer-value ng-model=vmAccountTreeTable.transferAmounts[userId] ng-placeholder placeholder=type_in_amount> <button class=nvs-AffiliateTransferTable-body--transfer-deposit uib-tooltip=\"{{\'deposit\'| translate}}\" ng-click=vmAccountTreeTable.depositTransfer(vmAccountTreeTable.transferAmounts[userId],userId)><span class=nvs-AffiliateTransferTable-body--transfer-deposit-icon></span></button></div></div><div class=\"nvs-AccountListTable-body-cell actions\"><button class=\"nvs-AccountListTable-body-cell--action-btn editPassword-btn\" ng-click=vmAccountTreeTable.changePassword(userId)><i class=\"fa fa-key\"></i></button> <button class=\"nvs-AccountListTable-body-cell--action-btn cancel-user-btn\" ng-click=vmAccountTreeTable.disableUser(userId)><i class=\"fa fa-user-times\"></i></button> <button class=\"nvs-AccountListTable-body-cell--action-btn transfer-btn\" ng-if=\"vmAccountTreeTable.reports.users[userId].childUsers.length >= 0\" ng-click=vmAccountTreeTable.transfer(userId)><i class=\"fa fa-money\"></i></button></div></div><div class=nvs-AccountListTable-body-row ng-if=\"vmAccountTreeTable.reports.users[userId].childUsers.length > 0 && vmAccountTreeTable.reports.users[userId].isOpen\"><nvs-account-tree-table owner-id=userId template=list reports=vmAccountTreeTable.reports class=nvs-AccountListTable></nvs-account-tree-table></div></div>");
$templateCache.put("app/profile/accountTreeTable/views/account-tree-revenue.html","<div ng-class=\"{\'virtual-game\':vmAccountTreeTable.filter.product===\'virtual_game\'}\"><div class=nvs-RevenueReportTable-header ng-if=vmAccountTreeTable.reports.users[vmAccountTreeTable.ownerId].isOpen nvs-user-type user=vmAccountTreeTable.reports.users[vmAccountTreeTable.ownerId]><div class=\"nvs-RevenueReportTable-header-cell sub-level{{vmAccountTreeTable.reports.users[vmAccountTreeTable.ownerId].level}}\"><i class=\"fa fa-2x\" ng-click=vmAccountTreeTable.toggleOpen(vmAccountTreeTable.ownerId) ng-if=\"vmAccountTreeTable.reports.users[vmAccountTreeTable.ownerId].childUsers.length > 0\" ng-class=\"{\'fa fa-plus\': !vmAccountTreeTable.reports.users[vmAccountTreeTable.ownerId].isOpen, \'fa fa-minus\': vmAccountTreeTable.reports.users[vmAccountTreeTable.ownerId].isOpen}\" aria-hidden=true></i></div><div class=\"nvs-RevenueReportTable-header-cell symbol-labels\">L{{vmAccountTreeTable.reports.users[vmAccountTreeTable.ownerId].level}}</div><div class=\"nvs-RevenueReportTable-header-cell symbol-labels\" nvs-user-symbol typeof=vmAccountTreeTable.reports.users[vmAccountTreeTable.ownerId]></div><div class=nvs-RevenueReportTable-header-cell>{{vmAccountTreeTable.reports.users[vmAccountTreeTable.ownerId].username}}</div><div class=nvs-RevenueReportTable-header-cell>{{vmAccountTreeTable.reports.users[vmAccountTreeTable.reports.users[vmAccountTreeTable.ownerId].owner_id].username ? vmAccountTreeTable.reports.users[vmAccountTreeTable.reports.users[vmAccountTreeTable.ownerId].owner_id].username : \'\'}}</div><div class=\"nvs-RevenueReportTable-header-cell market-label\" ng-if=\"vmAccountTreeTable.filter.product===\'virtual_game\'\"><button class=market-toggle ng-click=vmAccountTreeTable.selectedUserMarket(vmAccountTreeTable.ownerId)>show/hide</button></div><div class=\"nvs-RevenueReportTable-header-cell ticket-label\">{{vmAccountTreeTable.reports.users[vmAccountTreeTable.ownerId].report.total_game}}</div><div class=nvs-RevenueReportTable-header-cell ng-class=\"{\'nvs-negative-number\':vmAccountTreeTable.reports.users[vmAccountTreeTable.ownerId].report.average_ticket<0}\"><data-nvs-currency-format value={{vmAccountTreeTable.reports.users[vmAccountTreeTable.ownerId].report.average_ticket}}></data-nvs-currency-format></div><div class=nvs-RevenueReportTable-header-cell ng-class=\"{\'nvs-negative-number\':vmAccountTreeTable.reports.users[vmAccountTreeTable.ownerId].report.total_stake<0}\"><!--Av.--><data-nvs-currency-format value={{vmAccountTreeTable.reports.users[vmAccountTreeTable.ownerId].report.total_stake}}></data-nvs-currency-format></div><div class=nvs-RevenueReportTable-header-cell ng-class=\"{\'nvs-negative-number\':vmAccountTreeTable.reports.users[vmAccountTreeTable.ownerId].report.total_winnings<0}\"><data-nvs-currency-format value={{vmAccountTreeTable.reports.users[vmAccountTreeTable.ownerId].report.total_winnings}}></data-nvs-currency-format></div><div class=nvs-RevenueReportTable-header-cell ng-if=\"vmAccountTreeTable.filter.product===\'virtual_game\'\" ng-class=\"{\'nvs-negative-number\':vmAccountTreeTable.reports.users[vmAccountTreeTable.ownerId].report.jackpot<0}\"><data-nvs-currency-format value=\"{{vmAccountTreeTable.reports.users[vmAccountTreeTable.ownerId].report.jackpot ? vmAccountTreeTable.reports.users[vmAccountTreeTable.ownerId].report.jackpot : 0}}\"></data-nvs-currency-format></div><div class=nvs-RevenueReportTable-header-cell ng-class=\"{\'nvs-negative-number\':vmAccountTreeTable.reports.users[vmAccountTreeTable.ownerId].report.total_profit<0}\"><data-nvs-currency-format value={{vmAccountTreeTable.reports.users[vmAccountTreeTable.ownerId].report.total_profit}}></data-nvs-currency-format></div></div><div class=nvs-RevenueReportTable-body-row ng-if=\"vmAccountTreeTable.reports.users[vmAccountTreeTable.ownerId].report.items && vmAccountTreeTable.selectedMarkets[vmAccountTreeTable.ownerId] && vmAccountTreeTable.filter.product===\'virtual_game\'\"><div class=nvs-RevenueReport-market-body ng-repeat=\"(key,value) in vmAccountTreeTable.reports.users[vmAccountTreeTable.ownerId].report.items track by $index\"><div class=nvs-RevenueReport-market-body-row><div class=nvs-RevenueReport-market-body-cell>{{value.market}}</div><div class=nvs-RevenueReport-market-body-cell>{{value.total_game}}</div><div class=nvs-RevenueReport-market-body-cell ng-class=\"{\'nvs-negative-number\':value.average_ticket<0}\"><data-nvs-currency-format value={{value.average_ticket}}></data-nvs-currency-format></div><div class=nvs-RevenueReport-market-body-cell ng-class=\"{\'nvs-negative-number\':value.total_stake<0}\"><data-nvs-currency-format value={{value.total_stake}}></data-nvs-currency-format></div><div class=nvs-RevenueReport-market-body-cell ng-class=\"{\'nvs-negative-number\':value.total_winnings<0}\"><data-nvs-currency-format value={{value.total_winnings}}></data-nvs-currency-format></div><div class=nvs-RevenueReport-market-body-cell ng-class=\"{\'nvs-negative-number\':value.jackpot<0}\"><data-nvs-currency-format value={{value.jackpot}}></data-nvs-currency-format></div><div class=nvs-RevenueReport-market-body-cell ng-class=\"{\'nvs-negative-number\':value.total_profit<0}\"><data-nvs-currency-format value={{value.total_profit}}></data-nvs-currency-format></div></div></div></div><div class=nvs-RevenueReportTable-body ng-repeat=\"userId in vmAccountTreeTable.reports.users[vmAccountTreeTable.ownerId].childUsers track by $index\"><div class=nvs-RevenueReportTable-body-row ng-if=!vmAccountTreeTable.reports.users[userId].isOpen nvs-user-type user=vmAccountTreeTable.reports.users[userId]><div class=\"nvs-RevenueReportTable-body-cell sub-level{{vmAccountTreeTable.reports.users[userId].level}}\"><i class=\"fa fa-2x\" ng-click=vmAccountTreeTable.toggleOpen(userId) ng-if=\"vmAccountTreeTable.reports.users[userId].childUsers.length > 0\" ng-class=\"{\'fa fa-plus\': !vmAccountTreeTable.reports.users[userId].isOpen, \'fa fa-minus\': vmAccountTreeTable.reports.users[userId].isOpen}\" aria-hidden=true></i></div><div class=\"nvs-RevenueReportTable-body-cell symbol-labels\">L{{vmAccountTreeTable.reports.users[userId].level}}</div><div class=\"nvs-RevenueReportTable-body-cell symbol-labels\" nvs-user-symbol typeof=vmAccountTreeTable.reports.users[userId]></div><div class=nvs-RevenueReportTable-body-cell>{{vmAccountTreeTable.reports.users[userId].username}}</div><div class=nvs-RevenueReportTable-body-cell>{{vmAccountTreeTable.reports.users[userId].owner_id}} - {{vmAccountTreeTable.reports.users[vmAccountTreeTable.reports.users[userId].owner_id].username}}</div><div class=\"nvs-RevenueReportTable-body-cell market-label\" ng-if=\"vmAccountTreeTable.filter.product===\'virtual_game\'\"><button class=market-toggle ng-click=vmAccountTreeTable.selectedUserMarket(userId)>show/hide</button></div><div class=\"nvs-RevenueReportTable-body-cell ticket-label\">{{vmAccountTreeTable.reports.users[userId].report.total_game}}</div><div class=nvs-RevenueReportTable-body-cell ng-class=\"{\'nvs-negative-number\':vmAccountTreeTable.reports.users[userId].report.average_ticket<0}\"><data-nvs-currency-format value={{vmAccountTreeTable.reports.users[userId].report.average_ticket}}></data-nvs-currency-format></div><div class=nvs-RevenueReportTable-body-cell ng-class=\"{\'nvs-negative-number\':vmAccountTreeTable.reports.users[userId].report.total_stake<0}\"><data-nvs-currency-format value={{vmAccountTreeTable.reports.users[userId].report.total_stake}}></data-nvs-currency-format></div><div class=nvs-RevenueReportTable-body-cell ng-class=\"{\'nvs-negative-number\':vmAccountTreeTable.reports.users[userId].report.total_winnings<0}\"><data-nvs-currency-format value={{vmAccountTreeTable.reports.users[userId].report.total_winnings}}></data-nvs-currency-format></div><div class=nvs-RevenueReportTable-body-cell ng-if=\"vmAccountTreeTable.filter.product===\'virtual_game\'\" ng-class=\"{\'nvs-negative-number\':vmAccountTreeTable.reports.users[userId].report.jackpot<0}\"><data-nvs-currency-format value=\"{{vmAccountTreeTable.reports.users[userId].report.jackpot ?\n                vmAccountTreeTable.reports.users[userId].report.jackpot : 0}}\"></data-nvs-currency-format></div><div class=nvs-RevenueReportTable-body-cell ng-class=\"{\'nvs-negative-number\':vmAccountTreeTable.reports.users[userId].report.total_profit<0}\"><data-nvs-currency-format value={{vmAccountTreeTable.reports.users[userId].report.total_profit}}></data-nvs-currency-format></div></div><div class=nvs-RevenueReportTable-body-row ng-if=\"vmAccountTreeTable.reports.users[userId].report.items && vmAccountTreeTable.selectedMarkets[userId] && vmAccountTreeTable.filter.product===\'virtual_game\'\"><div class=nvs-RevenueReport-market-body ng-repeat=\"(key,value) in vmAccountTreeTable.reports.users[userId].report.items track by $index\"><div class=nvs-RevenueReport-market-body-row><div class=nvs-RevenueReport-market-body-cell>{{value.market}}</div><div class=nvs-RevenueReport-market-body-cell>{{value.total_game}}</div><div class=nvs-RevenueReport-market-body-cell ng-class=\"{\'nvs-negative-number\':value.average_ticket<0}\"><data-nvs-currency-format value={{value.average_ticket}}></data-nvs-currency-format></div><div class=nvs-RevenueReport-market-body-cell ng-class=\"{\'nvs-negative-number\':value.total_stake<0}\"><data-nvs-currency-format value={{value.total_stake}}></data-nvs-currency-format></div><div class=nvs-RevenueReport-market-body-cell ng-class=\"{\'nvs-negative-number\':value.total_winnings<0}\"><data-nvs-currency-format value={{value.total_winnings}}></data-nvs-currency-format></div><div class=nvs-RevenueReport-market-body-cell ng-class=\"{\'nvs-negative-number\':value.jackpot<0}\"><data-nvs-currency-format value={{value.jackpot}}></data-nvs-currency-format></div><div class=nvs-RevenueReport-market-body-cell ng-class=\"{\'nvs-negative-number\':value.total_profit<0}\"><data-nvs-currency-format value={{value.total_profit}}></data-nvs-currency-format></div></div></div></div><div class=nvs-RevenueReportTable-body-row ng-if=\"vmAccountTreeTable.reports.users[userId].childUsers.length > 0 && vmAccountTreeTable.reports.users[userId].isOpen\"><nvs-account-tree-table owner-id=userId template=revenue reports=vmAccountTreeTable.reports class=nvs-RevenueReportTable></nvs-account-tree-table></div></div></div>");
$templateCache.put("app/profile/betHistory/betHistoryDetail/bet-history-detail.html","<apt-bet-history-detail-content></apt-bet-history-detail-content>");
$templateCache.put("app/profile/money/voucher/create-withdraw.html","<div class=\"clearfix wrapper\"><h4 ng-translate translate=create_withdraw></h4><div class=\"col-xs-12 bottom\"><div class=\"col-xs-12 left\"><div class=button_wrapper data-ng-repeat=\"button in vmVoucherCreateWithdraw.stakeButtons track by $index\" ng-if=\"$index < 6\"><button ng-click=vmVoucherCreateWithdraw.setAmount(button) class=\"btn btn-sm\" data-ng-class=\"{\'active\':vmVoucherCreateWithdraw.amount==button.stake}\"><span apt-currency-format button-stake=button.stake></span></button></div><div class=col-xs-12><input type=number class=form-control data-ng-model=vmVoucherCreateWithdraw.amount ng-pattern=/^(0|\\-?[1-9][0-9]*)$/ ng-placeholder placeholder=amount ng-virtual-keyboard=\"{kt: \'Numerico\'}\"></div></div><div class=\"col-xs-6 right\"><button class=\"btn btn-lg create\" data-ng-click=vmVoucherCreateWithdraw.createWithdraw()><span ng-translate translate=create></span></button> <button class=\"btn btn-lg reset\" data-ng-click=vmVoucherCreateWithdraw.resetAmount()><span ng-translate translate=reset_amount></span></button></div><div class=\"col-xs-6 right\"><button class=\"btn btn-lg print\" data-ng-click=vmVoucherCreateWithdraw.printWithdraw(vmVoucherCreateWithdraw.voucherData) ng-disabled=vmVoucherCreateWithdraw.buttonsStatus.printTicketButtonStatus><span ng-translate translate=print></span></button> <button class=\"btn btn-lg export\" data-ng-click=vmVoucherCreateWithdraw.exportWithdraw() ng-disabled=vmVoucherCreateWithdraw.buttonsStatus.exportTicketButtonStatus><span ng-translate translate=export></span></button></div></div></div>");
$templateCache.put("app/profile/money/voucher/redeem-deposit.html","<div class=wrapper><div class=\"col-lg-offset-3 col-lg-6\"><h4 ng-translate translate=redeem_deposit></h4><label for=voucher ng-translate translate=voucher_id_code></label><input type=text class=form-control name=voucher data-ng-model=vmVoucherRedeemDeposit.code ng-placeholder placeholder=voucher_id_code ng-virtual-keyboard=\"\"></div><div class=\"col-lg-offset-3 col-lg-6\"><button type=button class=\"btn btn-lg btn-success\" data-ng-click=vmVoucherRedeemDeposit.redeemDeposit()><span ng-translate translate=deposit></span></button></div></div>");
$templateCache.put("app/profile/money/voucher/voucher-export-popup.html","<div id=exportContainer class=clearfix><div class=\"container printable\"><div class=modal-body><div class=voucher-wrapper><div class=header-top-info><div class=logo-area><img src=\"\" alt=\"\"></div><div class=\"amount-info-area clearfix\"><span>#{{voucherExportData.amount}}#</span></div><div class=\"amount-info-area clearfix\"><span ng-if=\"voucherExportData.transfer_type == \'0\'\">Withdraw</span> <span ng-if=\"voucherExportData.transfer_type == \'1\'\">Deposit</span></div></div><div class=\"code-area-container clearfix\"><div class=code-area-left><img data-ng-src={{base64Src}} alt=qrcode></div><div class=code-area-right><p translate=printed_at class=uppercase></p><p>{{voucherExportData.created_at}}</p><p class=line></p><p translate=expires_at class=\"expire-date uppercase\"></p><p data-ng-if=voucherExportData.expiration_date>{{voucherExportData.expiration_date}}</p><br><p data-ng-if=!voucherExportData.expiration_date></p><p class=voucher-code>{{voucherExportData.code}}</p></div></div></div><div class=barcode-area><barcode type=code128b string={{barcode}} render=img options=barcodeOptions></barcode></div></div><div class=information-area><span translate=voucher_information_area>The owner of this printed receipt is the only person entitled to withdraw the potential winnings. Printing of this receipt constitutes a full acceptance of all MyBetArena terms & conditions on the part of the owner. This transaction, sent froma shop licensed by MyBetArena and accepted from the company itself. The potencial winnings indicated on this coupon are inteded as a guideline, and the final calculation could be different.</span></div></div></div>");
$templateCache.put("app/profile/money/voucher/voucher-list-filter.html","<div class=\"clearfix main-box\"><div class=transaction-history><div class=row><div class=\"col-md-12 col-lg-9\"><div class=row><div class=col-xs-4><label for=voucherListFilterDateRange ng-translate translate=date_range></label><div class=\"input-group dark-gray-input-group\"><div class=input-group-addon><i class=\"fa fa-calendar\" aria-hidden=true></i></div><input date-range-picker=\"\" id=voucherListFilterDateRange name=voucherListFilterDateRange class=\"form-control date-picker\" type=text ng-model=vmVoucherListFilter.date required options=vmVoucherListFilter.dateOptions></div></div><div class=col-xs-4><div class=form-group><label for=vocuherListFilterDateTypeSelection ng-translate translate=date_type></label><select class=\"form-control dark-input\" id=vocuherListFilterDateTypeSelection ng-model=vmVoucherListFilter.data.date_type><option value=closing_date ng-translate translate=closing_date></option><option value=issue_date ng-translate translate=issue_date></option></select></div></div><div class=col-xs-4><div class=form-group><label for=voucherFilterStatusSelection ng-translate translate=status></label><select class=\"form-control dark-input\" id=voucherFilterStatusSelection ng-model=vmVoucherListFilter.data.status><option value=\"\" ng-translate translate=all_status></option><option value=1 ng-translate translate=confirmed></option><option value=3 ng-translate translate=cancelled></option><option value=2 ng-translate translate=pending></option></select></div></div></div><div class=row><div class=col-xs-3><label ng-translate translate=code></label><input type=text class=\"form-control dark-input\" data-ng-model=vmVoucherListFilter.data.code ng-virtual-keyboard=\"\"></div><div class=col-xs-3><label ng-translate translate=min_amount></label><input type=text class=\"form-control dark-input\" data-ng-model=vmVoucherListFilter.data.min_amount ng-virtual-keyboard=\"{kt: \'Numerico\'}\"></div><div class=col-xs-3><label ng-translate translate=max_amount></label><input type=text class=\"form-control dark-input\" data-ng-model=vmVoucherListFilter.data.max_amount ng-virtual-keyboard=\"{kt: \'Numerico\'}\"></div><div class=col-xs-3><label style=\"height: 15px\"></label><button class=\"btn btn-success btn-md search\" ng-click=vmVoucherListFilter.search()><i class=\"fa fa-search\" aria-hidden=true></i> <span ng-translate translate=search></span></button></div></div></div><div class=\"col-md-12 col-lg-3\"><div class=row><div class=list-item><span><strong ng-translate translate=total_deposit></strong>: </span><span class=pull-right><nvs-currency-format-filter value=vmVoucherListFilter.voucherTotalData.deposit class=\"ng-binding ng-isolate-scope\"></nvs-currency-format-filter></span></div><div class=list-item><span><strong ng-translate translate=no_deposit></strong>: </span><span class=pull-right>{{vmVoucherListFilter.voucherTotalData.deposit_count}}</span></div><div class=list-item><span><strong ng-translate translate=total_withdraw></strong>: </span><span class=pull-right><nvs-currency-format-filter value=vmVoucherListFilter.voucherTotalData.withdraw class=\"ng-binding ng-isolate-scope\"></nvs-currency-format-filter></span></div><div class=list-item><span><strong ng-translate translate=no_withdraw></strong>: </span><span class=pull-right>{{vmVoucherListFilter.voucherTotalData.withdraw_count}}</span></div></div></div></div></div></div>");
$templateCache.put("app/profile/money/voucher/voucher-list.html","<section><h3 ng-translate translate=voucher_list></h3><div class=tableContainerStyle><table class=\"table table-hover table-bordered\"><thead class=voucherTableHead><tr><th ng-translate ranslate=code></th><th ng-translate translate=issue_date></th><th ng-translate translate=closing_date></th><th ng-translate translate=issuer></th><th ng-translate translate=amount></th><th ng-translate translate=type></th><th ng-translate translate=status></th><th ng-translate translate=action></th></tr></thead><tbody class=voucherTable><tr data-ng-repeat=\"voucher in vmVoucherList.voucherData | orderBy:\'-\'\" class=active style=\"color: black\"><td>{{voucher.code}}</td><td>{{voucher.created_at | timeZoneFilter}}</td><td><span data-ng-if=\"voucher.status==1 && voucher.transfer_type === 0\">{{voucher.expiration_date | timeZoneFilter}}</span> <span data-ng-if=\"voucher.status==1 && voucher.transfer_type === 1\">{{voucher.updated_at | timeZoneFilter}}</span> <span data-ng-if=\"voucher.status==3\">{{voucher.updated_at | timeZoneFilter}}</span></td><td>{{voucher.issuer}}</td><td><nvs-currency-format-filter value=voucher.amount class=\"ng-binding ng-isolate-scope\"></nvs-currency-format-filter></td><td><span data-ng-if=\"voucher.transfer_type == 0\"><span ng-translate translate=withdraw></span> </span><span data-ng-if=\"voucher.transfer_type == 1\"><span ng-translate translate=deposit></span></span></td><td><span data-ng-if=\"voucher.status==1\" class=\"btn btn-xs btn-success\" ng-translate translate=confirmed></span> <span data-ng-if=\"voucher.status==2\" class=\"btn btn-xs btn-warning\" ng-translate translate=pending></span> <span data-ng-if=\"voucher.status==3\" class=\"btn btn-xs btn-danger\" ng-translate translate=canceled></span> <span data-ng-if=\"voucher.status==4\" class=\"btn btn-xs btn-info\" ng-translate translate=expired></span></td><td><div data-ng-if=\"voucher.status!=1\"><button data-ng-if=\"vmVoucherList.user==\'player\' && voucher.status === 2\" type=button class=\"btn btn-danger btn btn-xs\" data-ng-click=vmVoucherList.cancelVoucher(voucher)><span ng-translate translate=cancel></span></button> <button data-ng-if=\"voucher.status!=3\" type=button class=\"btn btn-xs btn-success\" data-ng-click=vmVoucherList.printVoucher(voucher)><span ng-translate translate=print></span></button></div><span data-ng-if=\"voucher.status==1 || voucher.status==3\" class=\"btn btn-xs btn\"></span></td></tr></tbody></table></div></section>");
$templateCache.put("app/profile/money/voucher/voucher-manager.html","<section class=\"main-wrap clearfix voucher_manager\"><div class=\"col-md-12 col-lg-12\"><div class=clearfix><!--<div class=\"col-md-12 col-lg-6 create_withdraw\" >--><!--<data-apt-voucher-create-withdraw></data-apt-voucher-create-withdraw>--><!--</div>--><div class=\"col-md-12 col-lg-12 redeem_deposit\" ng-if=\"vmVoucherManagerCtrl.section === \'deposit\' \"><data-apt-voucher-redeem-deposit></data-apt-voucher-redeem-deposit></div><div class=\"col-md-12 col-lg-12 create_withdraw\" ng-if=\"vmVoucherManagerCtrl.section === \'withdraw\'\"><data-apt-voucher-create-withdraw></data-apt-voucher-create-withdraw></div><div class=\"col-md-12 col-xs-12 list_filter\"><data-apt-voucher-list-filter></data-apt-voucher-list-filter></div><div class=\"col-md-12 col-xs-12 voucher_list\"><data-apt-voucher-list></data-apt-voucher-list></div></div></div></section>");
$templateCache.put("app/profile/money/withdraw/money-withdraw-manager.html","<section class=\"main-wrap clearfix deposit-container\"><div class=col-xs-12><div class=\"clearfix main-box\" id=money_container style=\"margin-top: 30px\"></div><div class=methodContainer></div></div></section>");
$templateCache.put("app/profile/personalDetails/directives/personal-detail-form.html","<div class=personel-info-container><div class=personel-info-scrooll><h4 style=\"border-bottom: 2px solid white;padding-bottom: 20px;color: whitesmoke\" ng-translate translate=personal_details></h4><div class=row><div class=col-xs-6><label style=\"color: whitesmoke\" ng-translate translate=id></label><input type=text class=form-control data-ng-model=vmPersonalDetailForm.personalData.id disabled></div><div class=col-xs-6><label style=\"color: whitesmoke\" ng-translate translate=username></label><input type=text class=form-control data-ng-model=vmPersonalDetailForm.personalData.username disabled></div></div><h3 style=\"border-bottom: 2px solid white;padding-bottom: 20px;color: whitesmoke\" ng-translate translate=personal_data></h3><div class=row><div class=col-xs-6><label style=\"color: whitesmoke\" ng-translate translate=name></label><input type=text class=form-control data-ng-model=vmPersonalDetailForm.personalData.name disabled></div><div class=col-xs-6><label style=\"color: whitesmoke\" ng-translate translate=surname></label><input type=text class=form-control data-ng-model=vmPersonalDetailForm.personalData.surname disabled></div></div><div class=row><div class=col-xs-6><label style=\"color: whitesmoke\" ng-translate translate=date_of_birth></label><div class=row><div class=col-xs-4><ui-select ng-model=selected ng-disabled=false><ui-select-match placeholder=Months>{{selected}}</ui-select-match><ui-select-choices repeat=\"month in vmPersonalDetailForm.months \"><span ng-bind-html=\"month | highlight: selected\"></span></ui-select-choices></ui-select></div><div class=col-xs-4><ui-select ng-model=selected ng-disabled=false><ui-select-match placeholder=Day>{{selected}}</ui-select-match><ui-select-choices repeat=\"day in vmPersonalDetailForm.dates \"><span ng-bind-html=\"day | highlight: selected\"></span></ui-select-choices></ui-select></div><div class=col-xs-4><ui-select ng-model=selected ng-disabled=false><ui-select-match placeholder=Year>{{selected}}</ui-select-match><ui-select-choices repeat=\"year in vmPersonalDetailForm.years \"><span ng-bind-html=\"year | highlight: selected\"></span></ui-select-choices></ui-select></div></div></div><div class=col-xs-6><label style=\"color: whitesmoke\" ng-translate translate=gender></label><!-- <input type=\"text\" class=\"form-control\" data-ng-model=\"vmPersonalDetailForm.personalData.genderType\"\n                   disabled>--><ui-select ng-model=vmPersonalDetailForm.personalData.info.gender ng-model-options=\" {getterSetter: true }\" ng-disabled=false><ui-select-match placeholder=\"Select or search a currencies in the list...\" ng-translate translate={{$select.selected.name}}></ui-select-match><ui-select-choices repeat=\"gender.value as gender in vmPersonalDetailForm.genders | filter: $select.search\"><span ng-bind-html=\"gender.name | highlight: $select.search | translate\"></span></ui-select-choices></ui-select></div></div><div class=row><div class=col-xs-6><label style=\"color: whitesmoke\" ng-translate translate=country_of_residence></label><input type=text class=form-control data-ng-model=vmPersonalDetailForm.personalData.info.country_of_residance ng-virtual-keyboard></div><div class=col-xs-6><label style=\"color: whitesmoke\" ng-translate translate=city></label><input type=text class=form-control data-ng-model=vmPersonalDetailForm.personalData.info.city ng-virtual-keyboard></div></div><div class=row><div class=col-xs-6><label style=\"color: whitesmoke\" ng-translate translate=province></label><input type=text class=form-control data-ng-model=vmPersonalDetailForm.personalData.info.province ng-virtual-keyboard></div><div class=col-xs-6><label style=\"color: whitesmoke\" ng-translate translate=zip></label><input type=text class=form-control data-ng-model=vmPersonalDetailForm.personalData.info.zip ng-virtual-keyboard></div></div><div class=row><div class=col-xs-12><label style=\"color: whitesmoke\" ng-translate translate=address></label><textarea rows=4 class=form-control data-ng-model=vmPersonalDetailForm.personalData.info.address ng-virtual-keyboard></textarea></div></div><h3 style=\"border-bottom: 2px solid white;padding-bottom: 20px;color: whitesmoke\" ng-translate translate=contact_details></h3><div class=row><div class=col-xs-6><label style=\"color: whitesmoke\" ng-translate translate=email></label><input type=text class=form-control data-ng-model=vmPersonalDetailForm.personalData.email disabled></div><div class=col-xs-6><label style=\"color: whitesmoke\" ng-translate translate=currency></label><!--<input type=\"text\" class=\"form-control\" data-ng-model=\"vmPersonalDetailForm.personalData.currency_id\"\n                   disabled>--><ui-select ng-model=vmPersonalDetailForm.personalData.currency_id ng-model-options=\" {getterSetter: true }\" ng-disabled=false><ui-select-match placeholder=\"Select or search a currencies in the list...\">{{$select.selected.name}} - ({{$select.selected.symbol}})</ui-select-match><ui-select-choices repeat=\"currency.id as currency in vmPersonalDetailForm.currencies | filter: $select.search\"><span ng-bind-html=\"currency.name | highlight: $select.search\"></span> <small ng-bind-html=\"currency.symbol | highlight: $select.search\"></small></ui-select-choices></ui-select></div></div><div class=row><div class=col-xs-6><label style=\"color: whitesmoke\" ng-translate translate=contact_number></label><input type=text class=form-control ng-disabled=false data-ng-model=vmPersonalDetailForm.personalData.info.phone ng-virtual-keyboard></div><div class=col-xs-6><label style=\"color: whitesmoke\" ng-translate translate=timezones></label><div class=row><div class=col-xs-8><div class=select-box><ui-select ng-model=vmPersonalDetailForm.personalData.timezone_value ng-model-options=\" {getterSetter: true }\"><ui-select-match placeholder=\"Select or search a timezones in the list...\">{{$select.selected.value}}</ui-select-match><ui-select-choices repeat=\"timezone.value as timezone in vmPersonalDetailForm.timezones | filter: $select.search\"><span ng-bind-html=\"timezone.value | highlight: $select.search\"></span></ui-select-choices></ui-select></div></div><div class=col-xs-4><button class=\"btn btn-sm btn-success\" style=\"float: left\" data-ng-click=vmPersonalDetailForm.updateTimezone()><span ng-translate translate=update></span></button></div></div></div></div><!--<h3 style=\"border-bottom: 2px solid white;padding-bottom: 20px;color: whitesmoke\">{{\'document\' | translate}}</h3>--><!--<div class=\"row\">--><!--<div class=\"col-xs-12\">--><!--<label style=\"color: whitesmoke\">{{\'document_number\' | translate}}</label>--><!--<input type=\"text\" class=\"form-control\"--><!--data-ng-model=\"vmPersonalDetailForm.personalData.info.document_number\" disabled>--><!--</div>--><!--</div>--></div></div>");
$templateCache.put("app/profile/sessions/directives/session-filter.html","<div class=form><div class=\"col-md-4 row\"><input date-range-picker class=\"form-control date-picker\" type=text ng-placeholder placeholder=Select_Date_Range options=vmSessionFilter.dateOptions ng-model=vmSessionFilter.date></div><div class=\"col-xs-6 row\"><button class=\"btn btn-success\" data-ng-click=vmSessionFilter.search() ng-translate translate=search></button></div></div>");
$templateCache.put("app/profile/sessions/directives/session-list.html","<nvs-loading-bar data-ng-show=vmSessionList.sessionListSetting.showLoadingBar></nvs-loading-bar><div class=divTableBody data-ng-if=vmSessionList.sessionListSetting.showSessionList><div class=sessionScroll><div class=divTable><div class=divTableBody><div class=\"divTableRow divTableHeader\" id=first-row><div class=\"divTableCell divTableID\" ng-translate translate=id></div><div class=divTableCell ng-translate translate=login_date></div><div class=divTableCell ng-translate translate=logout_date></div><div class=divTableCell ng-translate translate=ip_address></div></div><div class=divTableRow data-ng-repeat=\"session in vmSessionList.sesionList track by $index\"><div class=divTableCell>{{session.id}}</div><div class=divTableCell>{{session.login_date | timeZoneFilter}}</div><div class=divTableCell>{{session.logout_date | timeZoneFilter}}</div><div class=divTableCell>{{session.ip_address}}</div></div></div></div></div></div>");
$templateCache.put("app/sport/oddsPage/directives/extra-odds-page.html","<div class=odds-page-content-extra-odds-wrapper data-ng-repeat=\"data in vmExtraOddsPage.extraOddsData track by $index\"><div class=extra-odds-item><!-- Extra Odds Name --><div class=\"extra-odds-name odds-{{data.column}}\"><h2>{{data.name}}</h2></div><!-- ./Extra Odds Name --><!-- Extra Odds Rate --><div class=extra-odds-odds><ul data-ng-repeat=\"row in data.rows\"><li data-ng-repeat=\"odds in row.odds\"><span class=extra-odds-odds-btn><i class=extra-odds-title data-tooltip={{odds.name}}>{{odds.name}}</i> <button class=extra-odds-btn data-ng-class=\"{\'active\':vmExtraOddsPage.checkOdds(odds)}\" data-ng-click=vmExtraOddsPage.clickOdds(odds,data) data-ng-disabled=\"(odds.value==\'-\' || !odds.value)\"><!--{{odds.value}}--><data-nvs-palimpsest-odds-format odds={{odds.value}}></data-nvs-palimpsest-odds-format></button></span></li></ul></div><!-- ./Extra Odds Rate --></div></div>");
$templateCache.put("app/sport/oddsPage/displayTemplate/display-template-0.html","<div data-ng-class=\"{\'open\':event.eventExtraOdds}\" class=odds-page-main-items-content><div class=odds-page-content-container-time><h2>{{event.time}}</h2></div><div class=\"odds-page-content-container-event market-{{marketGroupEvent.marketNavBarLength}}\"><h2>{{event.name}}</h2></div><div class=\"odds-page-content-container-odds market-name-{{$index + 1}}\" data-ng-repeat=\"market in event.markets\"><ul data-ng-repeat=\"row in market.rows\"><li data-ng-repeat=\"odds in row.odds\"><button class=odds-rate>{{odds.value}}</button></li></ul></div><div class=odds-page-content-container-extra-odds><button class=extra-odds-button data-ng-click=vmOddsPage.openExtraOdds(event)>+318</button></div></div>");
$templateCache.put("app/user/register/registerForm/register-form.html","<div class=register-form-container><data-nvs-loading-bar data-ng-if=vmRegisterForm.settings.loadingBar></data-nvs-loading-bar><button type=button class=\"register-close form-modal-close\" data-ng-click=vmRegisterForm.close()><span class=close-icon></span></button><div class=\"row register-modal-header\"><button class=login-button data-ng-click=vmRegisterForm.loginForm() ng-translate translate=login></button> <button class=\"join-button active\" ng-translate translate=register></button></div><!--<p ng-show=\"vmLoginForm.loginValidationForm.email.$invalid  &&( !vmLoginForm.loginValidationForm.email.$pristine||!vmLoginForm.isEmail)\"--><form data-ng-submit=vmRegisterForm.register() name=vmRegisterForm.registerValidationForm><div class=\"row register-form-group\"><label><input type=text name=username class=register-form-input data-ng-model=vmRegisterForm.data.username ng-placeholder placeholder=username ng-virtual-keyboard required><p ng-show=\"vmRegisterForm.registerValidationForm.username.$invalid && (!vmRegisterForm.registerValidationForm.username.$pristine ||vmRegisterForm.isUsername)\" class=text-danger ng-translate translate=required_username></p><p ng-show=\"vmRegisterForm.registerValidationForm.username.$error.custom && !vmRegisterForm.registerValidationForm.username.$pristine\" class=text-danger>{{vmRegisterForm.registerValidationForm.username.$error.custom}}</p></label></div><div class=\"row register-form-group\"><label><input type=text name=name class=register-form-input data-ng-model=vmRegisterForm.data.name ng-pattern=vmRegisterForm.validOnlyText ng-placeholder placeholder=first_name ng-virtual-keyboard required><p ng-show=\"vmRegisterForm.registerValidationForm.name.$invalid && (!vmRegisterForm.registerValidationForm.name.$pristine ||vmRegisterForm.isName)\" class=text-danger ng-translate translate=required_name></p><p ng-show=\"vmRegisterForm.registerValidationForm.name.$error.pattern && !vmRegisterForm.registerValidationForm.name.$pristine\" class=text-danger ng-translate translate=text_only_please></p><p ng-show=\"vmRegisterForm.registerValidationForm.name.$error.custom && !vmRegisterForm.registerValidationForm.name.$pristine\" class=text-danger>{{vmRegisterForm.registerValidationForm.name.$error.custom}}</p></label></div><div class=\"row register-form-group\"><label><input type=text name=surname class=register-form-input data-ng-model=vmRegisterForm.data.surname ng-placeholder placeholder=last_name ng-virtual-keyboard required><p ng-show=\"vmRegisterForm.registerValidationForm.surname.$invalid && (!vmRegisterForm.registerValidationForm.surname.$pristine ||vmRegisterForm.isSurname)\" class=text-danger ng-translate translate=required_surname></p><p ng-show=\"vmRegisterForm.registerValidationForm.surname.$error.pattern && !vmRegisterForm.registerValidationForm.surname.$pristine\" class=text-danger ng-translate translate=text_only_please></p><p ng-show=\"vmRegisterForm.registerValidationForm.surname.$error.custom && !vmRegisterForm.registerValidationForm.surname.$pristine\" class=text-danger>{{vmRegisterForm.registerValidationForm.surname.$error.custom}}</p></label></div><div class=\"row register-form-group\"><label><input type=email name=email class=register-form-input data-ng-model=vmRegisterForm.data.email ng-pattern=vmRegisterForm.email ng-placeholder placeholder=email ng-virtual-keyboard required> <input ng-model=vmRegisterForm.data.owner_id type=hidden><p ng-show=\"vmRegisterForm.registerValidationForm.email.$invalid && (!vmRegisterForm.registerValidationForm.email.$pristine)\" class=text-danger ng-translate translate=required_email></p><p ng-show=\"vmRegisterForm.registerValidationForm.email.$error.pattern && !vmRegisterForm.registerValidationForm.email.$pristine\" class=text-danger>{{vmRegisterForm.registerValidationForm.email.$error.custom}}</p></label></div><div class=\"row register-form-group\"><label><input type=password name=password class=register-form-input data-ng-model=vmRegisterForm.data.password ng-placeholder placeholder=password minlength=8 ng-pattern=vmRegisterForm.password ng-change=validatePassword(vmRegisterForm.data.password) ng-virtual-keyboard required><p ng-show=\"vmRegisterForm.registerValidationForm.password.$invalid && (!vmRegisterForm.registerValidationForm.password.$pristine ||vmRegisterForm.isPassword)\" class=text-danger ng-translate translate=required_password></p><p ng-show=\"(!vmRegisterForm.registerValidationForm.password.$pristine && vmRegisterForm.data.password.length<8)\" ng-translate translate=password_must_be_at_least_8_characters></p><p>{{vmRegisterForm.password.length>8||vmRegisterForm.lengthError}}</p><p class=text-danger ng-show=\"vmRegisterForm.data.password !== vmRegisterForm.data.password_confirm\" ng-translate translate=password_confirmation_not_match></p></label></div><div class=\"row register-form-group\"><label><input type=password name=password_confirm class=register-form-input data-ng-model=vmRegisterForm.data.password_confirm compare-to=registerFormData.password ng-placeholder placeholder=password_confirm ng-virtual-keyboard required><!--<p ng-show=\"vmRegisterForm.registerValidationForm.password_confirm.$error.compareTo && (!vmRegisterForm.registerValidationForm.password_confirm.$pristine ||vmRegisterForm.isPassword_confirm)\" class=\"text-danger\">\n                    <span translate=\"password_confirmation_not_match\"></span>\n                </p>--><p ng-show=\"vmRegisterForm.registerValidationForm.password_confirm.$invalid && !vmRegisterForm.registerValidationForm.password_confirm.$pristine\" class=text-danger><span ng-translate translate=required_password_confirm></span></p><p class=text-danger ng-show=\"vmRegisterForm.data.password !== vmRegisterForm.data.password_confirm\" ng-translate translate=password_confirmation_not_match></p><p></p></label></div><div class=\"row register-form-group\"><div class=row><div class=col-xs-6><!--<a href=\"\" class=\"if-you-member\" data-ng-click=\"vmRegisterForm.ifYouMember()\">If you member?</a>--></div><div class=col-xs-6><button class=register-user-btn type=submit data-ng-disabled=vmRegisterForm.settings.buttonDisable><span ng-translate translate=register></span> <span class=\"fa fa-arrow-icon\"></span></button></div></div></div></form></div>");
$templateCache.put("app/nvsTicket/directives/novusCheckout/directives/ticket-print-popup.html","<div id=print-content><style>/**Modal Styles for Print**/\n        @page {\n            size: auto;\n            margin: 0;\n            padding: 0;\n        }\n\n        body * {\n            visibility: hidden;\n        }\n\n        @media print {\n            body * {\n                visibility: visible;\n            }\n        }\n        .nvs-ticket-print-main-container {\n            font-size: 9px;\n            font-family: \"Arial\", sans-serif;\n            width: 100%;\n            overflow: visible;\n            position: relative;\n        }\n\n        .nvs-ticket-print-main-container .nvs-ticket-print-main-container * #ticket-content * {\n            visibility: visible;\n            height: 100%;\n            font-family: \"Arial\", sans-serif;\n            margin: 0;\n        }\n\n        .nvs-ticket-print-main-container .nvs-ticket-print-info-area {\n            border: 2px solid black;\n            width: 100%;\n            display: inline-block;\n            text-transform: uppercase;\n        }\n\n        .nvs-ticket-print-main-container .nvs-ticket-print-info-area .nvs-ticket-print-id {\n            float: left;\n            width: 100%;\n            border-bottom: 2px dotted black;\n        }\n\n        .nvs-ticket-print-main-container .nvs-ticket-print-info-area .nvs-ticket-print-id .nvs-print-id-caption {\n            float: left;\n            font-weight: 700;\n        }\n\n        .nvs-ticket-print-main-container .nvs-ticket-print-info-area .nvs-ticket-print-id .nvs-print-id {\n            float: right;\n        }\n\n        .nvs-ticket-print-main-container .nvs-ticket-print-info-area .nvs-ticket-user-id {\n            float: left;\n            width: 100%;\n        }\n\n        .nvs-ticket-print-main-container .nvs-ticket-print-info-area .nvs-ticket-user-id .nvs-print-user-id-caption {\n            float: left;\n            font-weight: 700;\n        }\n\n        .nvs-ticket-print-main-container .nvs-ticket-print-info-area .nvs-ticket-user-id .nvs-print-user-id {\n            float: right;\n        }\n\n        .nvs-ticket-print-main-container .nvs-ticket-print-multiple-combined {\n            border: 2px solid black;\n            width: 100%;\n            display: inline-block;\n            text-align: center;\n            text-transform: uppercase;\n            font-weight: 700;\n            margin: 2px 0px;\n        }\n\n        .nvs-ticket-print-main-container .nvs-ticket-print-copy-ticket {\n            text-align: center;\n        }\n\n        .nvs-ticket-print-main-container .nvs-ticket-print-container {\n            border: 2px solid black;\n            width: 100%;\n        }\n\n        .nvs-ticket-print-main-container .nvs-ticket-print-container .nvs-ticket-print-event-container {\n\n            border-bottom: 2px dotted black;\n            line-height: 14px;\n        }\n\n        .nvs-ticket-print-main-container .nvs-ticket-print-container .nvs-ticket-print-event-container:last-child {\n            border-bottom: none;\n        }\n\n        .nvs-ticket-print-main-container .nvs-ticket-print-container .nvs-ticket-print-event-container .nvs-ticket-print-event-category-name {\n            font-weight: 700;\n            border-bottom: 2px dotted black;\n        }\n\n        .nvs-ticket-print-main-container .nvs-ticket-print-container .nvs-ticket-print-event-container .nvs-ticket-print-event-name {\n            text-transform: uppercase;\n            font-weight: 700;\n        }\n\n        .status-live {\n            margin-right: 2px;\n        }\n\n        .status-live:before {\n            content: \'LIVE\';\n            border: 1px solid;\n            font-weight: 500;\n        }\n\n        .nvs-ticket-print-main-container .nvs-ticket-print-container .nvs-ticket-print-event-container .nvs-ticket-print-selected-odds {\n            width: 100%;\n            display: inline-block;\n        }\n\n        .nvs-ticket-print-main-container .nvs-ticket-print-container .nvs-ticket-print-event-container .nvs-ticket-print-selected-odds .ticket-odds-name {\n            float: left;\n        }\n\n        .nvs-ticket-print-main-container .nvs-ticket-print-container .nvs-ticket-print-event-container .nvs-ticket-print-selected-odds .ticket-odds {\n            float: right;\n        }\n\n        .nvs-ticket-info-container {\n            width: 100%;\n            display: inline-block;\n            text-align: center;\n            margin: 2px 0px;\n        }\n\n        .nvs-ticket-print-type-area {\n            width: 15%;\n            float: left;\n        }\n\n        .nvs-ticket-print-stake-area {\n            width: 45%;\n            float: left;\n        }\n\n        .nvs-ticket-print-min-profit-area {\n            width: 20%;\n            float: left;\n        }\n\n        .nvs-ticket-print-max-profit-area {\n            width: 20%;\n            float: left;\n        }\n\n        .nvs-ticket-print-currency-area {\n            width: 100%;\n            display: inline-block;\n            border: 2px solid;\n            text-align: center;\n            margin: 2px 0;\n        }\n\n        .nvs-ticket-print-currency-name {\n            float: left;\n            width: 50%;\n            text-align: right;\n        }\n\n        .nvs-ticket-print-currency-value {\n            float: right;\n            width: 50%;\n            text-align: left;\n        }\n\n        .nvs-ticket-info-container > div > span {\n            display: block;\n            border: 2px solid;\n            margin: 1px 1px 0px 0px;\n            text-transform: uppercase;\n            width: 99%;\n        }\n\n        .nvs-ticket-total-odds {\n            border: 2px solid;\n            width: 100%;\n            display: inline-block;\n\n        }\n\n        .nvs-total-odds-name {\n            float: left;\n        }\n\n        .nvs-total-odds-value {\n            float: right;\n        }\n\n        .nvs-ticket-print-stake {\n            border: 2px solid;\n            width: 100%;\n            display: inline-block;\n\n        }\n\n        .nvs-ticket-print-coupon-stake-name {\n            float: left;\n        }\n\n        .nvs-ticket-print-coupon-stake-value {\n            float: right;\n        }\n\n        .nvs-ticket-print-bonus {\n            border: 2px solid;\n            width: 100%;\n            font-weight: 700;\n            text-align: center;\n            text-transform: uppercase;\n        }\n\n        .nvs-ticket-print-bonus-name {\n            display: block;\n            border-bottom: 2px solid;\n\n        }\n\n        .nvs-ticket-print-bonus-value {\n            display: block;\n\n        }\n\n        .nvs-ticket-print-winnings-caption {\n            border: 2px solid;\n            width: 100%;\n            font-weight: 700;\n            text-align: center;\n            display: inline-block;\n            margin: 2px 0px;\n            text-transform: uppercase;\n\n        }\n\n        .nvs-ticket-print-min-winnings-name {\n            float: left;\n            width: 50%;\n        }\n\n        .nvs-ticket-print-max-winnings-name {\n            float: right;\n            width: 50%;\n        }\n\n        .nvs-ticket-print-winnings-value {\n            border: 2px solid;\n            width: 100%;\n            font-weight: 700;\n            text-align: center;\n            display: inline-block;\n\n        }\n\n        .nvs-ticket-print-min-winnings-value {\n            float: left;\n            width: 50%;\n        }\n\n        .nvs-ticket-print-max-winnings-value {\n            float: right;\n            width: 50%;\n        }\n\n        .nvs-ticket-print-digit-code {\n            text-align: center;\n            border: 2px solid;\n            width: 100%;\n            margin: 2px 0px;\n\n        }\n\n        .nvs-ticket-print-coupon-info {\n            text-align: center;\n            border: 2px solid;\n            width: 100%;\n            margin: 2px 0px;\n\n        }\n\n        .nvs-ticket-tournament-events-separate {\n            border-bottom: 2px dotted;\n        }\n\n        .nvs-ticket-tournament-events-separate:last-child {\n            border-bottom: none;\n        }\n\n        .nvs-ticket-print-main-container .barcodeArea {\n            margin-top: 10px;\n            width: 100%;\n            text-align: center;\n        }\n\n        .nvs-ticket-print-main-container .qr-code-container {\n            width: 30%;\n            float: right;\n            margin-bottom: 10px;\n        }\n\n        .nvs-ticket-print-main-container .qr-code-container img {\n            width: 60%;\n            float: right;\n        }</style><div class=modal-body><div class=nvs-ticket-print-main-container><div class=qr-code-container><img data-ng-src={{vmTicketPrintPopup.qrCodeImage}} alt=qrcode style=\"margin-top: 10px\"></div><div class=nvs-ticket-print-info-area><div class=nvs-ticket-print-id><span class=nvs-print-id-caption>Betslip ID</span> <span class=nvs-print-id>{{vmTicketPrintPopup.printData.code}}</span></div><div class=nvs-ticket-user-id><span class=nvs-print-user-id-caption>User</span> <span class=nvs-print-user-id>{{vmTicketPrintPopup.printData.operator.id}} - {{vmTicketPrintPopup.printData.operator.username}}</span></div></div><div class=nvs-ticket-print-multiple-combined>{{vmTicketPrintPopup.printData.bets_type}} - {{vmTicketPrintPopup.printData.type}}</div><div class=nvs-ticket-print-copy-ticket>*** Copy Ticket ***</div><div class=nvs-ticket-print-container><div class=nvs-ticket-print-event-container data-ng-repeat=\"tournament in vmTicketPrintPopup.printData.tournaments track by $index\"><div class=nvs-ticket-print-event-category-name><span>{{tournament.sport.name}} - {{tournament.category.name}} - {{tournament.tournament.name}}</span></div><div class=nvs-ticket-tournament-events-separate data-ng-repeat=\"event in tournament.events track by $index\"><div class=nvs-ticket-print-event-name data-ng-class=\"{\'status-live\':event.is_live}\"><span>{{event.event_name}}</span></div><div class=nvs-ticket-print-event-date><span>{{event.date}}</span><!--<span>14:00</span>--></div><div class=nvs-ticket-print-selected-odds data-ng-repeat=\"item in event.items track by $index\"><span class=ticket-odds-name>{{item.market_name}} - ( {{item.odds_code}} )</span> <span class=ticket-odds>Odds : {{item.odds_value}}</span></div></div></div></div><div class=nvs-ticket-info-container><div class=nvs-ticket-print-type-area><span class=nvs-ticket-print-type-name>Type </span><span class=nvs-ticket-print-type-value data-ng-repeat=\"system in vmTicketPrintPopup.printData.systems track by $index\">{{system.code}}</span></div><div class=nvs-ticket-print-stake-area><span class=nvs-ticket-print-stake-name>Stake </span><span class=nvs-ticket-print-stake-value data-ng-repeat=\"system in vmTicketPrintPopup.printData.systems track by $index\"><data-nvs-ticket-print-money-currency price={{system.combinations}} currency-setting=vmTicketPrintPopup.printData.ticket_currency></data-nvs-ticket-print-money-currency>X<data-nvs-ticket-print-money-currency price={{system.stake}} currency-setting=vmTicketPrintPopup.printData.ticket_currency></data-nvs-ticket-print-money-currency>=<data-nvs-ticket-print-money-currency price={{system.combinations*system.stake}} currency-setting=vmTicketPrintPopup.printData.ticket_currency></data-nvs-ticket-print-money-currency></span></div><div class=nvs-ticket-print-min-profit-area><span class=nvs-ticket-print-min-profit-name>Min </span><span class=nvs-ticket-print-min-profit-value data-ng-repeat=\"system in vmTicketPrintPopup.printData.systems track by $index\"><data-nvs-ticket-print-money-currency price={{system.min_win}} currency-setting=vmTicketPrintPopup.printData.ticket_currency></data-nvs-ticket-print-money-currency></span></div><div class=nvs-ticket-print-max-profit-area><span class=nvs-ticket-print-max-profit-name>Max </span><span class=nvs-ticket-print-max-profit-value data-ng-repeat=\"system in vmTicketPrintPopup.printData.systems track by $index\"><data-nvs-ticket-print-money-currency price={{system.max_win}} currency-setting=vmTicketPrintPopup.printData.ticket_currency></data-nvs-ticket-print-money-currency></span></div><div class=nvs-ticket-print-currency-area data-ng-if=\"vmTicketPrintPopup.printData.ticket_currency.symbol.length>1\"><div class=nvs-ticket-print-currency-name>Currency :</div><div class=nvs-ticket-print-currency-value>{{vmTicketPrintPopup.printData.ticket_currency.name}} - ({{vmTicketPrintPopup.printData.ticket_currency.symbol}})</div></div></div><div class=nvs-ticket-total-odds><span class=nvs-total-odds-name>Total Odds </span><span class=nvs-total-odds-value>{{vmTicketPrintPopup.printData.total_odds}}</span></div><div class=nvs-ticket-print-stake><span class=nvs-ticket-print-coupon-stake-name>Stake </span><span class=nvs-ticket-print-coupon-stake-value><data-nvs-ticket-print-money-currency price={{vmTicketPrintPopup.printData.stake}} currency-setting=vmTicketPrintPopup.printData.ticket_currency></data-nvs-ticket-print-money-currency></span></div><div class=nvs-ticket-print-bonus><span class=nvs-ticket-print-bonus-name>Bonus </span><span class=nvs-ticket-print-bonus-value><data-nvs-ticket-print-money-currency price={{vmTicketPrintPopup.printData.stake}} currency-setting=vmTicketPrintPopup.printData.ticket_currency></data-nvs-ticket-print-money-currency>|||{{vmTicketPrintPopup.printData.min_bonus}}|||</span></div><div class=nvs-ticket-print-winnings-caption><span class=nvs-ticket-print-min-winnings-name>Min Winning </span><span class=nvs-ticket-print-max-winnings-name>Max Winning</span></div><div class=nvs-ticket-print-winnings-value><span class=nvs-ticket-print-min-winnings-value><data-nvs-ticket-print-money-currency price={{vmTicketPrintPopup.printData.stake}} currency-setting=vmTicketPrintPopup.printData.ticket_currency></data-nvs-ticket-print-money-currency>||| {{vmTicketPrintPopup.printData.min_win}} ||| </span><span class=nvs-ticket-print-max-winnings-value><data-nvs-ticket-print-money-currency price={{vmTicketPrintPopup.printData.stake}} currency-setting=vmTicketPrintPopup.printData.ticket_currency></data-nvs-ticket-print-money-currency>||| {{vmTicketPrintPopup.printData.max_win}} |||</span></div><div class=nvs-ticket-print-digit-code><span class=nvs-digit-code-name>Type the 4 digit code</span> <span class=nvs-digit-code-value>2241</span></div><div class=nvs-ticket-print-coupon-info>Kasa Zamanı: 01/09/2017 09:55:06 Basım Zamanı : 05/09/2017 11:54:15 Bu fişin sahibi bu fişte yazılı olan kazanılablecek olan parayı çekmeye tek yetkilidir. Bu fişin basımı MyBetArena koşullarının tümünün kabülünü zorunlu kılar. Bu fş MyBetArena tarafından lsanslanmış ve onun tarafından kabul edlmş frma tarafından yapılmaktadır. Bu fşte kazanılması muhtemel mktarlar rehberlk amacıyla basılmıştır ve nha hesaplamalar ve kazançlar farklı olablr.</div><div class=barcodeArea><barcode type=code128b string={{vmTicketPrintPopup.barCode}} render=img options=vmTicketPrintPopup.barcodeOptions></barcode></div></div></div></div>");
$templateCache.put("app/profile/betHistory/betHistoryDetail/directives/betHistoryDetailContent.html","<div id=bet-history-detail-wrapper><!-- Bet History Detail Header --><div id=bet-history-detail-header><!-- Bet History Detail Title --><div class=bet-history-detail-title><h3 ng-translate translate=bet_history_detail></h3></div><!-- ./Bet History Detail Title --><!-- Bet History Detail Back --><div class=bet-history-back><a ui-sref=betHistory ng-translate translate=back></a></div><!-- ./Bet History Detail Back --></div><!-- ./Bet History Detail Header --><!-- Bet History Detail Content --><div id=bet-history-detail-content><!-- Bet-Slip Container --><div id=betslip-container><div class=betslip-container-title><div class=betslip-container-title-wrap><h5><span ng-translate translate=betslip></span></h5></div></div><div class=betslip-container-content><div class=betslip-container-content-item><div class=betslip-container-content-left><h5 ng-translate translate=betslip_id></h5></div><div class=betslip-container-content-right><span ng-bind=vmBetHistoryDetailContent.betHistoryDetail.code></span></div></div><div class=betslip-container-content-item><div class=betslip-container-content-left><h5 ng-translate translate=betslip_status></h5></div><div class=betslip-container-content-right><span apt-ticket-status status={{vmBetHistoryDetailContent.betHistoryDetail.status}} class=\"ticket-status status-{{vmBetHistoryDetailContent.betHistoryDetail.status}}\"></span></div></div><div class=betslip-container-content-item><div class=betslip-container-content-left><h5 ng-translate translate=date></h5></div><div class=betslip-container-content-right><span>{{vmBetHistoryDetailContent.betHistoryDetail.checkout_time | timeZoneFilter}}</span></div></div><div class=betslip-container-content-item><div class=betslip-container-content-left><h5 ng-translate translate=bet_type></h5></div><div class=betslip-container-content-right><span ng-bind=vmBetHistoryDetailContent.betHistoryDetail.type></span></div></div><div class=betslip-container-content-item><div class=betslip-container-content-left><h5 ng-translate translate=stake></h5></div><div class=betslip-container-content-right><span ng-bind=vmBetHistoryDetailContent.betHistoryDetail.stake></span></div></div><div class=betslip-container-content-item><div class=betslip-container-content-left><h5 ng-translate translate=bet_history_detail></h5></div><div class=betslip-container-content-right><span ng-bind=\"vmBetHistoryDetailContent.betHistoryDetail.original_stake || vmBetHistoryDetailContent.betHistoryDetail.stake\"></span></div></div><div class=betslip-container-content-item><div class=betslip-container-content-left><h5 ng-translate translate=original_winning></h5></div><div class=betslip-container-content-right><span ng-bind=vmBetHistoryDetailContent.betHistoryDetail.max_win></span></div></div><div class=betslip-container-content-item><div class=betslip-container-content-left><h5 ng-translate translate=total_winning></h5></div><div class=betslip-container-content-right><span ng-bind=vmBetHistoryDetailContent.betHistoryDetail.winnings></span></div></div></div></div><!-- Bet-Slip Container --><!-- Bets Container --><div id=bets-container><div class=bets-container-title><div class=bets-container-title-wrap><h5><span ng-translate translate=bets></span></h5></div></div><div class=bets-container-content><div class=bets-container-content-header><div class=bets-container-content-header-wrapper><div class=combination-type><h5 ng-translate translate=combination_type></h5></div><div class=no-of-combination><h5 ng-translate translate=no_of_combinations></h5></div><div class=amount><h5 ng-translate translate=amount></h5></div><div class=pot-winnings><h5 ng-translate translate=pot_winnings></h5></div><div class=status><h5 ng-translate translate=status></h5></div><div class=pot-bonus><h5 ng-translate translate=pot_bonus></h5></div><div class=winning><h5 ng-translate translate=winnings></h5></div><div class=payment-date><h5 ng-translate translate=payment_date></h5></div></div></div><div class=bets-container-content-item ng-repeat=\"system in vmBetHistoryDetailContent.betHistoryDetail.systems\"><div class=bets-container-content-item-wrapper><div class=combination-type><h5 ng-bind=system.code></h5></div><div class=no-of-combination><h5 ng-bind=system.combinations></h5></div><div class=amount><h5>{{system.combinations}} x {{system.stake}} = {{system.combinations * system.stake}}</h5></div><div class=pot-winnings><h5 ng-bind=system.max_win></h5></div><div class=status><h5 ng-bind=system.status></h5></div><div class=pot-bonus><h5>{{system.status == 1 ? system.max_bonus : system.bonus_winnings}}</h5></div><div class=winning><h5 ng-bind=\"system.winnings || \'-\'\"></h5></div><div class=payment-date><h5>{{system.payed_time | timeZoneFilter}}</h5></div></div></div></div></div><!-- Bets Container --><!-- Events Container --><div id=events-container><div class=events-container-title><div class=events-container-title-wrap><h5><span ng-translate translate=events>ng-translate </span></h5></div></div><div class=events-container-content><div class=events-container-content-header><div class=events-container-content-header-wrapper><div class=event><h5 ng-translate translate=event></h5></div><div class=start-date><h5 ng-translate translate=start_date></h5></div><div class=markets><h5 ng-translate translate=markets></h5></div><div class=type><h5 ng-translate translate=type></h5></div><div class=hnd><h5 ng-translate translate=hnd></h5></div><div class=banker><h5 ng-translate translate=banker></h5></div><div class=results><h5 ng-translate translate=results></h5></div><div class=outcome><h5 ng-translate translate=outcome></h5></div></div></div><div class=events-container-content-item><div class=events-container-content-item-wrapper ng-repeat=\"item in vmBetHistoryDetailContent.betHistoryDetail.items\"><div class=event><h5 ng-bind=item.event_name></h5></div><div class=start-date><h5>{{item.event_date | timeZoneFilter}}</h5></div><div class=markets><h5 ng-bind=item.market_name></h5></div><div class=type><h5 ng-bind=item.odds_code></h5></div><div class=hnd><h5>{{(item.special_value != -1 && item.special_value != 0 ? item.special_value : \'-\')}}</h5></div><div class=banker><h5>{{item.banker == 1 ? \'Yes\': \'No\'}}</h5></div><div class=results><h5 ng-bind=item.status></h5></div><div class=outcome><h5><i ng-class=\"item.status != 1 ? \'fa fa-circle\' : \'\'\"></i></h5></div></div></div></div></div><!-- Events Container --></div><!-- ./Bet History Detail Content --><!-- Bet History Detail Footer --><div id=bet-history-detail-footer><button class=print-ticket-btn data-ng-click=vmBetHistoryDetailContent.printCopyTicket() ng-translate translate=print_copy_ticket></button></div><!-- ./Bet History Detail Footer --></div>");
$templateCache.put("app/profile/betHistory/directives/betHistoryContentList/betHistoryContentList.html","<div class=bet-history-table-container><div class=bet-history-table-header ng-if=\"vmBetHistoryContentList.betList.length > 0\"><!-- Bet History Table Content --><div class=bet-history-table-find><h5></h5></div><div class=bet-history-bet-code><h5 ng-translate translate=\" bet_code\">{</h5></div><div class=bet-history-username><h5 ng-translate translate=username></h5></div><div class=bet-history-owner><h5 ng-translate translate=\" owner\"></h5></div><div class=bet-history-type><h5 ng-translate translate=type></h5></div><div class=bet-history-amount><h5 ng-translate translate=\" amount\"></h5></div><div class=bet-history-date><h5 ng-translate translate=\" date\"></h5></div><div class=bet-history-result-date><h5 ng-translate translate=\" result_date\"></h5></div><div class=bet-history-winnings><h5 ng-translate translate=winning></h5></div><div class=bet-history-status><h5 ng-translate translate=status></h5></div></div><div class=bet-history-table-container><!-- Bet History Table Content --><div class=bet-history-table-container-item data-ng-repeat=\"betList in vmBetHistoryContentList.betList\"><div class=bet-history-table-find><a ui-sref=\"betHistoryDetail({ticketCode: betList.code})\"><i class=\"fa fa-search\"></i></a></div><div class=bet-history-bet-code><a ui-sref=\"betHistoryDetail({ticketCode: betList.code})\" ng-bind=betList.code></a></div><div class=bet-history-username><h5 ng-bind=\"betList.username || \'-\'\"></h5></div><div class=bet-history-owner><h5 ng-bind=betList.owner></h5></div><div class=bet-history-type><h5 ng-bind=betList.bets_type></h5></div><div class=bet-history-amount><h5 ng-bind=betList.stake></h5></div><div class=bet-history-date><h5>{{betList.checkout_time | timeZoneFilter }}</h5></div><div class=bet-history-result-date><h5>{{betList.result_date | timeZoneFilter}}</h5></div><div class=bet-history-winnings><h5 ng-bind=betList.winnings></h5></div><div class=bet-history-status><span class=\"bet-history-status-inner ticket-status-{{betList.status}}\" apt-ticket-status status={{betList.status}}></span></div></div><!-- ./Bet History Table Content --></div></div>");
$templateCache.put("app/profile/betHistory/directives/betHistoryHeaderLeftForm/betHistoryHeaderLeftForm.html","<!-- Bet History Header Left Area --><div class=bet-history-manager-header-left><div class=bet-history-manager-header-left-container><!-- Bet History Search Form Area --><!-- Bet History Manager Detail Header Form Line 1 --><div class=bet-history-manager-header-search-form-line><span class=input-title ng-translate translate=date_range></span></div><div class=bet-history-manager-header-search-form-line><div class=bet-history-manager-header-date-picker><label><i class=input-icon></i> <input date-range-picker class=\"form-control date-picker\" type=text ng-placeholder=Select_Date_Range options=vmBetHistoryHeaderLeft.dateOptions ng-model=vmBetHistoryHeaderLeft.date></label></div><div class=bet-history-manager-header-search><button class=bet-history-manager-header-search-btn ng-click=vmBetHistoryHeaderLeft.setBetList() ng-translate translate=search></button></div></div><!-- ./Bet History Manager Detail Header Form Line 1 --><!-- Bet History Manager Detail Header Form Line 2 --><div class=bet-history-manager-header-search-form-line><div class=bet-history-manager-header-option><label><span class=input-title ng-translate translate=member_name></span> <input type=text ng-model=vmBetHistoryHeaderLeft.data.username ng-virtual-keyboard></label></div><div class=bet-history-manager-header-option><label><span class=input-title ng-translate translate=bet_code></span> <input type=text ng-model=vmBetHistoryHeaderLeft.data.code ng-virtual-keyboard></label></div><div class=bet-history-manager-header-option><label><span class=input-title ng-translate translate=ticket_type></span><select name=ticket-type id=ticket-type ng-model=vmBetHistoryHeaderLeft.data.status><option value=all selected ng-translate ng-translate translate=all_ticket></option><option value=running ng-translate translate=running></option><option value=resulted ng-translate translate=\" resulted\"></option><option value=won ng-translate translate=\" won\"></option><option value=lost ng-translate translate=\" lost\"></option><option value=void ng-translate translate=\" void\"></option><option value=rejected ng-translate translate=\" rejected\"></option><option value=canceled ng-translate translate=\" canceled\"></option><option value=awaiting ng-translate translate=\" awaiting\"></option></select></label></div></div><!-- ./Bet History Manager Detail Header Form Line 2 --><!-- ./Bet History Search Form Area --></div></div><!-- Bet History Header Left Area -->");
$templateCache.put("app/profile/betHistory/directives/betHistoryHeaderRightForm/betHistoryHeaderRightForm.html","<div class=bet-history-manager-header-right><!-- Bet History Header Right Content --><div class=bet-history-manager-header-right-container><!-- Bet History Header Line --><div class=\"bet-history-manager-header-top-line first-line\"><!-- First Item Name Null --><div class=bet-history-manager-header-top-title></div><!-- ./First Item Name Null --><!-- First Item Amount - Tickets Title --><div class=bet-history-manager-header-top-right-container><div class=bet-history-manager-header-top-description><h4 ng-translate translate=amount></h4></div><div class=bet-history-manager-header-top-description><h4 ng-translate translate=tickets></h4></div></div><!-- First Item Amount - Tickets Title --></div><!-- Bet History Header Line --><!-- Bet History Header Line --><div class=bet-history-manager-header-top-line><div class=bet-history-manager-header-top-title><h3 ng-translate translate=total_bet></h3></div><div class=bet-history-manager-header-top-right-container><div class=bet-history-manager-header-top-description><span class=description-container ng-bind=\"vmBetHistoryHeaderRight.stats.total_bet || \'0\'\"></span></div><div class=bet-history-manager-header-top-description><span class=description-container ng-bind=\"vmBetHistoryHeaderRight.stats.total_bet_count || \'0\'\"></span></div></div></div><!-- Bet History Header Line --><!-- Bet History Header Line --><div class=bet-history-manager-header-top-line><div class=bet-history-manager-header-top-title><h3 ng-translate translate=total_win></h3></div><div class=bet-history-manager-header-top-right-container><div class=bet-history-manager-header-top-description><span class=description-container ng-bind=\"vmBetHistoryHeaderRight.stats.total_win || \'0\'\"></span></div><div class=bet-history-manager-header-top-description><span class=description-container ng-bind=\"vmBetHistoryHeaderRight.stats.total_win_count || \'0\'\"></span></div></div></div><!-- Bet History Header Line --><!-- Bet History Header Line --><div class=bet-history-manager-header-top-line><div class=bet-history-manager-header-top-title><h3 ng-translate translate=total_running></h3></div><div class=bet-history-manager-header-top-right-container><div class=bet-history-manager-header-top-description><span class=description-container ng-bind=\"vmBetHistoryHeaderRight.stats.total_running || \'0\'\"></span></div><div class=bet-history-manager-header-top-description><span class=description-container ng-bind=\"vmBetHistoryHeaderRight.stats.total_running_count || \'0\'\"></span></div></div></div><!-- Bet History Header Line --><!-- Bet History Header Line --><div class=bet-history-manager-header-top-line><div class=bet-history-manager-header-top-title><h3 ng-translate translate=total_canceled></h3></div><div class=bet-history-manager-header-top-right-container><div class=bet-history-manager-header-top-description><span class=description-container ng-bind=\"vmBetHistoryHeaderRight.stats.total_canceled || \'0\'\"></span></div><div class=bet-history-manager-header-top-description><span class=description-container ng-bind=\"vmBetHistoryHeaderRight.stats.total_canceled_count || \'0\'\"></span></div></div></div><!-- Bet History Header Line --></div><!-- ./Bet History Header Right Content --></div><!-- Bet History Header Right Area -->");
$templateCache.put("app/profile/revenueReport/directives/filter/revenue-report-filter.html","<section id=nvsRevenueReportFilterContainer><div class=nvs-revenueReport-filter-segment><div class=nvs-revenue-report-filter-date-bar><h6 class=nvs-revenue-report-filter-bar--header translate=date_range></h6><label class=nvs-revenue-report-filter-bar--options><span class=nvs-revenue-report-filter-bar--date-icon></span> <input class=nvs-revenue-report-filter-bar--date-picker type=text date-range-picker data-ng-if=vmRevenueReportFilter.showDatePicker data-ng-model=vmRevenueReportFilter.dateTime options=vmRevenueReportFilter.dateOptions></label></div><div class=nvs-revenue-report-filter-bar><h6 class=nvs-revenue-report-filter-bar--header translate=product></h6><label class=nvs-revenue-report-filter-bar--options><select data-ng-model=vmRevenueReportFilter.filterData.product class=nvs-revenue-report-filter-bar--inputs><option value=sportsbook translate=sportsbook></option><option value=casino_game translate=casino_games></option><option value=virtual_game translate=virtual_games></option><option value=live_dealer_game translate=Ezugi></option></select></label></div><div class=nvs-revenue-report-filter-bar ng-if=\"vmRevenueReportFilter.filterData.product !== \'sportsbook\'\"><h6 class=nvs-revenue-report-filter-bar--header translate=provider></h6><label class=nvs-revenue-report-filter-bar--options><select data-ng-model=vmRevenueReportFilter.filterData.provider class=nvs-revenue-report-filter-bar--inputs><option value=all translate=all_providers></option><option value=casinomodule ng-if=\"vmRevenueReportFilter.filterData.product === \'casino_game\' || vmRevenueReportFilter.filterData.product === \'live_dealer_game\'\" translate=casino_module></option><option value=goldenrace ng-if=\"vmRevenueReportFilter.filterData.product === \'virtual_game\'\" translate=golden_race></option><option value=ezugi ng-if=\"vmRevenueReportFilter.filterData.product === \'live_dealer_game\'\">EZugi</option></select></label></div><div class=nvs-revenue-report-filter-bar ng-if=\"vmRevenueReportFilter.filterData.product === \'sportsbook\'\"><h6 class=nvs-revenue-report-filter-bar--header translate=ticket_type></h6><label class=nvs-revenue-report-filter-bar--options><select data-ng-model=vmRevenueReportFilter.filterData.ticketType class=nvs-revenue-report-filter-bar--inputs><option value=open translate=payment_open_bets></option><option value=close translate=closed_bets></option><option value=all translate=all_bets></option></select></label></div><div class=nvs-revenue-report-filter-bar><h6 class=nvs-revenue-report-filter-bar--header translate=view_method></h6><label class=nvs-revenue-report-filter-bar--options><select data-ng-model=vmRevenueReportFilter.filterData.viewMethod class=nvs-revenue-report-filter-bar--inputs><option value=all translate=view_all_accounts></option><option value=firstLevel translate=view_first_level_only></option></select></label></div><div class=nvs-revenue-report-filter-bar><h6 class=nvs-revenue-report-filter-bar--header></h6><label class=nvs-revenue-report-filter-bar--options><button class=nvs-revenue-report-filter-bar--btn-search data-ng-click=vmRevenueReportFilter.search()><i class=\"fa fa-search\" aria-hidden=true></i> <span translate=search></span></button></label></div></div></section>");
$templateCache.put("app/profile/revenueReport/directives/list/revenue-report-list.html","<section id=nvsRevenueReportListContainer><div class=nvs-RevenueReportTable-wrapper data-ng-if=vmRevenueReportList.reportList.users[vmRevenueReportList.user.id] ng-class=\"{\'virtual-game-title\':vmRevenueReportList.filter.product===\'virtual_game\'}\"><div class=nvs-RevenueReportTable><div class=\"nvs-RevenueReportTable-header-labels sub-level\"><span translate=sub_users></span></div><div class=\"nvs-RevenueReportTable-header-labels symbol-labels\"><span translate=level></span></div><div class=\"nvs-RevenueReportTable-header-labels symbol-labels\"><span translate=user_type></span></div><div class=nvs-RevenueReportTable-header-labels><span translate=username></span></div><div class=nvs-RevenueReportTable-header-labels><span translate=owner></span></div><div class=nvs-RevenueReportTable-header-labels ng-if=\"vmRevenueReportList.filter.product===\'virtual_game\'\"><span translate=market></span></div><div class=\"nvs-RevenueReportTable-header-labels ticket-label\"><span translate=ticket_no></span></div><div class=nvs-RevenueReportTable-header-labels>Av. <span translate=ticket></span></div><div class=nvs-RevenueReportTable-header-labels><span translate=bet></span></div><div class=nvs-RevenueReportTable-header-labels><span translate=win></span></div><div class=nvs-RevenueReportTable-header-labels ng-if=\"vmRevenueReportList.filter.product===\'virtual_game\'\"><span translate=jackpot></span></div><div class=nvs-RevenueReportTable-header-labels><span translate=profit></span></div></div><nvs-account-tree-table owner-id=vmRevenueReportList.reportList.ownerId reports=vmRevenueReportList.reportList template=revenue class=nvs-RevenueReportTable></nvs-account-tree-table></div></section>");
$templateCache.put("app/profile/transactions/directives/transactionDetail/transactionDetail.html","<div class=transaction-detail><div class=odds-table><!-- market group name --><!--<div class=\"table-header\">--><!--<div class=\"rotate-text\"><span>#{{vmTransactionsDetailCtrl.transactionDetailData.id}}</span></div>--><!--</div>--><div id=bet-history-detail-header><!-- Bet History Detail Title --><div class=bet-history-detail-title><h3># {{vmTransactionsDetailCtrl.transactionDetailData.id}}</h3></div><!-- ./Bet History Detail Title --><!-- Bet History Detail Back --><div class=bet-history-back><a ui-sref=transactionHistory ng-translate translate=back></a></div><!-- ./Bet History Detail Back --></div><table class=profile-table><tbody><tr><td class=head ng-translate translate=transaction_id></td><td>{{vmTransactionsDetailCtrl.transactionDetailData.id}}</td></tr><tr><td class=head ng-translate translate=transaction_type></td><td ng-if=\"vmTransactionsDetailCtrl.transactionDetailData.transfer_type == \'0\'\">Withdraw</td><td ng-if=\"vmTransactionsDetailCtrl.transactionDetailData.transfer_type == \'1\'\">Deposit</td></tr><tr><td class=head ng-translate translate=date></td><td>{{vmTransactionsDetailCtrl.transactionDetailData.created_at | timeZoneFilter }}</td></tr><tr><td class=head ng-translate translate=amount></td><td>{{vmTransactionsDetailCtrl.transactionDetailData.transfer_type ? \'+\' : \'-\'}}{{vmTransactionsDetailCtrl.transactionDetailData.amount | nvsCurrencyFilter}}</td></tr><tr><td class=head ng-translate translate=product></td><td>{{vmTransactionsDetailCtrl.transactionDetailData.product}}</td></tr><tr><td class=head ng-translate translate=note></td><td>{{vmTransactionsDetailCtrl.transactionDetailData.note}}</td></tr><tr data-ng-if=vmTransactionsDetailCtrl.transactionDetailData.virtual_game><td class=head ng-translate translate=event_id></td><td>{{vmTransactionsDetailCtrl.transactionDetailData.virtual_game.event_id}}</td></tr><tr data-ng-if=vmTransactionsDetailCtrl.transactionDetailData.virtual_game><td class=head ng-translate translate=ticket_id></td><td>{{vmTransactionsDetailCtrl.transactionDetailData.virtual_game.ticket_id}}</td></tr><tr><td class=head ng-translate translate=description></td><td>{{vmTransactionsDetailCtrl.transactionDetailData.description}}</td></tr></tbody></table></div></div>");
$templateCache.put("app/profile/transactions/directives/transactionForm/transactionForm.html","<div id=transaction-form><div id=transaction-form-container><div class=transaction-form-content><div class=transaction-date-range><label><input date-range-picker class=date-picker type=text ng-placeholder placeholder=Select_Date_Range options=vmTransactionForm.dateOptions ng-model=vmTransactionForm.date></label></div><div class=transaction-type><label><select name=transaction-type id=transaction-type ng-model=vmTransactionForm.data.type><option value=all ng-translate translate=all_transactions></option><option value=deposit ng-translate translate=deposit></option><option value=withdraw ng-translate translate=withdraw></option></select></label></div><div class=transaction-transaction-id><label><input type=text ng-placeholder placeholder=transaction_id ng-model=vmTransactionForm.data.transaction_id ng-virtual-keyboard></label></div><div class=transaction-member-name><label><input type=text ng-placeholder placeholder=member_name ng-model=vmTransactionForm.data.username ng-virtual-keyboard></label></div><div class=transaction-product><label><select name=transaction-product id=transaction-product ng-model=vmTransactionForm.data.transaction_type><option value=sportsbook ng-translate translate=sportsbook>ng-translate</option><option value=casino ng-translate translate=casino></option><option value=virtual ng-translate translate=virtual_games></option><!--<option value=\"liveCasino\">{{\' live_casino \' | translate}}</option>--></select></label></div></div><div class=transaction-form-content><div class=transaction-ticket-id><label><input type=text ng-placeholder placeholder=ticket_id ng-model=vmTransactionForm.data.ticket_id ng-virtual-keyboard></label></div><div class=transaction-ticket-type><label><select name=transaction-ticket-type id=transaction-ticket-type ng-model=vmTransactionForm.data.ticket_type><option value=all selected ng-translate translate=all_tickets></option><option value=running ng-translate translate=\" running\"></option><option value=resulted ng-translate translate=\" resulted\"></option><option value=won ng-translate translate=\" won\"></option><option value=lost ng-translate translate=\" lost\"></option><option value=void ng-translate translate=\" void\"></option><option value=rejected ng-translate translate=\" rejected\"></option><option value=canceled ng-translate translate=\" canceled\"></option><option value=awaiting ng-translate translate=\" awaiting\"></option><option value=cashout ng-translate translate=\" cashout\"></option></select></label></div><div class=transaction-check><label><span class=transaction-check-title ng-translate translate=all_users></span> <input type=checkbox class=transaction-checkbox ng-model=vmTransactionForm.data.all ng-true-value=1 ng-false-value=null> <span class=transition-check></span></label></div><div class=transaction-search><label><button id=transaction-search-btn ng-click=vmTransactionForm.transactionsSearch() tabindex=search ng-translate translate=search></button></label></div></div></div></div>");
$templateCache.put("app/profile/transactions/directives/transactionList/transactionList.html","<div id=transaction-list><div class=transaction-list-container><div class=transaction-list-header ng-if=\"vmTransactionList.transactions.length > 0\"><div class=\"transaction-list-item transaction-id\"><h4>#</h4></div><div class=\"transaction-list-item transaction-date\"><h4 ng-translate translate=date></h4></div><div class=\"transaction-list-item transaction-description\"><h4 ng-translate translate=description></h4></div><div class=\"transaction-list-item transaction-old-balance\"><h4 ng-translate translate=old_balance></h4></div><div class=\"transaction-list-item transaction-amount\"><h4 ng-translate translate=amount></h4></div><div class=\"transaction-list-item transaction-new-balance\"><h4 ng-translate translate=new_balance></h4></div><div class=\"transaction-list-item transaction-type\"><h4 ng-translate translate=type></h4></div><div class=\"transaction-list-item transaction-product\"><h4 ng-translate translate=product></h4></div></div><div class=transaction-list-content><!-- Repeat Transactions Data --><div class=transaction-list-row ng-repeat=\"transaction in vmTransactionList.transactions\"><div class=\"transaction-list-item transaction-id\"><h4><a ng-href=#/profile/transaction-detail/{{transaction.id}}>#{{transaction.id}}</a></h4></div><div class=\"transaction-list-item transaction-date\"><h4>{{transaction.created_at | timeZoneFilter}}</h4></div><div class=\"transaction-list-item transaction-description\"><h4>{{transaction.description}}</h4></div><div class=\"transaction-list-item transaction-old-balance\"><h4>{{transaction.balance_before}}</h4></div><div class=\"transaction-list-item transaction-amount\"><h4>{{transaction.amount}}{{transaction.currency.utf8_symbol}}</h4></div><div class=\"transaction-list-item transaction-new-balance\"><h4>{{transaction.balance_after}}</h4></div><div class=\"transaction-list-item transaction-type\"><h4>{{transaction.transfer_type == 0 ? \'Withdraw\':\'Deposit\'}}</h4></div><div class=\"transaction-list-item transaction-product\"><h4 ng-translate translate={{transaction.product}}></h4></div></div><!-- ./Repeat Transactions Data --></div></div></div>");}]);